import * as Yup from 'yup'
import axios from 'axios'
import { Icon } from '@iconify/react'
import trash2Outline from '@iconify/icons-eva/trash-2-outline'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { capitalCase, sentenceCase } from 'change-case'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Form, FormikProvider, useFormik } from 'formik'
import {
  Container,
  Grid,
  IconButton,
  Stack,
  Box,
  Button,
  TableRow,
  TableBody,
  Checkbox,
  Card,
  TableCell,
  Typography,
  TableContainer,
  Table,
  TablePagination,
  TextField,
  Switch,
  FormControlLabel,
  Autocomplete,
  Divider,
  Paper,
  Popover,
  CardHeader,
  TableHead,
  List,
  Menu,
  MenuItem,
  ListItemText,
  ListItem,
  Tabs,
  Tab,
  Tooltip,
  CircularProgress,
  Badge,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  RadioGroup,
  Radio,
  Skeleton,
} from '@material-ui/core'
import CloseIcon from '@iconify/icons-eva/close-fill'
import {
  useTheme,
  experimentalStyled as styled,
} from '@material-ui/core/styles'
import plusFill from '@iconify/icons-eva/plus-fill'
// redux
import {
  LoadingButton,
  MobileDatePicker,
  MobileDateRangePicker,
} from '@material-ui/lab'
// routes
// components
import Page from '../../components/Page'
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs'
import Modal from '../../components/_dashboard/blog/ProjectModel'
import Label from 'src/components/Label'
import { useSnackbar } from 'notistack'
import {
  Delete,
  UploadFile,
  LocationOn,
  ExpandMore,
  ExpandLess,
  Remove,
  Add,
  NoteAdd,
  Visibility,
  VisibilityOff,
  KeyboardBackspaceOutlined,
  Description,
  PictureAsPdf,
  DragIndicator,
  AttachMoney,
  Receipt,
} from '@material-ui/icons'
import OfficialRequestSearch from 'src/components/_dashboard/official-request/OfficialRequestSearch'
import InfiniteScroll from 'react-infinite-scroll-component'
import OfficialCard from 'src/components/_dashboard/official-request/OfficialCard'
import Scrollbar from 'src/components/Scrollbar'
import moment from 'moment'
import { formatDateOnly, dateOnlyMoment, dateOnlyToUnix, toDateOnlyUnix, localTodayDateOnlyUnix } from 'src/utils/dateOnly';
import { getBaseUnixForLeadTime, getInstallEndPatchFromLead, isInstallBeforeRequiredLead, resolveProductsLeadTime } from 'src/utils/installationLeadTime'
import { createRushFeeSyncRefs, runRushFeeLeadSync, markRushFeeUserToggled } from 'src/utils/rushFee'
import {
  currentFacilityId,
  DOMAIN,
  FacilityTypes,
  REST_API,
  REST_API_END_POINT,
  UNITS,
} from 'src/constants/Defaultvalues'
import quickbookLogo from 'src/assets/quickbookLogo-removebg-preview.png';
import { UploadAvatar, UploadMultiFile, UploadSingleFile } from 'src/components/upload'
import { storage } from '../../firebase/firebase'
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage'
import ReactToPrint from 'react-to-print'
import { empty } from 'src/Helpers/Common'
import { resolveAttachmentProxyPath } from 'src/Helpers/FileDownloadUtils'
import LoadingScreen from 'src/components/LoadingScreen'
import { DialogAnimate } from '../../components/animate'
import filePdfIcon from '@iconify/icons-mdi/file-pdf'
import SearchNotFound from 'src/components/SearchNotFound'
import RequestProgressModal from 'src/components/RequestProgressModal'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { Block } from '../components-overview/Block'
import { supabase } from '../../supabase/supabaseClient';
import { fUSPrice, roundMoneyValue } from 'src/utils/formatNumber'
import ViewProductFormulaModal from 'src/components/ViewProductFormulaModal'
import getLabourCostServiceTabLabel from 'src/utils/getLabourCostServiceTabLabel'
import AttachmentDownloadIconButton from 'src/components/_dashboard/official-request/AttachmentDownloadIconButton'
import AttachmentDownloadAllButton from 'src/components/_dashboard/official-request/AttachmentDownloadAllButton'
import {
  applyInstallPriceEdit,
  applyRetailPriceEdit,
  ensureCatalogBaselines,
  formatPriceToTwoDecimals,
  formatRetailPriceDisplay,
  getCatalogProductWithAdjustment,
  getDisplayedInstallPrice,
  getSignedMarketingAdjustment,
  getSignedInstallMarketingAdjustment,
  hydrateEstimateLineMarketingPrices,
  limitDecimalInput,
  normalizeProductForSave,
  normalizeRetailArrowChange,
  reconcileCatalogMarketingPrices,
  stepRetailPriceByArrow,
  canShowProductFormulaIcon,
} from 'src/utils/retailPriceEdit'

const getStatusColorAndLabel = (status) => {
  switch (status) {
    case 1:
      return { color: 'warning', label: 'Status: Draft' }
    case 2:
      return { color: 'info', label: 'Status: Open' }
    case 3:
      return { color: 'primary', label: 'Status: Accepted' } // Evaluating
    case 4:
      return { color: 'success', label: 'Status: In Production' } // Converted to Job
    case 5:
      return { color: 'warning', label: 'Status: Closed' }
    case 6:
      return { color: 'error', label: 'Status: Rejected' }
    default:
      return { color: 'default', label: 'Status: Open' }
  }
}

const formatProjectAddress = (project) => {
  if (!project) return 'No address available';
  const addressParts = [project.address, project.city, project.state, project.zip]
    .map((part) => (part || '').toString().trim())
    .filter(Boolean);
  return addressParts.length > 0 ? addressParts.join(', ') : 'No address available';
}

const selectInputValue = (event) => {
  const input = event.target
  setTimeout(() => {
    if (input?.select) {
      input.select()
    }
  }, 0)
}

const markupTypes = [
  { id: 1, name: 'Wholesale Markup' },
  { id: 2, name: 'Retail Markup' },
]
const marketingAdjustmentType = [
  { id: 1, name: '$' },
  { id: 2, name: '%' },
  // { id: 3, name: '¢' }
]

//sorting
const SORT = [
  { id: 'new', label: 'Newest', color: '#54D62C' },
  { id: 'old', label: 'Oldest', color: '#ffff00' },
  { id: 'last_updated', label: 'Recently Updated', color: '#ffff00' },
  { id: 'custom_order', label: 'Custom Order', color: '#ffff00' },
]
const MAX_CHARACTERS = 500

const ATTACHMENTS_PUBLIC_MARKER = '/storage/v1/object/public/signwise-attachments/'

const normalizeUrlString = (raw) => {
  if (!raw) return ''
  try {
    return decodeURIComponent(String(raw).split('?')[0].split('#')[0].trim())
  } catch {
    return String(raw).split('?')[0].split('#')[0].trim()
  }
}

/** True for URLs / storage paths — false for bare filenames like "Screenshot.png". */
const looksLikeAttachmentRef = (raw) => {
  const s = String(raw || '')
  if (!s) return false
  if (
    s.includes('://') ||
    s.includes('/attachments/file') ||
    s.includes('/storage/v1/object/') ||
    s.includes(ATTACHMENTS_PUBLIC_MARKER)
  ) {
    return true
  }
  return s.includes('/') && /\.[a-z0-9]+$/i.test(s)
}

/** Collapse proxy URLs + direct Supabase URLs to the same storage path. */
const normalizeAttachmentIdentifier = (raw) => {
  if (!raw) return ''
  const str = String(raw).trim()
  if (!str) return ''

  if (str.includes('/attachments/file') && str.includes('path=')) {
    return normalizeUrlString(resolveAttachmentProxyPath(str))
  }

  const publicIdx = str.indexOf(ATTACHMENTS_PUBLIC_MARKER)
  if (publicIdx !== -1) {
    return normalizeUrlString(str.slice(publicIdx + ATTACHMENTS_PUBLIC_MARKER.length))
  }

  return normalizeUrlString(str)
}

const getAttachmentRecordId = (f) =>
  f?.id ?? f?.ID ?? f?.attachment_id ?? f?.request_attachment_id ?? null

/** Prefer url/file_url; only use name when it is a URL/path (not a bare filename). */
const getAttachmentPrimaryRef = (f) => {
  if (!f) return ''
  if (f.url) return f.url
  if (f.file_url) return f.file_url
  if (looksLikeAttachmentRef(f.name)) return f.name
  return ''
}

const attachmentFileKey = (f) => {
  const primary = getAttachmentPrimaryRef(f)
  if (primary) return normalizeAttachmentIdentifier(primary)
  return normalizeAttachmentIdentifier(f?.name || '')
}

const attachmentMatches = (a, b) => {
  const idA = getAttachmentRecordId(a)
  const idB = getAttachmentRecordId(b)
  if (idA != null && idB != null && String(idA) !== '' && String(idB) !== '') {
    return String(idA) === String(idB)
  }

  const keyA = attachmentFileKey(a)
  const keyB = attachmentFileKey(b)
  return Boolean(keyA && keyB && keyA === keyB)
}

const pruneAttachmentMapsByFile = (map, fileToRemove) => {
  if (!fileToRemove || !map) return map || {}
  const next = { ...map }
  Object.keys(next).forEach((k) => {
    const arr = next[k]
    if (!Array.isArray(arr)) return
    const filtered = arr.filter((f) => !attachmentMatches(f, fileToRemove))
    if (filtered.length === 0) {
      delete next[k]
    } else {
      next[k] = filtered
    }
  })
  return next
}

const catalogTypes = [
  { id: 'in_stock', label: 'In Stock',inhouse:4,isTrafficCatalog:false },
  { id: 'client_owned', label: 'Client Owned',inhouse:5 ,isTrafficCatalog:false},
  { id: 'traffic', label: 'Traffic',inhouse:1 ,isTrafficCatalog:true}
]

// Catalog types for split orders (all types + All option)
const splitOrderCatalogTypes = [
  { id: 'all', label: 'All',inhouse:null ,isTrafficCatalog:null},
  { id: 'in_stock', label: 'In Stock',inhouse:4,isTrafficCatalog:false },
  { id: 'client_owned', label: 'Client Owned',inhouse:5 ,isTrafficCatalog:false},
  { id: 'traffic', label: 'Traffic',inhouse:1 ,isTrafficCatalog:true},
  { id: 'production_catalog', label: 'Production Catalog',inhouse:1 ,isTrafficCatalog:false},
  { id: 'split_catalog', label: 'Split Catalog',inhouse:6 ,isTrafficCatalog:false},
  { id: 'estimate_catalog', label: 'Estimate Catalog',inhouse:7 ,isTrafficCatalog:false}
]
const getMaterialMaxNegativeAdjustment = (item, hasPermission = false) => {
  // Quantity and location quantities
  const qty = Number(item.quantity) || 1;
  const formulaEach = Number(item.price)
  const retailEachBase = Number(item.markUpCost)
  const formulaTotal = formulaEach * qty ;
  const retailTotal = retailEachBase * qty ;

  // Max negative adjustment allowed so that retailTotal - adjustment >= formulaTotal
  // const maxNegative = Math.max(0, retailTotal - formulaTotal);
  const maxNegative = Math.max(0, retailEachBase - formulaEach);

  console.log('getMaxNegativeAdjustment1-item--', item);
  console.log('getMaxNegativeAdjustment1-formulaEach--', formulaEach);
  console.log('getMaxNegativeAdjustment1-retailEachBase--', retailEachBase);
  console.log('getMaxNegativeAdjustment1-qty--', qty);
  console.log('getMaxNegativeAdjustment1-formulaTotal--', formulaTotal);
  console.log('getMaxNegativeAdjustment1-retailTotal--', retailTotal);
  console.log('getMaxNegativeAdjustment1-maxNegative--', maxNegative);

  if (hasPermission) {
    return retailEachBase;
  }
  return maxNegative;
};
const getMaxNegativeAdjustment = (item,hasPermission) => {
  // Quantity and location quantities
  const qty = Number(item.quantity) || 1;
  const locQty = Number(item.locationQuantity) || 1;

  // Product Formula Cost per unit (material + service with markup)
  const formulaEach = item?.inhouse === 0 ? Number(item?.sub_contract_price || 0) : Number(
    (item?.expected_material_cost_with_markup || 0) +
      (item?.expected_service_cost_with_markup || 0),
  );
  const formulaTotal = formulaEach * qty * locQty;

  // Base retail each BEFORE marketing adjustment
  const retailEachBase = Math.max(
    0,
    Number(
      item.original_actual_retail_price ??
        item.original_retail_price ??
        item.actual_retail_price ??
        item.retail_price ??
        item.product_retail_price ??
        0,
    ),
  );
  const retailTotal = retailEachBase * qty * locQty;

  // Max negative adjustment allowed so that retailTotal - adjustment >= formulaTotal
  // const maxNegative = Math.max(0, retailTotal - formulaTotal);
  const maxNegative = Math.max(0, retailEachBase - formulaEach);

  // console.log('getMaxNegativeAdjustment1-item--', item);
  // console.log('getMaxNegativeAdjustment1-formulaEach--', formulaEach);
  // console.log('getMaxNegativeAdjustment1-retailEachBase--', retailEachBase);
  // console.log('getMaxNegativeAdjustment1-qty--', qty);
  // console.log('getMaxNegativeAdjustment1-locQty--', locQty);
  // console.log('getMaxNegativeAdjustment1-formulaTotal--', formulaTotal);
  // console.log('getMaxNegativeAdjustment1-retailTotal--', retailTotal);
  // console.log('getMaxNegativeAdjustment1-maxNegative--', maxNegative);
if(hasPermission){
  return retailEachBase;
}
  return maxNegative;
};

const getMaxNegativeInstallAdjustment = (data, hasPermission) => {
  const formula = Number(data?.expected_install_labor_cost_with_markup) || 0;
  const retail = Math.max(
    0,
    Number(data?.original_install_cost) || Number(data?.install_cost) || 0,
  );
  const qty = Number(data?.install_quantity) || 1;
  const locQty = Number(data?.locationQuantity) || 1;

  const totalFormula = formula * qty * locQty;
  const totalRetail = retail * qty * locQty;
  // console.log('getMaxNegativeAdjustment1-formula--',data)
  // console.log('getMaxNegativeAdjustment1-formula--',formula)
  // console.log('getMaxNegativeAdjustment1-retail--',retail)
  // console.log('getMaxNegativeAdjustment1-qty--',qty)
  // console.log('getMaxNegativeAdjustment1-locQty--',locQty)
  // console.log('getMaxNegativeAdjustment1-totalFormula--',totalFormula)
  // console.log('getMaxNegativeAdjustment1-totalRetail--',totalRetail)
  if(hasPermission){
    return retail;
  }
  return Math.max(0, retail - formula);
  // return Math.max(0, totalRetail - totalFormula);
};

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const getChunks = (str) => {
    const chunks = [];
    let currentChunk = '';
    let chunkType = null; // 'hash', 'otherSpecial', 'digit', or 'letter'

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      const isDigit = /\d/.test(char);
      const isLetter = /[a-zA-Z]/.test(char);
      const isHash = char === '#';
      const isOtherSpecial = !isDigit && !isLetter && !isHash;
      
      // Determine chunk type with priority: hash < otherSpecial < digit < letter
      let currentType;
      if (isHash) {
        currentType = 'hash';
      } else if (isOtherSpecial) {
        currentType = 'otherSpecial';
      } else if (isDigit) {
        currentType = 'digit';
      } else {
        currentType = 'letter';
      }

      if (i === 0) {
        chunkType = currentType;
        currentChunk = char;
      } else if (currentType === chunkType) {
        currentChunk += char;
      } else {
        chunks.push({
          value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
          type: chunkType
        });
        currentChunk = char;
        chunkType = currentType;
      }
    }

    if (currentChunk) {
      chunks.push({
        value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
        type: chunkType
      });
    }

    return chunks;
  };

  const chunksA = getChunks(a);
  const chunksB = getChunks(b);
  const len = Math.min(chunksA.length, chunksB.length);

  // Type priority: hash (0) < otherSpecial (1) < digit (2) < letter (3)
  const getTypePriority = (type) => {
    if (type === 'hash') return 0;
    if (type === 'otherSpecial') return 1;
    if (type === 'digit') return 2;
    return 3; // letter
  };

  for (let i = 0; i < len; i++) {
    const chunkA = chunksA[i];
    const chunkB = chunksB[i];

    const priorityA = getTypePriority(chunkA.type);
    const priorityB = getTypePriority(chunkB.type);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // Same type, compare values
    if (chunkA.type === 'digit') {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    } else {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    }
  }

  if (chunksA.length < chunksB.length) return -1;
  if (chunksA.length > chunksB.length) return 1;

  return 0;
}

export default function OfficialRequestAdd({
    open,
    setShowProgressModal,
    showProgressModal,
    searching,
    setOpen,
    page,
    setPage,
    preview,
    setPreview,
    rowsPerPage,
    setRowsPerPage,
    totalCount,
    setTotalCount,
    allCount,
    setAllCount,
    acceptedCount,
    setAcceptedCount,
    openCount,
    setOpenCount,
    inProductionCount,
    setinProductionCount,
    completedCount,
    setCompletedCount,
    installsCount,
    setInstallsCount,
    pickupCount,
    setPickupCount,
    shippingCount,
    setShippingCount,
    allRequest,
    setAllRequest,
    loadingCards,
    setLoadingCards,
    skillServices,
    setSkillServices,
    allProducts,
    setAllproducts,
    materials,
    setAllMaterials,
    labourCostServices,
    setLabourCostServices,
    filteredServices,
    setFilteredServices,
    requestTeam,
    setRequestTeam,
    openPreview,
    setOpenPreview,
    isSaving,
    setIsSaving,
    selectedProducts,
    setSelectedProducts,
    selectedMaterials,
    setSelectedMaterials,
    selectedServices,
    setSelectedServices,
    additionalSelectedServices,
    setAdditionalSelectedServices,
    avatarUrl,
    setAvatarUrl,
    location,
    setLocation,
    projectTypes,
    setProjectTypes,
    workflow,
    setWorkFlow,
    projectCategories,
    setProjectCategories,
    noChargeType,
    setNoChargeType,
    communities,
    setCommunities,
    isCommunityLoading,
    setIsCommunityLoading,
    locationStates,
    setLocationStates,
    serviceOnlyLocationStates,
    setServiceOnlyLocationStates,
    rfpLocationStates,
    setRfpLocationStates,
    rfpServiceLocationStates,
    setRfpServiceLocationStates,
    allLocationSame,
    setAllLocationSame,
    allServiceLocationSame,
    setAllServiceLocationSame,
    allRfpServiceLocationSame,
    setAllRfpServiceLocationSame,
    allRfpProductsLocationSame,
    setAllRfpProductsLocationSame,
    address,
    setAddress,
    progress,
    setProgress,
    currentDate,
    setCurrentDate,
    user,
    userType,
    userId,
    teamId,
    explodedPermissions,
    hasMarkupPermission,
    hasDiscountPermission,
    allClients,
    setAllClients,
    communitiesOpen,
    setCommunitiesOpen,
    communitiesData,
    setCommunitiesData,
    filterCommunity,
    setFilterCommunity,
    markupType,
    setMarkupType,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    showServices,
    setShowServices,
    showWarning,
    setShowWarning,
    currentTab,
    setCurrentTab,
    indexCounter,
    setIndexCounter,
    serviceIndexCounter,
    setServiceIndexCounter,
    rfps,
    setRfps,
    selectedRfp,
    setSelectedRfp,
    openModal,
    setOpenModal,
    tabIndex,
    setTabIndex,
    rfpServices,
    setRfpServices,
    rfpProducts,
    setRfpProducts,
    cart,
    setCart,
    cartService,
    setCartService,
    totalProductLabourCost,
    filterDateValue,
    setFilterDateValue,
    sort,
    setSort,
    sortOpen,
    setSortOpen,
    noCharge,
    setNoCharge,
    openProductNote,
    setOpenProductNote,
    openServiceNote,
    setOpenServiceNote,
    isSavingNote,
    setIsSavingNote,
    currentNote,
    setCurrentNote,
    openProductAttachment: openProductAttachmentProp,
    setOpenProductAttachment: setOpenProductAttachmentProp,
    selectedTaxCategory,
    setSelectedTaxCategory,
    taxCategories,
    setTaxCategories,
    isSubmitted,
    setIsSubmitted,
    allId,
    setAllId,
    mapServices,
    setMapServices,
    mapServicesLoading,
    setMapServicesLoading,
    selectedMapserviceProducts,
    setSelectedMapserviceProducts,

    newTotalAmount,
    setNewTotalAmount,
    newTotalMarkup,
    setNewTotalMarkup,
    newTotalProductFormula,
    setNewTotalProductFormula,
    newTotalWholesalePrice,
    setNewTotalWholesalePrice,
    newTotalRetailPrice,
    setNewTotalRetailPrice,
    newOriginalTotalMarkup,
    setNewOriginalTotalMarkup,
    newOriginalTotalServiceMarkup,
    setNewOriginalTotalServiceMarkup,
    newTotalServiceMarkup,
    setNewTotalServiceMarkup,
    newTotalDiscount,
    setNewTotalDiscount,
    newDiscountTotal,
    setNewDiscountTotal,
    newTotalJobcostSum,
    setNewTotalJobcostSum,
    newTotalsum,
    setNewTotalsum,
    newGrandTotal,
    setNewGrandTotal,

    newValues,
    setNewValues,
    setRenderCard,
    renderCard,
    otherInstallationProducts,
    splitManagementSettings,
    splitPercentage,
    setSplitPerscentage,
    incomingSplitMarkup,
    pageSplitOrder,handleOpenViewSalesOrder,
    openEmailModal,
    setOpenEmailModal,
    billingTypes
  }) {
    console.log('selectedProductsselectedProducts',billingTypes)
    // Initialize openProductAttachment state if not provided as prop
    const [localOpenProductAttachment, setLocalOpenProductAttachment] = useState({});
    const openProductAttachment = openProductAttachmentProp !== undefined ? openProductAttachmentProp : localOpenProductAttachment;
    const setOpenProductAttachment = setOpenProductAttachmentProp !== undefined ? setOpenProductAttachmentProp : setLocalOpenProductAttachment;
    
    // Local state for clearing notes
    const [isClearingNote, setIsClearingNote] = useState(false);
    
    const theme = useTheme()
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar()
    const canViewCosts = !!explodedPermissions?.some((permission) =>
      ['View Sales Order Cost'].includes(permission),
    )

    // User variables for client filtering
    let isClient = user?.isClient || user?.isclient
    console.log('user+++++++++++++++++', user)
    
    const refCommunities = useRef(null);
    const refSort = useRef(null);
    const productInputValueRef = useRef(''); // Track product autocomplete input value for production builds
    const rushFeeSyncRefs = useRef(createRushFeeSyncRefs());
    const [productAutocompleteInput, setProductAutocompleteInput] = useState('');
    const [facilityProductInputs, setFacilityProductInputs] = useState({});
    const [error,setError] = useState(false)
    const [showAddNewRow,setShowAddNewRow] = useState(false)
    const [openInstallNote, setOpenInstallNote] = useState({})
    const [openMaterialNote, setOpenMaterialNote] = useState({})
    const [singleLocationCard,setSingleLocationCard] = useState(true)

    // Auto-save confirmation dialog state
    const [openBackConfirm, setOpenBackConfirm] = useState(false);
    const [isUploading,setIsUploading] = useState(false)
    const [productAttachments, setProductAttachments] = useState({}) // Store attachments per product by indexId
    const [isUploadingProduct, setIsUploadingProduct] = useState({}) // Track upload state per product
    const [productAttachmentDragOver, setProductAttachmentDragOver] = useState({})
    const [attachmentTabValue, setAttachmentTabValue] = useState({}) // Track tab value per product attachment modal
    const [selectedUploadedImages, setSelectedUploadedImages] = useState({}) // Track selected images from avatarUrl per product
    const [serviceAttachments, setServiceAttachments] = useState({}) // Store attachments per service by indexId
    const [isUploadingService, setIsUploadingService] = useState({}) // Track upload state per service
    const [serviceAttachmentDragOver, setServiceAttachmentDragOver] = useState({})
    const [attachmentTabValueService, setAttachmentTabValueService] = useState({}) // Track tab value per service attachment modal
    const [selectedUploadedImagesService, setSelectedUploadedImagesService] = useState({}) // Track selected images from avatarUrl per service
    const [openServiceAttachment, setOpenServiceAttachment] = useState({}) // Track open state for attachment modal per service
    const [selectedPDF, setSelectedPDF] = useState(null)
    const [openPDFModal, setOpenPDFModal] = useState(false)
    const [pdfLoading, setPdfLoading] = useState(true)
    const [useOfficeViewer, setUseOfficeViewer] = useState(true)
    const [openMakeTaskDialog,setOpenMakeTaskDialog] = useState(false)
    const [showMakeTaskErrorDialog,setShowMakeTaskErrorDialog] = useState(false)
    const [confirmMakeTask,setConfirmMakeTask] = useState(false)
    const [openDialog,setOpenDialog] = useState(false);
    const [pendingProject, setPendingProject] = useState(null);
    const [stockType, setStockType] = useState(1);
    const [pendingMaterial, setPendingMaterial] = useState(null);
    const [partialProducts, setPartialProducts] = useState([]);
    const [convertionUnit, setConvertionUnit] = useState(0);
    const [totalMinusMaterialTax,setTotalMinusMaterialTax] = useState(null)
    const [pendingAutocompleteMaterials, setPendingAutocompleteMaterials] = useState([]);
    const [allCommunities, setAllCommunities] = useState([]);
    const [clientCommunities, setClientCommunities] = useState([]);
    const [produtFormulaMaterial,setProductFormulaMaterial] = useState([])
    const [totalProductInstallCost, setTotalProductInstallCost] = useState(0)
    const [installCost, setInstallCost] = useState(0);
    const [progressRequestData, setProgressRequestData] = useState(null);
    const [openNoChargeReasonPopup, setOpenNoChargeReasonPopup] = useState(false);
    const [noChargeReason, setNoChargeReason] = useState('');
    const [noChargeReasonError, setNoChargeReasonError] = useState(false);
    const [socketReady, setSocketReady] = useState(false);
    const [isSplitOrder,setIsSplitOrder] = useState(false)
    const [selectedSplitOrderSettings,setSelectedSplitOrderSettings] = useState([])
    const [salesRepName, setSalesRepName] = useState('');
    const [salesRepId, setSalesRepId] = useState(null);
    const [salesRepOptions, setSalesRepOptions] = useState([]);
    const [collaborators, setCollaborators] = useState([]);
    const [teamMembersOptions, setTeamMembersOptions] = useState([]);
    console.log('teamMembersOptions',teamMembersOptions)
    const [teamMembersLoading, setTeamMembersLoading] = useState(false);
    const [nameFileds, setNameFileds] = useState({
      name: '',
      po_number: '',
      description: '',
      notes :''
    })
    const [fieldErrors, setFieldErrors] = useState({});
    // const [teamMembersOptions, setTeamMembersOptions] = useState([]);
    // const [teamMembersLoading, setTeamMembersLoading] = useState(false);
    const [refreshCalculation,setRefreshCalculation] = useState(false)
    const [depositAndProgressBilling, setDepositAndProgressBilling] = useState(false);
    const [depositProgressBillingRows, setDepositProgressBillingRows] = useState([{ title: '', amount: '' }]);

    const [companyProfileData, setCompanyProfileData] = useState({});
    const [openProductFormulaModal, setOpenProductFormulaModal] = useState(false);
const [selectedProductFormulaId, setSelectedProductFormulaId] = useState(null);

    const handleDepositProgressBillingChange = (index, field, value) => {
      if (field === 'amount') {
        setDepositProgressBillingRows((prevRows) => {
          const maxAmount = Math.max(
            (Number(grandTotal) || 0) -
              prevRows.reduce((sum, row, rowIndex) => (
                rowIndex === index ? sum : sum + (Number(row.amount) || 0)
              ), 0),
            0
          );
          const amount = value === ''
            ? ''
            : Number(value) > maxAmount
              ? maxAmount.toFixed(2)
              : value;

          return prevRows.map((row, rowIndex) =>
            rowIndex === index ? { ...row, [field]: amount } : row
          );
        });
        return;
      }

      setDepositProgressBillingRows((prevRows) =>
        prevRows.map((row, rowIndex) =>
          rowIndex === index ? { ...row, [field]: value } : row
        )
      );
    };

    const handleAddDepositProgressBillingRow = () => {
      setDepositProgressBillingRows((prevRows) => [...prevRows, { title: '', amount: '' }]);
    };

    const handleDeleteDepositProgressBillingRow = (index) => {
      setDepositProgressBillingRows((prevRows) =>
        prevRows.length === 1
          ? [{ title: '', amount: '' }]
          : prevRows.filter((_, rowIndex) => rowIndex !== index)
      );
    };

    const getDepositProgressBillingTotal = (excludeIndex = null) =>
      depositProgressBillingRows.reduce((sum, row, rowIndex) => (
        rowIndex === excludeIndex ? sum : sum + (Number(row.amount) || 0)
      ), 0).toFixed(2);

    const getDepositProgressBillingMaxAmount = (index) =>
      Math.max((Number(grandTotal) || 0) - getDepositProgressBillingTotal(index), 0);

    const canAddDepositProgressBillingRow = () =>
      getDepositProgressBillingTotal() < Math.max(Number(grandTotal) || 0, 0);


    useEffect(() => {
      const fetchCompanyProfile = async () => {
        try {
          const res = await axios.post(`${REST_API}webservice/settings/get-companyProfile-details`);
          if (res.data.status === 1) {
            setCompanyProfileData(...res.data.data);
          }
        } catch (error) {
          console.log('get-companyProfile-details error : ', error);
        }
      };
      fetchCompanyProfile();
    }, []);


    const getSalesRepOptionsFromCommunity = (community) => {
      // Prefer resolved eligible sales-rep fields (admin/sales only from backend).
      // all_sales_rep_* comes from getAllCommunitiesByClient; sales_rep_* from getAllCommunities.
      // Use ?? so an empty eligible list does not fall back to raw stored IDs.
      const rawNames = community?.all_sales_rep_names ?? community?.sales_rep_names;
      const rawIds = community?.all_sales_rep_ids ?? community?.sales_rep_ids;

      const names = Array.isArray(rawNames)
        ? rawNames
        : typeof rawNames === 'string'
          ? rawNames.split(',').map((s) => s.trim()).filter(Boolean)
          : [];

      const ids = Array.isArray(rawIds)
        ? rawIds
        : typeof rawIds === 'string'
          ? rawIds.split(',').map((s) => s.trim()).filter(Boolean)
          : [];

      return names.map((name, idx) => ({
        id: ids[idx] ?? null,
        name,
      }));
    };


    const getCommunitySalesRepIds = (community) => {
      const rawIds = community?.all_sales_rep_ids ?? community?.sales_rep_ids;
      if (!rawIds) {
        return [];
      }

      const ids = Array.isArray(rawIds)
        ? rawIds
        : typeof rawIds === 'string'
          ? rawIds.split(',')
          : [];

      return ids
        .map((id) => String(id ?? '').trim())
        .filter(Boolean);
    };

    // Split-order: per-product Delivery & Installation assignment (UI-only; persisted in selectedProducts state)
    const [deliveryInstallDialog, setDeliveryInstallDialog] = useState({
      open: false,
      productIndexId: null,
      productFacilityId: null, // used to apply same selection to all products from that facility
      complete_status: 1, // 1=installation, 2=pickup, 3=shipping
      installerFacility: null, // facility option (from FacilityTypes)
      facilityOptions: [],
      isEditMode: false, // true when editing existing delivery type (apply to single item only)
      itemType: 'product', // 'product' | 'service' - which list the item belongs to
    })

    const deliveryTypeLabelById = (deliveryTypeId) => {
      if (Number(deliveryTypeId) === 1) return 'Installs'
      if (Number(deliveryTypeId) === 2) return 'Pickup'
      if (Number(deliveryTypeId) === 3) return 'Shipping'
      return 'Installs'
    }

    const [openJobTypeDialog, setOpenJobTypeDialog] = useState(false);
    const [pendingJobType, setPendingJobType] = useState(null);

    const getFacilityOption = (facilityId) => {
      const fid = Number(facilityId)
      const match = FacilityTypes?.find((f) => Number(f?.id) === fid)
      // FacilityTypes uses `label` (see `src/constants/Defaultvalues.js`)
      if (match) return { id: match.id, name: match.label || match.name || match.value || `Facility ${fid}` }
      return { id: fid, name: `Facility ${fid}` }
    }

    // Helper function to get existing delivery/installer settings for a facility
    const getExistingDeliverySettingsForFacility = (facilityId) => {
      const isOtherFacility = Number(facilityId) !== Number(currentFacilityId);
      const isCurrentFacility = Number(facilityId) === Number(currentFacilityId);
      
      // Check products first
      const existingProductSettings = selectedProducts.find(
        (p) => Number(p?.facility_id) === Number(facilityId) &&
               p?.delivery_installation &&
               (isSplitOrder ? (isOtherFacility || isCurrentFacility) : true) // For split orders, check both other and current facilities; for normal, all facilities
      );

      if (existingProductSettings?.delivery_installation) {
        const deliverySettings = existingProductSettings.delivery_installation;
        
        // For split orders: return full delivery_installation object
        // For normal sales orders: only return delivery_type_id (no installer_facility_id)
        if (isSplitOrder) {
          // For current facility in split orders, ensure installer_facility_id is set
          if (isCurrentFacility) {
            const currentFacility = getFacilityOption(currentFacilityId);
            return {
              ...deliverySettings,
              installer_facility_id: Number(currentFacilityId),
              installer_facility_name: currentFacility?.name || null,
            };
          }
          return deliverySettings;
        } else {
          // Normal sales order: only inherit delivery_type_id
          if (deliverySettings?.delivery_type_id) {
            return {
              delivery_type_id: deliverySettings.delivery_type_id,
              installer_facility_id: Number(currentFacilityId),
            };
          }
        }
      }

      // Check services
      const existingServiceSettings = additionalSelectedServices.find(
        (s) => Number(s?.facility_id) === Number(facilityId) &&
               s?.delivery_installation &&
               (isSplitOrder ? (isOtherFacility || isCurrentFacility) : true) // For split orders, check both other and current facilities; for normal, all facilities
      );

      if (existingServiceSettings?.delivery_installation) {
        const deliverySettings = existingServiceSettings.delivery_installation;
        
        // For split orders: return full delivery_installation object
        // For normal sales orders: only return delivery_type_id (no installer_facility_id)
        if (isSplitOrder) {
          // For current facility in split orders, ensure installer_facility_id is set
          if (isCurrentFacility) {
            const currentFacility = getFacilityOption(currentFacilityId);
            return {
              ...deliverySettings,
              installer_facility_id: Number(currentFacilityId),
              installer_facility_name: currentFacility?.name || null,
            };
          }
          return deliverySettings;
        } else {
          // Normal sales order: only inherit delivery_type_id
          if (deliverySettings?.delivery_type_id) {
            return {
              delivery_type_id: deliverySettings.delivery_type_id,
              installer_facility_id: Number(currentFacilityId),
            };
          }
        }
      }

      // For split orders with current facility: if no existing settings found, return default with currentFacilityId
      if (isSplitOrder && isCurrentFacility) {
        const currentFacility = getFacilityOption(currentFacilityId);
        // Try to find delivery_type_id from any existing product/service from current facility
        const currentFacilityProduct = selectedProducts.find(
          (p) => Number(p?.facility_id) === Number(currentFacilityId) && p?.delivery_installation?.delivery_type_id
        );
        const currentFacilityService = additionalSelectedServices.find(
          (s) => Number(s?.facility_id) === Number(currentFacilityId) && s?.delivery_installation?.delivery_type_id
        );
        
        const deliveryTypeId = currentFacilityProduct?.delivery_installation?.delivery_type_id || 
                              currentFacilityService?.delivery_installation?.delivery_type_id || 
                              1; // default to 1 (Installs)
        
        return {
          delivery_type_id: deliveryTypeId,
          installer_facility_id: Number(currentFacilityId),
          installer_facility_name: currentFacility?.name || null,
        };
      }

      return null;
    };

    const openDeliveryInstallDialog = async (productRow) => {
      if (!productRow) return
      // Only for products from other facilities
      if (Number(productRow?.facility_id) === Number(currentFacilityId)) return

      const existing = productRow?.delivery_installation || null
      const facilityOptions = [
        ...new Map(
          [currentFacilityId, productRow?.facility_id]
            .map((id) => getFacilityOption(id))
            .map((o) => [Number(o.id), o]),
        ).values(),
      ]
      const existingFacilityId =
        existing?.installer_facility_id || existing?.installerFacility?.id || null
      const existingFacility =
        facilityOptions.find((o) => Number(o.id) === Number(existingFacilityId)) ||
        facilityOptions.find((o) => Number(o.id) === Number(productRow?.facility_id)) ||
        facilityOptions[0] ||
        null

      setDeliveryInstallDialog({
        open: true,
        productIndexId: productRow?.indexId,
        productFacilityId: productRow?.facility_id || null,
        complete_status: Number(existing?.delivery_type_id || existing?.complete_status || 1),
        installerFacility: existingFacility,
        facilityOptions,
      })
    }

    // Normal sales order: open dialog only to select delivery_type_id (no installer required)
    // itemType: 'product' | 'service' - when Edit mode, changes apply only to this specific item
    const openDeliveryTypeDialog = (productRow, itemType = 'product') => {
      if (!productRow) return
      const existing = productRow?.delivery_installation || null
      const isEditMode = !!(existing?.delivery_type_id || existing?.complete_status)

      setDeliveryInstallDialog({
        open: true,
        productIndexId: productRow?.indexId,
        productFacilityId: productRow?.facility_id || null,
        complete_status: Number(existing?.delivery_type_id || existing?.complete_status || 1),
        installerFacility: existing?.installer_facility_id
          ? getFacilityOption(existing?.installer_facility_id)
          : null,
        facilityOptions: [], // not used for non-split orders
        isEditMode,
        itemType,
      })
    }

    const closeDeliveryInstallDialog = () => {
      setDeliveryInstallDialog({
        open: false,
        productIndexId: null,
        productFacilityId: null,
        complete_status: 1,
        installerFacility: null,
        facilityOptions: [],
        isEditMode: false,
        itemType: 'product',
      })
    }

    const saveDeliveryInstallSelection = () => {
      const { productIndexId, productFacilityId, complete_status, installerFacility } = deliveryInstallDialog

      if (!productIndexId) return
      if (!installerFacility?.id) {
        enqueueSnackbar('Please choose an installer facility', { variant: 'error' })
        return
      }
      if (![1, 2, 3].includes(Number(complete_status))) {
        enqueueSnackbar('Please choose Installs / Pickup / Shipping', {
          variant: 'error',
        })
        return
      }

      setSelectedProducts((prev) =>
        (prev || []).map((p) => {
          // Apply to all products from the same facility as the one being edited (reduces repeated selections)
          const shouldApplyByFacility =
            productFacilityId != null &&
            Number(p?.facility_id) === Number(productFacilityId) &&
            Number(p?.facility_id) !== Number(currentFacilityId)

          const shouldApply = shouldApplyByFacility || p?.indexId === productIndexId

          if (!shouldApply) return p
          return {
            ...p,
            delivery_installation: {
              delivery_type_id: Number(complete_status),
              installer_facility_id: Number(installerFacility?.id),
              installer_facility_name: installerFacility?.name,
            },
          }
        }),
      )

        // Update selected services in a similar manner as products
      setAdditionalSelectedServices((prev) =>
        (prev || []).map((s) => {
          // Apply to all services from the same facility as the one being edited
          const shouldApplyByFacility =
            productFacilityId != null &&
            Number(s?.facility_id) === Number(productFacilityId) &&
            Number(s?.facility_id) !== Number(currentFacilityId);

          const shouldApply = shouldApplyByFacility || s?.indexId === productIndexId;

          if (!shouldApply) return s;
          return {
            ...s,
            delivery_installation: {
              delivery_type_id: Number(complete_status),
              installer_facility_id: Number(installerFacility?.id),
              installer_facility_name: installerFacility?.name,
            },
          }
        }),
      )

      closeDeliveryInstallDialog()
    }

    // Normal sales order: save delivery_type_id and set installer_facility_id to currentFacilityId
    // Edit mode: apply only to the specific product/service; Set mode: apply to all from same facility
    const saveDeliveryTypeSelection = () => {
      const { productIndexId, productFacilityId, complete_status, isEditMode, itemType } = deliveryInstallDialog

      if (!productIndexId) return

      if (![1, 2, 3].includes(Number(complete_status))) {
        enqueueSnackbar('Please choose Installs / Pickup / Shipping', {
          variant: 'error',
        })
        return
      }

      // Get current facility info for installer_facility_id and installer_facility_name
      const currentFacility = getFacilityOption(currentFacilityId)

      // Single-item edit only when: Edit mode AND not split order AND not project category 12
      const useSingleItemEdit = isEditMode && !isSplitOrder && values?.project_categories?.id !== 12

      if (useSingleItemEdit) {
        // Edit: apply only to the specific item that was clicked
        if (itemType === 'product') {
          setSelectedProducts((prev) =>
            (prev || []).map((p) =>
              p?.indexId === productIndexId
                ? {
                    ...p,
                    delivery_installation: {
                      ...(p.delivery_installation || {}),
                      delivery_type_id: Number(complete_status),
                      installer_facility_id: Number(currentFacilityId),
                      installer_facility_name: currentFacility?.name || null,
                    },
                  }
                : p,
            ),
          )
        } else {
          setAdditionalSelectedServices((prev) =>
            (prev || []).map((s) =>
              s?.indexId === productIndexId || s?.newIndexId === productIndexId
                ? {
                    ...s,
                    delivery_installation: {
                      ...(s.delivery_installation || {}),
                      delivery_type_id: 1,
                      installer_facility_id: Number(currentFacilityId),
                      installer_facility_name: currentFacility?.name || null,
                    },
                  }
                : s,
            ),
          )
        }
      } else {
        // Initial Set: apply to all products/services from the same facility
        setSelectedProducts((prev) =>
          (prev || []).map((p) => {
            const shouldApplyByFacility =
              productFacilityId != null &&
              Number(p?.facility_id) === Number(productFacilityId)

            const shouldApply = shouldApplyByFacility || p?.indexId === productIndexId

            if (!shouldApply) return p

            return {
              ...p,
              delivery_installation: {
                ...(p.delivery_installation || {}),
                delivery_type_id: Number(complete_status),
                installer_facility_id: Number(currentFacilityId),
                installer_facility_name: currentFacility?.name || null,
              },
            }
          }),
        )

        setAdditionalSelectedServices((prev) =>
          (prev || []).map((s) => {
            const shouldApplyByFacility =
              productFacilityId != null &&
              Number(s?.facility_id) === Number(productFacilityId)

            const shouldApply = shouldApplyByFacility || s?.indexId === productIndexId

            if (!shouldApply) return s

            return {
              ...s,
              delivery_installation: {
                ...(s.delivery_installation || {}),
                delivery_type_id: 1,
                installer_facility_id: Number(currentFacilityId),
                installer_facility_name: currentFacility?.name || null,
              },
            }
          }),
        )
      }

      closeDeliveryInstallDialog()
    }

    const handleMaterialStockCheck = async (material) => {
      setPendingMaterial(material);
      setStockType(1); // default to Finished
      setConvertionUnit(0);
      setPartialProducts([]);

      // if (material.inhouse !== 1) {
      //   enqueueSnackbar('Only inhouse materials can be stocked', { variant: 'warning' });
      //   return;
      // }

      try {
        const res = await axios.post(`${REST_API_END_POINT}product/get-partial-finished-products-stock-by-unit`, { editId: material?.id });
        const productListData = res.data.results;
        setPartialProducts(productListData || []);
      } catch (err) {
        console.error(err);
        setPartialProducts([]);
      } finally {
        openDialogs(); // open the stockType dialog
      }
    };
const handleSubmitPopUp = () => {
  if (!pendingMaterial) return;

  const normalizedId = pendingMaterial.product_id || pendingMaterial.id;
  
  if (stockType === 2 && !convertionUnit) {
    enqueueSnackbar('Please choose a conversion unit', { variant: 'error' });
    return;
  }

const alreadyAdded = selectedMaterials.some((item) => {
  const sameProduct = (item.product_id || item.id) === normalizedId;
  const sameStock = item.stock_type === stockType;

  if (!sameProduct || !sameStock) return false;

  // ❌ Prevent Finished duplicate
  if (stockType === 1) return true;

  // ❌ Prevent *any* other Partial for same product
  if (stockType === 2) return true;

  return false;
});

  if (alreadyAdded) {
    enqueueSnackbar('Material Already Added', { variant: 'error' });
    return;
  }

  let initial_max_price = 0;  
  let unit = 4;
  let quantity = 1;
  
  if (stockType === 1) {
    console.log("qqqqqqqqqqqqqqqqqqq",pendingMaterial);
    initial_max_price = pendingMaterial.max_price || pendingMaterial.special_price;
    unit = pendingMaterial.unit || 4;
    console.log("qqqqqqqqqqqqqqqqqqq",initial_max_price);
  } else {
    console.log("qqqqqqqqqqqqqqqqqqq",partialProducts);
    const selectedUnitData = partialProducts.find(p => p.partial_unit === convertionUnit);
    if (!selectedUnitData || selectedUnitData.total_qty <= 0) {
      return enqueueSnackbar('No Partial Stock Available', { variant: 'error' });
    }
    initial_max_price = selectedUnitData.max_unit_cost || 0;
    unit = selectedUnitData.partial_unit || 4;
    console.log("qqqqqqqqqqqqqqqqqqq",initial_max_price);
  }
let price = initial_max_price;
  const newMaterial = {
    ...pendingMaterial,
    quantity: 1,
    price,
    unit,
    stock_type:stockType,
    convertion_unit:convertionUnit,
    initial_max_price,
    adj_value_type: true,
  };
  console.log("newMaterial============",newMaterial);
  
  const additionalRows = selectedMaterials.filter(item => item.isAdditionalProduct === true);
  // const finalMaterialList = [
  //   ...pendingAutocompleteMaterials.filter(m => m.id !== pendingMaterial.id),
  //   newMaterial
  // ];
  const finalMaterialList = [
    ...pendingAutocompleteMaterials.filter(m =>
      !(
        m.id === pendingMaterial.id &&
        m.stock_type === stockType &&
        (stockType === 1 || m.convertion_unit === convertionUnit)
      )
    ),
    newMaterial
  ];
  setFieldValue('additionalMaterials', finalMaterialList);
  setPendingAutocompleteMaterials(finalMaterialList); // ✅ Keeps Autocomplete in sync
  handleMaterial(finalMaterialList);

  // ✅ Reset dialog-related state
  setPendingMaterial(null);
  setPartialProducts([]);
  setStockType(1);
  setConvertionUnit(0);
  closeDialog(); // ✅ Close the stock type dialog
};

  
    const closeDialog=()=>{
      setOpenDialog(false);
    }
    const openDialogs=()=>{
      setOpenDialog(true);
    }

    const NewUserSchema = Yup.object().shape({
        // name: Yup.string().required('Name is required'),
        // description: Yup.string().required('Description is required'),
        // address: Yup.string().required('Address is required'),
        // city: Yup.string().required('City is required'),
        // state: Yup.string().required('State is required'),
        // zip: Yup.string().required('Zip/Postal Code is required'),
        // skills:userType!=3 && Yup.array().min(1, 'Skill is required'),
        // clients:userType!=3 && Yup.array().min(1, 'Clients is required'),
        clients: userType != 3 && Yup.object().nullable().required('Clients is required'),
        // workflows:userType!=3 && Yup.array().min(1, 'workflow is required'),
        start: Yup.mixed().required('Start Date is required'),
        end: Yup.date()
          .nullable()
          .transform((value, originalValue) => {
            return originalValue ? new Date(originalValue * 1000) : null;
          })
          .when('start', (start, schema) => {
            return start
              ? schema.min(
                start,
                'Installation Date must be greater than the Start Date'
              )
              : schema;
          }),
        products: userType != 3 && Yup.array(),
        //.min(1, 'At least one product is required')
        // services:userType!=3 && Yup.array(), 
        project_type: userType != 3 && Yup.object().nullable().required('Job Class is required'),
        markup_type: userType != 3 && Yup.object().nullable().required('Please select the markup type'),
        project_categories: userType != 3 && Yup.object().nullable().required('Job Type is required'),
        map_service: Yup.mixed().when('project_categories', {
          is: (project_categories) => userType !== 3 && project_categories?.id == 14,
          then: Yup.object().nullable().required('Please select the map service'),
          otherwise: Yup.mixed().nullable(),
        }),
        community: userType != 3 
          ? Yup.object().nullable().required('Project is required,Enable projects for client')
          : Yup.object().nullable().required('Project is required'),
        billing_type: Yup.object().nullable(),
    });
    
    const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    // color: theme.palette.text.secondary,
    //   marginBottom: theme.spacing(1)
    }));

    const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    // color: theme.palette.text.secondary,
    }))
    
    const load = useLocation().state

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: '',
            po_number: '',
            description: '',
            notes: '',
            // skills: [],
            clients: null,
            // workflows:[],
            start: toDateOnlyUnix(currentDate) ?? localTodayDateOnlyUnix(),
            end: toDateOnlyUnix(currentDate) ?? localTodayDateOnlyUnix(),
            installation_start_date: null,
            installation_end_date: null,
            // avatarUrl: [],
            products: [],
            services: [],
            additionalMaterials: [],
            labour_cost: 0,
            budget: 0,
            sub_total: 0,
            invoice_discount: null,
            welcome_message: null,
            draft: null,
            client_approve: userType !==3 ? false : true,
            manager_approval_required: false,
            show_install_price: 1,
            rush_fee: 0,
            rush_fee_amount: 0,
            // is_single_card: true,
            total: 0,
            taxAmount: 0,
            subject: null,
            email_content: null,
            map_service: null,
            catalog_type: null,
            split_catalog_type: splitOrderCatalogTypes.find((type) => type.id === 'all'), // Default to "All"
            project_categories: null,
            project_type: null,
            markup_type:  markupTypes[1] ||null,
            no_charge_type: null,
            community: null,
            bill_to: '',
            ship_to: '',
            // address:null,
            // city:null,
            // state:null,
            // zip:null,
            rfp:null,
            is_split:null,
            facility_type: [],
             billing_type: null,
             customerTypeId: null,
        },
        validationSchema: NewUserSchema,
        onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
        
            try {
              if(depositAndProgressBilling && Math.max((Number(grandTotal) || 0) - getDepositProgressBillingTotal(), 0).toFixed(2) !== '0.00'){
              
                return enqueueSnackbar('Total deposit amount should be equal to grand total', { variant: 'error' });
              }
            setIsSubmitted(true);
            const newErrors = {};

            if (!nameFileds?.name?.trim()) {
              newErrors.name = 'Name is required.';
            }
            if (!nameFileds?.description?.trim()) {
              newErrors.description = 'Description is required.';
            }

            if (Object.keys(newErrors).length > 0) {

              setFieldErrors(newErrors)
              return;
            }

            values.name = nameFileds?.name || '';
            values.po_number = nameFileds?.po_number || '';
            values.description = nameFileds?.description || '';
            values.notes = nameFileds?.notes || '';
            values.bill_to = billToInputValue;
            values.ship_to = shipToInputValue;
            if (!values?.bill_to?.trim()) {
              values.bill_to = buildMultilineAddress(
                values?.clients?.name || values?.clients?.customer_name || '',
                values?.clients?.address || values?.clients?.customer_address || '',
                values?.clients?.city || values?.clients?.customer_city || '',
                values?.clients?.state || values?.clients?.customer_state || '',
                values?.clients?.zip || values?.clients?.customer_zipcode || values?.clients?.zip_code || '',
              );
            }
            if (!values?.ship_to?.trim()) {
              values.ship_to = buildMultilineAddress(
                values?.community?.name || '',
                values?.community?.address || '',
                values?.community?.city || '',
                values?.community?.state || '',
                values?.community?.zip || '',
              );
            }
            // No charge reason is collected inline when job type is No Charge (no popup)
            if (values.project_categories?.id === 13 && !noChargeReason.trim()) {
              setNoChargeReasonError(true);
              enqueueSnackbar('Please enter the no charge reason.', { variant: 'error' });
              setSubmitting(false);
              return;
            }

            // if(values.project_categories?.name == 'Time & Material'){
              // Filter out items with id == 10 when project_categories.id !== 11
              const filteredAdditionalServices = values.project_categories?.id !== 11 
                ? additionalSelectedServices.filter(item => item.id !== 10)
                : additionalSelectedServices;

              const hasEmptyProductName = selectedProducts?.some(product => product.name.trim() === '');
              const hasEmptyServiceName = filteredAdditionalServices?.some(product => product.name.trim() === '');
              const hasEmptyMaterialName = selectedMaterials?.some(product => product.name.trim() === '');

              // Check if all products have attachments
              // const productsWithoutAttachments = selectedProducts?.filter(product => {
              //   const attachments = productAttachments[product.indexId] || [];
              //   return attachments.length === 0;
              // });

              // if (productsWithoutAttachments && productsWithoutAttachments.length > 0) {
              //   enqueueSnackbar('Please upload image/PDF for all selected products/catalogs.', { variant: 'error' });
              //   return;
              // }

              if(selectedProducts?.length ==0 && additionalSelectedServices?.length == 0 && selectedMaterials?.length ==0 && userType !==3){
                enqueueSnackbar(values?.project_categories?.id == 11 || values?.project_categories?.id == 12 ? 'Please add at least one service.' : 'Please add at least one product or service.', { variant: 'error' });
                return;
              }
              
              const areAllAdditionalServicesTasks = filteredAdditionalServices.every(item => item.makeAsTask === 0);
              const hasMixedMakeAsTask = !filteredAdditionalServices.every(item => item.makeAsTask === 0 || item.makeAsTask === 1) ||
                (filteredAdditionalServices.some(item => item.makeAsTask === 0) &&
                filteredAdditionalServices.some(item => item.makeAsTask === 1));

              const areAllAdditionalServicesJobCost = filteredAdditionalServices.every(item => item.jobCost === 0);
              const hasMixedMakeJobCost = !filteredAdditionalServices.every(item => item.jobCost === 0 || item.jobCost === 1) ||
                (filteredAdditionalServices.some(item => item.jobCost === 0) &&
                filteredAdditionalServices.some(item => item.jobCost === 1));
              
              const areAllAdditionalServicesInstalls = filteredAdditionalServices.every(item => item.makeInstallCard === 0);
              const hasMixedMakeInstalls = !filteredAdditionalServices.every(item => item.makeInstallCard === 0 || item.makeInstallCard === 1) ||
                (filteredAdditionalServices.some(item => item.makeInstallCard === 0) &&
                filteredAdditionalServices.some(item => item.makeInstallCard === 1));
              
              // 🛑 Block submission if all tasks are off
              const additionalAllOff = filteredAdditionalServices?.length > 0 && filteredAdditionalServices.every(item => item?.makeInstallCard === 0);

              const cartServiceAllOff = cartService?.length > 0 && cartService.every(item => item?.makeInstallCard_lcs === 0);

              const allInstallCardsOff = (additionalAllOff || !filteredAdditionalServices?.length) && (cartServiceAllOff || !cartService?.length);
              let noServiceNoTask = false;
              // 🛑 Block submission if Service Only job and all tasks are off
              if (values?.project_categories?.id == 11 && allInstallCardsOff && selectedProducts?.length ==0) {
                noServiceNoTask = true;
                // setShowMakeTaskErrorDialog(true);
                // return;
              }
              // 🛑 Block submission if T&M job and no products and material is there and all tasks are off
              if (
                values?.project_categories?.id == 12 &&
                selectedProducts?.length === 0 &&
                selectedMaterials?.length === 0 &&
                allInstallCardsOff
              ) {
                // noServiceNoTask = true;
                noServiceNoTask = false;
                // setShowMakeTaskErrorDialog(true);
                // return;
              }
              // 🛑 Block submission if No Charge job and no products and material is there and all tasks are off
              if (
                values?.project_categories?.id == 13 &&
                selectedProducts?.length === 0 &&
                selectedMaterials?.length === 0 &&
                allInstallCardsOff
              ) {
                noServiceNoTask = true;
                // setShowMakeTaskErrorDialog(true);
                // return;
              }

              // Use this condition inside your if-block
              if (!confirmMakeTask && (areAllAdditionalServicesTasks || areAllAdditionalServicesInstalls || areAllAdditionalServicesJobCost) && !hasMixedMakeAsTask && !hasMixedMakeInstalls && !hasMixedMakeJobCost && filteredAdditionalServices.length > 0 && userType != 3) {
                  setOpenMakeTaskDialog(true); // your state for opening dialog
                  return;
              }

              if (hasEmptyProductName) {
                enqueueSnackbar('Please fill in all required product names.', { variant: 'error' });
                return;
              }
              if (hasEmptyServiceName) {
                enqueueSnackbar('Please fill in all required service names.', { variant: 'error' });
                return;
              }
              if (hasEmptyMaterialName) {
                enqueueSnackbar('Please fill in all required material names.', { variant: 'error' });
                return;
              }

              // ✅ Split-order validation: for products from OTHER facilities, Delivery & Installation must be set
              if (isSplitOrder && (Array.isArray(selectedProducts) && selectedProducts.length > 0 || Array.isArray(additionalSelectedServices) && additionalSelectedServices.length > 0)) {
                console.log('selectedProducts1', selectedProducts);
                console.log('values?.services1', additionalSelectedServices);
                const missingDelivery = selectedProducts.filter((p) => {
                  if (Number(p?.facility_id) === Number(currentFacilityId)) return false; // only other-facility products
                  const di = p?.delivery_installation || {};
                  const deliveryTypeId = Number(di?.delivery_type_id || di?.complete_status || 0);
                  const installerFacilityId = Number(di?.installer_facility_id || 0);
                  return !deliveryTypeId || !installerFacilityId;
                });
                const missingDeliveryServices = additionalSelectedServices?.filter((p) => {
                  if (Number(p?.facility_id) === Number(currentFacilityId)) return false; // only other-facility products
                  const di = p?.delivery_installation || {};
                  const deliveryTypeId = Number(di?.delivery_type_id || di?.complete_status || 0);
                  const installerFacilityId = Number(di?.installer_facility_id || 0);
                  return !deliveryTypeId || !installerFacilityId;
                });
                console.log('missingDelivery', missingDelivery);
                console.log('missingDeliveryServices', missingDeliveryServices);
                if (missingDelivery.length > 0 || missingDeliveryServices.length > 0) {
                  // const preview = missingDelivery
                  //   .slice(0, 5)
                  //   .map((p) => `#${p?.indexId}${p?.name ? ` (${p.name})` : ''}`)
                  //   .join(', ');

                  enqueueSnackbar(
                    `Please set Delivery & Installation (facility + type) for other-facility products`,
                    // `Please set Delivery & Installation (facility + type) for other-facility products: ${preview}${missingDelivery.length > 5 ? ` +${missingDelivery.length - 5} more` : ''}`,
                    { variant: 'error' },
                  );

                  // Optional: open the picker for the first missing product to speed up fixing
                  try {
                    openDeliveryInstallDialog(missingDelivery[0] || missingDeliveryServices[0]);
                  } catch (e) {
                    // no-op: keep submit blocked with snackbar error
                  }

                  return;
                }
              }
              const allServicesMatchCondition = additionalSelectedServices?.every(
                (service) => service.makeAsTask === 0 && service.makeInstallCard === 0
              );
              // ✅ Normal sales order validation: for ALL products/services, Delivery Type must be set
              // if (!isSplitOrder && (Array.isArray(selectedProducts) && selectedProducts.length > 0 || Array.isArray(additionalSelectedServices) && additionalSelectedServices.length > 0)) {
                if (
                  !isSplitOrder && 
                  (
                    (Array.isArray(selectedProducts) && selectedProducts.length > 0) || 
                    (Array.isArray(additionalSelectedServices) && additionalSelectedServices.length > 0)
                  ) && 
                  !(allServicesMatchCondition && values.project_categories?.id === 11)
                ) {  
              const missingDelivery = selectedProducts.filter((p) => {
                  const di = p?.delivery_installation || {};
                  const deliveryTypeId = Number(di?.delivery_type_id || di?.complete_status || 0);
                  return !deliveryTypeId;
                });
                const missingDeliveryServices = additionalSelectedServices?.filter((p) => {
                  const di = p?.delivery_installation || {};
                  const deliveryTypeId = Number(di?.delivery_type_id || di?.complete_status || 0);
                  return !deliveryTypeId;
                });
                console.log('missingDelivery (normal sales order)', missingDelivery);
                console.log('missingDeliveryServices (normal sales order)', missingDeliveryServices);
                if (missingDelivery.length > 0 || missingDeliveryServices.length > 0) {
                  enqueueSnackbar(
                    `Please set Installation type (Installs/Pickup/Shipping) for all products and services`,
                    { variant: 'error' },
                  );

                  // Optional: open the picker for the first missing product to speed up fixing
                  try {
                    const firstMissing = missingDelivery[0] || missingDeliveryServices[0];
                    const itemType = missingDelivery[0] ? 'product' : 'service';
                    openDeliveryTypeDialog(firstMissing, itemType);
                  } catch (e) {
                    // no-op: keep submit blocked with snackbar error
                  }

                  return;
                }
              }
              const hasInvalidProductName = selectedProducts?.filter(item=>item?.isAdditionalProduct == true)?.some(product => {
                const trimmedName = product.name.trim();
                if (trimmedName === '.') {
                  enqueueSnackbar('Product name cannot be just a dot.', { variant: 'error' });
                  return true;
                }
                if (trimmedName === '-') {
                  enqueueSnackbar('Product name cannot be just a hyphen.', { variant: 'error' });
                  return true;
                }
                // if (!/^[a-zA-Z0-9\s-]+$/.test(trimmedName)) {
                //   enqueueSnackbar('Product name can only contain letters, numbers, and hyphens.', { variant: 'error' });
                //   return true;
                // }
                if (/[:]/.test(trimmedName)) {
                  enqueueSnackbar('Product name cannot contain colon (:).', { variant: 'error' });
                  return true;
                }
                if (trimmedName[0] === '.') {
                  enqueueSnackbar('Product name cannot start with a dot.', { variant: 'error' });
                  return true;
                }
                if (trimmedName[0] === '-') {
                  enqueueSnackbar('Product name cannot start with a hyphen.', { variant: 'error' });
                  return true;
                }
                if (trimmedName === '') {
                  enqueueSnackbar('Product name cannot be empty or just spaces.', { variant: 'error' });
                  return true;
                }
                return false;
              });
              
              const hasInvalidServiceName = filteredAdditionalServices?.filter(item=>item?.isAdditionalProduct == true)?.some(product => {
                const trimmedName = product.name.trim();
                if (trimmedName === '.') {
                  enqueueSnackbar('Service name cannot be just a dot.', { variant: 'error' });
                  return true;
                }
                if (trimmedName === '-') {
                  enqueueSnackbar('Service name cannot be just a hyphen.', { variant: 'error' });
                  return true;
                }
                if (/[:]/.test(trimmedName)) {
                  enqueueSnackbar('Service name cannot contain colon (:).', { variant: 'error' });
                  return true;
                }                
                if (trimmedName[0] === '.') {
                  enqueueSnackbar('Service name cannot start with a dot.', { variant: 'error' });
                  return true;
                }
                if (trimmedName[0] === '-') {
                  enqueueSnackbar('Service name cannot start with a hyphen.', { variant: 'error' });
                  return true;
                }
                if (trimmedName === '') {
                  enqueueSnackbar('Service name cannot be empty or just spaces.', { variant: 'error' });
                  return true;
                }
                return false;
              });
              
              const hasInvalidMaterialName = selectedMaterials?.filter(item=>item?.isAdditionalProduct == true)?.some(product => {
                const trimmedName = product.name.trim();
                if (trimmedName === '.') {
                  enqueueSnackbar('Material name cannot be just a dot.', { variant: 'error' });
                  return true;
                }
                if (trimmedName === '-') {
                  enqueueSnackbar('Material name cannot be just a hyphen.', { variant: 'error' });
                  return true;
                }
                if (/[:]/.test(trimmedName)) {
                  enqueueSnackbar('Material name cannot contain colon (:).', { variant: 'error' });
                  return true;
                }                
                if (trimmedName[0] === '.') {
                  enqueueSnackbar('Material name cannot start with a dot.', { variant: 'error' });
                  return true;
                }
                if (trimmedName[0] === '-') {
                  enqueueSnackbar('Material name cannot start with a hyphen.', { variant: 'error' });
                  return true;
                }
                if (trimmedName === '') {
                  enqueueSnackbar('Material name cannot be empty or just spaces.', { variant: 'error' });
                  return true;
                }
                return false;
              });
              
              if (hasInvalidProductName || hasInvalidServiceName || hasInvalidMaterialName) {
                // enqueueSnackbar('Product names must contain letters or numbers.', { variant: 'error' });
                return;
              }

              // 🛑 Block if only proposal service or proposal exists and project_category is invalid
              if (
                selectedProducts?.length <= 0 &&
                selectedMaterials?.length <= 0 &&
                additionalSelectedServices?.length <= 0 &&
                (cartService?.length > 0 || cart?.length > 0)
              ) {
                if(values.project_categories?.id == 11) {
                  enqueueSnackbar("Please choose at least one additional service.",{ variant: 'error' });
                }else if(values.project_categories?.id == 12 || values.project_categories?.id == 13) {
                  enqueueSnackbar("Please choose at least one additional service or catalog or material.",{ variant: 'error' });
                }else{
                  enqueueSnackbar("Please choose at least one catalog.", { variant: 'error' });
                }
                return;
              }

              if(selectedProducts?.length <= 0 && selectedMaterials?.length <= 0 && additionalSelectedServices?.length > 0 && values.project_categories?.id != 11 && values.project_categories?.id != 12 && values.project_categories?.id != 13 ) {
                enqueueSnackbar("Please select 'Service Only', 'Time & Material', or 'No Charge' as the job type or choose at least one catalog.", { variant: 'error' });
                return;
              }

              if(selectedProducts?.length <= 0 && additionalSelectedServices?.length <= 0 && selectedMaterials?.length > 0 && values.project_categories?.id != 12 && values.project_categories?.id != 13 && values.project_categories?.id != 15 ) {
                if(values.project_categories?.id == 11) {
                  enqueueSnackbar("You have selected 'Service Only'. Please choose at least one additional service or choose 'Time & Material' as the job type.",{ variant: 'error' });
                }else{
                  enqueueSnackbar("Please select 'Time & Material' as the job type or choose at least one catalog.", { variant: 'error' });
                }
                return;
              }

              if(selectedProducts?.length <= 0 && additionalSelectedServices?.length > 0 && selectedMaterials?.length > 0 && values.project_categories?.id != 11 && values.project_categories?.id != 12 && values.project_categories?.id != 13 ) {
                enqueueSnackbar("Please select 'Service Only' or 'Time & Material' as the job type or choose at least one catalog.", { variant: 'error' });
                return;
              }
            // }
            let user = JSON.parse(localStorage.getItem('user'));
           
            const userName = user.first_name;
            const clientsArray = values.clients ? [values.clients] : [];

            values.map_service = (values.project_type?.name == 'TS' && (values.project_categories && values.project_categories?.id == 14)) ? values.map_service : null

            values.clientsData = clientsArray
            // Filter out images from avatarUrl that are already in product/service attachments to avoid duplicates in database
            const allProductAttachmentUrls = Object.values(productAttachments).flat().map(f => f?.url).filter(Boolean);
            const allServiceAttachmentUrls = Object.values(serviceAttachments).flat().map(f => f?.url).filter(Boolean);
            const filteredAvatarUrl = avatarUrl.filter(
              (file) =>
                !allProductAttachmentUrls.includes(file.url) &&
                !allServiceAttachmentUrls.includes(file.url),
            );
            values.avatarUrl = filteredAvatarUrl
            values.productAttachments = productAttachments // Pass product attachments to backend
            values.serviceAttachments = serviceAttachments
            const productsForRushSave =
              selectedProducts?.length > 0 ? selectedProducts : (values.products || [])
            // Override alone is enough to keep rush_fee OFF under lead-time lock
            const canOverrideRushFeeLockSave = !!explodedPermissions?.some((permission) =>
              ['Override Rush Fee'].includes(permission),
            )
            if (isInstallBeforeRequiredLead(values, productsForRushSave)) {
              // Auto-ON unless override user explicitly toggled rush_fee off
              if (!(canOverrideRushFeeLockSave && Number(values.rush_fee) === 0)) {
                values.rush_fee = 1
              }
            }
            values.rush_fee_amount =
              values.rush_fee == 1
                ? parseFloat(
                    (
                      parseFloat(values.total || totalsum || 0) *
                      ((Number(companyProfileData?.rush_fee_percentage) || 0) / 100)
                    ).toFixed(2),
                  )
                : 0
            const markupTotal = markupType == 1 ? (((values.totalWholesalePrice - values.totalProductFormula) / values.totalProductFormula) * 100)?.toFixed(2) : (((values.totalRetailPrice - values.totalProductFormula) / values.totalProductFormula) * 100)?.toFixed(2)
            values.totalMarkup = markupTotal
            values.products = selectedProducts
            // const allServices = [...selectedServices, ...additionalSelectedServices];
             const allServices = [
          ...selectedServices.map(s => ({ ...s, quantityDifference: 0 })),
          ...additionalSelectedServices
        ];
            values.selectedServices = allServices
            values.additionalSelectedServices = additionalSelectedServices
            const servicesIdArray = allServices?.map(service => service.id);
            values.serviceData = servicesIdArray?.join(',')
            values.depositAndProgressBilling = depositAndProgressBilling
            values.depositProgressBillingRows = depositAndProgressBilling
              ? depositProgressBillingRows.reduce((rows, row) => {
                const title = row.title?.trim() || '';
                const remainingAmount = Math.max(
                  (Number(grandTotal) || 0) -
                    rows.reduce((sum, currentRow) => sum + (Number(currentRow.amount) || 0), 0),
                  0
                );
                const amount = Math.min(Number(row.amount) || 0, remainingAmount);

                if (title && amount > 0) {
                  rows.push({ title, amount });
                }

                return rows;
              }, [])
              : []

            const prodAddress= selectedProducts.reduce((acc, product) => {
                return [
                ...acc,
                ...product.addresses.map((address) => ({
                    ...address,
                    productId: product.id,
                    productIndex: product.indexId,
                    isService:0
                })),
                ];
            }, []);
            const serviceAddress= additionalSelectedServices?.reduce((acc, product) => {
                return [
                ...acc,
                ...product.addresses.map((address) => ({
                    ...address,
                    productId: product.id,
                    productIndex: product.indexId,
                    isService:1
                })),
                ];
            }, []);

            const combinedAddress = [...prodAddress,...serviceAddress]

            const addDataToOtherFacility = selectedProducts?.some(
              (product) => product?.facilityId !== currentFacilityId
            );

            const addDataToOtherFacilityServices = values?.selectedServices?.some(
              (service) => service?.facility_id !== currentFacilityId
            );
console.log('addDataToOtherFacilityServices', addDataToOtherFacilityServices)
console.log('selectedServicesselectedServices', values?.selectedServices)
// return;
            const targetedFacilityIds = isSplitOrder ? values?.facility_type?.filter(fac => !fac.default)?.map(fac => fac?.id) : [];  

            const submitIsNoChargeJob = values.project_categories?.id === 13 || noCharge;
            const submitHasNegativeMarketingAdjustment =
              (selectedProducts || []).some(
                (p) => p?.adj_value_type === false || p?.install_adj_value_type === false || p?.adj_value_type === 0 || p?.install_adj_value_type === 0,
              ) ||
              (additionalSelectedServices || []).some(
                (s) => s?.adj_value_type === false || s?.install_adj_value_type === false || s?.adj_value_type === 0 || s?.install_adj_value_type === 0,
              ) ||
              (selectedMaterials || []).some((m) => m?.adj_value_type === false || m?.adj_value_type === 0);
            const shouldSendManagerApproval = submitIsNoChargeJob || submitHasNegativeMarketingAdjustment;

            const requestData = {
                values,
                noServiceNoTask,
                userId,
                userType,
                isClient: !!(isClient || userType === 3),
                clientId: user?.partner_client_id || user?.client_id || null,
                partnerClientId: user?.partner_client_id || user?.client_id || null,
                userName,
                taxCategory : selectedTaxCategory?.id,
                allLocationSame,
                allServiceLocationSame,
                allRfpServiceLocationSame,
                allRfpProductsLocationSame,
                rfpProducts: cart,
                rfpServices: cartService,
                materials:selectedMaterials,
                address: combinedAddress,
                produtFormulaMaterial:produtFormulaMaterial,
                isSplitOrder,
                noChargeReason: noChargeReason,
                addDataToOtherFacility,
                targetedFacilityIds,
                addDataToOtherFacilityServices,
                salesRepName,
                salesRepId,
                manager_approval_required: false,
                collaborators: Array.isArray(collaborators) ? collaborators.map((c) => (typeof c === 'object' && c?.id != null ? c.id : c)).filter(Boolean).join(',') : (collaborators || ''),

                // address: (values.project_categories?.name == 'Service only' || values.project_categories?.name == 'Time & Material') ? serviceAddress : prodAddress
            };

            let isvalidationNotOk = false
            let isServicevalidationNotOk = false
            // if((values.project_categories?.name == 'Service only') || (values?.project_categories?.name == 'Time & Material')){
                isServicevalidationNotOk = additionalSelectedServices?.find(product => {
                if (product.addresses.length && product.addresses.some(obj =>
                    [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                )) {
                    return true
                } else {
                    return false
                }
                })
            // }
            if((values.project_categories?.name != 'Service only') && (values?.project_categories?.name != 'Time & Material')){
                isvalidationNotOk = selectedProducts?.find(product => {
                if (product.addresses.length && product.addresses.some(obj =>
                    [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                )) {
                    return true
                } else {
                    return false
                }
                })
            }
            const isvalidationNotOkRfp = cart?.find(product => {
                if (product.addresses.length > 0 && product.addresses.some(obj =>
                [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                )) {
                console.log("Validation failed for product:", product);
                return true;
                } else {
                console.log("Validation passed for product:", product);
                return false;
                }
            });

            let isvalidationNotOkRfpServices= false
            // if(values.project_categories?.name == 'Service only' || (values?.project_categories?.name == 'Time & Material')){
                isvalidationNotOkRfpServices = cartService?.find(product => {
                if (product.addresses.length > 0 && product.addresses.some(obj =>
                    [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                )) {
                    console.log("Validation failed for product:", product);
                    return true;
                } else {
                    console.log("Validation passed for product:", product);
                    return false;
                }
                });
            // }
            if(userType != 3 &&
                (values?.project_categories?.name == "Time & Material") &&
                // (cart.length <= 0 && cartService?.length <= 0 && additionalSelectedServices?.length <= 0 && selectedProducts?.length <= 0)
    (cartService?.length <= 0 && additionalSelectedServices?.length <= 0 && selectedMaterials?.length <=0 && selectedProducts?.length <= 0)
            ){
                enqueueSnackbar('Please choose atleast one product/ Service/ Proposal service', { variant: 'error' });
            }else if((values?.project_categories?.name != "Time & Material") && values.total <= 0 && userType != 3 && values.project_categories == 15){
                enqueueSnackbar('Please choose atleast one product/ service/ Proposal', { variant: 'error' });
            }else if (
                isvalidationNotOk || isServicevalidationNotOk ||
                isvalidationNotOkRfp || 
                // (isvalidationNotOkRfpServices && values.project_categories?.name == 'Service only' ) ||
                // (isvalidationNotOkRfpServices && values.project_categories?.name == 'Time & Material' )
                (isvalidationNotOkRfpServices && cartService?.length > 0 )
            ) {
                enqueueSnackbar('Please fill all the address fields', { variant: 'error' });
            } else {

            //   if(values?.project_categories?.name =="Time & Material"){
            //  const productResponse = await axios.post(`${REST_API_END_POINT}product/add-product-on-request`,{values})
            
            //  if(productResponse) {
            //   await axios.post(`${REST_API}webservice/request/add-request`, requestData)
            //   .then((res) => {
            //     setOpen(false);
            //     resetForm();
            //     setSelectedProducts([]);
            //     setSelectedMapserviceProducts([]);
            //     setSelectedServices([]);
            //     setAdditionalSelectedServices([])
            //     setFilteredServices([])
            //     setRfps([])
            //     setSelectedTaxCategory(null);
            //     setSelectedRfp(null)
            //     setRfpServices([])
            //     setRfpProducts([])
            //     setCart([])
            //     setCartService([])
            //     setSelectedMaterials([])
            //     setAvatarUrl([])
            //     enqueueSnackbar('Create success', { variant: 'success' });
            //   })
            //   .catch((errors) => {
            //     console.log(errors, 'error');
            //   });

            //  }   
            
            //   }else{
                // 🚀 PROGRESS TRACKING: Show progress modal and make API call
                setProgressRequestData(requestData);
                setShowProgressModal(true);
                
                // Wait for socket connection to establish and stabilize
                await new Promise(resolve => setTimeout(resolve, 2000));
                
                // Additional wait if socket is not ready yet
                if (!socketReady) {
                    console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
                    await new Promise(resolve => setTimeout(resolve, 1000));
                }
                
                await axios.post(`${REST_API}webservice/request/add-request`, requestData)
                .then((res) => {
                  // console.log("resssssssssssssssssssssssssssssssssssss",res);
                  const newRequestId = res?.data?.reqresult.data[0]?.id;
                   const name = res?.data?.reqresult.data[0]?.name;
            // console.log("resssssssssssssssssssssssssssssssssssssnewRequestId", newRequestId, name);
                   setOpenEmailModal(true);
                   handleOpenViewSalesOrder(newRequestId, name, true);
                    enqueueSnackbar('Create success', { variant: 'success' });
                    const reqResult = res?.data?.reqresult;
                      if (reqResult && Array.isArray(reqResult.data) && reqResult.data.length > 0) {
                          const partnerId = reqResult.data[0]?.rt_partner_id;
                          
                          if (requestData.values.project_categories?.name === "Time & Material" && requestData.values.client_approve === false && !isSplitOrder) {
                              handleConvertToJob(res?.data?.result,partnerId)
                          }
                      }
                    setOpen(false);
                    resetForm();
                    setSelectedProducts([]);
                    setSelectedMapserviceProducts([]);
                    setSelectedTaxCategory(null);
                    setSelectedServices([]);
                    setAdditionalSelectedServices([])
                    setFilteredServices([])
                    setRfps([])
                    setSelectedRfp(null)
                    setRfpServices([])
                    setRfpProducts([])
                    setCart([])
                    setCartService([])
                    setTabIndex(0)
                    setSelectedMaterials([])
                    setAvatarUrl([])
                    setCollaborators([])
                    setDepositAndProgressBilling(false)
                    setDepositProgressBillingRows([{ title: '', amount: '' }])
                    setShowProgressModal(false)
                  })
                .catch((errors) => {
                    console.log(errors, 'error');
                    setShowProgressModal(false);
                });

                // }
            
            }
            } catch (error) {
            console.error(error);
            }
        }
    });

    
    const handleCloseMakeTastDialog = () => {
      setOpenMakeTaskDialog(false)
   }

   const handleContinueMakeTastDialog = () => {
      setOpenMakeTaskDialog(false)
      setConfirmMakeTask(true)
   }

     const handleConvertJobToInstallation = async (id,requestPartnerId)=>{
       const user = JSON.parse(window.localStorage.getItem('user'))
   
       let selectedIds=id
       let request = true
       const response = await axios.post(`${REST_API_END_POINT}installation/convert-job-to-installation`,{selectedIds,userId,request,userType:userType , clientId:requestPartnerId})
       if(response.data.status==1){
          if(response.data.movedToInvoicing === 1){
          enqueueSnackbar("Moved to Invoicing successfully !", { variant: 'success' });
          setRenderCard(!renderCard)  
        }else{
            enqueueSnackbar("Job converted to Installation successfully !", { variant: 'success' });
            setRenderCard(!renderCard)
          }
       }
       else{
        enqueueSnackbar("Failed to converting the job !", { variant: 'error' });
       }
      //  else{
      //    // enqueueSnackbar("Installation Not Moved !", { variant: 'error' });
      //    fetchRequestDetailsNew()
      //    fetchRequestDetails()
      //  }
     }

    console.log('setSelectedProducts', selectedProducts)
    const handleConvertToJob = async (requestId,requestPartnerId) => {
      try {
        // setOpenConvertToRFQ(false);
        // setConvertToRFQ(true);
        // let requestPartnerId = details?.rt_partner_id
        let acceptStatus = 1
  
        const data = { requestId, requestPartnerId, acceptStatus, userId,projectCategoryId:values?.project_categories?.id }
        const res = await axios.post(`${REST_API}webservice/request/accept-or-reject-invoice`, data);
  
        if (res.data.status == 1) {
          // setConfirmInvoice(false)
          // setRejectInvoice(false)
          enqueueSnackbar('Job created successfully', { variant: 'success' });
          setRenderCard(!renderCard)

           if(res.data.allCreatedTask?.length <= 0 && values?.project_categories?.id !== 12 ){
          handleConvertJobToInstallation(requestId,requestPartnerId)
           }
          // fetchRequestDetailsNew()
          // fetchRequestDetails()
          // if(details?.job_category_name== "Service only" || details?.job_category_name == 11){
          //   handleConvertJobToInstallation(requestId)
          // }
        } else {
          // setConfirmInvoice(false)
          // setRejectInvoice(false)
          enqueueSnackbar('Failed to convert Sales Order to Job', { variant: 'error' });
        }
      } catch (error) {
        console.log(error, 'error in Converting Sales Order to job')
        // setConfirmInvoice(false)
        // setRejectInvoice(false)
        enqueueSnackbar('Server Error', { variant: 'error' })
      }
      // finally{
      //   setConvertToRFQ(false);
      // }
    }

    const VALUE = [
        { id: 1, value: 'Sl No.' },
        { id: 22, value: 'Qb' },
        { id: 2, value: 'Products' },
        { id: 3, value: 'Note' },
        { id: 19, value: 'Attachments' },
        { id: 4, value: 'Product Formula' },
        //  { id: 4, value: 'Product formula cost (Material cost + Service cost with markup)' },
        { id: 5, value: 'Product formula cost Each' },
        { id: 20, value: 'Markup (%)' },
        { id: 16, value: 'Incoming Percentage' },
        { id: 6, value: markupType ? ((markupType == 2 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
        { id: 7, value: markupType ? ((markupType == 1 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
        // { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
        // { id: 8, value: hasMarkupPermission ? 'Markup (%)' : null },
        // { id: 9, value: 'Unit' },
        { id: 10, value: 'Quantity' },
        { id: 18, value: pageSplitOrder ? 'Delivery & Installation' : 'Installation' },
        { id: 11, value: 'Location' },
        { id: 17, value: 'Marketing Adjustment Type' },
        { id: 12, value: 'Marketing Adjustment ' },
        // { id: 12, value: 'Discount' },
        { id: 13, value: 'Subtotal' },
        { id: 14, value: 'Product Total' },
        { id: 15, value: '' }
    ];
    
    const VALUE_TIME = [
        { id: 1, value: 'Sl No.' },
        { id: 2, value: 'Products' },
        { id: 3, value: 'Note' },
        { id: 4, value: 'Retail Price Each'},
        { id: 14, value: 'SPMA' },
        { id: 5, value: 'Unit' },
        { id: 6, value: 'Quantity' },
        { id: 7, value: 'Location' },
        { id: 11, value: 'Marketing Adjustment Type' },
        { id: 8, value: 'Marketing Adjustment ' },
        { id: 9, value: 'Subtotal' },
        { id: 10, value: '' }
    ];

    const VALUE_TIME_Preview = [
        { id: 1, value: 'Sl No.' },
        { id: 2, value: 'Products' },
        // { id: 3, value: 'Note' },
        { id: 4, value: 'Retail Price Each'},
        { id: 14, value: 'SPMA' },
        { id: 5, value: 'Unit' },
        { id: 6, value: 'Quantity' },
        // { id: 7, value: 'Location' },
        { id: 8, value: 'Marketing Adjustment' },
        { id: 9, value: 'Subtotal' },
        { id: 10, value: '' }
    ];

    // const VALUE_MATERIAL=[
    //     {id: 0, value: 'Material'},
    //     {id: 1, value: 'Unit Price'},
    //     {id: 2, value: 'Markup (%)'},
    //     {id: 3, value: 'Markup Cost (Unit)' },
    //     {id: 4, value: 'Quantity'},
    //     {id: 5, value: 'Product Formula Cost'},
    //     {id: 6, value: 'Total'},
    //     {id: 7, value: ''}
    // ]
    const VALUE_MATERIAL=[
      { id: -1, value: 'Sl No.' },
      { id: 22, value: 'Qb' },
        {id: 0, value: 'Material'},        
        {id: 8, value: 'Note'},
        {id: 9, value: 'Stock Type'},
        {id: 1, value: 'Unit Price'},
        {id: 2, value: 'Markup (%)'},
        {id: 3, value: 'Markup Cost (Unit)' },
        {id: 4, value: 'Quantity'},
        { id: 8, value: 'Marketing Adjustment Type' },
        { id: 9, value: 'Marketing Adjustment' },
        // {id: 5, value: 'Product Formula Cost'},
        {id: 6, value: 'Total'},
        {id: 7, value: ''}
    ]

    const VALUEPreview = [
        { id: 0, value: 'Sl No.' },
        { id: 1, value: 'Products & Notes' },
        // { id: 2, value: 'Product formula cost' }, // (Material cost + Service cost with markup)
        { id: 3, value: markupType ? ((markupType == 2 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
        { id: 4, value: markupType ? ((markupType == 1 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
        { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
        // { id: 5, value: hasMarkupPermission ? 'Markup (%)' : null },
        { id: 6, value: 'Unit  ' },
        { id: 7, value: 'Quantity' },
        { id: 8, value: 'Marketing Adjustment' },
        // { id: 8, value: 'Discount' },
        { id: 9, value: 'Subtotal' },
        { id: 10, value: '' }
    ]
    const VALUE_SERVICES = [
      { id: 0, value: 'Sl No.' },
      { id: 22, value: 'Qb' },
      { id: 1, value: 'Service Name' },
      { id: 2, value: 'Note' },
      { id: 19, value: 'Attachments' },
      { id: 3, value: 'Markup (%)' },
      { id: 4, value: 'Cost (Hourly)' },
      { id: 5, value: 'Markup Cost (Hourly)' },
      { id: 6, value: 'Hours' },
      { id: 18, value: pageSplitOrder ? 'Delivery & Installation' : 'Installation' },
      // { id: 7, value: 'Make As Task' },
      // { id: 8, value: 'Make Install Card' },
      { id: 9, value: 'Location' },
      // { id: 10, value: 'Product Formula Cost'},
      { id: 11, value: 'Additional Cost' },
      { id: 12, value: 'Total cost' },
      { id: 13, value: '' }
    ];

    const VALUE_RFP_Product = [
      { id: -1, value: 'Sl No.' },
      { id: 22, value: 'Qb' },
        { id: 0, value: 'Name' },
        { id: 1, value: 'Mark Up (%)' },
        { id: 2, value: 'Cost ' },
        { id: 3, value: 'Retail Price Each' },
        { id: 4, value: 'Unit' },
        { id: 5, value: 'Quantity' },
        // { id: 6, value: 'Product Formula Cost'},
        { id: 7, value: 'Total' },
        // { id: 8, value: 'Make As Task' },
        // { id: 9, value: 'Make Install Card' },
        { id: 10, value: 'Location' },
        { id: 11, value: '' }
    ];

    const VALUE_RFP = [
        { id: 0, value: ' Name' },
        { id: 1, value: 'Markup (%)' },
        { id: 2, value: 'Cost ' },
        { id: 3, value: 'Markup Cost (Hourly)' },
        { id: 4, value: 'Hours' },
        { id: 5, value: 'Total cost' },
        { id: 6, value: '' },
        { id: 7, value: '' }
    ];

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };
    
    // const addToCart = (item) => {
    // console.log("communitycommunitycommunity",values?.community)
    // let { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
    // let communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };
    // if (tabIndex === 0) {
    //     let addresses = [{
    //     id: 0,
    //     address: '',
    //     city: '',
    //     state: '',
    //     zip: '',
    //     }]
    //     setCartService([...cartService, { ...item,addresses: addresses }]);

    //     if(values?.community?.address  && values?.community?.city  && values?.community?.state  && values?.community?.zip){
    //     // Assign addresses using the utility function
    //     const newService = assignAddresses(cartService, item, allRfpServiceLocationSame, communityAddress);

    //     // Update the cartService state immutably
    //     setCartService([...cartService, newService]);
    //     }
    // }
    // else {
    //     let addresses = [{
    //     id: 0,
    //     address: '',
    //     city: '',
    //     state: '',
    //     zip: '',
    //     }]
    //     setCart([...cart, { ...item, addresses: addresses },]);

        
    // if(values?.community?.address  && values?.community?.city  && values?.community?.state  && values?.community?.zip){

    //     const newProduct = assignAddresses(cart, item, allRfpProductsLocationSame, communityAddress);
    //     setCart([...cart, newProduct]);
    // }

    // }
    
    //     communityAddress = { address: '', city: '', state: '', zip: '' };
    // setOpenModal(false);
    // setSelectedRfp(null);
    // setFieldValue('rfp',null)
    // if(allRfpServiceLocationSame){

    //     const commonAddress = cartService[0]?.addresses?.[0] || {
    //     address: '',
    //     city: '',
    //     state: '',
    //     zip: '',
    //     };

    //     setCartService(prevProducts =>
    //     prevProducts.map(product => ({
    //         ...product,
    //         addresses: product.addresses ? product.addresses.map(() => ({ ...commonAddress })) : [{ ...commonAddress }],
    //     }))
    //     );
    // }

    // if(allRfpProductsLocationSame) {


    //     const commonAddress = cart[0]?.addresses?.[0] || {
    //     address: '',
    //     city: '',
    //     state: '',
    //     zip: '',
    //     };

    //     setCart(prevProducts =>
    //     prevProducts.map(product => ({
    //         ...product,
    //         addresses: product.addresses ? product.addresses.map(() => ({ ...commonAddress })) : [{ ...commonAddress }],
    //     }))
    //     );

    // }
    // };

    // Utility function to assign addresses
    
    const addToCart = (item) => {
      console.log("itemitemitemitemitemitem", item);
  
      let { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
      let communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };
  
      if (tabIndex === 1) {
          // **For Services**
        let addresses = [{
          id: 0,
          address: '',
          city: '',
          state: '',
          zip: '',
        }];
        setCartService([...cartService, { ...item, addresses: addresses }]);
  
        if (values?.community?.address && values?.community?.city && values?.community?.state && values?.community?.zip) {
          // Assign addresses using utility function
          const newService = assignAddresses(cartService, item, allRfpServiceLocationSame, communityAddress);
          setCartService([...cartService, newService]);
        }
      } else {
        // **For Products**
        // Always start with a single location; toggle controls how many are shown later
        let addresses = [
          {
            id: 0,
            address: '',
            city: '',
            state: '',
            zip: '',
          },
        ];

        let newProduct = { 
          ...item, 
          is_single_card: true,
          allRfpProductsLocationSame: true, // Each product gets its own flag
          addresses,
        };

        setCart([...cart, newProduct]);

        if (values?.community?.address && values?.community?.city && values?.community?.state && values?.community?.zip) {
          newProduct = assignAddresses(cart, newProduct, newProduct.allRfpProductsLocationSame, communityAddress);
          setCart([...cart, newProduct]);
        }
      }
  
      communityAddress = { address: '', city: '', state: '', zip: '' };
      setOpenModal(false);
      setSelectedRfp(null);
      setFieldValue('rfp', null);
  
      // Keep cart items as created above; location count is controlled by the Qty Location toggle
    };
  
    const assignAddresses = (existingCart, newProduct, allLocationsSame, communityAddress) => {
    let assignedAddresses = [];

    if (allLocationsSame && existingCart.length > 0) {
        
        const commonAddress = existingCart[0].addresses[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
        };
        assignedAddresses = [{ ...commonAddress }];
    } else {
        
        assignedAddresses = [{
        id: 0,
        address: communityAddress.address,
        city: communityAddress.city,
        state: communityAddress.state,
        zip: communityAddress.zip,
        }];
    }

    return {
        ...newProduct,
        addresses: assignedAddresses,
    };
    };

    // const handleMaterial = (newValue) => {
    //   setSelectedMaterials((prevMaterials) => {
    //     const additionals = prevMaterials?.filter(item => item.isAdditionalProduct == true);
    //     return [...newValue, ...additionals];
    //   });
    // };

    const handleMaterial = (newValue) => {
      setSelectedMaterials((prevMaterials) => {
        const updatedNewValue = newValue.map((item) => {
          const existing = (prevMaterials || []).find((p) => {
            const sameBase =
              (p.product_id || p.id) === (item.product_id || item.id) &&
              Number(p.stock_type || 0) === Number(item.stock_type || 0);
            if (!sameBase) return false;
            if (Number(item.stock_type || 0) === 1) return true;
            return Number(p.convertion_unit || 0) === Number(item.convertion_unit || 0);
          });

          return {
            ...item,
            ...(existing || {}),
            quantity: existing?.quantity ?? item.quantity ?? 1,
            adj_value_type: existing?.adj_value_type ?? item.adj_value_type ?? true,
            adjustment: existing?.adjustment ?? item.adjustment ?? 0,
          };
        });
    
        // Filter out additional products
        const additionals = prevMaterials?.filter(item => item.isAdditionalProduct === true);
    
        // Return the new state with updated newValue and additional products
        return [...updatedNewValue, ...additionals];
      });
    };
    

    const handleDeleteService = (servId, indexId, deletedIndex) => {
      // const newFilteredServices = additionalSelectedServices?.filter(data => (data.indexId !== indexId));
      const newFilteredServices = additionalSelectedServices?.filter((data,index) => {
        console.log('handleDeleteService---deletedIndex', deletedIndex)
        console.log('handleDeleteService---index', index)
        if (data?.isAdditionalProduct) {
          return index != deletedIndex;
          // return data?.newIndexId !== indexId;
        }
        return index != deletedIndex;
        // return data?.id !== servId;
      });
      
      const newLocationStates = { ...serviceOnlyLocationStates };
      delete newLocationStates[indexId];
      setServiceOnlyLocationStates(newLocationStates);

      const newServiceAttachmentStates = { ...openServiceAttachment };
      delete newServiceAttachmentStates[indexId];
      setOpenServiceAttachment(newServiceAttachmentStates);

      const newServiceAttachments = { ...serviceAttachments };
      delete newServiceAttachments[indexId];
      setServiceAttachments(newServiceAttachments);

      // const allFilteredServices = filteredServices?.find(data => data.id !== servId);
      setFieldValue('services', newFilteredServices);
      setAdditionalSelectedServices(newFilteredServices);
    };
    
    const handleDeleteMaterial = (id, indexId, materialData = null) => {
    // const updatedMaterials = selectedMaterials.filter(data => (data.indexId !== indexId));
    const updatedMaterials = selectedMaterials?.filter((data) => {
      if (data?.isAdditionalProduct) {
        return data?.newIndexId !== indexId;
      }
      return data?.id !== id;
    });
    
    setSelectedMaterials(updatedMaterials);

    const deletedMaterial =
      materialData ||
      selectedMaterials?.find((item) =>
        item?.isAdditionalProduct
          ? item?.newIndexId === indexId
          : item?.id === id,
      );

    if (deletedMaterial && !deletedMaterial?.isAdditionalProduct) {
      setPendingAutocompleteMaterials((prev) => {
        const next = (prev || []).filter((item) => {
          const sameBase =
            (item?.product_id || item?.id) ===
              (deletedMaterial?.product_id || deletedMaterial?.id) &&
            Number(item?.stock_type || 0) ===
              Number(deletedMaterial?.stock_type || 0);
          if (!sameBase) return true;
          if (Number(item?.stock_type || 0) === 1) return false;
          return (
            Number(item?.convertion_unit || 0) !==
            Number(deletedMaterial?.convertion_unit || 0)
          );
        });
        setFieldValue('additionalMaterials', next);
        return next;
      });
    }
    };

    const isInCart = (item) => {
    console.log("######################Cart111New", item);
    console.log("######################Cart111", cart);
    return cart.some(cartItem => cartItem.product_id === item.product_id);
    };

    const isInCartService = (item) => {
    return cartService.some(cartItem => cartItem.id === item.id);
    };

    const closeModal = () => {
    setOpenModal(false);
    setFieldValue('rfp',null)
    };

    useEffect(() => {
        if (selectedProducts.length <= 0) {
          setAllLocationSame(false)
        }
        if (additionalSelectedServices.length <= 0) {
          setAllServiceLocationSame(false)
        }
        if (cart.length <= 0) {
          setAllRfpProductsLocationSame(false)
        }
        if (cartService.length <= 0) {
          setAllRfpServiceLocationSame(false)
        }
    }, [selectedProducts,additionalSelectedServices,cart,cartService])

    const handleDeleteRFPProduct = (productId) => {
    setCart(prevCart => prevCart.filter(item => item.id !== productId));
    };

    const handleDeleteRFPService = (productId) => {
    console.log("######################Cartde", productId);
    setCartService(prevCart => prevCart.filter(item => item.id !== productId));
    };
    
    const handleOpenNote = (indexId, note) => {
        setCurrentNote(note || '');
        setOpenProductNote((prev) => ({ ...prev, [indexId]: true }));
    };

    const handleCloseNote = (indexId) => {
        setOpenProductNote((prev) => ({ ...prev, [indexId]: false }));
        setCurrentNote('');
    };

    const handleOpenAttachment = (indexId) => {
        const key = String(indexId ?? '');
        const currentAttachments = productAttachments[key] || productAttachments[indexId] || [];
        setOpenProductAttachment((prev) => ({ ...prev, [indexId]: true }));
        setAttachmentTabValue((prev) => ({ ...prev, [indexId]: 0 }));
        setSelectedUploadedImages((prev) => ({ ...prev, [key]: [...currentAttachments] }));
    };

    const handleCloseAttachment = (indexId) => {
        setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }));
        setAttachmentTabValue((prev) => ({ ...prev, [indexId]: 0 }));
        setSelectedUploadedImages((prev) => ({ ...prev, [indexId]: [] }));
    };

    const handleAttachmentTabChange = (event, newValue, indexId) => {
        setAttachmentTabValue((prev) => ({ ...prev, [indexId]: newValue }));
    };

    const handleImageSelect = (file, indexId, isSelected) => {
        const key = String(indexId ?? '');
        setSelectedUploadedImages((prev) => {
            const current = prev[key] || prev[indexId] || [];
            if (isSelected) {
                if (current.some((f) => attachmentMatches(f, file))) return prev;
                return { ...prev, [key]: [...current, file] };
            }
            return { ...prev, [key]: current.filter((f) => !attachmentMatches(f, file)) };
        });
    };

    const handleAddSelectedImages = (indexId) => {
        const key = String(indexId ?? '');
        const selected = selectedUploadedImages[key] || selectedUploadedImages[indexId] || [];
        const original = productAttachments[key] || productAttachments[indexId] || [];
        const toLink = selected.filter((file) => !original.some((orig) => attachmentMatches(orig, file)));
        const toUnlink = original.filter((file) => !selected.some((sel) => attachmentMatches(sel, file)));
        if (toLink.length === 0 && toUnlink.length === 0) {
            setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }));
            return;
        }
        setProductAttachments((prev) => ({
            ...prev,
            [key]: selected.map((file) => ({ ...file, product_index_id: indexId })),
        }));
        setSelectedUploadedImages((prev) => ({ ...prev, [key]: [], [indexId]: [] }));
        setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }));
        enqueueSnackbar('Product attachments updated successfully', { variant: 'success' });
    };

    // Service attachment modal handlers (mirror products)
    const handleOpenServiceAttachment = (indexId) => {
        const key = String(indexId ?? '');
        const currentAttachments = serviceAttachments[key] || serviceAttachments[indexId] || [];
        setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: true }));
        setAttachmentTabValueService((prev) => ({ ...prev, [indexId]: 0 }));
        setSelectedUploadedImagesService((prev) => ({ ...prev, [key]: [...currentAttachments] }));
    };

    const handleCloseServiceAttachment = (indexId) => {
        setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: false }));
        setAttachmentTabValueService((prev) => ({ ...prev, [indexId]: 0 }));
        setSelectedUploadedImagesService((prev) => ({ ...prev, [indexId]: [] }));
    };

    const handleAttachmentTabChangeService = (event, newValue, indexId) => {
        setAttachmentTabValueService((prev) => ({ ...prev, [indexId]: newValue }));
    };

    const handleImageSelectService = (file, indexId, isSelected) => {
        const key = String(indexId ?? '');
        setSelectedUploadedImagesService((prev) => {
            const current = prev[key] || prev[indexId] || [];
            if (isSelected) {
                if (current.some((f) => attachmentMatches(f, file))) return prev;
                return { ...prev, [key]: [...current, file] };
            }
            return { ...prev, [key]: current.filter((f) => !attachmentMatches(f, file)) };
        });
    };

    const handleAddSelectedImagesService = (indexId) => {
        const key = String(indexId ?? '');
        const selected = selectedUploadedImagesService[key] || selectedUploadedImagesService[indexId] || [];
        const original = serviceAttachments[key] || serviceAttachments[indexId] || [];
        const toLink = selected.filter((file) => !original.some((orig) => attachmentMatches(orig, file)));
        const toUnlink = original.filter((file) => !selected.some((sel) => attachmentMatches(sel, file)));
        if (toLink.length === 0 && toUnlink.length === 0) {
            setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: false }));
            return;
        }
        setServiceAttachments((prev) => ({
            ...prev,
            [key]: selected.map((file) => ({ ...file, service_index_id: indexId })),
        }));
        setSelectedUploadedImagesService((prev) => ({ ...prev, [key]: [], [indexId]: [] }));
        setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: false }));
        enqueueSnackbar('Service attachments updated successfully', { variant: 'success' });
    };

    const handleNoteChange = (event) => {
        const newNote = event.target.value;
        if (newNote.length <= MAX_CHARACTERS) {
        setCurrentNote(newNote);
        }
        if (error) {
            setError(false);
        }
    };

    const handleSaveNote = (indexId) => {
      if (!currentNote.trim()) {
        setError('Note cannot be empty or just spaces');
        return; // Exit early if validation fails
      }
      setIsSavingNote(true);
      setTimeout(() => {
        setSelectedProducts((prev) =>
          prev.map((product) =>
            product.indexId === indexId
              ? { ...product, product_notes: currentNote }
              : product,
          ),
        );
        setIsSavingNote(false);
        handleCloseNote(indexId);
      }, 100);
    };

    // Clear product note and save empty value
    const handleClearNote = (indexId) => {
      setError(false);
      setIsClearingNote(true);
      setTimeout(() => {
        setSelectedProducts((prev) =>
          prev.map((product) =>
            product.indexId === indexId
              ? { ...product, product_notes: '' }
              : product,
          ),
        );
        setCurrentNote('');
        setIsClearingNote(false);
      }, 100);
    };

    // Service notes handlers
    const handleOpenServiceNote = (indexId, note) => {
        setCurrentNote(note || '');
        setOpenServiceNote((prev) => ({ ...prev, [indexId]: true }));
    };

    const handleCloseServiceNote = (indexId) => {
        setOpenServiceNote((prev) => ({ ...prev, [indexId]: false }));
        setCurrentNote('');
    };

    const handleServiceNoteChange = (event) => {
        const newNote = event.target.value;
        if (newNote.length <= MAX_CHARACTERS) {
            setCurrentNote(newNote);
        }
        if (error) {
            setError(false);
        }
    };

    const handleSaveServiceNote = (indexId) => {
      if (!currentNote.trim()) {
        setError('Note cannot be empty or just spaces');
        return; // Exit early if validation fails
    }
        setIsSavingNote(true);
        setTimeout(() => {
            // Update selectedServices
            setSelectedServices((prev) =>
                prev.map((service) =>
                    service.indexId === indexId ? { ...service, service_notes: currentNote } : service
                )
            );
            // Update additionalSelectedServices
            setAdditionalSelectedServices((prev) =>
                prev.map((service) =>
                    service.indexId === indexId ? { ...service, service_notes: currentNote } : service
                )
            );
            // Update cartService
            setCartService((prev) =>
                prev.map((service) =>
                    service.indexId === indexId ? { ...service, service_notes: currentNote } : service
                )
            );
            setIsSavingNote(false);
            handleCloseServiceNote(indexId);
        }, 100);
    };

    // Clear service note and save empty value
    const handleClearServiceNote = (indexId) => {
      setError(false);
      setIsClearingNote(true);
      setTimeout(() => {
        setSelectedServices((prev) =>
          prev.map((service) =>
            service.indexId === indexId ? { ...service, service_notes: '' } : service
          )
        );
        setAdditionalSelectedServices((prev) =>
          prev.map((service) =>
            service.indexId === indexId ? { ...service, service_notes: '' } : service
          )
        );
        setCartService((prev) =>
          prev.map((service) =>
            service.indexId === indexId ? { ...service, service_notes: '' } : service
          )
        );
        setCurrentNote('');
        setIsClearingNote(false);
      }, 100);
    };

    // Install notes handlers
    const handleOpenInstallNote = (indexId, note) => {
        setCurrentNote(note || '');
        setOpenInstallNote((prev) => ({ ...prev, [indexId]: true }));
    };

    const handleCloseInstallNote = (indexId) => {
        setOpenInstallNote((prev) => ({ ...prev, [indexId]: false }));
        setCurrentNote('');
    };

    const handleSaveInstallNote = (indexId) => {
        if (!currentNote.trim()) {
            setError('Note cannot be empty or just spaces');
            return; // Exit early if validation fails
        }
        setIsSavingNote(true);
        setTimeout(() => {
            setSelectedProducts((prev) =>
                prev.map((product) =>
                    product.indexId === indexId ? { ...product, install_notes: currentNote } : product
                )
            );
            setIsSavingNote(false);
            handleCloseInstallNote(indexId);
        }, 100);
    };

// Material notes handlers
const handleOpenMaterialNote = (indexId, note) => {
  setCurrentNote(note || '');
  setOpenMaterialNote((prev) => ({ ...prev, [indexId]: true }));
  };
   
  const handleCloseMaterialNote = (indexId) => {
  setOpenMaterialNote((prev) => ({ ...prev, [indexId]: false }));
  setCurrentNote('');
  setError(false);
  };
   
  const handleSaveMaterialNote = (indexId) => {
  if (!currentNote.trim()) {
  setError('Note cannot be empty or just spaces');
  return; // Exit early if validation fails
  }
  setIsSavingNote(true);
  setTimeout(() => {
  setSelectedMaterials((prev) =>
  prev.map((material, idx) => {
  const materialId = material.newIndexId || idx;
  return materialId === indexId ? { ...material, material_notes: currentNote } : material;
  })
  );
  setIsSavingNote(false);
  handleCloseMaterialNote(indexId);
  }, 100);
  };
  // Clear material note and save empty value
  const handleClearMaterialNote = (indexId) => {
    setError(false);
    setIsClearingNote(true);
    setTimeout(() => {
      setSelectedMaterials((prev) =>
        prev.map((material) =>
          material.newIndexId === indexId ? { ...material, material_notes: '' } : material
        )
      );
      setCurrentNote('');
      setIsClearingNote(false);
    }, 100);
  };
    const handleRfpSelect = (event, value) => {

        if (!empty(value)) {
        setOpenModal(true);
        setSelectedRfp(value);
        console.log("########Services", value?.services);
        console.log("########Services cart", value?.products);

        // Sort RFP services alphanumerically by name
        const filteredRfpServices = value?.services?.filter(service => !isInCartService(service)) || [];
        const sortedRfpServices = [...filteredRfpServices].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        setRfpServices(sortedRfpServices);
        setRfpProducts(value?.products?.filter(product => !isInCart(product)) || []);
        }
    };
  
    const fetchAllMaterials = async () => {
        setLoadingCards(true)
        try {
        let user = JSON.parse(localStorage.getItem('user'))
        

        let whereCondition = '';
        if (currentTab == 'OPEN') {
            whereCondition = ` ((r.status=2) OR (r.status=3 AND r.min_payment_status=0)) `
        } else if (currentTab == 'ACCEPTED') {
            whereCondition = ` (r.status=3 AND r.min_payment_status =1) ` // r.status=4 OR 
        } else if (currentTab == 'IN PRODUCTION') {
            whereCondition = ` r.status=4 and i.status IS NULL `
        } else if (currentTab == 'INSTALLATION' ||currentTab =='PICKUP' || currentTab =='SHIPPING'  ) {
            let completeStatus = currentTab == 'INSTALLATION' ? 1: currentTab == 'PICKUP' ? 2 : 3
            // whereCondition = ` i.status IS NOT NULL AND ( COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) OR (pc.name = 'Service only' AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0)) ) `
            whereCondition = ` i.status IS NOT NULL AND i.status != 5 AND i.complete_status = ${completeStatus} AND ( 
              (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
              AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
            ) `
            // whereCondition = ` i.status IS NOT NULL AND i.status != 5 AND i.complete_status = ${completeStatus} AND ( 
            // COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) 
            // OR (pc.name = 'Service Only' AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0))
            // OR (COALESCE(cop.product_count, 0) = 0 AND COALESCE(rss.service_count, 0) > 0 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0))
            // ) `
        } else if (currentTab == 'COMPLETED') {
            whereCondition = ` i.status IS NOT NULL AND (
            (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
            AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0) ) `
            // whereCondition = ` i.status IS NOT NULL AND ( inst_counts.installation_count >= cop.product_count OR inst_counts.installation_count >= rss.service_count ) `
        }

        const formattedFrom = filterDateValue[0] ? moment(filterDateValue[0]).format('YYYY-MM-DD HH:mm:ss') : null;
        const formattedTo = filterDateValue[1] ? moment(filterDateValue[1]).format('YYYY-MM-DD HH:mm:ss') : null;

        const values = {
            userType: userType, userId: userId, page: page + 1, rowsPerPage, search: searching, where: whereCondition,
            sort:sort.id,
            from:formattedFrom,
            to:formattedTo,
            filterCommunity:filterCommunity
        }
        await axios.post(`${REST_API}webservice/request/get-all-request-for-add`, values)
            .then((res) => {
            setAllproducts(res.data.products)
            // setAllMaterials(res.data.materials)
            const allMatData = Array.isArray(res.data.materials)
              ? res.data.materials.map((material) => ({
                  ...material,
                  markup: Number(material.retail_price || 0),
                }))
              : []
            console.log('allMatData---',allMatData)
            const filteredMaterials = allMatData?.filter(item=>item.isAdditionalProduct == 0)
            // Sort materials alphanumerically by description (fallback to name)
            const sortedMaterials = [...(filteredMaterials || [])].sort((a, b) => {
              const aValue = a?.description || a?.name || '';
              const bValue = b?.description || b?.name || '';
              return alphanumericCompare(aValue, bValue);
            })
            setAllMaterials(sortedMaterials)
            // Sort labour cost services alphanumerically by name
            let currentInstallationServiceData = res?.data?.labourCostServices
            let otherInstallationServiceData = res?.data?.otherInstallationServices
            let combinedServices = [...(currentInstallationServiceData || []), ...(otherInstallationServiceData || [])];
            const sortedLabourCostServices = [...(combinedServices || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
            setLabourCostServices(sortedLabourCostServices)
            // Sort proposals alphanumerically by description
            const sortedProposals = [...(res.data.allProposals || [])].sort((a, b) => alphanumericCompare(a?.description || '', b?.description || ''))
            setRfps(sortedProposals)
            setFilteredServices(sortedLabourCostServices)
            })
            .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
            })
        }catch(error){
        console.log("fetchAllMaterials error : ",error)
        }finally{
        setLoadingCards(false)
        }
    }

    const fetchAllCommunityByClient = async (clientId) => {
        setIsCommunityLoading(true);
        try {
        clientId = clientId.id
        const res = await axios.post(`${REST_API}webservice/rfq/get-community-by-client`, { clientId,userType,From:"addSalesOrder",teamId })
        let data = res.data?.community
        let allCommunity = res.data?.allCommunity
        // Sort communities alphanumerically by name
        const sortedCommunities = [...(data || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        await setCommunities(sortedCommunities)
        setAllCommunities(allCommunity)
        } catch (error) {
        console.log(error, 'Error in fetching all clients');
        setCommunities([]);
        } finally {
        setIsCommunityLoading(false)
        }
    }

  const fetchAllCommunityByClientCommunity = async (clientObj, preselectCommunityId = null) => {
    setIsCommunityLoading(true);
    try {
      const clientId = clientObj.id;
      const res = await axios.post(`${REST_API}webservice/rfq/get-community-by-client`, { clientId,userType,From:"addSalesOrder",teamId });
      const data = res.data?.community || [];
      const allCommunity = res.data?.allCommunity || [];

      // Sort communities alphanumerically by name
      const sortedCommunities = [...data].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
      setCommunities(sortedCommunities);
      setAllCommunities(allCommunity);

      if (preselectCommunityId) {
        const alreadyInList = data.some(c => c.id === preselectCommunityId);

        if (!alreadyInList) {
          const matched = allCommunity.find(c => c.id === preselectCommunityId);
          if (matched) {
            const updatedCommunities = [...sortedCommunities, matched];
            const reSortedCommunities = [...updatedCommunities].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
            setCommunities(reSortedCommunities);
            setFieldValue('community', matched);
          }
        } else {
          const matched = sortedCommunities.find(c => c.id === preselectCommunityId);
          setFieldValue('community', matched);
        }
      }

    } catch (error) {
      console.log('Error fetching communities:', error);
      setCommunities([]);
    } finally {
      setIsCommunityLoading(false);
    }
  };

  // New function for client-specific project autocomplete
  const fetchClientSpecificProjects = async () => {
    console.log('fetchClientSpecificProjects called with:', { userId, userType, isClient, clientId: user?.client_id });
    setIsCommunityLoading(true);
    try {
      const res = await axios.post(`${REST_API}webservice/rfq/get-communities-for-client-autocomplete`, {
        userId: userId,
        userType: userType,
        isClient: isClient,
        clientId: user?.client_id
      });
      
      console.log('API response:', res.data);
      if (res.data?.status === 1) {
        setClientCommunities(res.data.data || []);
        console.log('Set clientCommunities to:', res.data.data);
      } else {
        setClientCommunities([]);
        console.log('API returned status 0, setting empty clientCommunities');
      }
    } catch (error) {
      console.log('Error fetching client-specific projects:', error);
      setClientCommunities([]);
    } finally {
      setIsCommunityLoading(false);
    }
  };


    const fetchAllMapServices = async () => {
        setMapServicesLoading(true);
        try {
        const res = await axios.post(`${REST_API}webservice/route/fetch-routes-with-locations`)
        let data = res.data?.routeData
        if(data){
            const newData = data?.filter((i) => i.locations != null)
            if(newData){
            setMapServices(newData);
            }else{
            setMapServices([]);
            }
        }else{
            setMapServices([]);
        }
        } catch (error) {
        setMapServices([]);
        console.log(error, 'Error in fetching map services');
        }finally {
        setMapServicesLoading(false)
        }
    }

    const fetchAllClients = async () => {    

        try {
        const res = await axios.post(`${REST_API}webservice/clients/getAllClients`, { userType, userId ,order:true,From:"addSalesOrder",teamId})
        let data = res.data?.customer
        await setAllClients(data) 
        } catch (error) {
        console.log(error, 'Error in fetching all clients', error)
        }
    }

    const fetchTeamMembersForCollaborators = async () => {
        setTeamMembersLoading(true);
        try {
            const res = await axios.post(`${REST_API_END_POINT}teams/get-all-teams-data-collaborators`, {
                usersId: userId,
                usersType: userType,
                isClient: isClient || false,
                page: 1,
                rowsPerPage: 5000,
                orderBy: 'name',
                order: 'asc',
            });
            const raw = res.data?.team_members?.data || res.data?.team_members || [];
            const list = Array.isArray(raw) ? raw : [];
            const filteredList = list.filter(member => member.userRole !== "Development" && member.user_type !== 51);
            setTeamMembersOptions(filteredList);
        } catch (error) {
            console.log(error, 'Error fetching team members for collaborators');
            setTeamMembersOptions([]);
        } finally {
            setTeamMembersLoading(false);
        }
    };
    
    const fetchTaxCategory = async () => {
        try{
            const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
            if(response.data.status === 1){
                setTaxCategories(response.data.taxResult);
            }else{
            setTaxCategories([])
            }
        }catch(error){
            console.log("Error - ",error);
            setTaxCategories([])
        }
    }

    useEffect(() => {
        if(open){
        // setFieldValue('markup_type', markupTypes[1])
        setMarkupType(2)
        try {
            axios.post(`${REST_API_END_POINT}project/get-data-for-add-project`,{isSalesOrder:true}, {
            // userType:userType,From:"addSalesOrder",teamId:teamId,
            headers: {
                'Content-Type': 'application/json',
            },
            }).then((response) => {
            if (response.data.status === 1) {
                const pts = response.data.projectTypes
                setProjectTypes(pts)
                setProjectCategories(response.data.projectCategories)
                setNoChargeType(response.data.noChargeType)
                // When only one Job Class exists, preselect it (same as user choosing it manually)
                if (
                  DOMAIN === 'la' &&
                  pts?.length === 1 &&
                  userType != 3 &&
                  !formik.values.project_type
                ) {
                  formik.setFieldValue('project_type', pts[0])
                  setShowAddNewRow(true)
                }
                // setCommunities(response.data.community)
            } else {
                setProjectTypes([])
                setNoChargeType([])
                setProjectCategories([])
                setCommunities([])
            }
            }).catch((error) => {
            console.error(error);
            setProjectTypes([])
            setNoChargeType([])
            setProjectCategories([])
            setCommunities([])
            })
        }
        catch (error) {
            console.error("Error fetching data:", error);
        }
        fetchTaxCategory();
        fetchAllMapServices();
        fetchAllClients();
        fetchTeamMembersForCollaborators();
        }
    }, [open])

    const addNewProductRow = () => {
        const newIndexCounter = indexCounter + 1
        setIndexCounter(newIndexCounter)
        const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
        // Auto-populate addresses from the selected Project
        const newAddresses = [{
          id: 0,
          address: projAddress,
          city: projCity,
          state: projState,
          zip: projZip
        }];
      
        setSelectedProducts((prevProducts) => {
        // if (allLocationSame && prevProducts.length > 0) {
        //     const commonAddress = { ...prevProducts[0].addresses[0] } || {
        //     address: '',
        //     city: '',
        //     state: '',
        //     zip: '',
        //     };
        //     newAddresses[0] = commonAddress;
        // }
        return [
        ...prevProducts,
        { 
            indexId: newIndexCounter, 
            name: '', 
            quantity: 1, 
            price: 0,
            adjustment:0,
            retail_price:0, 
            unit:4,
            locationQuantity: 1, 
            expected_total_service_cost:0,
            expected_service_cost:0,
            expected_material_cost:0,
            discount: 0 ,
            allLocationSame: true,
            service:[],
            isAdditionalProduct:true,
            addresses: newAddresses,
            is_single_card:values.project_categories?.id !==14 ? true : false
        },
        ]});
    };

    // const addNewServiceRow = () => {
    //   const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
    //   // Auto-populate addresses from the selected Project
    //   const newAddresses = [{
    //     id: 0,
    //     address: projAddress,
    //     city: projCity,
    //     state: projState,
    //     zip: projZip
    //   }];
    
    //   setAdditionalSelectedServices((prevServices) => {
    //     return [
    //       ...prevServices,
    //       {  
    //         id:null,
    //         newIndexId: prevServices?.length + 1,
    //         name: '', 
    //         avatarUrl: null,
    //         quantity: 1, 
    //         cost: 0,
    //         markup: 0, 
    //         workflow: null,
    //         originalMarkup: 0, 
    //         service_type: null,
    //         total_cost:0,
    //         product_total:0,
    //         allLocationSame: true,
    //         isAdditionalProduct:true,
    //         addresses: newAddresses,
    //       }
    //     ]
    //   });
    // };

    // const addNewMaterialRow = () => {
    //   setSelectedMaterials((prevProducts) => {
    //   return [
    //   ...prevProducts,
    //   { 
    //     newIndexId: prevProducts?.length + 1,
    //     quantity: 1, 
    //     allLocationSame: true,
    //     isAdditionalProduct:true,
    //     description: '',
    //     finishedProductQty: 0,
    //     markUpCost: 0,
    //     markup: 0,
    //     material_types: 1,
    //     max_price: null,
    //     max_value: 10,
    //     meterial: 1,
    //     min_value: 1,
    //     name: '',
    //     partial: 0,
    //     partialProductQty: 0,
    //     pf_retail_markup: null,
    //     price: 0,
    //     recipe_id: null,
    //     retail_price: 0,
    //     special_price: 0,
    //     tags: '',
    //     tax: null,
    //     tax_category: 0,
    //     total_qty: 0,
    //     twilio_field_value_sid: null,
    //     unit: 4,
    //     unit_qty: 0,
    //     vendor_id: '',
    //     vpt_number: '',
    //     workflow: null,
    //   },
    //   ]});
    // };

    const addNewServiceRow = () => {
      const {
        address: projAddress = '',
        city: projCity = '',
        state: projState = '',
        zip: projZip = '',
      } = values?.community || {};
    
      const newAddresses = [
        {
          id: 0,
          address: projAddress,
          city: projCity,
          state: projState,
          zip: projZip,
        },
      ];
    
      setAdditionalSelectedServices((prevServices) => {
        const maxId = prevServices.reduce(
          (max, item) => Math.max(max, item.newIndexId || 0),
          0
        );
    
        return [
          ...prevServices,
          {
            id: null,
            newIndexId: maxId + 1,
            name: '',
            avatarUrl: null,
            quantity: 1,
            cost: 0,
            markup: 0,
            workflow: null,
            originalMarkup: 0,
            service_type: null,
            total_cost: 0,
            product_total: 0,
            allLocationSame: true,
            isAdditionalProduct: true,
            addresses: newAddresses,
          },
        ];
      });
    };
    

    const addNewMaterialRow = () => {
      setSelectedMaterials((prevProducts) => {
        const maxId = prevProducts.reduce(
          (max, item) => Math.max(max, item.newIndexId || 0),
          0
        );
    
        return [
          ...prevProducts,
          {
            newIndexId: maxId + 1,
            quantity: 1,
            allLocationSame: true,
            isAdditionalProduct: true,
            description: '',
            finishedProductQty: 0,
            markUpCost: 0,
            markup: 0,
            material_types: 1,
            max_price: null,
            max_value: 10,
            meterial: 1,
            min_value: 1,
            name: '',
            partial: 0,
            partialProductQty: 0,
            pf_retail_markup: null,
            price: 0,
            recipe_id: null,
            retail_price: 0,
            special_price: 0,
            tags: '',
            tax: null,
            tax_category: 0,
            total_qty: 0,
            twilio_field_value_sid: null,
            unit: 4,
            unit_qty: 0,
            vendor_id: '',
            vpt_number: '',
            workflow: null,
            adj_value_type: true,
          },
        ];
      });
    };

    
    const handleProduct = (value) => {
      console.log('handleProduct---value--', value)
      console.log('handleProduct---selectedProducts--', selectedProducts)
      // 1) Grab the project's address data from Formik (or wherever you store your project)
      //    If there's no project selected, default to empty strings.
      const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
  
//       setSelectedProducts((prevProducts) => {
//         // If "All Locations Same" is on, we might use the addresses from the very first product
//         let commonAddresses = null;
//         // const commonAddresses = (allLocationSame && prevProducts.length > 0) ? [...prevProducts[0].addresses] : null;
    
//         // 2) Map over the newly selected array of products
//         const updatedProducts = value.map((product, index) => {
//           // Check if product already exists in selectedProducts
//           const existingProduct = prevProducts.find((p) => p.id === product.id && p.indexId === product.indexId);
//           console.log('existingProduct', existingProduct)
  
//           if (existingProduct) {
//             // -----------------------
//             // If product already exists
//             // -----------------------
//             const quantity = existingProduct.quantity; 
//             const locationQuantity = existingProduct.locationQuantity;
//             let addresses = [...existingProduct.addresses];

//             if (allLocationSame && commonAddresses) {
//                 // Overwrite all addresses with the "common" addresses (from the first product)
//                 addresses = [...commonAddresses];
//             } else {
//                 // Ensure at least one address object
//                 for (let i = addresses.length; i < 1; i++) {
//                 addresses.push({
//                     id: i,
//                     address: '',
//                     city: '',
//                     state: '',
//                     zip: '',
//                 });
//                 }
//             }
    
//             return {
//                 ...existingProduct,
//                 quantity,
//                 locationQuantity,
//                 addresses
//             };
//           } else {
//             // -----------------------
//             // BRAND NEW product
//             // -----------------------
//             // Auto-populate addresses from the selected Project
//             const newAddresses = [
//                 {
//                 id: 0,
//                 address: projAddress,
//                 city: projCity,
//                 state: projState,
//                 zip: projZip
//                 }
//             ];
    
//             // If "allLocationSame" is on, we might prefer the addresses from the first product
//             if (false) {
//             // if (allLocationSame && prevProducts.length > 0) {
//                 const commonAddress = { ...prevProducts[0].addresses[0] } || {
//                 address: '',
//                 city: '',
//                 state: '',
//                 zip: '',
//                 };
//                 newAddresses[0] = commonAddress;
//             }
    
//             // Bump the index counter for a unique indexId
//             const newIndexCounter = indexCounter + 1;
//             setIndexCounter(newIndexCounter);
    
//             return {
//                 ...product,
//                 indexId: newIndexCounter,
//                 allLocationSame: true,
//                 quantity: 1,
//                 locationQuantity: 1,
//                 discount: 0,
//                 addresses: newAddresses
//             };
//           }
//         });

//         console.log('updatedProducts', updatedProducts)
//         // Merge products from selectedMapserviceProducts with fromMapServices = true into the value
//         const allSelectedProducts = [
//             ...updatedProducts,
//             ...selectedProducts?.filter((item)=>item.isAdditionalProduct == true),
//             ...selectedMapserviceProducts?.filter(product => product?.fromMapServices == true)
//         ];
    
//         // 3) Build up a combined list of “services” for all products
//         const productServices = allSelectedProducts?.reduce((services, product) => {
//           if (product.services && product.services.length > 0) {
//             return services.concat(
//               product.services.map((service) => ({
//                 ...service,
//                 productIndex: product?.indexId,
//                 fromMapServices: product?.fromMapServices,
//                 quantity: service.quantity * product.quantity * product.locationQuantity,
//                 previousQty: service.quantity,
//                 qtyData: product.quantity,
//                 locationQuantity: product.locationQuantity
//               }))
//             );
//           }
//           return services;
//         }, []);
    
//         // Update your “selectedServices” state (if your code needs it)
//         setSelectedServices(productServices);


    
//         // Optionally filter out services you’ve already chosen, etc.
//         const filteredServices =
//           productServices.length === 0
//           ? labourCostServices
//           : labourCostServices.filter(
//               (service) =>
//                   !productServices.find(
//                   (selectedService) => selectedService.id === service.id
//                   )
//               );
//               console.log('filteredServices', filteredServices)
//               console.log('filteredServices 2', productServices)
// ///////////////////////for additional service filter
//               const updatedAdditionalSelectedServices = additionalSelectedServices?.filter(
//                 (service) => !productServices.some(
//                   (selectedService) => selectedService.id === service.id
//                 )
//               );
              
//               // Now update the state
//               setAdditionalSelectedServices(updatedAdditionalSelectedServices);
//               setFieldValue('services', updatedAdditionalSelectedServices)
//               ///////////////////////
//         // setFilteredServices(filteredServices);
//         setFieldValue('products', allSelectedProducts);
        
//         // Calculate installation date based on highest lead_time of selected products
//         const productsWithLeadTime = allSelectedProducts.filter(product => product.lead_time && product.lead_time > 0);
        
//         if (productsWithLeadTime.length > 0) {
//           const highestLeadTime = Math.max(...productsWithLeadTime.map(product => product.lead_time));
//           const installationDate = moment().add(highestLeadTime, 'days');
          
//           // Set only the single installation date field
//           setFieldValue('end', installationDate.unix());
//         } else {
//           // If no products with lead_time, set installation date to current date
//           setFieldValue('end', moment().unix());
//         }
        
//         return allSelectedProducts;
//       });
      setSelectedProducts((prevProducts) => {
        // If "All Locations Same" is on, we might use the addresses from the very first product
        let commonAddresses = null;

        // 2) Map over the newly selected array of products
        const updatedProducts = value.map((product, index) => {
          // Check if product already exists in selectedProducts
          const existingProduct = prevProducts.find((p) => p.id === product.id && p.indexId === product.indexId);
          console.log('existingProduct', existingProduct)

          if (existingProduct) {
            // If product already exists, use its values
            const quantity = existingProduct.quantity;
            const locationQuantity = existingProduct.locationQuantity;
            let addresses = [...existingProduct.addresses];

            if (allLocationSame && commonAddresses) {
              // Overwrite all addresses with the "common" addresses (from the first product)
              addresses = [...commonAddresses];
            } else {
              // Ensure at least one address object
              for (let i = addresses.length; i < 1; i++) {
                addresses.push({
                  id: i,
                  address: '',
                  city: '',
                  state: '',
                  zip: '',
                });
              }
            }

            return {
              ...existingProduct,
              quantity,
              locationQuantity,
              addresses
            };
          } else {
            // BRAND NEW product
            const newAddresses = [
              {
                id: 0,
                address: projAddress,
                city: projCity,
                state: projState,
                zip: projZip
              }
            ];

            if (false) {
              const commonAddress = { ...prevProducts[0].addresses[0] } || {
                address: '',
                city: '',
                state: '',
                zip: '',
              };
              newAddresses[0] = commonAddress;
            }

            // Increment the index counter
            const newIndexCounter = indexCounter + 1;
            setIndexCounter(newIndexCounter);

            // Auto-apply existing delivery/installer settings for this facility
            const existingDeliverySettings = getExistingDeliverySettingsForFacility(product.facility_id);

            return {
              ...product,
              indexId: newIndexCounter,
              allLocationSame: true,
              quantity: 1,
              locationQuantity: 1,
              discount: 0,
              sub_contract_markup : product?.markup,
              addresses: newAddresses,
              ...(existingDeliverySettings && { delivery_installation: existingDeliverySettings })
            };
          }
        });

        console.log('updatedProducts', updatedProducts);

        // Merge products from selectedMapserviceProducts with fromMapServices = true into the value
        const allSelectedProducts = [
          ...updatedProducts,
          ...selectedProducts?.filter((item) => item.isAdditionalProduct == true),
          ...selectedMapserviceProducts?.filter(product => product?.fromMapServices == true)
        ];

        // Recalculate index IDs after filtering out removed products
        const filteredProducts = allSelectedProducts.filter(product => product !== null);


        const productServices = allSelectedProducts?.reduce((services, product) => {
          if (product.services && product.services.length > 0) {
            return services.concat(
              product.services.map((service) => ({
                ...service,
                productIndex: product?.indexId,
                fromMapServices: product?.fromMapServices,
                quantity: service.quantity * product.quantity * product.locationQuantity,
                previousQty: service.quantity,
                qtyData: product.quantity,
                locationQuantity: product.locationQuantity
              }))
            );
          }
          return services;
        }, []);
    
        // Update your “selectedServices” state (if your code needs it)
        setSelectedServices(productServices);

        // Reassign the indexId starting from 1 for all filtered products
        const resetIndexProducts = filteredProducts.map((product, idx) => ({
          ...product,
          indexId: idx + 1 // Reset the index to start from 1
        }));

        // Now update the products state with the new indexId
        setFieldValue('products', resetIndexProducts);

        const patch = getInstallEndPatchFromLead(
          values,
          getBaseUnixForLeadTime(values),
          resetIndexProducts
        );
        if (patch) setFieldValue(patch.field, patch.finalUnix);

        return resetIndexProducts;
      });

};
  
    const handleServices = (value) => {
      setAdditionalSelectedServices(prevProducts => {
        const updatedProducts = value.map((product, index) => {
          const existingProduct = prevProducts.find(p => (p?.id === product?.id && p?.indexId === product?.indexId));
          console.log('existingProduct-----------------',existingProduct)
          console.log('prevProducts-----------------',prevProducts)
          console.log('product-----------------',product)
          if (existingProduct) {
            let addresses = [...existingProduct.addresses];
            for (let i = addresses.length; i < 1; i++) {
              addresses.push({
                id: i,
                address: '',
                city: '',
                state: '',
                zip: '',
              });
            }
            return {
              ...existingProduct,
              addresses
            };
          } else {
            const newAddresses = [{
              id: 0,
              address: '',
              city: '',
              state: '',
              zip: '',
            }];
  
            // if (prevProducts.length > 0) {
            //   const commonAddress = { ...prevProducts[0].addresses[0] } || {
            //     address: '',
            //     city: '',
            //     state: '',
            //     zip: '',
            //   };
            //   newAddresses[0] = commonAddress;
            // }
            const newIndexCounter = indexCounter + 1
            console.log('indexCounter product------------',newIndexCounter)
            setIndexCounter(newIndexCounter);
            return {
              ...product,
              indexId: newIndexCounter,
              addresses: newAddresses
            };
          }
        });
        return updatedProducts;
      });
    };

    const handleDeleteProduct = (productId, indexId) => {
      const filteredProduct = selectedProducts?.filter((data) => !(data.id === productId && data.indexId === indexId));
      // Reassign indexId starting from 1 for remaining products
      const resetIndexProducts = filteredProduct.map((product, idx) => ({
        ...product,
        indexId: idx + 1 // Reset the index to start from 1
      }));

      // Update state with the new list of products
      setFieldValue('products', resetIndexProducts);
      setSelectedProducts(resetIndexProducts);

      // setFieldValue('products', filteredProduct);
      // setSelectedProducts(filteredProduct);
  
      // Remove the corresponding location state when a product is deleted
      const newLocationStates = { ...locationStates };
      delete newLocationStates[indexId];
      setLocationStates(newLocationStates);

      setProductAttachments((prev) => {
        const reIndexedAttachments = {};
        filteredProduct.forEach((product, newIndex) => {
          const oldIndexId = product.indexId;
          if (oldIndexId === indexId) return;
          const newIndexId = newIndex + 1;
          if (prev[oldIndexId]) {
            reIndexedAttachments[newIndexId] = prev[oldIndexId];
          }
        });
        return reIndexedAttachments;
      });

      setSelectedUploadedImages((prev) => {
        const reIndexedSelected = {};
        filteredProduct.forEach((product, newIndex) => {
          const oldIndexId = product.indexId;
          if (oldIndexId === indexId) return;
          const newIndexId = newIndex + 1;
          if (prev[oldIndexId]) {
            reIndexedSelected[newIndexId] = prev[oldIndexId];
          }
        });
        return reIndexedSelected;
      });

      console.log("Filtered products", filteredProduct);
      console.log("Filtered All Services", selectedServices);
      const optedProductIds = filteredProduct.map(product => product.id);
      const result = selectedServices?.filter(service =>
        filteredProduct?.some((product) => (product?.id === service?.product_id && product?.indexId === service?.productIndex))
      )
  
  
      console.log("Filtered chat", result);
      const filteredServices = selectedServices?.filter(service => !filteredProduct?.some(product => product?.services?.includes(service)));
      console.log("Filtered Services", filteredServices);
      if (filteredProduct?.length == 0) {
        setSelectedServices([])
      }
      else {
        // setSelectedServices(filteredServices);
        setSelectedServices(result)
      }
      
      const patch = getInstallEndPatchFromLead(
        values,
        getBaseUnixForLeadTime(values),
        filteredProduct
      );
      if (patch) setFieldValue(patch.field, patch.finalUnix);

    };

    const handleDeleteInstallCost = (productId, indexId) => {
      console.log('handleDeleteInstallCost productId', productId)
      console.log('handleDeleteInstallCost indexId', indexId)
      // Remove only the install_cost from the product, keeping the product itself
      const updatedProducts = selectedProducts?.map((product) => {
        if (product.id == productId && product.indexId == indexId) {
          console.log('handleDeleteInstallCost productId 2', product.id )
          console.log('handleDeleteInstallCost indexId 2', product.indexId )
          const restoredOriginalRetail =
            product.original_retail_price_before_install_adjustment ??
            product.original_retail_price

          const retailBefore = product?.retail_price_before_no_charge
          const actualBefore = product?.actual_retail_price_before_no_charge
          const originalRetailBefore = product?.original_retail_price_before_no_charge
          const originalActualBefore = product?.original_actual_retail_price_before_no_charge

          return {
            ...product,
            install_cost: null, // or 0, depending on your preference
            expected_install_labor_cost:null,
            original_install_cost: null,
            install_adjustment: 0,
            install_adj_value_type: true,
            original_retail_price_before_install_adjustment: undefined,
            original_retail_price: restoredOriginalRetail,
            // product_total:product.actual_retail_price * product.locationQuantity,
            // product_sub_total:product.actual_retail_price * product.locationQuantity,
            retail_price:product.actual_retail_price * product.locationQuantity,
            install_cost_before_no_charge: null,
            original_install_cost_before_no_charge: null,
            retail_price_before_no_charge: actualBefore ?? retailBefore,
            original_retail_price_before_no_charge: originalActualBefore ?? originalRetailBefore,
          };
        }
        return product;
      });
      
      setSelectedProducts(updatedProducts);
      setFieldValue('products', updatedProducts);
    };
  
    // const handleAllLocationSameChange = () => {
  
    //   console.log("##################Alllll", allLocationSame);
    //   if (!allLocationSame) {
    //     const commonAddress = selectedProducts[0]?.addresses[0] || {
    //       address: '',
    //       city: '',
    //       state: '',
    //       zip: '',
    //     };
    //     setSelectedProducts(prevProducts =>
    //       prevProducts.map(product => ({
    //         ...product,
    //         addresses: product.addresses.map(() => commonAddress),
    //       }))
    //     );
    //   }
    //   setAllLocationSame(!allLocationSame);
    // };
  
    const handleAllLocationSameChange = (productIndex) => {
      setSelectedProducts(prevProducts =>
        prevProducts.map((product, index) => {
          if (index === productIndex) {
            console.log('productIndex--1---', index)
            console.log('productIndex--2---', productIndex)

            // Toggle allLocationSame flag
            const isAllSame = !product?.allLocationSame;
            // Get the first address of the selected product
            const commonAddress = product.addresses[0] || {
              address: '',
              city: '',
              state: '',
              zip: '',
            };
    
            return {
              ...product,
              allLocationSame: isAllSame,
              addresses: product.addresses.map(() => commonAddress),
            };
          }
          return product;
        })
      );
    };
    
    const handleAllServiceLocationSameChange = () => {
  
      console.log("##################Alllll", allLocationSame);
      if (!allServiceLocationSame) {
        const commonAddress = additionalSelectedServices[0]?.addresses[0] || {
          address: '',
          city: '',
          state: '',
          zip: '',
        };
        setAdditionalSelectedServices(prevProducts =>
          prevProducts.map(product => ({
            ...product,
            addresses: product.addresses.map(() => commonAddress),
          }))
        );
      }
      setAllServiceLocationSame(!allServiceLocationSame);
    };
  
    const handleAllRfpServiceLocationSameChange = () => {
      
      if (!allRfpServiceLocationSame) {
        // Ensure there's at least one service and its location array is valid
        const commonAddress = cartService[0]?.addresses?.[0] || {
          address: '',
          city: '',
          state: '',
          zip: '',
        };
    
        console.log("Common Address being applied:", commonAddress);
    
        // Update all locations to use the commonAddress
        setCartService(prevProducts =>
          prevProducts.map(product => ({
            ...product,
            addresses: product.addresses ? product.addresses.map(() => ({ ...commonAddress })) : [{ ...commonAddress }],
          }))
        );
        setAllRfpServiceLocationSame(true);
  
      }else{
  
        setAllRfpServiceLocationSame(false);
      }
    
    };
  
    // const handleAllRfpProductsLocationSameChange = () => {
      
    //   if (!allRfpProductsLocationSame) {
    //     // Ensure there's at least one service and its location array is valid
    //     const commonAddress = cart[0]?.addresses?.[0] || {
    //       address: '',
    //       city: '',
    //       state: '',
    //       zip: '',
    //     };
    
    //     console.log("Common Address being applied:", commonAddress);
    
    //     // Update all locations to use the commonAddress
    //     setCart(prevProducts =>
    //       prevProducts.map(product => ({
    //         ...product,
    //         addresses: product.addresses ? product.addresses.map(() => ({ ...commonAddress })) : [{ ...commonAddress }],
    //       }))
    //     );
    //     setAllRfpProductsLocationSame(true);
  
    //   }else{
  
    //     setAllRfpProductsLocationSame(false);
    //   }
    
    // };

    const handleAllRfpProductsLocationSameChange = (productIndex) => {
      setCart(prevProducts => 
        prevProducts.map((product, index) => {
          if (index === productIndex) {
            const isAllSame = !product?.allRfpProductsLocationSame;
    
            // Ensure there's at least one service and its location array is valid
            const commonAddress = product?.addresses?.[0] || {
              address: '',
              city: '',
              state: '',
              zip: '',
            };
    
            console.log("Common Address being applied:", commonAddress);
    
            return {
              ...product,
              allRfpProductsLocationSame: isAllSame,
              addresses: product.addresses ? product.addresses.map(() => ({ ...commonAddress })) : [{ ...commonAddress }]
            };
          }
          return product; // Keep other products unchanged
        })
      );
    };
    const handleOpenProductFormula = (id) => {
  setSelectedProductFormulaId(id);
  setOpenProductFormulaModal(true);
};
  const calculateTotal = (
    price,
    quantity,
    discount = 0,
    location = 1,
    adjustment = 0,
    markAdjType = 1,
    adj_value_type = true
  ) => {
    const parsedQuantity = parseFloat(quantity) || 1
    const parsedDiscount = parseFloat(discount) || 0
    const locationQuantity = parseFloat(location) || 1
    const newPrice = parseFloat(price) || 0
    // let subtotal = price * parsedQuantity * locationQuantity;

    let SPMA =
      newPrice //+ (newPrice * (adjustment ? Number(adjustment) : 0)) / 100
    let subtotal =
      parseFloat(SPMA)?.toFixed(2) * parsedQuantity * locationQuantity

    if (markAdjType == 2 || markAdjType == 3) {
      SPMA = newPrice //+ (adjustment ? Number(adjustment) : 0)
      subtotal =
        parseFloat(SPMA)?.toFixed(2) * parsedQuantity * locationQuantity
    }

    if (discount) {
      subtotal = subtotal - discount
    }
    return parseFloat(subtotal.toFixed(2))
  }

  const handleRetailPriceChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, retail_price_draft: undefined }
              : product,
          ),
        )
      } else {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, retail_price_draft: limitedValue }
              : product,
          ),
        )
      }
      return
    }

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.indexId === indexId
            ? { ...product, retail_price_draft: limitedValue }
            : product,
        ),
      )
      return
    }

    let adjustmentFieldToSync = null
    let adjustmentValueToSync = null

    setSelectedProducts((prevProducts) => {
      const productIndex = prevProducts.findIndex((p) => p.indexId === indexId)
      return prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const editResult = applyRetailPriceEdit(
          ensureCatalogBaselines(product),
          valueToApply,
          markupType,
          {
            hasNegativePermission: explodedPermissions?.some((permission) =>
              ['Allow Negative Marketing Adjustment Sales Order'].includes(
                permission,
              ),
            ),
          },
        )

        if (!editResult) {
          return { ...product, retail_price_draft: limitedValue }
        }

        if (editResult.error) {
          if (!isBlur) {
            return { ...product, retail_price_draft: limitedValue }
          }
          enqueueSnackbar(editResult.error, { variant: 'error' })
          return { ...product, retail_price_draft: undefined }
        }

        const reconciled = reconcileCatalogMarketingPrices({
          ...product,
          ...editResult,
          retail_price_draft: isBlur ? undefined : limitedValue,
          adjustment_draft: undefined,
        })

        const priceForTotal =
          markupType === 1
            ? reconciled.price
            : reconciled.install_cost && parseFloat(reconciled.install_cost) > 0
            ? reconciled.retail_price
            : reconciled.actual_retail_price

        const total = calculateTotal(
          priceForTotal,
          Number(product.quantity),
          product.discount || 0,
          product.locationQuantity,
          reconciled.adjustment,
          product.markAdjType,
          reconciled.adj_value_type,
        )

        if (productIndex >= 0) {
          adjustmentFieldToSync = `adjustment_${productIndex}`
          adjustmentValueToSync = Number(reconciled.adjustment)
            ? reconciled.adjustment
            : ''
        }

        return {
          ...reconciled,
          retail_price_draft: isBlur ? undefined : limitedValue,
          product_total: total,
        }
      })
    })

    if (adjustmentFieldToSync != null) {
      formik.setFieldValue(adjustmentFieldToSync, adjustmentValueToSync)
    }
    setRefreshCalculation((v) => !v)
  }

  const handleMarketingAdjustmentChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)

    if (limitedValue === '' || limitedValue === '-') {
      if (isBlur) {
        setSelectedProducts((prevProducts) => {
          const productIndex = prevProducts.findIndex((p) => p.indexId === indexId)
          if (productIndex >= 0) {
            formik.setFieldValue(`adjustment_${productIndex}`, '')
          }
          return prevProducts.map((product) => {
            if (product.indexId !== indexId) return product
            const baselined = ensureCatalogBaselines(product)
            const originalActual = Number(
              baselined.original_actual_retail_price ?? 0,
            )
            const originalRetail = Number(
              baselined.original_retail_price ?? originalActual,
            )
            return reconcileCatalogMarketingPrices({
              ...baselined,
              adjustment: 0,
              adjustment_draft: undefined,
              retail_price_edited: false,
              actual_retail_price: originalActual,
              retail_price: originalRetail,
            })
          })
        })
        setRefreshCalculation((v) => !v)
      } else {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) => {
            if (product.indexId !== indexId) return product
            const baselined = ensureCatalogBaselines(product)
            const originalActual = Number(
              baselined.original_actual_retail_price ?? 0,
            )
            const originalRetail = Number(
              baselined.original_retail_price ?? originalActual,
            )
            return {
              ...product,
              adjustment_draft: '',
              adjustment: '',
              actual_retail_price: originalActual,
              retail_price: originalRetail,
              retail_price_edited: false,
              retail_price_draft: undefined,
            }
          }),
        )
        setRefreshCalculation((v) => !v)
      }
      return
    }

    if (!isBlur) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) => {
          if (product.indexId !== indexId) return product

          const hasPermission = explodedPermissions?.some((permission) =>
            ['Allow Negative Marketing Adjustment Sales Order'].includes(
              permission,
            ),
          )
          const maxNegative = getMaxNegativeAdjustment(product, hasPermission)
          if (
            Number(limitedValue) >= maxNegative &&
            (product.adj_value_type === false || product.adj_value_type === 0) &&
            hasPermission
          ) {
            enqueueSnackbar('Retail value cannot be zero or less', {
              variant: 'error',
            })
            return product
          }
          if (
            Number(limitedValue) > maxNegative &&
            (product.adj_value_type === false || product.adj_value_type === 0) &&
            !hasPermission
          ) {
            enqueueSnackbar(
              `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Product Formula Limit)`,
              { variant: 'error' },
            )
            return product
          }

          const numAdjustment = Number(limitedValue) || 0
          const signedAdj =
            product.adj_value_type === false || product.adj_value_type === 0
              ? -numAdjustment
              : numAdjustment
          const baselined = ensureCatalogBaselines(product)
          const originalActual = Number(baselined.original_actual_retail_price ?? 0)
          const originalRetail = Number(
            baselined.original_retail_price ?? originalActual,
          )

          return {
            ...product,
            adjustment_draft: limitedValue,
            adjustment: limitedValue,
            actual_retail_price: Number((originalActual + signedAdj).toFixed(2)),
            retail_price: Number((originalRetail + signedAdj).toFixed(2)),
            retail_price_edited: numAdjustment !== 0,
            retail_price_draft: undefined,
          }
        }),
      )
      setRefreshCalculation((v) => !v)
      return
    }

    const normalizedValue = formatPriceToTwoDecimals(limitedValue)
    const numValue = Number(normalizedValue) || 0

    setSelectedProducts((prevProducts) => {
      const productIndex = prevProducts.findIndex((p) => p.indexId === indexId)
      return prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const hasPermission = explodedPermissions?.some((permission) =>
          ['Allow Negative Marketing Adjustment Sales Order'].includes(
            permission,
          ),
        )
        const maxNegative = getMaxNegativeAdjustment(product, hasPermission)
        if (
          numValue >= maxNegative &&
          (product.adj_value_type === false || product.adj_value_type === 0) &&
          hasPermission
        ) {
          enqueueSnackbar('Retail value cannot be zero or less', {
            variant: 'error',
          })
          return { ...product, adjustment_draft: undefined }
        }
        if (
          numValue > maxNegative &&
          (product.adj_value_type === false || product.adj_value_type === 0) &&
          !hasPermission
        ) {
          enqueueSnackbar(
            `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Product Formula Limit)`,
            { variant: 'error' },
          )
          return { ...product, adjustment_draft: undefined }
        }

        const signedAdj =
          product.adj_value_type === false || product.adj_value_type === 0
            ? -numValue
            : numValue
        const baselined = ensureCatalogBaselines(product)
        const originalActual = Number(baselined.original_actual_retail_price ?? 0)
        const originalRetail = Number(
          baselined.original_retail_price ?? originalActual,
        )

        const reconciled = reconcileCatalogMarketingPrices(
          normalizeProductForSave({
            ...baselined,
            adjustment: numValue,
            adj_value_type: numValue === 0 ? true : product.adj_value_type ?? true,
            actual_retail_price: Number((originalActual + signedAdj).toFixed(2)),
            retail_price: Number((originalRetail + signedAdj).toFixed(2)),
            retail_price_edited: numValue !== 0,
            adjustment_draft: undefined,
            retail_price_draft: undefined,
          }),
        )

        if (productIndex >= 0) {
          formik.setFieldValue(
            `adjustment_${productIndex}`,
            numValue ? normalizedValue : '',
          )
        }

        return reconciled
      })
    })
    setRefreshCalculation((v) => !v)
  }

  const handleInstallPriceChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, install_price_draft: undefined }
              : product,
          ),
        )
      } else {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, install_price_draft: limitedValue }
              : product,
          ),
        )
      }
      return
    }

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.indexId === indexId
            ? { ...product, install_price_draft: limitedValue }
            : product,
        ),
      )
      return
    }

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const editResult = applyInstallPriceEdit(
          ensureCatalogBaselines(product),
          valueToApply,
          {
            hasNegativePermission: explodedPermissions?.some((permission) =>
              ['Allow Negative Marketing Adjustment Sales Order'].includes(
                permission,
              ),
            ),
          },
        )

        if (!editResult) {
          return { ...product, install_price_draft: limitedValue }
        }

        if (editResult.error) {
          if (!isBlur) {
            return { ...product, install_price_draft: limitedValue }
          }
          enqueueSnackbar(editResult.error, { variant: 'error' })
          return { ...product, install_price_draft: undefined }
        }

        const normalized = normalizeProductForSave({
          ...product,
          ...editResult,
        })

        const total = calculateTotal(
          normalized.retail_price,
          Number(product.quantity),
          product.discount || 0,
          product.locationQuantity,
          normalized.adjustment,
          product.markAdjType,
          normalized.adj_value_type,
        )

        return {
          ...normalized,
          install_price_draft: isBlur ? undefined : limitedValue,
          install_adjustment_draft: undefined,
          product_total: total,
        }
      }),
    )
    setRefreshCalculation((v) => !v)
  }

  const calculateServiceTotal = (price, quantity, discount, location = 1) => {
    const parsedQuantity = parseFloat(quantity) || 0;
    const parsedDiscount = parseFloat(discount) || 0;
    const locationQuantity = parseFloat(location) || 1
    const subtotal = price * parsedQuantity * locationQuantity;
    if (discount) {
      const totalDiscount = subtotal - discount;
      return totalDiscount;
    } else {
      return subtotal;
    }
  };

  
  let totalAmount = 0;
  let totalMarkup = 0;
  let totalProductFormula = 0;
  let totalWholesalePrice = 0;
  let totalRetailPrice = 0;
  let originaltotalMarkup = 0
  let originaltotalServiceMarkup = 0
  let totalServiceMarkup = 0;
  let totalDiscount = 0

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;

  const buildAddressLine = useCallback((addressParts = []) => {
    return addressParts
      .map((part) => (part == null ? '' : String(part).trim()))
      .filter(Boolean)
      .join(', ');
  }, []);

  const buildMultilineAddress = useCallback((name, address, city, state, zip) => {
    const line1 = (name == null ? '' : String(name).trim());
    const line2 = (address == null ? '' : String(address).trim());
    const line3 = buildAddressLine([city, state, zip]);
    return [line1, line2, line3].filter(Boolean).join('\n');
  }, [buildAddressLine]);

  const clientAddressForBillTo = useMemo(() => {
    return buildMultilineAddress(
      values?.clients?.name || values?.clients?.customer_name || '',
      values?.clients?.address || values?.clients?.customer_address || '',
      values?.clients?.city || values?.clients?.customer_city || '',
      values?.clients?.state || values?.clients?.customer_state || '',
      values?.clients?.zip || values?.clients?.customer_zipcode || values?.clients?.zip_code || '',
    );
  }, [buildMultilineAddress, values?.clients]);

  const projectAddressForShipTo = useMemo(() => {
    return buildMultilineAddress(
      values?.community?.name || '',
      values?.community?.address || '',
      values?.community?.city || '',
      values?.community?.state || '',
      values?.community?.zip || '',
    );
  }, [buildMultilineAddress, values?.community]);

  const [isBillToDirty, setIsBillToDirty] = useState(false);
  const [isShipToDirty, setIsShipToDirty] = useState(false);
  const [billToInputValue, setBillToInputValue] = useState('');
  const [shipToInputValue, setShipToInputValue] = useState('');

  useEffect(() => {
    setIsBillToDirty(false);
  }, [values?.clients?.id]);

  useEffect(() => {
    setIsShipToDirty(false);
  }, [values?.community?.id]);

  // Seed / re-sync from saved value or client/project default only when user hasn't edited.
  useEffect(() => {
    if (isBillToDirty) return;
    const nextValue = (values?.bill_to || '').trim()
      ? values.bill_to
      : (clientAddressForBillTo || '');
    setBillToInputValue(nextValue);
  }, [isBillToDirty, values?.bill_to, clientAddressForBillTo, values?.clients?.id]);

  useEffect(() => {
    if (isShipToDirty) return;
    const nextValue = (values?.ship_to || '').trim()
      ? values.ship_to
      : (projectAddressForShipTo || '');
    setShipToInputValue(nextValue);
  }, [isShipToDirty, values?.ship_to, projectAddressForShipTo, values?.community?.id]);

  const applyLeadTimeInstallPatch = (baseUnix, productsList) => {
    const products =
      productsList ??
      (selectedProducts?.length > 0 ? selectedProducts : values.products || []);
    const patch = getInstallEndPatchFromLead(values, baseUnix, products);
    if (patch) setFieldValue(patch.field, patch.finalUnix);
  };

  const applyInstallationFromStartAndLead = (newStartUnix) => {
    applyLeadTimeInstallPatch(getBaseUnixForLeadTime(values, newStartUnix));
  };

  const remapProductIndexIds = useCallback(
    (indexIdMap, productsSnapshot) => {
      const remapKey = (oldKey) => {
        const mapped = indexIdMap[String(oldKey)]
        return mapped !== undefined ? String(mapped) : String(oldKey)
      }

      const remappedProducts = (productsSnapshot || []).map((product) => {
        const newId = indexIdMap[String(product.indexId)]
        if (newId === undefined) return product
        return {
          ...product,
          indexId: newId,
          product_index: newId,
        }
      })

      const remapKeyedState = (prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = remapKey(oldKey)
          next[newKey] = prev[oldKey]
        })
        return next
      }

      setSelectedProducts(remappedProducts)
      setFieldValue('products', remappedProducts)

      setProductAttachments((prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = remapKey(oldKey)
          next[newKey] = (prev[oldKey] || []).map((f) => ({
            ...f,
            product_index_id: newKey,
          }))
        })
        return next
      })

      setAttachmentTabValue(remapKeyedState)
      setSelectedUploadedImages(remapKeyedState)
      setOpenProductAttachment(remapKeyedState)

      setSelectedServices((prev) =>
        (prev || []).map((service) => ({
          ...service,
          productIndex:
            indexIdMap[String(service.productIndex)] ?? service.productIndex,
          indexId: indexIdMap[String(service.indexId)] ?? service.indexId,
          newIndexId:
            indexIdMap[String(service.newIndexId)] ?? service.newIndexId,
          product_index:
            indexIdMap[String(service.product_index)] ?? service.product_index,
        })),
      )

      setAdditionalSelectedServices((prev) =>
        (prev || []).map((service) => ({
          ...service,
          productIndex:
            indexIdMap[String(service.productIndex)] ?? service.productIndex,
          indexId: indexIdMap[String(service.indexId)] ?? service.indexId,
          newIndexId:
            indexIdMap[String(service.newIndexId)] ?? service.newIndexId,
          product_index:
            indexIdMap[String(service.product_index)] ?? service.product_index,
        })),
      )

      setSelectedMaterials((prev) =>
        (prev || []).map((material) => ({
          ...material,
          newIndexId:
            indexIdMap[String(material.newIndexId)] ?? material.newIndexId,
          product_index:
            indexIdMap[String(material.product_index)] ?? material.product_index,
        })),
      )

      setLocationStates(remapKeyedState)
      setOpenProductNote(remapKeyedState)
      setOpenInstallNote(remapKeyedState)

      const maxIndex =
        remappedProducts.length > 0
          ? Math.max(...remappedProducts.map((p) => Number(p.indexId) || 0))
          : 0
      setIndexCounter(maxIndex)

      return remappedProducts
    },
    [setFieldValue, setOpenProductAttachment],
  )

  const handleProductTableDragEnd = useCallback(
    async (result) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }

      const sorted = [...(selectedProducts || [])].sort(
        (a, b) => (Number(a?.indexId) || 0) - (Number(b?.indexId) || 0),
      )
      const [moved] = sorted.splice(result.source.index, 1)
      sorted.splice(result.destination.index, 0, moved)

      const indexIdMap = {}
      sorted.forEach((p, idx) => {
        indexIdMap[String(p.indexId)] = idx + 1
      })

      remapProductIndexIds(indexIdMap, selectedProducts)
    },
    [selectedProducts, remapProductIndexIds],
  )

  const getServiceLineKey = (service) =>
    String(service?.newIndexId ?? service?.indexId ?? service?.product_index ?? '')

  const remapServiceIndexIds = useCallback((indexIdMap) => {
    const remapKey = (oldKey) => {
      const mapped = indexIdMap[String(oldKey)]
      return mapped !== undefined ? String(mapped) : String(oldKey)
    }

    const remapKeyedState = (prev) => {
      const next = {}
      Object.keys(prev || {}).forEach((oldKey) => {
        const newKey = remapKey(oldKey)
        next[newKey] = prev[oldKey]
      })
      return next
    }

    setAdditionalSelectedServices((prev) =>
      (prev || []).map((service) => {
        const oldKey = getServiceLineKey(service)
        const newId = indexIdMap[oldKey]
        if (newId === undefined) return service
        return {
          ...service,
          newIndexId: newId,
          indexId: newId,
          product_index: newId,
        }
      }),
    )

    setServiceAttachments((prev) => {
      const next = {}
      Object.keys(prev || {}).forEach((oldKey) => {
        const newKey = remapKey(oldKey)
        next[newKey] = (prev[oldKey] || []).map((f) => ({
          ...f,
          service_index_id: newKey,
        }))
      })
      return next
    })

    setAttachmentTabValueService(remapKeyedState)
    setSelectedUploadedImagesService(remapKeyedState)
    setOpenServiceAttachment(remapKeyedState)
    setIsUploadingService(remapKeyedState)
    setOpenServiceNote(remapKeyedState)
    setServiceOnlyLocationStates(remapKeyedState)
  }, [setAdditionalSelectedServices])

  const handleServiceTableDragEnd = useCallback(
    (result) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }

      const sorted = [...(additionalSelectedServices || [])].sort(
        (a, b) =>
          (Number(a?.newIndexId ?? a?.indexId ?? a?.product_index) || 0) -
          (Number(b?.newIndexId ?? b?.indexId ?? b?.product_index) || 0),
      )
      const [moved] = sorted.splice(result.source.index, 1)
      sorted.splice(result.destination.index, 0, moved)

      const indexIdMap = {}
      sorted.forEach((s, idx) => {
        indexIdMap[getServiceLineKey(s)] = idx + 1
      })

      remapServiceIndexIds(indexIdMap)
    },
    [additionalSelectedServices, remapServiceIndexIds],
  )

  console.log('values.......', values);

  useState(()=>{
    if(values){
        setNewValues(values)
    }
},[values, setNewValues])

  useEffect(() => {
    setPreview(values)
  }, [openPreview])

  const selectedProductsTotalDiscount = selectedProducts?.reduce((total, data, index) => {
    const quantityFieldName = `quantity_${index}`;
    const discountFieldName = `discount_${index}`;
    const adjustmentFieldName = `adjustment_${index}`;
    // const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
    const quantityVal = data.quantity ? Number(data.quantity) : 1
    const discountVal = values[discountFieldName] ? values[discountFieldName] : 0
    const adjustmentVal = values[adjustmentFieldName] ? values[adjustmentFieldName] : 0

    // Calculate product subtotal (same as Product Total calculation in table)
    const locQty = Number(data?.locationQuantity) || 1
    const productSubTotal = markupType == 1
      ? (Number(data?.price) || 0) * locQty
      : markupType == 2
      ? (Number(data?.actual_retail_price || data?.retail_price || 0)) * locQty
      : 0

    // Calculate install subtotal (same as Install Subtotal calculation in table)
    const installQty = Number(data?.install_quantity ?? 0)
    const installSubTotal = (Number(data?.install_cost) || 0) * installQty

    // Product Total is the sum of both subtotals minus discount (same as table calculation)
    const productTotal = Math.max(0, productSubTotal + installSubTotal - discountVal)
    const fixedProductTotal = parseFloat(productTotal).toFixed(2);
    return total + parseFloat(fixedProductTotal);
  }, 0);

  const selectedProductsTotalDiscountForJobCost = selectedProducts?.reduce((total, data, index) => {
    const quantityFieldName = `quantity_${index}`;
    const discountFieldName = `discount_${index}`;
    // const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
    const quantityVal = data.quantity ? Number(data.quantity) : 1
    const discountVal = values[discountFieldName] ? values[discountFieldName] : 0
    console.log("#########DATAJobcost", data);
    console.log("#########quantityVal", quantityVal);
    const productTotal = calculateTotal(parseFloat(data.expected_material_cost), quantityVal, 0, data.locationQuantity);
    // const productTotal = calculateTotal(data.expected_material_cost, quantityVal, discountVal);
    console.log("#####################ProductTotal", productTotal);
    return total + parseFloat(productTotal);
  }, 0);

  // const allServices = [...selectedServices, ...additionalSelectedServices];
  const allServices = [ ...additionalSelectedServices];
  let selectedServicesCost = allServices?.reduce((total, service, index) => {
    const quantityFieldName = `service_quantity_${index}`;
    const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
    console.log("#######Service quantity-------", service.quantity);
    const serviceTotal = calculateServiceTotal(service.cost, Number(service.quantity), 0, 1);
    console.log("#######Service Total--2-----", serviceTotal);
    return total + parseFloat(serviceTotal?.toFixed(2));
  }, 0);
  let selectedServicesTotalCost = allServices?.reduce((total, service, index) => {
    const quantityFieldName = `service_quantity_${index}`;
    const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
    console.log("###########service?.locationQuantity", service?.locationQuantity);
    const serviceTotal = calculateServiceTotal(service?.total_cost, service?.quantity, 0, 1);
    console.log("###########service", service);
    console.log("###########serviceTotal", serviceTotal);
    
    // return total + Number(service?.total);
    return total + Number(serviceTotal);
  }, 0);
  let InitialServiceCostInProductFormula =0
  //  selectedProducts?.reduce((total, data, index) => {
  //   console.log("#####################Data", data);
  //   const serviceTotal = (data?.quantity) * (parseFloat(data?.expected_total_service_cost?.toFixed(2))) * (data?.locationQuantity || 1)
  //   return total + Number(serviceTotal);
  // }, 0);
  const InitialServiceCostforJobcost = selectedProducts?.reduce((total, data, index) => {
    const totalServiceCost = (data?.quantity) * (parseFloat(data?.expected_service_cost?.toFixed(2))) * (data?.locationQuantity || 1)
    return total + parseFloat(Number(totalServiceCost)?.toFixed(2));
  }, 0);
  // selectedServicesCost = selectedServicesCost - InitialServiceCostforJobcost
  const roundToThreeDecimals = (num) => Math.round(num * 1000) / 1000;
  selectedServicesTotalCost = roundToThreeDecimals(selectedServicesTotalCost);
  InitialServiceCostInProductFormula = roundToThreeDecimals(InitialServiceCostInProductFormula);
  const roundToTwoDecimals = (num) => Math.round(num * 100) / 100;

  const selectedAdditionalServiceCost = additionalSelectedServices?.filter(item=>item?.isAdditionalProduct == true)
                                          ?.reduce((total, item) => total + (Number(item.total_cost) || 0), 0)

  const selectedServicesSubTotal = roundToTwoDecimals(selectedServicesTotalCost - InitialServiceCostInProductFormula);

  values['labour_cost'] = selectedServicesSubTotal // selectedServicesCost
  const RFQSubTotal = (selectedProductsTotalDiscount + selectedServicesTotalCost) - (values['invoice_discount'] ? values['invoice_discount'] : 0)

  console.log('InitialServiceCostforJobcost-------', InitialServiceCostforJobcost);
  console.log('InitialServiceCostInProductFormula-------', InitialServiceCostInProductFormula);
  console.log('selectedServicesCost--------hhhh', selectedServicesCost);
  console.log('selectedServicesTotalCost-------', selectedServicesTotalCost);
  console.log('selectedServicesSubTotal-------', selectedServicesSubTotal);
  // console.log('InitialServiceCostInProductFormula-------',InitialServiceCostInProductFormula);
  console.log('selectedProductsTotalDiscountForJobCost111-------', selectedProductsTotalDiscountForJobCost);
  console.log('selectedProductsTotalDiscount-------', selectedProductsTotalDiscount);

  const calculateProductTotal = (price, markup, quantity,location=1) => {
    return parseFloat((price + price * (markup / 100))?.toFixed(2)) * quantity*location;
  };

  const calculateJobCostTotal = (price, quantity,location=1) => {
    return price * quantity * location;
  };

  const getProductMarkup = (data, markupType) => {
    if (markupType) {
      return markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup;
    }
    return 0;
  };

  const selectedRfpProduct = useMemo(() => {
    return cart?.reduce((total, data) => {
      const markup = getProductMarkup(data, markupType);
      let productTotal = calculateProductTotal(data.product_price, markup, data.quantity,data.location_quantity);
      productTotal = parseFloat(productTotal.toFixed(2));
      console.log("#####################ProductTotal", productTotal);
      return total + productTotal;
    }, 0);
  }, [cart, markupType]);

  const selectedRfpServices = useMemo(() => {
    return cartService?.reduce((total, data) => {
      let productTotal = calculateProductTotal(data.sellingPrice, data.originalMarkup, data.qty);
      productTotal = parseFloat(productTotal.toFixed(2));
      return total + productTotal;
    }, 0);
  }, [cartService]);
  const selectedNonTaxRfpServices = useMemo(() => {
    return cartService?.reduce((total, data) => {
      if (data?.taxable === 0) return total;
      let productTotal = calculateProductTotal(data.sellingPrice, data.originalMarkup, data.qty);
      productTotal = parseFloat(productTotal.toFixed(2));
      return total + productTotal;
    }, 0);
  }, [cartService]);
  console.log('proposal servicessss',selectedRfpServices)
  console.log('proposal servicessss new',selectedNonTaxRfpServices)

  const selectedRfpServicesForJobCost = useMemo(() => {
    return cartService?.reduce((total, data) => {
      let productTotal = calculateJobCostTotal(data.sellingPrice, data.qty);
      productTotal = parseFloat(productTotal.toFixed(2));
      return total + productTotal;
    }, 0);
  }, [cartService]);

  const selectedRfpProductJobCost = useMemo(() => {
    return cart?.reduce((total, data) => {
      let productTotal = calculateJobCostTotal(data.product_price, data.quantity,data.location_quantity);
      productTotal = parseFloat(productTotal.toFixed(2));
      return total + productTotal;
    }, 0);
  }, [cart]);
  //   const selectedMaterialCost = useMemo(() => {
  //   return selectedMaterials?.reduce((total, data) => {
  //   console.log("########SElected",data);
  //     let productTotal = calculateJobCostTotal(data.price, data.quantity||1);
  //      console.log("########SElectedproductTotal",productTotal);
  //     productTotal = parseFloat(productTotal.toFixed(2));
      
  //     return total + productTotal;
  //   }, 0);
  // }, [selectedMaterials]);
  const selectedMaterialCostJobCost = useMemo(() => {
    return selectedMaterials?.reduce((total, data) => {
      console.log("########SElectedmaterial-jobcost",data);
      let price = data?.inhouse == 0 ? 0 : parseFloat(data?.price || 0);
      let quantity = parseFloat(data?.quantity || 0);
      // if(values.project_categories?.name == 'Time & Material'){
      //   price = parseFloat(0);
      //   quantity = parseFloat(0);
      // }
      let productTotal = price * (quantity);
      if(data?.inhouse == 0){
        productTotal = 0
      }
      // let productTotal = calculateJobCostTotal(data.price, data.quantity||1);
      console.log("########SElectedmaterial-jobcost-productTotal",productTotal);
      productTotal = parseFloat(productTotal.toFixed(2));
      return total + productTotal;
    }, 0);
  }, [selectedMaterials]);

  // Load client-specific projects on component mount for clients
  useEffect(() => {
    console.log('useEffect triggered - isClient:', isClient, 'userType:', userType, 'userId:', userId);
    if (isClient || userType === 3) {
      console.log('Calling fetchClientSpecificProjects');
      fetchClientSpecificProjects();
    }
  }, [isClient, userType, userId]);

  useEffect(()=>{
    const productMaterial = selectedProducts?.reduce((materials, product) => {
      if (product.materials && product.materials.length > 0) {
        return materials.concat(
          product.materials
            .map((material) => {
              console.log('materialsssssss',material)
              const price = parseFloat(material.max_unit_cost || 0);
              const quantity = parseFloat(material.quantity || 1);
              const retail_price = parseFloat(material.retail_price || 0);

              const subtotal = price * quantity;
              const markup = (subtotal * retail_price) / 100;
              const total = (subtotal + markup) * (product.locationQuantity || 1)

              console.log('✅ total, subtotal, markup:', total, subtotal, markup);
              console.log('✅ price, quantity, retail_price:', price, quantity, retail_price);

              return {
                ...material,
                totalCost: total.toFixed(2),
              };
            })
        );
      }
      return materials;
    }, []);

    console.log("setProductFormulaMaterial",productMaterial)
   setProductFormulaMaterial(productMaterial)
    const getTotalCostSum = (productMaterial) => {
      return productMaterial.reduce((sum, item) => {
                console.log('itemmmmmm',item)
        // Only include if taxable == 0 (string or number)
        if (Number(item.taxable) !== 0) return sum;

        const cost = parseFloat(item.totalCost || 0);
        return sum + cost;
      }, 0).toFixed(2);
    };

    const totalCostSum = getTotalCostSum(productMaterial);
    setTotalMinusMaterialTax(totalCostSum)
    console.log('🧾 Total cost sum of all materials:', totalCostSum);

    // const productServices = selectedProducts?.reduce((services, product) => {
    //   if (product.services?.length > 0) {
    //     return services.concat(
    //       product.services.map((service) => {
    //         const cost = parseFloat(service.unit_cost ?? service.total_cost ?? 0);
    //         const quantity = parseFloat(service.quantity ?? 1);
    //         const retail_price = parseFloat(service.retail_price ?? 0);
    //         const locationQty = parseFloat(product.locationQuantity ?? 1);

    //         const subtotal = cost * quantity;
    //         const markup = (subtotal * retail_price) / 100;
    //         const total = (subtotal + markup) * locationQty;

    //         return {
    //           ...service,
    //           totalCost: total.toFixed(2),
    //         };
    //       })
    //     );
    //   }
    //   return services;
    // }, []);
    // console.log('productServicesproductServices', productServices)
    // const getTotalServiceCostSum = (services) => {
    //   return parseFloat(
    //     services.reduce((sum, item) => {
    //       console.log('itemservices', item);
    //       if (item.id !== 10) return sum;
    //       const cost = parseFloat(item.totalCost ?? 0);
    //       return sum + cost;
    //     }, 0).toFixed(2)
    //   );
    // };
    // const totalInstallServiceCostSum = getTotalServiceCostSum(productServices);
    // setTotalProductInstallCost(totalInstallServiceCostSum)

      // console.log('🧾 Total cost sum of all product services (taxable == 0):', totalInstallServiceCostSum);

    const installCost = selectedProducts?.map((product) => {
      const retailPrice = parseFloat(product.install_cost  || 0);
      const locationQuantity = parseFloat(product.locationQuantity || 1);

      const total = retailPrice * locationQuantity;

      return {
        ...product,
        totalCost: total.toFixed(2),
      };
    });

    console.log('🧾 installCost', installCost);

    const getTotalInstallCostSum = (installCost = []) => {
      return installCost.reduce((sum, item) => {
        const cost = parseFloat(item.totalCost || 0);
        return sum + cost;
      }, 0).toFixed(2);
    };

    const totalInstallCostSum = getTotalInstallCostSum(installCost);
    console.log('🧾 Total cost production costtt', totalInstallCostSum);
    setInstallCost(totalInstallCostSum)
  },[selectedProducts])

  const isNoChargeJob = values.project_categories?.id === 13 || noCharge;

  const selectedMaterialCost = useMemo(() => {
    return selectedMaterials?.reduce((total, data) => {
      console.log("########SElectedmaterial-totalsum1",data);
      // let price = data?.inhouse == 0 ? 0 : parseFloat(data?.price || 0);
      let price = parseFloat(data?.price || 0);
      let markup = isNoChargeJob ? 0 : parseFloat(data?.markup || 0);
      let quantity = parseFloat(data?.quantity || 0);
      // if(values.project_categories?.name == 'Time & Material'){
      //   price = parseFloat(0);
      //   quantity = parseFloat(0);
      // }
      let markUpCost = price + ((price * markup) / 100);
      markUpCost = parseFloat(markUpCost.toFixed(2)) || 0;
      let adjustment = data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0);
      // let productTotal = markUpCost * quantity;
      let productTotal = (markUpCost + adjustment) * (data.quantity || 0);
      console.log("########SElectedmaterial-totalsum2-productTotal",productTotal);
      // if(data?.inhouse == 0){
      //   productTotal = 0
      // }
      if(data?.inhouse == 0 && values?.project_categories?.id == 11){
        productTotal = 0
      }
      productTotal = parseFloat(productTotal.toFixed(2));

      // let markUpCost = data?.price + ((parseFloat(data?.price) * parseFloat(data?.markup || 0)) / 100)
      // markUpCost = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
      // let productTotal = markUpCost * (data.quantity || 1);
      // let productTotal = calculateJobCostTotal(data.markUpCost, data.quantity||1);
      console.log("########SElectedmaterial-totalsum2-data.price",data?.price);
      console.log("########SElectedmaterial-totalsum2-price",price);
      console.log("########SElectedmaterial-totalsum3-data.markup",data?.markup);
      console.log("########SElectedmaterial-totalsum4-markUpCost",markUpCost);
      console.log("########SElectedmaterial-totalsum5-productTotal",productTotal);
      // productTotal = parseFloat(productTotal.toFixed(2));
      return total + parseFloat(productTotal.toFixed(2));
    }, 0);
  }, [selectedMaterials, isNoChargeJob, refreshCalculation]);

  const selectedNonTaxMaterialCost = useMemo(() => {
    return selectedMaterials?.reduce((total, data) => {
      if (data?.taxable === 0) return total;
      console.log("########SElectedmaterial-totalsum1",data);
      let price = data?.inhouse == 0 ? 0 : parseFloat(data?.price || 0);
      let markup = isNoChargeJob ? 0 : parseFloat(data?.markup || 0);
      let quantity = parseFloat(data?.quantity || 0);
      // if(values.project_categories?.name == 'Time & Material'){
      //   price = parseFloat(0);
      //   quantity = parseFloat(0);
      // }
      let markUpCost = price + ((price * markup) / 100);
      markUpCost = parseFloat(markUpCost.toFixed(2)) || 0;
      let productTotal = markUpCost * quantity;
      if(data?.inhouse == 0){
        productTotal = 0
      }
      productTotal = parseFloat(productTotal.toFixed(2));
      console.log("########SElectedmaterial-totalsum2-data.price",data?.price);
      console.log("########SElectedmaterial-totalsum2-price",price);
      console.log("########SElectedmaterial-totalsum3-data.markup",data?.markup);
      console.log("########SElectedmaterial-totalsum4-markUpCost",markUpCost);
      console.log("########SElectedmaterial-totalsum5-productTotal",productTotal);
      return total + parseFloat(productTotal.toFixed(2));
    }, 0);
  }, [selectedMaterials, isNoChargeJob]);
console.log("selectedMaterialCostttt new ",selectedNonTaxMaterialCost);
console.log("selectedMaterialCostttt old",selectedMaterialCost);
  console.log("########SElectedmaterial-totalsum-selectedMaterialCost",selectedMaterialCost);
  values['labour_cost'] = (selectedServicesSubTotal || 0) + selectedRfpServices
  // setTotalProductLabourCost(selectedServicesSubTotal || 0)
  // const totalsum = (selectedProductsTotalDiscount + selectedServicesSubTotal+selectedRfpProduct+selectedRfpServices) - parseFloat(values['invoice_discount'] || 0);

  // const totalJobcostSum = (selectedProductsTotalDiscountForJobCost + selectedServicesCost+selectedRfpProductJobCost);
  const totalsum = useMemo(() => {
    return (selectedProductsTotalDiscount + selectedServicesSubTotal + selectedMaterialCost+selectedRfpProduct + selectedRfpServices + totalProductInstallCost) - parseFloat(values['invoice_discount'] || 0);
  }, [selectedProductsTotalDiscount,totalProductInstallCost, selectedServicesSubTotal, selectedRfpProduct,selectedMaterialCost, selectedRfpServices, values['invoice_discount']]);
  setNewTotalsum(totalsum);
  console.log('totalsummmmmmmm', totalsum)

// Non Taxable Calculation 
    let selectedServicesTaxTotalCost = allServices?.reduce((total, service, index) => {
  // Skip services that are not taxable
  if (service?.taxable === 0) return total;

  const quantityFieldName = `service_quantity_${index}`;
  const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1;

  const serviceTotal = calculateServiceTotal(service?.total_cost, service?.quantity, 0, 1);

  return total + Number(serviceTotal);
}, 0);


// const selectedNonTaxableServicesSubTotal = roundToTwoDecimals(selectedServicesTaxTotalCost - InitialServiceCostInProductFormula);
const selectedNonTaxableServicesSubTotal = Math.max(
  0,
  roundToTwoDecimals(selectedServicesTaxTotalCost - InitialServiceCostInProductFormula)
);

console.log('selectedNonTaxableServicesSubTotal', selectedNonTaxableServicesSubTotal)
console.log('InitialServiceCostInProductFormula', InitialServiceCostInProductFormula)
console.log('selectedServicesTaxTotalCost', selectedServicesTaxTotalCost)

  const nonTaxabletotalsum = useMemo(() => {
    return (selectedProductsTotalDiscount + selectedNonTaxableServicesSubTotal + selectedNonTaxMaterialCost+selectedRfpProduct + selectedNonTaxRfpServices) - parseFloat(values['invoice_discount'] || 0) - parseFloat(totalMinusMaterialTax || 0);
  }, [selectedProductsTotalDiscount, selectedNonTaxableServicesSubTotal, selectedRfpProduct,selectedNonTaxMaterialCost, selectedNonTaxRfpServices, totalMinusMaterialTax, values['invoice_discount']]);
  setNewTotalsum(totalsum);

  const newFixedtaxAmount = selectedTaxCategory ? (selectedTaxCategory.type === 1 ? (nonTaxabletotalsum * (selectedTaxCategory.value || 0) / 100) : (selectedTaxCategory.value || 0) ) : 0;
  const newtaxAmount = parseFloat(parseFloat(newFixedtaxAmount).toFixed(2))
  const taxAmount =0 // selectedTaxCategory ? (selectedTaxCategory.type === 1 ? (totalsum * (selectedTaxCategory.value || 0) / 100) : (selectedTaxCategory.value || 0) ) : 0;

  console.log("taxAmounttttt neww>",newtaxAmount)
  console.log("taxAmounttttt>",taxAmount)
  // const grandTotal =  (parseFloat(totalsum) + parseFloat(taxAmount)).toFixed(2);

  const productsForLeadRaw =
    selectedProducts?.length > 0 ? selectedProducts : values.products || [];
  const productsForLead = resolveProductsLeadTime(productsForLeadRaw, allProducts);
  const isRushFeeAutoLocked = isInstallBeforeRequiredLead(values, productsForLead);
  // Manual: can ON/OFF when not lead-time locked; cannot turn OFF under lead-time lock
  const canManuallyToggleRushFee = !!explodedPermissions?.some((permission) =>
    ['Manage Rush Fee Toggle'].includes(permission),
  );
  // Override: full authority (manual + can turn OFF under lead-time lock); independent of Manual
  const canOverrideRushFeeLock = !!explodedPermissions?.some((permission) =>
    ['Override Rush Fee'].includes(permission),
  );
  const canControlRushFee = canManuallyToggleRushFee || canOverrideRushFeeLock;

  useEffect(() => {
    runRushFeeLeadSync({
      values,
      products: productsForLeadRaw,
      catalog: allProducts,
      canOverride: canOverrideRushFeeLock,
      setFieldValue,
      refs: rushFeeSyncRefs.current,
      enabled: true,
    });
  }, [
    values?.end,
    values?.start,
    values?.installation_start_date,
    values?.installation_end_date,
    productsForLeadRaw,
    allProducts,
    isRushFeeAutoLocked,
    canOverrideRushFeeLock,
    setFieldValue,
  ]);

  // Derive flag — do not setFieldValue whenever locked+rush_fee!=1 (update-depth crash)
  // With override: respect values.rush_fee (including saved 0) even when auto-locked
  // Without override: auto-lock always shows ON
  const isRushFeeChecked =
    Number(values?.rush_fee) === 1 ||
    (!!isRushFeeAutoLocked && !canOverrideRushFeeLock);
  // Need Manual or Override to turn ON when not auto-locked
  const rushFeeAccessDenied =
    !canControlRushFee && !isRushFeeAutoLocked && !isRushFeeChecked;
  // Only dim when user has no control permission; locked Manual users keep normal look (OFF blocked in onChange)
  const rushFeeSwitchDisabled = rushFeeAccessDenied;

  const rushFeePercentage = Number(companyProfileData?.rush_fee_percentage) || 0;
  const rushFeeAmount =
    isRushFeeChecked
      ? parseFloat((parseFloat(totalsum || 0) * (rushFeePercentage / 100)).toFixed(2))
      : 0;
  values['rush_fee_amount'] = rushFeeAmount;

  let grandTotal = noCharge && totalsum >0
  ? (parseFloat(totalsum) + parseFloat(taxAmount) + rushFeeAmount) * -1
  : (parseFloat(totalsum) + parseFloat(taxAmount) + rushFeeAmount) 
  setNewGrandTotal(grandTotal);

  const totalJobcostSum = useMemo(() => {
    return (selectedProductsTotalDiscountForJobCost + selectedServicesCost+selectedMaterialCostJobCost + selectedRfpProductJobCost + selectedRfpServicesForJobCost);
  }, [selectedProductsTotalDiscountForJobCost, selectedServicesCost, selectedRfpProductJobCost,selectedMaterialCostJobCost, selectedRfpServicesForJobCost]);
  setNewTotalJobcostSum(totalJobcostSum)
  // console.log("Budget---------------", totalJobcostSum)
  console.log("####################selectedMaterials", selectedMaterials);
  
  values['total'] = totalsum
  values['taxAmount'] = taxAmount
  values['budget'] = totalJobcostSum
  // //discount count
  const selectedProductDiscount = selectedProducts?.reduce((acc, data, index) => {
    // const discountFieldName = `discount_${index}`;
    // const discountVal = values[discountFieldName] ? values[discountFieldName] : 0
    const discountVal = data.discount ? data.discount : 0
    let productDiscount = +discountVal || 0;
    return acc + productDiscount;
  }, 0);

  const DiscountTotal = selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0);
  setNewDiscountTotal(DiscountTotal);

  let selectedProductsTotalWholesalePrice = selectedProducts?.reduce((total, data, index) => {
    let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
    let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
    const dataWholesalePrice = data.product_price || data.price

    let newTotalWholesalePrice = dataWholesalePrice * data.quantity * data.locationQuantity
    newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0

    return total + newTotalWholesalePrice;
  }, 0);
  selectedProductsTotalWholesalePrice = selectedProductsTotalWholesalePrice ? Number(selectedProductsTotalWholesalePrice) : 0

  let selectedProductsTotalRetailPrice = selectedProducts?.reduce((total, data, index) => {
    let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
    let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
    const dataRetailPrice = data.product_retail_price || data.retail_price

    let newTotalRetailPrice = dataRetailPrice * data.quantity * data.locationQuantity
    newTotalRetailPrice = newTotalRetailPrice ? Number(newTotalRetailPrice) : 0

    return total + newTotalRetailPrice;
  }, 0);
  selectedProductsTotalRetailPrice = selectedProductsTotalRetailPrice ? Number(selectedProductsTotalRetailPrice) : 0


    let subTotal = markupType == 1 ? ((selectedProductsTotalWholesalePrice - DiscountTotal + selectedRfpProduct + selectedMaterialCost))
    : (markupType == 2 ? ((selectedProductsTotalRetailPrice - DiscountTotal + selectedRfpProduct + selectedMaterialCost)) : 0);
  console.log("################subTotal", subTotal);
  values['sub_total'] = subTotal
  console.log("project_categories", values.project_categories);

  // Determine when to show the Manager Approval toggle
  // Sales orders no longer use manager approval (estimate jobs only via EditEstimateJob)
  /* const hasNegativeMarketingAdjustment = useMemo(
    () =>
      (selectedProducts || []).some(
        (p) => p?.adj_value_type === false || p?.install_adj_value_type === false || p?.adj_value_type === 0 || p?.install_adj_value_type === 0,
      ) ||
      (additionalSelectedServices || []).some(
        (s) => s?.adj_value_type === false || s?.install_adj_value_type === false || s?.adj_value_type === 0 || s?.install_adj_value_type === 0,
      ) ||
      (selectedMaterials || []).some((m) => m?.adj_value_type === false || m?.adj_value_type === 0),
    [selectedProducts, additionalSelectedServices, selectedMaterials],
  );

  const managerApprovalLimit = Number(companyProfileData?.manager_approval_amount) || 5000;

  const isAboveLimit = useMemo(() => {
    if (isNoChargeJob) {
      const ncl = Number(companyProfileData?.no_charge_amount) || 5000;
      return Math.abs(parseFloat(grandTotal)) > Math.abs(ncl);
    }
    return parseFloat(grandTotal) > managerApprovalLimit;
  }, [isNoChargeJob, grandTotal, companyProfileData?.no_charge_amount, managerApprovalLimit]);

  const showManagerApprovalToggle = useMemo(() => {
    return isNoChargeJob || hasNegativeMarketingAdjustment;
  }, [isNoChargeJob, hasNegativeMarketingAdjustment]);

  const isLocked = useMemo(() => {
    return (isNoChargeJob && isAboveLimit) || (hasNegativeMarketingAdjustment && isAboveLimit);
  }, [isNoChargeJob, isAboveLimit, hasNegativeMarketingAdjustment]);

  const prevIsNoCharge = useRef(isNoChargeJob);
  const prevHasNeg = useRef(hasNegativeMarketingAdjustment);
  const prevIsAbove = useRef(isAboveLimit);

  useEffect(() => {
    if (isLocked) {
      if (!values.manager_approval_required) {
        setFieldValue('manager_approval_required', true);
      }
    } else {
      if (isNoChargeJob && !prevIsNoCharge.current) {
        setFieldValue('manager_approval_required', false);
      } else if (hasNegativeMarketingAdjustment && !prevHasNeg.current) {
        setFieldValue('manager_approval_required', true);
      }
      else if (!isAboveLimit && prevIsAbove.current && showManagerApprovalToggle) {
        setFieldValue('manager_approval_required', false);
      }
      else if (!isNoChargeJob && prevIsNoCharge.current && !hasNegativeMarketingAdjustment && !isAboveLimit) {
         setFieldValue('manager_approval_required', false);
      }
      else if (!showManagerApprovalToggle && values.manager_approval_required) {
        setFieldValue('manager_approval_required', false);
      }
    }
    prevIsNoCharge.current = isNoChargeJob;
    prevHasNeg.current = hasNegativeMarketingAdjustment;
    prevIsAbove.current = isAboveLimit;
  }, [isLocked, isNoChargeJob, hasNegativeMarketingAdjustment, isAboveLimit, showManagerApprovalToggle, values.manager_approval_required, setFieldValue]); */

  const selectedProductsAdditionalCost = selectedProducts?.filter(item=>item?.isAdditionalProduct == true)
      ?.reduce((total, item) => total + (item.product_total || 0), 0)
      ?.toFixed(2)

  const selectedMaterialSubTotal = selectedMaterials //?.filter(item=>item?.isAdditionalProduct == true)
    ?.reduce((total, item) => total + (((item.markUpCost + (item.adj_value_type ? Number(item.adjustment || 0) : -Number(item.adjustment || 0))) || 0) * (item.quantity || 0)), 0)
    ?.toFixed(2)    

  console.log("cartService--cartService--", cartService);
  console.log("cartService--rfpServiceLocationStates--", rfpServiceLocationStates);
  console.log("cartService--cart--", cart);
  console.log("cartService--rfpLocationStates--", rfpLocationStates);

  // const handleDrop = useCallback(
  //   (acceptedFiles) => {
  //     let permission =!explodedPermissions?.some((permission) => ['Upload Files Sales Order'].includes(permission))
  //     if(permission &&  user?.added_by_client ==1){
  //       return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
  //     }
  //     if (acceptedFiles && acceptedFiles.length > 0) {
  //       setIsUploading(true);
  //       const uploadPromises = acceptedFiles?.map((file) => {
  //         return new Promise((resolve, reject) => {
  //           const Filename = new Date().getTime() + file.name;
  //           const StorageRef = ref(storage, Filename);
  //           const uploadTask = uploadBytesResumable(StorageRef, file);

  //           uploadTask.on(
  //             'state_changed',
  //             (snapshot) => {
  //               const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
  //               setProgress(progress);
  //             },
  //             (error) => {
  //               console.error(error.message);
  //               setIsUploading(false);
  //               reject(error);
  //             },
  //             () => {
  //               getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //                 resolve({
  //                   url: downloadURL,
  //                   file_type: file.type,
  //                   extension: file.name.split('.').pop(),
  //                   size: file.size
  //                 });
  //               });
  //             }
  //           );
  //         });
  //       });

  //       Promise.all(uploadPromises)
  //         .then((downloadURLs) => {
  //           setAvatarUrl((prevAvatarUrls) => {
  //             const updatedFiles = downloadURLs.map((file) => ({
  //               url: file.url,
  //               file_type: file.file_type,
  //               extension: file.extension,
  //               size: file.size
  //             }));
  //             return [...prevAvatarUrls, ...updatedFiles]
  //           });
  //           setIsUploading(false);
  //         })
  //         .catch((error) => {
  //           console.error(error.message);
  //           setIsUploading(false);
  //         });
  //     }
  //   },
  //   [setFieldValue]
  // );

  const handleDrop = useCallback(
  async (acceptedFiles) => {
    const noPermission = !explodedPermissions?.some(
      (p) => p === 'Upload Files Sales Order'
    );
    if (noPermission && user?.added_by_client === 1) {
      enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
        variant: 'error',
      });
      return;
    }

    if (!acceptedFiles || acceptedFiles.length === 0) return;

    setIsUploading(true);

    try {
      const uploadPromises = acceptedFiles.map(async (file, index) => {
        const timestamp = Date.now();
        const sanitizedFileName = file.name.replace(/\s+/g, '_');
        const fileName = `${timestamp}_${index}_${sanitizedFileName}`;
        const filePath = `sales-orders/${fileName}`;

        const { error: uploadError } = await supabase.storage
          .from('signwise-attachments')
          .upload(filePath, file);

        if (uploadError) throw uploadError;

        const {
          data: publicUrlData,
          error: urlError,
        } = supabase.storage
          .from('signwise-attachments')
          .getPublicUrl(filePath);

        if (urlError || !publicUrlData?.publicUrl) {
          throw new Error('Failed to generate public URL');
        }

        return {
          url: publicUrlData.publicUrl,
          file_type: file.type,
          extension: file.name.split('.').pop(),
          size: file.size,
        };
      });

      const uploadedFiles = await Promise.all(uploadPromises);
      setAvatarUrl((prev) => [...prev, ...uploadedFiles]);
    } catch (error) {
      console.error('Upload error:', error.message);
      enqueueSnackbar('Upload failed: ' + error.message, { variant: 'error' });
    } finally {
      setIsUploading(false);
    }
  },
  [explodedPermissions, user, setAvatarUrl, setIsUploading]
); // image storing with supabase

  const handleRemoveAll = () => {
    const removed = [...avatarUrl];
    setAvatarUrl([]);
    if (removed.length === 0) return;
    setProductAttachments((prev) =>
      removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev),
    );
    setServiceAttachments((prev) =>
      removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev),
    );
    setSelectedUploadedImages((prev) =>
      removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev),
    );
    setSelectedUploadedImagesService((prev) =>
      removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev),
    );
  };

  const handleRemove = (file) => {
    if (file?._productAttachment) {
      const productIndexId = file?.product_index_id;
      if (productIndexId != null && String(productIndexId) !== '') {
        handleProductRemove(file, productIndexId);
        return;
      }
    }
    if (file?._serviceAttachment) {
      const serviceIndexId = file?.service_index_id;
      if (serviceIndexId != null && String(serviceIndexId) !== '') {
        handleServiceRemove(file, serviceIndexId);
        return;
      }
    }

    const removeKey = attachmentFileKey(file);
    setAvatarUrl((prev) =>
      prev.filter((f) => (removeKey ? attachmentFileKey(f) !== removeKey : !attachmentMatches(f, file))),
    );
    setProductAttachments((prev) => pruneAttachmentMapsByFile(prev, file));
    setServiceAttachments((prev) => pruneAttachmentMapsByFile(prev, file));
    setSelectedUploadedImages((prev) => pruneAttachmentMapsByFile(prev, file));
    setSelectedUploadedImagesService((prev) => pruneAttachmentMapsByFile(prev, file));
  };

  // Product attachment handlers
  const handleProductDrop = useCallback(
    async (acceptedFiles, productIndexId) => {
      const noPermission = !explodedPermissions?.some(
        (p) => p === 'Upload Files Sales Order'
      );
      if (noPermission && user?.added_by_client === 1) {
        enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
          variant: 'error',
        });
        return;
      }

      if (!acceptedFiles || acceptedFiles.length === 0) return;

      // Single file upload (commented for backup)
      // const file = acceptedFiles[0];

      setIsUploadingProduct(prev => ({ ...prev, [productIndexId]: true }));

      try {
        // Multiple file upload
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now();
          const sanitizedFileName = file.name.replace(/\s+/g, '_');
          const fileName = `${timestamp}_${sanitizedFileName}`;
          const filePath = `sales-orders/${fileName}`;

          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);

          if (uploadError) throw uploadError;

          const {
            data: publicUrlData,
            error: urlError,
          } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }

          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
            name: file.name,
            product_index_id: productIndexId,
          };
        });

        const uploadedFiles = await Promise.all(uploadPromises);

        const pKey = String(productIndexId ?? '');
        setProductAttachments((prev) => {
          const current = prev[pKey] || prev[productIndexId] || [];
          const existingKeys = current.map(attachmentFileKey);
          const newFiles = uploadedFiles
            .map((f) => ({ ...f, product_index_id: productIndexId }))
            .filter((f) => !existingKeys.includes(attachmentFileKey(f)));
          return {
            ...prev,
            [pKey]: [...current, ...newFiles],
          };
        });
        setSelectedUploadedImages((prev) => {
          const current = prev[pKey] || prev[productIndexId] || [];
          const merged = [...current];
          uploadedFiles.forEach((file) => {
            const withMeta = { ...file, product_index_id: productIndexId };
            if (!merged.some((f) => attachmentMatches(f, withMeta))) {
              merged.push(withMeta);
            }
          });
          return { ...prev, [pKey]: merged };
        });

        // Single file upload (commented for backup)
        // setProductAttachments((prev) => ({
        //   ...prev,
        //   [productIndexId]: [uploadedFile],
        // }));
        
      } catch (error) {
        console.error('Error uploading product file:', error);
        enqueueSnackbar('Failed to upload file', { variant: 'error' });
      } finally {
        setIsUploadingProduct(prev => ({ ...prev, [productIndexId]: false }));
      }
    },
    [explodedPermissions, user, enqueueSnackbar]
  );

  const handleProductIconDragOver = (e, productIndexId) => {
    if (e.dataTransfer?.types?.includes('Files')) {
      e.preventDefault();
      e.stopPropagation();
      setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: true }));
    }
  };

  const handleProductIconDragLeave = (e, productIndexId) => {
    e.preventDefault();
    e.stopPropagation();
    const related = e.relatedTarget;
    if (related && e.currentTarget.contains(related)) return;
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: false }));
  };

  const handleProductIconDrop = (e, productIndexId) => {
    e.preventDefault();
    e.stopPropagation();
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: false }));
    const files = Array.from(e.dataTransfer?.files || []);
    if (files.length > 0) {
      handleProductDrop(files, productIndexId);
    }
  };

  const handleProductRemove = (file, productIndexId) => {
    const key = String(productIndexId ?? '');
    setProductAttachments((prev) => {
      const current = prev[key] || prev[productIndexId] || [];
      if (!file) {
        return { ...prev, [key]: [] };
      }
      const filtered = current.filter((f) => !attachmentMatches(f, file));
      return {
        ...prev,
        [key]: filtered,
      };
    });
    if (file) {
      const removeKey = attachmentFileKey(file);
      setAvatarUrl((prev) =>
        prev.filter((f) => (removeKey ? attachmentFileKey(f) !== removeKey : !attachmentMatches(f, file))),
      );
      setServiceAttachments((prev) => pruneAttachmentMapsByFile(prev, file));
      setSelectedUploadedImages((prev) => pruneAttachmentMapsByFile(prev, file));
      setSelectedUploadedImagesService((prev) => pruneAttachmentMapsByFile(prev, file));
    }
  };

  // Service attachment handlers
  const handleServiceDrop = useCallback(
    async (acceptedFiles, serviceIndexId) => {
      const noPermission = !explodedPermissions?.some(
        (p) => p === 'Upload Files Sales Order'
      );
      if (noPermission && user?.added_by_client === 1) {
        enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
          variant: 'error',
        });
        return;
      }

      if (!acceptedFiles || acceptedFiles.length === 0) return;

      setIsUploadingService((prev) => ({ ...prev, [serviceIndexId]: true }));

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now();
          const sanitizedFileName = file.name.replace(/\s+/g, '_');
          const fileName = `${timestamp}_${sanitizedFileName}`;
          const filePath = `sales-orders/${fileName}`;

          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);

          if (uploadError) throw uploadError;

          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }

          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
            name: file.name,
            service_index_id: serviceIndexId,
          };
        });

        const uploadedFiles = await Promise.all(uploadPromises);

        const sKey = String(serviceIndexId ?? '');
        setServiceAttachments((prev) => {
          const current = prev[sKey] || prev[serviceIndexId] || [];
          const existingKeys = current.map(attachmentFileKey);
          const newFiles = uploadedFiles
            .map((f) => ({ ...f, service_index_id: serviceIndexId }))
            .filter((f) => !existingKeys.includes(attachmentFileKey(f)));
          return {
            ...prev,
            [sKey]: [...current, ...newFiles],
          };
        });
        setSelectedUploadedImagesService((prev) => {
          const current = prev[sKey] || prev[serviceIndexId] || [];
          const merged = [...current];
          uploadedFiles.forEach((file) => {
            const withMeta = { ...file, service_index_id: serviceIndexId };
            if (!merged.some((f) => attachmentMatches(f, withMeta))) {
              merged.push(withMeta);
            }
          });
          return { ...prev, [sKey]: merged };
        });
      } catch (error) {
        console.error('Error uploading service file:', error);
        enqueueSnackbar('Failed to upload file', { variant: 'error' });
      } finally {
        setIsUploadingService((prev) => ({ ...prev, [serviceIndexId]: false }));
      }
    },
    [explodedPermissions, user, enqueueSnackbar]
  );

  const handleServiceIconDragOver = (e, serviceIndexId) => {
    if (e.dataTransfer?.types?.includes('Files')) {
      e.preventDefault();
      e.stopPropagation();
      setServiceAttachmentDragOver((prev) => ({ ...prev, [serviceIndexId]: true }));
    }
  };

  const handleServiceIconDragLeave = (e, serviceIndexId) => {
    e.preventDefault();
    e.stopPropagation();
    const related = e.relatedTarget;
    if (related && e.currentTarget.contains(related)) return;
    setServiceAttachmentDragOver((prev) => ({ ...prev, [serviceIndexId]: false }));
  };

  const handleServiceIconDrop = (e, serviceIndexId) => {
    e.preventDefault();
    e.stopPropagation();
    setServiceAttachmentDragOver((prev) => ({ ...prev, [serviceIndexId]: false }));
    const files = Array.from(e.dataTransfer?.files || []);
    if (files.length > 0) {
      handleServiceDrop(files, serviceIndexId);
    }
  };

  const handleServiceRemove = (file, serviceIndexId) => {
    const key = String(serviceIndexId ?? '');
    if (!file) {
      setServiceAttachments((prev) => ({ ...prev, [key]: [] }));
      return;
    }
    setServiceAttachments((prev) => {
      const current = prev[key] || prev[serviceIndexId] || [];
      const filtered = current.filter((f) => !attachmentMatches(f, file));
      return {
        ...prev,
        [key]: filtered,
      };
    });
    const removeKey = attachmentFileKey(file);
    setAvatarUrl((prev) =>
      prev.filter((f) => (removeKey ? attachmentFileKey(f) !== removeKey : !attachmentMatches(f, file))),
    );
    setProductAttachments((prev) => pruneAttachmentMapsByFile(prev, file));
    setSelectedUploadedImages((prev) => pruneAttachmentMapsByFile(prev, file));
    setSelectedUploadedImagesService((prev) => pruneAttachmentMapsByFile(prev, file));
  };

  const uploadDesignsDisplayFiles = useMemo(() => {
    const allProductAttachmentFiles = Object.values(productAttachments).flat();
    const allServiceAttachmentFiles = Object.values(serviceAttachments).flat();
    const productAttachmentKeys = new Set(
      allProductAttachmentFiles.map(attachmentFileKey).filter(Boolean),
    );
    const serviceAttachmentKeys = new Set(
      allServiceAttachmentFiles.map(attachmentFileKey).filter(Boolean),
    );

    const availableAvatarFiles = (avatarUrl || [])
      .filter((file) => {
        const fileKey = attachmentFileKey(file);
        return (
          (!fileKey || !productAttachmentKeys.has(fileKey)) &&
          (!fileKey || !serviceAttachmentKeys.has(fileKey))
        );
      })
      .map((file) => ({
        ...file,
        product_index_id: undefined,
        service_index_id: undefined,
        productNames: [],
        serviceNames: [],
        _productAttachment: false,
        _serviceAttachment: false,
      }));

    const productFiles = allProductAttachmentFiles.map((file) => {
      const product = (selectedProducts || []).find(
        (p) => Number(p?.indexId) === Number(file.product_index_id),
      );
      const productName = product?.product_name || product?.name || '';
      const location_ids =
        product?.location
          ?.map((loc) => loc.id || loc.request_location_id)
          .filter(Boolean)
          .join(',') || String(file.product_index_id ?? '');
      return {
        ...file,
        url: file.url || file.name,
        name: file.name || file.url,
        location_ids,
        productNames: productName
          ? [{ product_id: product?.product_id || product?.id, product_name: productName }]
          : [],
        product_index_id: file.product_index_id,
        _productAttachment: true,
      };
    });

    const serviceFiles = allServiceAttachmentFiles.map((file) => {
      const svc =
        additionalSelectedServices?.find(
          (s) => String(s.newIndexId ?? s.indexId) === String(file.service_index_id),
        ) ||
        selectedServices?.find(
          (s) => String(s.indexId ?? s.id) === String(file.service_index_id),
        ) ||
        null;
      const serviceName = svc?.name || svc?.service_name || '';
      return {
        ...file,
        url: file.url || file.name,
        name: file.name || file.url,
        serviceNames: serviceName ? [{ service_name: serviceName }] : [],
        service_index_id: file.service_index_id,
        _serviceAttachment: true,
      };
    });

    const all = [...availableAvatarFiles, ...productFiles, ...serviceFiles];
    const seenKeys = new Set();
    return all.filter((file) => {
      const key = attachmentFileKey(file);
      if (key && seenKeys.has(key)) return false;
      if (key) seenKeys.add(key);
      return true;
    });
  }, [
    productAttachments,
    serviceAttachments,
    avatarUrl,
    selectedProducts,
    additionalSelectedServices,
    selectedServices,
  ]);

  const renderAttachmentModalContent = ({
    itemKey,
    isService = false,
    tabValue,
    onTabChange,
    selectedImages,
    linkedAttachments,
    onImageSelect,
    onAddSelected,
    onDrop,
    onRemove,
    isUploadingItem,
  }) => (
    <Grid
      container
      spacing={3}
      sx={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Upload Attachment
        </Typography>
        <Tabs
          value={tabValue || 0}
          onChange={(e, newValue) => onTabChange(e, newValue, itemKey)}
          sx={{ mb: 2 }}
        >
          <Tab label="Select from Uploaded" />
          <Tab label="Upload New" />
        </Tabs>

        {(tabValue || 0) === 0 ? (
          <Box>
            {(() => {
              const allProductAttachmentFiles = isService
                ? []
                : Object.values(productAttachments).flat()
              const allServiceAttachmentFiles = Object.values(serviceAttachments).flat()
              const currentLinkedAttachments = linkedAttachments || []

              const availableAvatarFiles = (avatarUrl || []).filter((file) => (
                !allProductAttachmentFiles.some((pfile) => attachmentMatches(pfile, file)) &&
                !allServiceAttachmentFiles.some((sfile) => attachmentMatches(sfile, file))
              ))

              const enrichProductAttachment = (file) => {
                const product = (selectedProducts || []).find(
                  (p) =>
                    Number(p?.indexId) === Number(file.product_index_id) ||
                    Number(p?.indexId) === Number(itemKey),
                )
                if (!product) {
                  return {
                    ...file,
                    product_index_id: file.product_index_id ?? itemKey,
                  }
                }
                const locationIds =
                  product.location
                    ?.map((loc) => loc.id || loc.request_location_id)
                    .filter(Boolean)
                    .join(',') || ''
                const productName = product.product_name || product.name || ''
                return {
                  ...file,
                  product_index_id: file.product_index_id ?? product.indexId ?? itemKey,
                  location_ids: file.location_ids || locationIds || String(itemKey),
                  productNames: file.productNames || (productName
                    ? [
                        {
                          product_id: product.product_id || product.id,
                          product_name: productName,
                        },
                      ]
                    : []),
                }
              }

              const enrichServiceAttachment = (file) => {
                const svc =
                  additionalSelectedServices?.find(
                    (s) =>
                      String(s.newIndexId ?? s.indexId) === String(file.service_index_id ?? itemKey),
                  ) || null
                const serviceName = svc?.name || svc?.service_name || ''
                return {
                  ...file,
                  service_index_id: file.service_index_id ?? itemKey,
                  serviceNames: file.serviceNames || (serviceName ? [{ service_name: serviceName }] : []),
                }
              }

              const allFiles = isService
                ? [
                    ...availableAvatarFiles,
                    ...allServiceAttachmentFiles.map(enrichServiceAttachment),
                    ...currentLinkedAttachments.map(enrichServiceAttachment),
                  ]
                : [
                    ...availableAvatarFiles,
                    ...allProductAttachmentFiles.map(enrichProductAttachment),
                    ...currentLinkedAttachments.map(enrichProductAttachment),
                  ]

              const allFilesUnique = (() => {
                const seen = []
                return allFiles.filter((file) => {
                  if (seen.some((f) => attachmentMatches(f, file))) return false
                  seen.push(file)
                  return true
                })
              })()

              if (allFilesUnique.length === 0) {
                return (
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                    No uploaded files available. Please upload files first.
                  </Typography>
                )
              }

              const availableImages = isService
                ? allFilesUnique.filter((file) => {
                    const isAddedToOtherService = Object.entries(serviceAttachments).some(
                      ([serviceId, attachments]) => {
                        if (String(serviceId) === String(itemKey)) return false
                        return (
                          attachments &&
                          attachments.some((f) => attachmentMatches(f, file))
                        )
                      },
                    )
                    const isAddedToAnyProduct = Object.values(productAttachments).some(
                      (atts) => atts && atts.some((f) => attachmentMatches(f, file)),
                    )
                    return !isAddedToOtherService && !isAddedToAnyProduct
                  })
                : allFilesUnique.filter((file) => {
                    const isAddedToOtherProduct = Object.entries(productAttachments).some(
                      ([productId, attachments]) => {
                        if (String(productId) === String(itemKey)) return false
                        return (
                          attachments &&
                          attachments.some((f) => attachmentMatches(f, file))
                        )
                      },
                    )
                    const isUsedOnService = Object.values(serviceAttachments).some(
                      (atts) => atts && atts.some((f) => attachmentMatches(f, file)),
                    )
                    return !isAddedToOtherProduct && !isUsedOnService
                  })

              if (availableImages.length === 0) {
                return (
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                    {isService
                      ? 'All files are already linked to other items.'
                      : 'All images are added to other products. No images left in the uploaded files.'}
                  </Typography>
                )
              }

              const toLink = (selectedImages || []).filter(
                (file) => !(linkedAttachments || []).some((orig) => attachmentMatches(orig, file)),
              )
              const toUnlink = (linkedAttachments || []).filter(
                (file) => !(selectedImages || []).some((sel) => attachmentMatches(sel, file)),
              )
              const hasChanges = toLink.length > 0 || toUnlink.length > 0

              return (
                <>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    {availableImages.map((file, idx) => {
                      const isSelected = (selectedImages || []).some((f) => attachmentMatches(f, file))
                      const isAlreadyAddedToCurrent = (linkedAttachments || []).some((f) => attachmentMatches(f, file))
                      return (
                        <Grid item xs={6} sm={4} md={3} key={idx}>
                          <Card
                            sx={{
                              position: 'relative',
                              border: isSelected ? '2px solid' : '1px solid',
                              borderColor: isSelected ? 'primary.main' : 'divider',
                              cursor: 'pointer',
                              opacity: 1,
                            }}
                            onClick={() => onImageSelect(file, itemKey, !isSelected)}
                          >
                            <Box
                              sx={{
                                position: 'relative',
                                width: '100%',
                                paddingTop: '100%',
                                overflow: 'hidden',
                              }}
                            >
                              {(() => {
                                const url = file.url || file.name
                                const preview = file.preview || url
                                const isActualPdf = file.file_type === 'pdf' || file.file_type === 'application/pdf' || file.extension === 'pdf' || (file.name || '').toLowerCase().split('?')[0].endsWith('.pdf')
                                const isImage = file.file_type?.startsWith('image/') || file.file_type === 'img' || file.file_type === 'image'

                                return isActualPdf ? (
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setPdfLoading(true)
                                      setSelectedPDF(url)
                                      setOpenPDFModal(true)
                                      setUseOfficeViewer(true)
                                    }}
                                    aria-label="open pdf"
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      p: 0,
                                      borderRadius: 0,
                                    }}
                                  >
                                    <Box
                                      component="iframe"
                                      src={url}
                                      title="PDF Preview"
                                      frameBorder="0"
                                      sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        pointerEvents: 'none',
                                      }}
                                    />
                                  </IconButton>
                                ) : !isImage ? (
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      window.open(url, '_blank')
                                    }}
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      p: 0,
                                      borderRadius: 0,
                                    }}
                                  >
                                    <Description style={{ fontSize: 50, color: 'gray' }} />
                                  </IconButton>
                                ) : (
                                  <Box
                                    component="img"
                                    src={preview}
                                    alt={file.name || 'Uploaded file'}
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                    }}
                                    onError={(e) => {
                                      if (preview !== url) {
                                        e.target.src = url
                                      }
                                    }}
                                  />
                                )
                              })()}
                              <AttachmentDownloadIconButton
                                file={file}
                                fileIndex={idx}
                                hidden={isClient || userType === 3}
                                sx={{
                                  position: 'absolute',
                                  top: 4,
                                  left: 4,
                                  zIndex: 2,
                                }}
                              />
                              <Checkbox
                                checked={isSelected}
                                sx={{
                                  position: 'absolute',
                                  top: 4,
                                  right: 4,
                                  bgcolor: 'rgba(255, 255, 255, 0.8)',
                                }}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  onImageSelect(file, itemKey, !isSelected)
                                }}
                              />
                              {isAlreadyAddedToCurrent && isSelected && (
                                <Chip
                                  label="Added"
                                  size="small"
                                  color="success"
                                  sx={{
                                    position: 'absolute',
                                    bottom: 4,
                                    left: 4,
                                  }}
                                />
                              )}
                            </Box>
                          </Card>
                        </Grid>
                      )
                    })}
                  </Grid>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <AttachmentDownloadAllButton
                      files={selectedImages || []}
                      allFiles={availableImages}
                      onToggleSelectAll={(checked) => {
                        availableImages.forEach((file) =>
                          onImageSelect(file, itemKey, checked),
                        )
                      }}
                      label="Download Selected"
                      hidden={isClient || userType === 3}
                    />
                    <Button
                      variant="contained"
                      onClick={() => onAddSelected(itemKey)}
                      disabled={!hasChanges}
                    >
                      Save Selection ({selectedImages?.length || 0})
                    </Button>
                  </Box>
                </>
              )
            })()}
          </Box>
        ) : (
          <UploadMultiFile
            showPreview
            multiple={true}
            maxSize={1024 * 1024 * 1024}
            files={linkedAttachments || []}
            onDrop={(acceptedFiles) => onDrop(acceptedFiles, itemKey)}
            onRemove={(file) => onRemove(file, itemKey)}
            onRemoveAll={() => onRemove(null, itemKey)}
            isUploading={isUploadingItem || false}
          />
        )}
      </Grid>
    </Grid>
  )

  const handleCancel = async () => {
    setOpenBackConfirm(true);
  }

  // Auto-save confirmation dialog handlers
  const handleBackConfirmYes = async () => {
    setOpenBackConfirm(false);
    try {
      await formik.submitForm();
      // Navigation will happen in onSubmit success handler
    } catch (error) {
      console.error('Auto-save failed:', error);
      // Still proceed with cancel on error
      handleCancelAction();
    }
  };

  const handleBackConfirmNo = () => {
    setOpenBackConfirm(false);
    handleCancelAction();
  };

  const handleCancelAction = () => {
    setOpen(false);
    formik.resetForm();
    setSelectedProducts([]);
    setSelectedMapserviceProducts([]);
    setSelectedServices([]);
    setAdditionalSelectedServices([])
    setFilteredServices([])
    setShowAddNewRow(false)
    setAllLocationSame(false)
    setAvatarUrl([])
    setAllMaterials([])
    setSelectedTaxCategory(null);
    setRfps([])
    setSelectedRfp(null)
    setRfpServices([])
    setRfpProducts([])
    setCart([])
    setCartService([])
    setTabIndex(0)
    setSelectedMaterials([])
    setCollaborators([])
  }

  // const filteredProductOptions = useMemo(() => {
  //   return (allProducts || []).filter((option) => {
  //       // OLD CODE - Prevents multiple selections of same product
  //       // const notAlreadySelected = !selectedProducts?.some((selected) => selected.id === option.id);
  //       // if (!notAlreadySelected) return false;
        
  //       // NEW CODE - Allow multiple selections of the same product for different designs
  //       // Commented out the filter to enable multiple selections

  //     const categoryId = values?.project_categories?.id;
  //     const catalogType = values?.catalog_type;

  //     if (categoryId === 15) {
  //       if(catalogType?.inhouse == 4){
  //         return option.inhouse === 4;
  //       }else if(catalogType?.inhouse == 5){
  //         return option.inhouse === 5;
  //       }else if (catalogType?.isTrafficCatalog){
  //         return option.isTrafficCatalog === 1
  //       }
  //     }else if(categoryId === 11) {
  //        return (option.inhouse === 5 || option.isTrafficCatalog)
  //     }

  //     // return option.inhouse !== 0;
  //     return option;
  //   });
  // }, [allProducts, selectedProducts, values?.project_categories?.id,values?.catalog_type?.inhouse]);

  const filteredProductOptions = useMemo(() => {
    const filtered = (allProducts || []).filter((option) => {
      // Active catalogs only (pending estimate catalogs may be status 0)
      const isPendingEstimateCatalog =
        Number(option.status) === 0 &&
        Number(option.created_with_approval) === 1 &&
        Number(option.inhouse) === 7
      if (Number(option.status) !== 1 && !isPendingEstimateCatalog) {
        return false
      }

      // Check if product is already selected for the same facility
      // const notAlreadySelected = !selectedProducts?.some(
      //   (selected) =>
      //     selected.id === option.id &&
      //     selected.facility_id === option.facility_id
      // );
      // if (!notAlreadySelected) return false;

      // For split orders, enforce facility matching; for non-split, do not restrict by facility
      if (isSplitOrder) {
        const selectedFacilities = values?.facility_type || [];
        if (selectedFacilities.length === 0) return false;
        const selectedIds = new Set(selectedFacilities.map((f) => Number(f.id)));
        const facilityMatch = selectedIds.has(Number(option.facility_id));
        if (!facilityMatch) return false;
      } else{
        const selectedFacilities = FacilityTypes.filter((f) => Number(f.id) === Number(currentFacilityId));
        if (selectedFacilities.length === 0) return false;
        const selectedIds = new Set(selectedFacilities.map((f) => Number(f.id)));
        const facilityMatch = selectedIds.has(Number(option.facility_id));
        if (!facilityMatch) return false;
      }

      const categoryId = values?.project_categories?.id;
      const catalogType = values?.catalog_type;
      const splitCatalogType = values?.split_catalog_type;

      // For split orders, use split catalog type for filtering
      if (isSplitOrder) {
        // If "All" is selected, show all products regardless of inhouse value
        if(splitCatalogType?.id === 'all' && categoryId == 11){
          return (option.inhouse === 5 || option.isTrafficCatalog === 1);
        }
        if (splitCatalogType?.id === 'all') {
          return true;
        }
        // Otherwise, filter based on the selected split catalog type
        if (splitCatalogType?.inhouse === 4) {
          return option.inhouse === 4;
        } else if (splitCatalogType?.inhouse === 5) {
          return option.inhouse === 5;
        } else if (splitCatalogType?.inhouse === 1 && !splitCatalogType?.isTrafficCatalog) {
          return option.inhouse === 1 ;
        } else if (splitCatalogType?.inhouse === 6) {
          return option.inhouse === 6;
        } else if (splitCatalogType?.isTrafficCatalog) {
          return option.isTrafficCatalog === 1;
        }else if (splitCatalogType?.inhouse === 7) {
          return option.inhouse === 7;
        }
        return true; // Default to show all for split orders
      }

      // Check for specific project category logic first
      if (categoryId === 15) {
        if(catalogType?.inhouse == 4){
          return option.inhouse === 4;
        }else if(catalogType?.inhouse == 5){
          return option.inhouse === 5;
        }else if (catalogType?.isTrafficCatalog){
          return option.isTrafficCatalog === 1
        }
      }else if(categoryId === 11) {
        // Service Only: filter based on selected catalog type
        if (values?.split_catalog_type) {
          const normalCatalogType = values.split_catalog_type;
          // If "All" is selected, show both client owned and traffic catalog
          if (normalCatalogType?.id === 'all') {
            return (option.inhouse === 5 || option.isTrafficCatalog === 1);
          }
          // Client Owned
          if (normalCatalogType?.inhouse === 5) {
            return option.inhouse === 5;
          }
          // Traffic Catalog
          if (normalCatalogType?.isTrafficCatalog) {
            return option.isTrafficCatalog === 1;
          }
        }
        // Default for Service Only: show both client owned and traffic catalog
        return (option.inhouse === 5 || option.isTrafficCatalog === 1);
      }

      // For normal orders, check split_catalog_type if it's set
      if (values?.split_catalog_type) {
        const normalCatalogType = values.split_catalog_type;
        // If "All" is selected, show all products except split catalog
        if (normalCatalogType?.id === 'all') {
          return option.inhouse !== 6;
        }
        // Otherwise, filter based on the selected catalog type
        // Check isTrafficCatalog first before inhouse === 1 to avoid conflicts
        if (normalCatalogType?.isTrafficCatalog) {
          return option.isTrafficCatalog === 1;
        } else if (normalCatalogType?.inhouse === 4) {
          return option.inhouse === 4;
        } else if (normalCatalogType?.inhouse === 5) {
          return option.inhouse === 5;
        } else if (normalCatalogType?.inhouse === 1) {
          return option.inhouse === 1 && option.isTrafficCatalog !== 1; // Production Catalog (inhouse 1 but not traffic)
        } else if (normalCatalogType?.inhouse === 0) {
          return option.inhouse === 0; // Sub Contract
        } else if (normalCatalogType?.inhouse === 7) {
          return option.inhouse === 7; // Estimate Catalog
        }
        // If no match, exclude split catalog
        return option.inhouse !== 6;
      }

      // if (categoryId === 15) {
      //   if(catalogType?.inhouse == 4){
      //     return option.inhouse === 4;
      //   }else if(catalogType?.inhouse == 5){
      //     return option.inhouse === 5;
      //   }else if (catalogType?.isTrafficCatalog){
      //     return option.isTrafficCatalog === 1
      //   }
      // }else if(categoryId === 11) {
      //    return (option.inhouse === 5 || option.isTrafficCatalog)
      // }
      return option.inhouse !== 6;
    });

    // Sort in strict alphanumeric order based on description and name only (ignore suffix)
    return filtered.sort((a, b) => {
      const getSortKey = (option) => {
        const name = (option.name || '').trim();
        const description = (option.description || '').trim();
        // Sort by description first, then by name for strict alphanumeric order
        // Combine description and name, separated by space for proper sorting
        const sortString = `${name}`.trim();
        return sortString;
      };

      const keyA = getSortKey(a);
      const keyB = getSortKey(b);
      
      // Strict alphanumeric sort: case-insensitive with natural numeric ordering
      return keyA.localeCompare(keyB, undefined, { 
        numeric: true, 
        sensitivity: 'base' 
      });
    });
  }, [allProducts, selectedProducts, values?.project_categories?.id, values?.catalog_type?.inhouse, values?.facility_type, isSplitOrder, values?.split_catalog_type, currentFacilityId]);

  // Helper function to filter selected products based on facility selection
  const filterSelectedProductsByFacility = (selectedFacilities) => {
    if (!selectedFacilities || selectedFacilities.length === 0) {
      return [];
    }

    const hasArizona = selectedFacilities.some(facility => facility.id === 1);
    const hasRiverside = selectedFacilities.some(facility => facility.id === 2);

    return selectedProducts.filter(product => {
      // If only Arizona is selected, keep products with undefined/null facility_id
      if (hasArizona && !hasRiverside) {
        return product.facility_id === undefined || product.facility_id === null;
      }
      // If only Riverside is selected, keep only products with facility_id = 2
      else if (hasRiverside && !hasArizona) {
        return product.facility_id === 2;
      }
      // If both are selected, keep all products
      return true;
    });
  };

    const filteredServiceOptions = useMemo(() => {
    const filtered = (labourCostServices || []).filter((option) => {
      // const notAlreadySelected = !selectedProducts?.some((selected) => selected.id === option.id);
      // if (!notAlreadySelected) return false;

      const selectedFacilities = isSplitOrder ? (values?.facility_type || []) : FacilityTypes.filter((f) => Number(f.id) === Number(currentFacilityId));
      if (selectedFacilities.length === 0) return false;
      const selectedIds = new Set(selectedFacilities.map((f) => Number(f.id)));
      const serviceFacilityId = option?.facility_id != null ? Number(option.facility_id) : Number(currentFacilityId);
      if (!selectedIds.has(serviceFacilityId)) return false;

      const categoryId = values?.project_categories?.id;
      const installLabour = option?.id;

      if (categoryId === 12) {
        if(installLabour){
          return option.id === 10;
        }
      }
      // Production catalog services (inhouse === 1) belong on production flows, not sales-order additional services.
      if (Number(option.inhouse) === 1) {
        return false;
      }
      return option.status == 1;
    });
    // Sort services alphanumerically by name
    return [...filtered].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''));
  }, [labourCostServices, selectedServices, values?.project_categories?.id, values?.facility_type, isSplitOrder, currentFacilityId]);

  console.log('filteredServiceOptions', filteredServiceOptions)
  const getSplitFacilityServiceOptions = (facility) => {
    const options = filteredServiceOptions?.filter((opt) => Number(opt?.facility_id) === Number(facility?.id)) || []
    if (Number(facility?.id) !== Number(currentFacilityId)) return options

    const seen = new Set()
    return options.filter((option) => {
      const key = `${option?.id ?? ''}-${option?.facility_id ?? currentFacilityId}`
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })
  }
useEffect(() => {
  if (values?.project_categories?.id !== 12) return;

  const service10 = (labourCostServices || []).find(s => s.id === 10);
  if (!service10) return;

  const alreadySelected = (values.services || []).some(s => s.id === 10);
  if (alreadySelected) return;

  // Pull community address just like in onChange
  const {
    address: projAddress = '',
    city: projCity = '',
    state: projState = '',
    zip: projZip = '',
  } = values?.community || {};

  const communityAddress = {
    address: projAddress,
    city: projCity,
    state: projState,
    zip: projZip,
  };
  const hasCommunityAddress = projAddress && projCity && projState && projZip;

  // prev services for address propagation / allServiceLocationSame
  const prevServices = values.services || [];
  let assignedService;

  if (hasCommunityAddress) {
    // same utility used in onChange
    assignedService = assignAddresses(
      prevServices,
      service10,
      allServiceLocationSame,
      communityAddress
    );
  } else {
    assignedService = {
      ...service10,
      addresses: [
        { id: 0, address: '', city: '', state: '', zip: '' },
      ],
    };

    // respect allServiceLocationSame like onChange
    if (allServiceLocationSame && prevServices.length > 0) {
      const commonAddress = { ...(prevServices[0]?.addresses?.[0] || {}) };
      assignedService.addresses[0] = commonAddress;
    }
  }

  const newIndexCounter = serviceIndexCounter + 1;
  setServiceIndexCounter(newIndexCounter);

  const serviceWithIndex = { ...assignedService, indexId: newIndexCounter , delivery_installation: {
    delivery_type_id: 1,
    installer_facility_id: Number(currentFacilityId),
  }, };

  const nextServices = [...prevServices, serviceWithIndex];
  setFieldValue('services', nextServices);
  setAdditionalSelectedServices(nextServices);
  setShowAddNewRow(true);
}, [
  values?.project_categories?.id,
  labourCostServices,
  values?.community,
  allServiceLocationSame,
  serviceIndexCounter
]);

  const syncProductsForJobTypeChange = (products = [], newValue) => {
    const nextIsNoCharge = newValue?.name == 'No Charge' || newValue?.id == 13

    return (products || []).map((product) => {
      if (product?.inhouse === 0) return product

      if (nextIsNoCharge) {
        const baseInstallCost = parseFloat(product?.expected_install_labor_cost) || 0
        const installAdj = parseFloat(product?.install_adjustment) || 0
        const signedInstallAdj = product?.install_adj_value_type === false ? -installAdj : installAdj
        const installCost = Math.max(0, baseInstallCost + signedInstallAdj)
        const expectedCost = (parseFloat(product?.expected_service_cost) || 0) + (parseFloat(product?.expected_material_cost) || 0)
        const installQty = Number(product?.install_quantity) || 1
        const prodQty = Number(product?.quantity) || 1
        const installEach = prodQty > 0 ? (installCost * (installQty / prodQty)) : installCost
        const calculatedRetailPrice = installEach > 0 ? expectedCost + installEach : expectedCost
        const adjustment = product?.adj_value_type ? (Number(product?.adjustment) || 0) : -(Number(product?.adjustment) || 0)

        return {
          ...product,
          expected_cost_before_no_charge: product?.expected_cost_before_no_charge ?? product?.expected_cost,
          retail_price_before_no_charge: product?.retail_price_before_no_charge ?? product?.retail_price,
          actual_retail_price_before_no_charge: product?.actual_retail_price_before_no_charge ?? product?.actual_retail_price,
          product_retail_price_before_no_charge: product?.product_retail_price_before_no_charge ?? product?.product_retail_price,
          price_before_no_charge: product?.price_before_no_charge ?? product?.price,
          original_actual_retail_price_before_no_charge: product?.original_actual_retail_price_before_no_charge ?? product?.original_actual_retail_price,
          original_retail_price_before_no_charge: product?.original_retail_price_before_no_charge ?? product?.original_retail_price,
          original_price_before_no_charge: product?.original_price_before_no_charge ?? product?.original_price,
          install_cost: installCost,
          expected_cost: expectedCost,
          original_actual_retail_price: expectedCost,
          original_retail_price: calculatedRetailPrice,
          original_price: expectedCost,
          retail_price: calculatedRetailPrice + adjustment,
          actual_retail_price: expectedCost + adjustment,
          product_retail_price: expectedCost + adjustment,
          retail_price_draft: undefined,
        }
      }

      if (product?.retail_price_before_no_charge == null && product?.actual_retail_price_before_no_charge == null) {
        return product
      }

      return {
        ...product,
        expected_cost: product?.expected_cost_before_no_charge ?? product?.expected_cost,
        retail_price: product?.retail_price_before_no_charge ?? product?.retail_price,
        actual_retail_price: product?.actual_retail_price_before_no_charge ?? product?.actual_retail_price,
        product_retail_price: product?.product_retail_price_before_no_charge ?? product?.product_retail_price,
        price: product?.price_before_no_charge ?? product?.price,
        original_actual_retail_price: product?.original_actual_retail_price_before_no_charge ?? product?.actual_retail_price_before_no_charge ?? product?.original_actual_retail_price,
        original_retail_price: product?.original_retail_price_before_no_charge ?? product?.retail_price_before_no_charge ?? product?.original_retail_price,
        original_price: product?.original_price_before_no_charge ?? product?.price_before_no_charge ?? product?.original_price,
        retail_price_draft: undefined,
      }
    })
  }

  const applyJobTypeChange = (newValue) => {
    console.log('newValuenewValuenewValue',newValue)
    setFieldValue('project_categories', newValue)
    // if(newValue?.id !== 9){
    //   setFieldValue('is_split', null)
    //   setIsSplitOrder(false)
    // }
    if (newValue?.name == 'Build Order' ||
      newValue?.id == 15
    ) {
      setFieldValue('catalog_type', catalogTypes[0])
      setFieldValue('split_catalog_type', null) // Clear catalog type for Build Order
    }
    
    if (
      newValue?.name == 'No Charge' ||
      newValue?.id == 13
    ) {
      setNoCharge(true)
      // For any No Charge job, always require manager approval
      // setFieldValue('manager_approval_required', true)
      // setFieldValue('client_approve',true)
    } else {
      setNoCharge(false)
      setFieldValue('no_charge_type', null)
      setNoChargeReason('')
      setNoChargeReasonError(false)
    }
    const syncedProducts = syncProductsForJobTypeChange(selectedProducts, newValue)
    setSelectedProducts(syncedProducts)
    setFieldValue('products', syncedProducts)
    if (
      newValue?.name == 'Time & Material' || values.project_categories?.id == 14
    ) {
    console.log('newValuenewValuenewValue 111',selectedProducts)

      // fetchAllMaterials()
      // setAvatarUrl([])
      setSelectedProducts([])
      setSelectedMapserviceProducts([]);
      
      setSelectedServices([])
      setSelectedMaterials([])
      setAdditionalSelectedServices([])
      setFieldValue('services', [])
      // fetchAllMaterials()
      console.log('newValuenewValuenewValue 222',selectedProducts)

      setCart([])
      setCartService([])
      setTabIndex(0)
      if (newValue?.name == 'Time & Material') {
        // addNewProductRow()
        // setMarkupType(1)
      // setFieldValue('client_approve',true)
      } else {
        setSelectedMaterials([])
      }
    }
    if (values.project_categories?.name == 'Time & Material') {

      fetchAllMaterials()
      setSelectedProducts([])
      setSelectedMapserviceProducts([]);
      setSelectedServices([])
      setSelectedMaterials([])
      setAdditionalSelectedServices([])
      setFieldValue('services', [])
      // fetchAllMaterials()
      setCart([])
      setCartService([])
      setTabIndex(0)
      // setFieldValue('client_approve',true)
    }
    // if ( values.project_categories?.name == 'Service only' ) {
    //   setSelectedMaterials([])
    // }
    // -------------------------------
    // SERVICE ONLY (ID = 11) - Clear all products
    // -------------------------------
    if (newValue?.id === 11 || newValue?.name === 'Service only') {
      setSelectedProducts([]);
      setSelectedMapserviceProducts([]);
      setSelectedMaterials([]);
      setCart([]);
      // Update Formik if needed
      setFieldValue('products', []);

      // Reset catalog type to 'All' for Service Only
      setFieldValue('split_catalog_type', splitOrderCatalogTypes.find((type) => type.id === 'all'));
    }
    // Clear map_service and related products when switching away from category 14
    if (
      values?.project_type?.name !== 'TS' ||
      newValue?.id != 14
    ) {
      setFieldValue('map_service', null)
      // if( newValue?.name == 'Service only'|| newValue?.id==11 || newValue?.name == 'Time & Material'){
      if( newValue?.name == 'Time & Material'){

        setSelectedProducts([]);
        setSelectedMapserviceProducts([]);
        setSelectedServices([])
      }
      setSelectedMapserviceProducts([]);
      // setSelectedServices([]);
      // const filteredProducts = selectedProducts?.filter(
      //   (product) => product?.fromMapServices !== true,
      // )
      // setSelectedProducts(filteredProducts)
    }
  };

    // Function to handle the logic for split type
    const handleSplitTypeLogic = (newValue) => {
      setFieldValue('is_split', newValue);
      setIsSplitOrder(!!newValue);
  
      if (newValue) {
        const defaultFacility = FacilityTypes?.filter(fac => fac.default);
        setFieldValue('facility_type', defaultFacility || []);
      } else {
        setFieldValue('facility_type', []);
      }
    };

    useEffect(() => {
      if (pageSplitOrder) {
        handleSplitTypeLogic(true);
      }
    }, [pageSplitOrder,values?.project_categories?.id]);

    // const collaboratorOptions = useMemo(() => {
    //   const availableTeamMembers = Array.isArray(teamMembersOptions) ? teamMembersOptions : [];
    //   let filteredMembers = availableTeamMembers;
    //   const communitySalesRepIds = getCommunitySalesRepIds(values.community);
  
    //   if (values.community && communitySalesRepIds.length > 0) {
    //     const allowedIds = new Set(communitySalesRepIds.map((id) => String(id)));
    //     filteredMembers = availableTeamMembers.filter((member) => {
    //       const memberId = member?.id ?? member?.user_id;
    //       return memberId != null && allowedIds.has(String(memberId));
    //     });
    //   }
  
    //   if (collaborators?.length) {
    //     const filteredIds = new Set(
    //       filteredMembers.map((member) => String(member?.id ?? member?.user_id))
    //     );
    //     const missingSelections = collaborators.filter((member) => {
    //       const memberId = member?.id ?? member?.user_id;
    //       return memberId != null && !filteredIds.has(String(memberId));
    //     });
    //     if (missingSelections.length) {
    //       filteredMembers = [...filteredMembers, ...missingSelections];
    //     }
    //   }
  
    //   return filteredMembers;
    // }, [teamMembersOptions, values.community, collaborators]);

    // Split order: if user removes a facility after selecting products, drop products that belong to removed facilities.
    // This prevents "removed facility" products from re-appearing as selectable/available in the remaining UI.
    
    const collaboratorOptions = useMemo(() => {
      const availableTeamMembers = Array.isArray(teamMembersOptions)
        ? teamMembersOptions
        : [];
    
      let collaboratorMembers = [...availableTeamMembers];
    
      // Preserve already-selected collaborators even if they are not
      // currently available inside teamMembersOptions.
      if (collaborators?.length) {
        const availableMemberIds = new Set(
          collaboratorMembers
            .map((member) => member?.id ?? member?.user_id)
            .filter((id) => id != null)
            .map(String)
        );
    
        const missingSelections = collaborators.filter((member) => {
          const memberId = member?.id ?? member?.user_id;
    
          return (
            memberId != null &&
            !availableMemberIds.has(String(memberId))
          );
        });
    
        collaboratorMembers = [
          ...collaboratorMembers,
          ...missingSelections,
        ];
      }
    
      return collaboratorMembers;
    }, [teamMembersOptions, collaborators]);
    
    useEffect(() => {
      if (!isSplitOrder) return;

      const selectedFacilities = values?.facility_type || [];

      const regularSelectedProducts = selectedProducts?.filter(
        (item) => item?.fromMapServices != true && !item?.isAdditionalProduct
      ) || [];

      // If split order is on but no facility is selected, clear the regular selected products
      if (!selectedFacilities?.length) {
        if (!regularSelectedProducts.length) return;
        const updated = [];
        setFieldValue('products', updated)
        handleProduct(updated)
        setShowAddNewRow(true)
        return;
      }

      const selectedIds = new Set(selectedFacilities.map((f) => Number(f?.id)));

      const filteredRegular = regularSelectedProducts.filter((p) =>
        selectedIds.has(Number(p?.facility_id))
      );

      // Only run when we actually removed something (avoids unnecessary recalcs)
      if (filteredRegular.length === regularSelectedProducts.length) return;

      const updated = filteredRegular.map((item) => ({
        ...item,
        is_single_card: values.project_categories?.id !== 14 ? true : false
      }));

      setFieldValue('products', updated)
      handleProduct(updated)
      setShowAddNewRow(true)
    }, [isSplitOrder, values?.facility_type]);

    useEffect(() => {
      if (!isSplitOrder) return;
      const selectedFacilities = values?.facility_type || [];
      const regularSelectedServices = values?.services?.filter(
        (item) => !item?.isAdditionalProduct
      ) || [];
      if (!selectedFacilities?.length) {
        if (!regularSelectedServices.length) return;
        const additionals = values?.services?.filter(item => item.isAdditionalProduct === true) || [];
        setFieldValue('services', additionals)
        setAdditionalSelectedServices(additionals)
        return;
      }
      const selectedIds = new Set(selectedFacilities.map((f) => Number(f?.id)));
      const filteredRegular = regularSelectedServices.filter((s) =>
        selectedIds.has(Number(s?.facility_id))
      );
      if (filteredRegular.length === regularSelectedServices.length) return;
      const additionals = values?.services?.filter(item => item.isAdditionalProduct === true) || [];
      const updated = [...filteredRegular, ...additionals];
      setFieldValue('services', updated)
      setAdditionalSelectedServices(updated)
    }, [isSplitOrder, values?.facility_type]);

    // Browser back button interception for auto-save (only when form is open)
    useEffect(() => {
      if (!open) return; // Only intercept when form is open

      const handlePopState = (event) => {
        event.preventDefault();
        setOpenBackConfirm(true);
        // Push a dummy state to prevent immediate navigation
        window.history.pushState(null, '', window.location.href);
      };

      // Push initial state for back button interception
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handlePopState);

      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }, [open]);

    return (
      <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
              <Button
                variant="outlined"
                onClick={handleCancel}
                sx={{ alignItems: 'right' }}
                startIcon={
                  <Stack>
                    <KeyboardBackspaceOutlined />
                  </Stack>
                }
              >
                Back
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 3 }}>
              <CardHeader sx={{ ml: -3, mt: -4 }} title="New Sales Order" />
              <Stack spacing={3}>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={{ xs: 3, sm: 2 }}
                >
                  <Stack flexDirection={'column'}>
                    <TextField
                      required
                      fullWidth
                      sx={{ width: 400 }}
                      label="Ordered Name"
                      name="name"
                      value={nameFileds?.name}
                      onChange={(e) => {
                        const v = e.target.value;
                        setNameFileds({ ...nameFileds, name: v });
                        if (v.trim()) {
                          setFieldErrors((prev) => ({
                            ...prev,
                            name: undefined,
                          }));
                        }
                      }}
                      error={Boolean(fieldErrors.name)}
                      helperText={fieldErrors.name || ''}
                    />
                  </Stack>
                  <TextField
                    sx={{ width: 400 }}
                    label="#PO Number"
                    // {...getFieldProps('po_number')}
                    name="po_number"
                    value={nameFileds?.po_number}
                    onChange={(e) => setNameFileds({...nameFileds, po_number: e.target.value})}
                    error={Boolean(touched.po_number && errors.po_number)}
                    helperText={touched.po_number && errors.po_number}
                  />
                </Stack>
                <LabelStyle>Description</LabelStyle>
                <TextField
                  required
                  fullWidth
                  multiline
                  minRows={3}
                  maxRows={7}
                  label="keep the summary brief and make it communicates"
                  name="description"
                  value={nameFileds?.description}
                  onChange={(e) => {
                    const v = e.target.value;
                    setNameFileds({ ...nameFileds, description: v });
                    if (v.trim()) {
                      setFieldErrors((prev) => ({
                        ...prev,
                        description: undefined,
                      }));
                    }
                  }}
                  error={Boolean(fieldErrors.description)}
                  helperText={fieldErrors.description || ''}
                />

                {userType !== 3 &&
                  explodedPermissions?.some((permission) =>
                    ['Create Request'].includes(permission),
                  ) && (
                    <>
                      {/* {values?.project_categories?.name != 'Service only' &&
                        values?.project_categories?.name !=
                          'Time & Material' && ( */}
                          <>
                            <LabelStyle>Upload Designs / Documents</LabelStyle>
                            <UploadMultiFile
                              showPreview
                              maxSize={1024 * 1024 * 1024}
                              files={uploadDesignsDisplayFiles}
                              onDrop={handleDrop}
                              onRemove={handleRemove}
                              onRemoveAll={handleRemoveAll}
                              isUploading={isUploading}
                              showProductLabels
                            />
                          </>
                        {/* )} */}
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <Autocomplete
                          // multiple
                          sx={{ width: '50%' }}
                          // fullWidth
autoComplete={false}
                          id="combo-box-demo"
                          options={allClients}
                          value={values.clients}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              setFieldValue('clients', newValue)
                              setFieldValue('community', null)
                              setSalesRepName('')
                              setSalesRepId(null)
                              setSalesRepOptions([])
                              fetchAllCommunityByClient(newValue)
                              setShowAddNewRow(true)
                            } else {
                              setFieldValue('clients', null)
                              setSalesRepName('')
                              setSalesRepId(null)
                              setSalesRepOptions([])
                              setFieldValue('community', null)
                              setCommunities([])
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              label="Clients"
                              error={Boolean(touched.clients && errors.clients)}
                              helperText={touched.clients && errors.clients}
                            />
                          )}
                          getOptionLabel={(option) => option.name}
                          renderOption={(props, option) => {
                            return (
                              <li {...props}>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: 40,
                                    justifyContent: 'center',
                                  }}
                                >
                                  {option?.syncWithQuickBook === 1 && (
                                    <img
                                      src={quickbookLogo}
                                      width="40px"
                                      height="20px"
                                      alt="QuickBooks"
                                    />
                                  )}
                                </div>
                                <span
                                >
                                  {option?.name}
                                </span>
                              </li>
                            );
                          }}
                        />
                        {isCommunityLoading ? (
                          <Stack
                            flexDirection={'row'}
                            alignItems="center"
                            justifyContent="center"
                          >
                            <CircularProgress
                              color="primary"
                              variant="indeterminate"
                            />
                            <Typography variant="body2">
                              Loading projects...
                            </Typography>
                          </Stack>
                        ) : communities?.length > 0 ? (
                        
                          <Autocomplete
                            // e.g. label="Project"
                            sx={{ width: '50%' }}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            id="community"
                            options={
                              [...(communities || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
                            }
                            value={values.community}
                            onChange={(event, newValue) => {
                              // 1) Set the community in Formik
                              if (newValue) {
                                setFieldValue('community', newValue)
                                 // Sales reps dropdown: populate all sales reps for selected project
                                 const matchedCommunity = allCommunities?.find(
                                   (community) => community?.id === newValue?.id
                                 );
                                 setCollaborators([])
                                 const repOptions = getSalesRepOptionsFromCommunity(matchedCommunity);
                                 setSalesRepOptions(repOptions);
                                 if (repOptions.length > 0) {
                                   // Keep current behavior (auto-select first), but allow changing via dropdown
                                   setSalesRepName(repOptions[0]?.name || '');
                                   setSalesRepId(repOptions[0]?.id || null);
                                 } else {
                                   setSalesRepName('');
                                   setSalesRepId(null);
                                 }
                                // 2) Check if the project has address/city/state/zip
                                if (
                                  newValue.address ||
                                  newValue.city ||
                                  newValue.state ||
                                  newValue.zip
                                ) {
                                  const { address, city, state, zip } = newValue

                                  // 3) Update selected products’ addresses
                                  setSelectedProducts((prevProducts) =>
                                    prevProducts?.map((product) => {
                                      if (product?.fromMapServices == true) {
                                        return product
                                      } else {
                                        const updatedAddresses =
                                          product.addresses.map((loc) => ({
                                            ...loc,
                                            address: address || loc.address,
                                            city: city || loc.city,
                                            state: state || loc.state,
                                            zip: zip || loc.zip,
                                          }))
                                        return {
                                          ...product,
                                          addresses: updatedAddresses,
                                        }
                                      }
                                    }),
                                  )

                                  // 4) Update selected services’ addresses (if applicable)
                                  setAdditionalSelectedServices(
                                    (prevServices) =>
                                      prevServices.map((service) => {
                                        const updatedAddresses =
                                          service.addresses.map((loc) => ({
                                            ...loc,
                                            address: address || loc.address,
                                            city: city || loc.city,
                                            state: state || loc.state,
                                            zip: zip || loc.zip,
                                          }))
                                        return {
                                          ...service,
                                          addresses: updatedAddresses,
                                        }
                                      }),
                                  )

                                  setCart((prevCart) =>
                                    prevCart.map((product) => {
                                      const updatedAddresses =
                                        product.addresses.map((loc) => ({
                                          ...loc,
                                          address: address || loc.address,
                                          city: city || loc.city,
                                          state: state || loc.state,
                                          zip: zip || loc.zip,
                                        }))
                                      return {
                                        ...product,
                                        addresses: updatedAddresses,
                                      }
                                    }),
                                  )

                                  // 6) Update RFP Services’ addresses
                                  // if(values.project_categories?.name == 'Service only' || (values?.project_categories?.name == 'Time & Material')){
                                  setCartService((prevServices) =>
                                    prevServices.map((service) => {
                                      const updatedAddresses =
                                        service.addresses.map((loc) => ({
                                          ...loc,
                                          address: address || loc.address,
                                          city: city || loc.city,
                                          state: state || loc.state,
                                          zip: zip || loc.zip,
                                        }))
                                      return {
                                        ...service,
                                        addresses: updatedAddresses,
                                      }
                                    }),
                                  )
                                  // }
                                }

                                // (Optional) If your community also decides the default tax category
                                if (newValue.tax_category) {
                                  const taxCat = taxCategories?.find(
                                    (cat) => newValue.tax_category === cat.id,
                                  )
                                  setSelectedTaxCategory(taxCat)
                                }
                              } else {
                                // Clear everything if user removes project
                                setFieldValue('community', null)
                                setSalesRepName('')
                                setSalesRepId(null)
                                setSalesRepOptions([])
                                setSelectedTaxCategory(null)
                              }
                            }}
                            renderInput={(params) => (
                              <Tooltip
                                title={values.community ? formatProjectAddress(values.community) : ''}
                              >
                                <TextField
                                  {...params}
                                  required
                                  label="Project"
                                  error={Boolean(
                                    touched.community && errors.community,
                                  )}
                                  helperText={
                                    touched.community && errors.community
                                  }
                                />
                              </Tooltip>
                            )}
                            getOptionLabel={(option) => option.name}
                            renderOption={(props, option) => {
                              const { style, ...liProps } = props;
                              return (
                                <li
                                  {...liProps}
                                  style={{
                                    ...style,
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Tooltip title={formatProjectAddress(option)}> 
                                    <span
                                      style={{
                                        flex: 1,
                                        minWidth: 0,
                                        display: 'block',
                                      }}
                                    >
                                      <span
                                        style={{
                                          display: 'block',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                        }}
                                      >
                                        {option?.name || ''}
                                      </span>
                                    </span>
                                  </Tooltip>
                                  <span style={{ display: 'none' }}>{option?.name || ''}</span>
                                </li>
                              );
                            }}
                          />
                        ) : (
                          <Stack
                            sx={{ width: '50%' }}
                            justifyContent={'center'}
                          >
                            {values?.clients ? (
                              <Typography sx={{ color: 'red' }}>
                                The selected client does not have any projects
                                yet. Please create a new project for them!
                              </Typography>
                            ) : (
                              <Typography sx={{ color: 'red' }}>
                                No client selected. Please choose a client from
                                the list.
                              </Typography>
                            )}
                          </Stack>
                        )}
                      </Stack>
                      {salesRepOptions?.length > 0 && (
                        <Stack sx={{ width: '100%' }}>
                          <Autocomplete
                            id="sales-rep"
                            options={salesRepOptions}
                            value={
                              salesRepOptions.find((opt) => {
                                if (salesRepId != null && opt?.id != null) {
                                  return String(opt.id) === String(salesRepId);
                                }
                                return salesRepName && opt?.name === salesRepName;
                              }) || null
                            }
                            onChange={(event, newValue) => {
                              setSalesRepName(newValue?.name || '');
                              setSalesRepId(newValue?.id || null);
                            }}
                            isOptionEqualToValue={(option, value) =>
                              (option?.id != null && value?.id != null && String(option.id) === String(value.id)) ||
                              option?.name === value?.name
                            }
                            getOptionLabel={(option) => option?.name || ''}
                            renderInput={(params) => (
                              <TextField {...params} label="Sales Rep" fullWidth />
                            )}
                          />
                        </Stack>
                      )}
                      
                      {/* {(values.community?.id != null && values.community?.sales_rep_names != null) &&( */}
                      <Stack sx={{ width: '100%' }}>
                        <Autocomplete
                          multiple
                          id="collaborators"
                          options={collaboratorOptions}
                          value={collaborators}
                          onChange={(event, newValue) => setCollaborators(newValue || [])}
                          loading={teamMembersLoading}
                          isOptionEqualToValue={(option, value) => (option?.id != null && value?.id != null && String(option.id) === String(value.id))}
                          getOptionLabel={(option) => {
                            if (!option) return '';
                            const name = option.name || [option.first_name, option.last_name].filter(Boolean).join(' ').trim();
                            return name || String(option.id || '');
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Collaborators"
                              fullWidth
                              placeholder="Select Collaborators"
                            />
                          )}
                        />
                      </Stack>
                    {/* )} */}
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        {DOMAIN === 'la' && projectTypes?.length === 1 ? (
                          <TextField
                            sx={{ width: { xs: '100%', sm: '50%' } }}
                            id="combo-box-demo-type"
                            label="Job Class"
                            value={
                              values.project_type?.name ??
                              projectTypes[0]?.name ??
                              ''
                            }
                            required
                            InputProps={{ readOnly: true }}
                            error={Boolean(
                              touched.project_type && errors.project_type,
                            )}
                            helperText={
                              touched.project_type && errors.project_type
                            }
                          />
                        ) : (
                          <Autocomplete
                            sx={{ width: { xs: '100%', sm: '50%' } }}
                            id="combo-box-demo-type"
                            options={projectTypes}
                            value={values.project_type}
                            onChange={(event, newValue) => {
                              setFieldValue('project_type', newValue)
                              setShowAddNewRow(true)
                              if (newValue?.name !== 'TS') {
                                setFieldValue('map_service', null)
                                const filteredProducts = selectedProducts?.filter(
                                  (product) => product?.fromMapServices !== true,
                                )
                                setSelectedProducts(filteredProducts)
                              }
                              setFieldValue('project_categories', null)
                              setFieldValue('map_service', null)
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Job Class"
                                error={Boolean(
                                  touched.project_type && errors.project_type,
                                )}
                                helperText={
                                  touched.project_type && errors.project_type
                                }
                              />
                            )}
                            getOptionLabel={(option) => option.name}
                          />
                        )}
                        {/* <Autocomplete
                          fullWidth
                          id="combo-box-demo-type"
                          options={markupTypes}
                          disabled
                          value={values.markup_type}
                          onChange={(event, newValue) => {
                            setFieldValue('markup_type', newValue)
                            setMarkupType(newValue?.id)
                          }}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              label="Markup Type"
                              error={Boolean(
                                touched.markup_type && errors.markup_type,
                              )}
                              helperText={
                                touched.markup_type && errors.markup_type
                              }
                            />
                          )}
                          getOptionLabel={(option) => option.name}
                        /> */}
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <Autocomplete
                          // fullWidth
                          sx={{ width: '50%' }}
                          id="combo-box-demo-category"
                          options={
                            pageSplitOrder ? projectCategories?.filter((ite) => ite.id !== 15 && ite.id != 14) :
                            values.project_type?.name == 'TS'
                              ? projectCategories
                              : projectCategories?.filter((ite) => ite.id != 14)
                          }
                          value={values.project_categories}
                          onChange={(event, newValue) => {
                            console.log('Selected Job Type:', newValue);
                            const isSwitchingFromTM =
                              values.project_categories?.name === 'Time & Material' &&
                              newValue?.name !== 'Time & Material';

                            // If switching away from T&M → show dialog
                            if (isSwitchingFromTM) {
                              setPendingJobType(newValue);
                              setOpenJobTypeDialog(true);
                              return;
                            }

                            // No popup → apply directly
                            applyJobTypeChange(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              label="Job Type"
                              error={Boolean(
                                touched.project_categories &&
                                  errors.project_categories,
                              )}
                              helperText={
                                touched.project_categories &&
                                errors.project_categories
                              }
                            />
                          )}
                          getOptionLabel={(option) => option.name}
                        />

                        <Dialog
                          open={openJobTypeDialog}
                          onClose={() => setOpenJobTypeDialog(false)}
                        >
                          <DialogTitle>Confirm Job Type Change</DialogTitle>

                          <DialogContent>
                            <Typography>
                              Switching from <strong>Time & Material</strong> will clear all
                              Materials and Services. Do you want to continue?
                            </Typography>
                          </DialogContent>

                          <DialogActions>
                            <Button
                              onClick={() => {
                                setOpenJobTypeDialog(false);
                                setPendingJobType(null);
                              }}
                              color="inherit"
                            >
                              Cancel
                            </Button>

                            <Button
                              onClick={() => {
                                setOpenJobTypeDialog(false);
                                applyJobTypeChange(pendingJobType);
                                setPendingJobType(null);
                              }}
                              variant="contained"
                              color="error"
                            >
                              Yes, Change Job Type
                            </Button>
                          </DialogActions>
                        </Dialog>

                        {values.project_categories?.id == 14 ? (
                          <Autocomplete
                            // fullWidth
                            sx={{ width: '50%' }}
                            id="combo-box-demo-type"
                            options={mapServices}
                            value={values.map_service}
                            // onChange={(event, newValue) => {
                              onChange={async (event, newValue) => {
                              setFieldValue('map_service', newValue)
                              console.log('newValue=======', newValue)
                              if (newValue?.client_id && newValue?.community_id) {
                              const matchedClient = allClients?.find(client => client.id === newValue.client_id);

                              if (matchedClient) {
                                setFieldValue('clients', matchedClient);
                                await fetchAllCommunityByClientCommunity(matchedClient, newValue.community_id);
                              }
                            }
                              if (newValue?.products) {
                                let newIndexCounter = indexCounter
                                const updatedProductsWithLocations =
                                  newValue?.products?.map((product, index) => {
                                    const filteredData = allProducts?.find(
                                      (i) => i.id === product.product_id,
                                    )
                                    const associatedLocations =
                                      newValue?.locations
                                        .filter(
                                          (location) =>
                                            location?.route_product_id ===
                                            product?.id,
                                        )
                                        .map((location) => ({
                                          address: location.address,
                                          city: location.city,
                                          state: location.state,
                                          zip: location.zip,
                                          route_location_id: location.id,
                                        }))
                                    newIndexCounter += 1
                                    return {
                                      ...product,
                                      ...filteredData,
                                      indexId: newIndexCounter, //`map_${index}`,
                                      fromMapServices: true,
                                      locationQuantity: product?.qty,
                                      addresses: associatedLocations,
                                      discount: 0,
                                      adjustment: 0,
                                      quantity: 1,
                                      markAdjType: 2,
                                    }
                                  })
                                const mergedSelectedProducts = [
                                  ...selectedProducts.filter(
                                    (product) =>
                                      product?.fromMapServices !== true,
                                  ), // Keep existing products without fromMapServices
                                  ...updatedProductsWithLocations, // Add the new products from map services
                                ]

                                setSelectedMapserviceProducts(
                                  updatedProductsWithLocations,
                                )
                                setSelectedProducts(mergedSelectedProducts)
                                setFieldValue(
                                  'products',
                                  mergedSelectedProducts,
                                )
                                setIndexCounter(newIndexCounter)
                                const productServices =
                                  mergedSelectedProducts?.reduce(
                                    (services, product) => {
                                      if (
                                        product.services &&
                                        product.services.length > 0
                                      ) {
                                        return services.concat(
                                          product.services.map((service) => ({
                                            ...service,
                                            fromMapServices:
                                              product?.fromMapServices || false,
                                            productIndex: product?.indexId,
                                            quantity:
                                              service.quantity *
                                              product.quantity *
                                              product.locationQuantity,
                                            previousQty: service.quantity,
                                            qtyData: product.quantity,
                                            locationQuantity:
                                              product.locationQuantity,
                                          })),
                                        )
                                      }
                                      return services
                                    },
                                    [],
                                  )
                                setSelectedServices(productServices)
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Routes"
                                error={Boolean(
                                  touched.map_service && errors.map_service,
                                )}
                                helperText={
                                  touched.map_service && errors.map_service
                                }
                              />
                            )}
                            // getOptionLabel={(option) => option.name}
                            getOptionLabel={(option) =>
                              `${option.name} (${option.locations_count})`
                            }
                          />
                        ) : (
                          ''
                        )}
                        {values.project_categories?.id == 15 ? (
                          <Autocomplete
                            // fullWidth
                            sx={{ width: '50%' }}
                            id="combo-box-demo-type"
                            options={catalogTypes}
                            value={values.catalog_type}
                            onChange={(event, newValue) => {
                              setFieldValue('catalog_type', newValue)
                              setFieldValue('products', [])
                              setSelectedProducts([])
                              setSelectedServices([])
                              console.log('newValue=======', newValue)
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Catalog"
                                error={Boolean(
                                  touched.catalog_type && errors.catalog_type,
                                )}
                                helperText={
                                  touched.catalog_type && errors.catalog_type
                                }
                              />
                            )}
                            getOptionLabel={(option) => option.label}
                          />
                        ) : (
                          ''
                        )}
                        {values?.project_categories?.id === 13 && (
                          <Autocomplete
                            // fullWidth
                            sx={{ width: '50%' }}
                            id="combo-box-demo-type"
                            options={noChargeType}
                            value={values.no_charge_type}
                            onChange={(event, newValue) => {
                              if(newValue){
                                setFieldValue('no_charge_type', newValue)
                                // setMarkupType(newValue?.id)
                              }else{
                                setFieldValue('no_charge_type', null)

                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="No charge Type"
                                error={Boolean(
                                  touched.no_charge_type &&
                                    errors.no_charge_type,
                                )}
                                helperText={
                                  touched.no_charge_type &&
                                  errors.no_charge_type
                                }
                              />
                            )}
                            getOptionLabel={(option) => option.name}
                          />
                        )}
                      </Stack>
                      {values?.project_categories?.id === 13 && (
                        <Stack sx={{ width: '100%' }}>
                          <TextField
                            fullWidth
                            id="no_charge_reason"
                            label="No charge reason"
                            placeholder="Reason for no charge"
                            value={noChargeReason}
                            onChange={(e) => {
                              setNoChargeReason(e.target.value);
                              if (e.target.value.trim()) setNoChargeReasonError(false);
                            }}
                            error={noChargeReasonError}
                            helperText={noChargeReasonError && 'No charge reason is required.'}
                            multiline
                            minRows={3}
                          />
                        </Stack>
                      )}

                      { pageSplitOrder  ? (
                        <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        {/* <Autocomplete
                          sx={{ width: '50%' }}
                          id="split-type-autocomplete"
                          options={[{ id: 1, label: 'Split' }]}
                          value={values.is_split || null}
                              onChange={(event, newValue) => {
                                setFieldValue('is_split', newValue);
                                // Update isSplitOrder based on the form field value
                                setIsSplitOrder(!!newValue);
                                
                                // If split order is enabled, set default facility
                                if (newValue) {
                                  const defaultFacility = FacilityTypes?.filter(fac => fac.default);
                                  setFieldValue('facility_type', defaultFacility || []);
                                } else {
                                  // If split order is disabled, clear facility_type
                                  setFieldValue('facility_type', []);
                                }
                          }}
                          getOptionLabel={(option) => option?.label ?? ''}
                          isOptionEqualToValue={(option, value) => option?.id === value?.id}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Choose Split Type"
                              placeholder="Select split type"
                              error={Boolean(touched.is_split && errors.is_split)}
                              helperText={touched.is_split && errors.is_split}
                            />
                          )}
                        /> */}

                        {
                          isSplitOrder ?(
                          
                            <Autocomplete
                            multiple
                            disableCloseOnSelect
                            filterSelectedOptions
                            sx={{ width: '50%' }}
                            id="combo-box-demo-type"
                            options={FacilityTypes || []}
                            value={values.facility_type || []}   
                            onChange={(event, newValue) => {
                              setFieldValue('facility_type', newValue);
                              let filteredVaue = newValue.find(v => !v.default )
                              const selectedData = (Array.isArray(filteredVaue) ? filteredVaue : [filteredVaue]) .map(v => {
                                const id = typeof v === 'object' ? v?.id : v;
                                return splitManagementSettings?.find(s => String(s?.id) === String(id));
                              })
                              .filter(Boolean);

                              setSelectedSplitOrderSettings(selectedData)
                            }}
                            getOptionLabel={(option) => option?.label ?? ''}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            renderTags={(selected, getTagProps) =>
                              selected.map((option, index) => (
                                <Chip
                                  key={option?.id ?? option?.label ?? index}
                                  label={option?.label}
                                  size="small"
                                  color={option?.color}//"primary"
                                  variant="outlined"
                                  {...getTagProps({ index })} // handles delete icon
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Choose Facility"
                                placeholder="Select facilities"
                                error={Boolean(touched.facility_type && errors.facility_type)}
                                helperText={touched.facility_type && errors.facility_type}
                              />
                            )}
                          />
                          )
                          :""
                        }

                        </Stack>
                      )
                        : ''}
                      {/* <Stack>
          <Autocomplete
              multiple
              // sx={{ width: 400 }}
              fullWidth
              id="combo-box-demo"
              options={workflow}
              value={values.workflows}
              onChange={(event, newValue) => setFieldValue('workflows', newValue)}
              renderInput={(params) => (
                <TextField  required 
                {...params} label="WorkFlows"
                error={Boolean(touched.workflows && errors.workflows)}
                helperText={touched.workflows && errors.workflows} />
              )}
              getOptionLabel={(option) => option.name}

            />
          </Stack> */}
                    </>
                  )}
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={{ xs: 3, sm: 2 }}
                >
                  <Box
                    component={MobileDatePicker}
                    // minDate={moment()}
                    label="Start Date"
                    value={dateOnlyMoment(values.start)}
                    onChange={(date) => {
                      const newStartUnix = dateOnlyToUnix(date);
                      setFieldValue('start', newStartUnix);
                      applyInstallationFromStartAndLead(newStartUnix);
                    }}
                    // value={values.start}
                    // onChange={(date) => setFieldValue('start', moment(date).format('YYYY-MM-DD'))}
                    renderInput={(params) => (
                      <TextField size="medium" {...params} fullWidth />
                    )}
                  />
                  <Box
                    component={MobileDatePicker}
                    minDate={values.start ? dateOnlyMoment(values.start) : moment()}
                    label="Installation Date"
                    value={values.end ? dateOnlyMoment(values.end) : null}
                    onChange={(date) => {
                      setFieldValue('end', dateOnlyToUnix(date));
                      // Clear installation start/end dates when single date is selected
                      setFieldValue('installation_start_date', null);
                      setFieldValue('installation_end_date', null);
                    }}
                    // value={values.end}
                    // onChange={(date) => setFieldValue('end', moment(date).format('YYYY-MM-DD'))}
                    renderInput={(params) => (
                      <TextField
                        size="medium"
                        {...params}
                        fullWidth
                        error={Boolean(touched.end && errors.end)}
                        helperText={touched.end && errors.end}
                      />
                    )}
                  />
                </Stack>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: 1, fontStyle: 'italic' }}>
                  Choose either single installation date above OR installation date range below
                </Typography>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Box
                    component={MobileDatePicker}
                    minDate={values.start ? dateOnlyMoment(values.start) : moment()}
                    label="Installation Start Date"
                    value={values.installation_start_date ? dateOnlyMoment(values.installation_start_date) : null}
                    onChange={(date) => {
                      const ux = dateOnlyToUnix(date);
                      setFieldValue('installation_start_date', ux);
                      setFieldValue('end', null);
                      applyLeadTimeInstallPatch(ux);
                    }}
                    renderInput={(params) => (
                      <TextField 
                        size="medium" 
                        {...params} 
                        fullWidth
                        error={Boolean(touched.installation_start_date && errors.installation_start_date)}
                        helperText={touched.installation_start_date && errors.installation_start_date}
                      />
                    )}
                  />
                  <Box
                    component={MobileDatePicker}
                    minDate={values.installation_start_date ? dateOnlyMoment(values.installation_start_date) : moment()}
                    label="Installation End Date"
                    value={values.installation_end_date ? dateOnlyMoment(values.installation_end_date) : null}
                    onChange={(date) => {
                      setFieldValue('installation_end_date', dateOnlyToUnix(date));
                      // Clear single installation date when range is selected
                      setFieldValue('end', null);
                    }}
                    renderInput={(params) => (
                      <TextField 
                        size="medium" 
                        {...params} 
                        fullWidth
                        error={Boolean(touched.installation_end_date && errors.installation_end_date)}
                        helperText={touched.installation_end_date && errors.installation_end_date}
                      />
                    )}
                  />
                </Stack>
                {/* Client-specific project autocomplete - only visible for clients */}
                  {(() => {
                    console.log('UI condition check - isClient:', isClient, 'userType:', userType, 'condition result:', (isClient || userType === 3));
                    return (isClient || userType === 3);
                  })() && (
                      <>
                        {isCommunityLoading ? (
                          <Stack
                            flexDirection={'row'}
                            alignItems="center"
                            justifyContent="center"
                            sx={{ mt: 2 }}
                          >
                            <CircularProgress
                              color="primary"
                              variant="indeterminate"
                            />
                            <Typography variant="body2">
                              Loading your projects...
                            </Typography>
                          </Stack>
                        ) : (
                             <Autocomplete
                               sx={{ width: '100%', mt: 2 }}
                               isOptionEqualToValue={(option, value) => option?.id === value?.id}
                               id="client-community"
                               options={clientCommunities}
                            value={values.community}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                setFieldValue('community', newValue)

                                // Check if the project has address/city/state/zip
                                if (
                                  newValue.address ||
                                  newValue.city ||
                                  newValue.state ||
                                  newValue.zip
                                ) {
                                  const { address, city, state, zip } = newValue

                                  // Update selected products' addresses
                                  setSelectedProducts((prevProducts) =>
                                    prevProducts?.map((product) => {
                                      if (product?.fromMapServices == true) {
                                        return product
                                      } else {
                                        const updatedAddresses =
                                          product.addresses.map((loc) => ({
                                            ...loc,
                                            address: address || loc.address,
                                            city: city || loc.city,
                                            state: state || loc.state,
                                            zip: zip || loc.zip,
                                          }))
                                        return {
                                          ...product,
                                          addresses: updatedAddresses,
                                        }
                                      }
                                    }),
                                  )

                                  // Update selected services' addresses
                                  setSelectedServices((prevServices) =>
                                    prevServices?.map((service) => {
                                      const updatedAddresses =
                                        service.addresses.map((loc) => ({
                                          ...loc,
                                          address: address || loc.address,
                                          city: city || loc.city,
                                          state: state || loc.state,
                                          zip: zip || loc.zip,
                                        }))
                                      return {
                                        ...service,
                                        addresses: updatedAddresses,
                                      }
                                    }),
                                  )

                                  // Update RFP Services' addresses
                                  setCartService((prevServices) =>
                                    prevServices.map((service) => {
                                      const updatedAddresses =
                                        service.addresses.map((loc) => ({
                                          ...loc,
                                          address: address || loc.address,
                                          city: city || loc.city,
                                          state: state || loc.state,
                                          zip: zip || loc.zip,
                                        }))
                                      return {
                                        ...service,
                                        addresses: updatedAddresses,
                                      }
                                    }),
                                  )
                                }

                                // Set tax category if available
                                if (newValue.tax_category) {
                                  const taxCat = taxCategories?.find(
                                    (cat) => newValue.tax_category === cat.id,
                                  )
                                  setSelectedTaxCategory(taxCat)
                                }
                              } else {
                                setFieldValue('community', null)
                                setSelectedTaxCategory(null)
                              }
                            }}
                            renderInput={(params) => (
                              <Tooltip
                                title={values.community ? formatProjectAddress(values.community) : ''}
                              >
                                <TextField
                                  {...params}
                                  required
                                  label="Select Project"
                                  error={Boolean(
                                    touched.community && errors.community,
                                  )}
                                  helperText={
                                    touched.community && errors.community
                                  }
                                />
                              </Tooltip>
                            )}
                            getOptionLabel={(option) => option.name}
                          />
                        )}
                      </>
                    )}
                {userType !== 3 &&
                  explodedPermissions?.some((permission) =>
                    ['Create Request'].includes(permission),
                  ) && (
                    <>
                      {values.project_categories?.name == 'Service only old' || values.project_categories?.name == 'Time & Material' || values.project_categories?.name == 'Service only'  ? (
                        ''
                      ) : (
                        <>
                          <Divider />
                          <LabelStyleHead>Products</LabelStyleHead>
                          {/* {values.project_categories?.name == 'Time & Material' ?  */}
                          {false ? (
                            <>
                              <Scrollbar>
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                    <TableHead>
                                      <TableRow>
                                        {VALUE_TIME?.map((val) =>
                                          val.id === 14 ? (
                                            <Tooltip
                                              key={val.id}
                                              title="Selling Price With Marketing Adjustment"
                                            >
                                              <TableCell>{val.value}</TableCell>
                                            </Tooltip>
                                          ) : (
                                            <TableCell key={val.id}>
                                              {val.value}
                                            </TableCell>
                                          ),
                                        )}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {selectedProducts?.map((data, index) => {
                                        const quantityFieldName = `quantity_${index}`
                                        const discountFieldName = `discount_${index}`
                                        const adjustmentFieldName = `adjustment_${index}`
                                        let unitName = UNITS?.filter(
                                          (item) => item?.id == data?.unit,
                                        )
                                        unitName = unitName[0]?.name
                                        let shortUnitName = ''
                                        if (unitName == 'Square feet') {
                                          shortUnitName = 'Sq ft'
                                        } else if (unitName == 'Lineal feet') {
                                          shortUnitName = 'Lin ft'
                                        } else if (
                                          unitName == 'Square Inches'
                                        ) {
                                          shortUnitName = 'Sq Inches'
                                        } else if (unitName == 'Unit') {
                                          shortUnitName = 'Unit'
                                        }
                                        let rowTotal = calculateTotal(
                                          markupType == 1
                                            ? data.price
                                            : markupType == 2
                                            ? data.retail_price
                                            : 0,
                                          Number(data.quantity),
                                          values[discountFieldName],
                                          data.locationQuantity,
                                          data.adjustment,
                                          data.adj_value_type
                                        )
                                        // Accumulate the totalAmount
                                        totalAmount += rowTotal
                                        // values['sub_total'] = totalAmount?.toFixed(2)
                                        data['product_sub_total'] = rowTotal
                                        data['markup_type'] = markupType
                                        const invoiceAmount =
                                          parseFloat(
                                            data?.expected_material_cost?.toFixed(
                                              2,
                                            ),
                                          ) +
                                          parseFloat(
                                            data?.expected_total_service_cost?.toFixed(
                                              2,
                                            ),
                                          )

                                        let markup =
                                          markupType == 1
                                            ? ((data.price -
                                                parseFloat(
                                                  data.expected_cost?.toFixed(
                                                    2,
                                                  ),
                                                )) /
                                                parseFloat(
                                                  data.expected_cost?.toFixed(
                                                    2,
                                                  ),
                                                )) *
                                              100
                                            : markupType == 2
                                            ? ((data.retail_price -
                                                parseFloat(
                                                  data.expected_cost?.toFixed(
                                                    2,
                                                  ),
                                                )) /
                                                parseFloat(
                                                  data.expected_cost?.toFixed(
                                                    2,
                                                  ),
                                                )) *
                                              100
                                            : 0
                                        // const markup = ((data.retail_price - data.price) / data.price) * 100;
                                        // let markup = markupType ? (invoiceAmount / rowTotal) : null
                                        markup = markup ? Number(markup) : 0
                                        if (isNoChargeJob) markup = 0

                                        let newTotalProductFormula =
                                          parseFloat(
                                            data.expected_cost?.toFixed(2),
                                          ) *
                                          data.quantity *
                                          data.locationQuantity
                                        newTotalProductFormula =
                                          newTotalProductFormula
                                            ? Number(newTotalProductFormula)
                                            : 0

                                        let newTotalWholesalePrice =
                                          data.price *
                                          data.quantity *
                                          data.locationQuantity
                                        if (data?.adjustment) {
                                          newTotalWholesalePrice =
                                            newTotalWholesalePrice
                                              ? newTotalWholesalePrice +
                                                (newTotalWholesalePrice *
                                                  data?.adjustment) /
                                                  100
                                              : 0
                                        }
                                        newTotalWholesalePrice =
                                          newTotalWholesalePrice
                                            ? Number(newTotalWholesalePrice)
                                            : 0

                                        let newTotalRetailPrice =
                                          data.retail_price *
                                          data.quantity *
                                          data.locationQuantity
                                        if (data?.adjustment) {
                                          newTotalRetailPrice =
                                            newTotalRetailPrice
                                              ? newTotalRetailPrice +
                                                (newTotalRetailPrice *
                                                  data?.adjustment) /
                                                  100
                                              : 0
                                        }
                                        newTotalRetailPrice =
                                          newTotalRetailPrice
                                            ? Number(newTotalRetailPrice)
                                            : 0

                                        totalProductFormula += Number(
                                          newTotalProductFormula,
                                        )
                                        totalWholesalePrice += Number(
                                          newTotalWholesalePrice,
                                        )
                                        totalRetailPrice +=
                                          Number(newTotalRetailPrice)

                                        values['totalProductFormula'] =
                                          totalProductFormula
                                        values['totalWholesalePrice'] =
                                          totalWholesalePrice
                                        values['totalRetailPrice'] =
                                          totalRetailPrice

                                        totalMarkup += markup
                                        let originalMarkup =
                                          markupType == 1
                                            ? data.wholesaleMarkup
                                            : markupType == 2
                                            ? data.retailMarkup
                                            : 0
                                        originaltotalMarkup += originalMarkup
                                        // values['totalMarkup'] = totalMarkup?.toFixed(2)
                                        data['markup'] = markup?.toFixed(2)
                                        // data['markup'] = Math.round(markup)
                                        console.log(
                                          '###############markup',
                                          markup,
                                        )
                                        console.log(
                                          '###############devvvvvv123',
                                          data,
                                        )

                                        const pfc =
                                          parseFloat(
                                            data.expected_cost?.toFixed(2),
                                          ) *
                                          data.quantity *
                                          data.locationQuantity // total product formula cost
                                        const rtp =
                                          data.retail_price *
                                          data.quantity *
                                          data.locationQuantity // total retail price
                                        const wsp =
                                          data.price *
                                          data.quantity *
                                          data.locationQuantity // total wholesale price

                                        // const maxDiscount_wholesale = (wsp - pfc) - DiscountTotal
                                        // const maxDiscount_retail = (rtp - pfc) - DiscountTotal

                                        const maxDiscount_wholesale = wsp - pfc
                                        const maxDiscount_retail = rtp - pfc

                                        console.log(
                                          'maxDiscount_wholesale--',
                                          maxDiscount_wholesale,
                                        )
                                        console.log(
                                          'maxDiscount_retail--',
                                          maxDiscount_retail,
                                        )
                                        console.log(
                                          'DiscountTotal--',
                                          DiscountTotal,
                                        )
                                        console.log('pfc--', pfc)
                                        console.log('rtp--', rtp)
                                        console.log('wsp--', wsp)
                                        data['product_total'] = lineProductTotal
                                        const productFormulaCost =
                                          parseFloat(
                                            (
                                              parseFloat(
                                                data.expected_material_cost?.toFixed(
                                                  2,
                                                ),
                                              ) *
                                              data.quantity *
                                              data.locationQuantity
                                            ).toFixed(2),
                                          ) +
                                          parseFloat(
                                            (
                                              parseFloat(
                                                data.expected_total_service_cost?.toFixed(
                                                  2,
                                                ),
                                              ) *
                                              data.quantity *
                                              data.locationQuantity
                                            ).toFixed(2),
                                          )

                                        let SPMA = 0
                                        if (markupType) {
                                          if (markupType == 1) {
                                            if (
                                              data.markAdjType == 2 ||
                                              data.markAdjType == 3
                                            ) {
                                              SPMA =
                                                (data.price
                                                  ? Number(data.price)
                                                  : 0) +
                                                (data.adjustment
                                                  ? Number(data.adjustment)
                                                  : 0)
                                            } else {
                                              SPMA =
                                                (data.price
                                                  ? Number(data.price)
                                                  : 0) +
                                                ((data.price
                                                  ? Number(data.price)
                                                  : 0) *
                                                  (data.adjustment
                                                    ? Number(data.adjustment)
                                                    : 0)) /
                                                  100
                                            }
                                          } else {
                                            if (
                                              data.markAdjType == 2 ||
                                              data.markAdjType == 3
                                            ) {
                                              SPMA =
                                                (data.retail_price
                                                  ? Number(data.retail_price)
                                                  : 0) +
                                                (data.adjustment
                                                  ? Number(data.adjustment)
                                                  : 0)
                                            } else {
                                              SPMA =
                                                (data.retail_price
                                                  ? Number(data.retail_price)
                                                  : 0) +
                                                ((data.retail_price
                                                  ? Number(data.retail_price)
                                                  : 0) *
                                                  (data.adjustment
                                                    ? Number(data.adjustment)
                                                    : 0)) /
                                                  100
                                            }
                                          }
                                        }
                                        console.log(
                                          'SPMA-----data.price-----',
                                          data.price,
                                        )
                                        console.log(
                                          'SPMA-----data.adjustment-----',
                                          data.adjustment,
                                        )
                                        console.log(
                                          'SPMA-----data.retail_price-----',
                                          data.retail_price,
                                        )
                                        console.log('SPMA-----SPMA-----', SPMA)
                                        SPMA = Number(SPMA)
                                        data['SPMA'] = SPMA?.toFixed(2)

                                        return (
                                          <>
                                            <TableRow key={index}>
                                              <TableCell>
                                                #{data?.indexId}
                                              </TableCell>
                                              <TableCell>
                                                {/* albin */}
                                                {/* <TextField required
                                      fullWidth
                                      type='text'
                                      label={'Product Name'}
                                      sx={{ width: 85 }}
                                      value={data.name}
                                      onChange={(event) => {
                                        let newValue = event.target.value;
                                        if (newValue !== "") {
                                          setSelectedProducts(pv => ([...pv.map(p => {
                                            if (p.indexId === data.indexId) {
                                              return {
                                                ...p,
                                                name: newValue,
                                              }
                                            } else {
                                              return p;
                                            }
                                          })]));
                                          data['name'] = newValue || '';
                                        }
                                      }}
                                      // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                      // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                    /> */}

                                                {/* ram */}
                                                <TextField
                                                  required
                                                  fullWidth
                                                  type="text"
                                                  label={'Product Name'}
                                                  sx={{ width: 85 }}
                                                  value={data.name}
                                                  onChange={(event) => {
                                                    let newValue =
                                                      event.target.value

                                                    // Update the selectedProducts state
                                                    setSelectedProducts(
                                                      (prevProducts) =>
                                                        prevProducts.map(
                                                          (product) => {
                                                            if (
                                                              product.indexId ===
                                                              data.indexId
                                                            ) {
                                                              return {
                                                                ...product,
                                                                name: newValue,
                                                              }
                                                            } else {
                                                              return product
                                                            }
                                                          },
                                                        ),
                                                    )
                                                    data['name'] =
                                                      newValue || ''
                                                    if (isSubmitted)
                                                      setIsSubmitted(false)
                                                  }}
                                                  error={
                                                    isSubmitted &&
                                                    data?.name?.trim() === ''
                                                  }
                                                  helperText={
                                                    isSubmitted &&
                                                    data?.name?.trim() === ''
                                                      ? 'Product Name is required'
                                                      : ''
                                                  }
                                                />
                                              </TableCell>
                                              <TableCell>
                                                <IconButton
                                                  onClick={() =>
                                                    handleOpenNote(
                                                      data.indexId,
                                                      data.product_notes,
                                                    )
                                                  }
                                                >
                                                  <NoteAdd
                                                    sx={{
                                                      color:
                                                        !data?.product_notes ||
                                                        data?.product_notes ===
                                                          ''
                                                          ? ''
                                                          : theme.palette
                                                              .primary.main,
                                                    }}
                                                  />
                                                </IconButton>
                                              </TableCell>
                                              <TableCell>
                                                {/* {(hasMarkupPermission && markupType == 2) ? data.retail_price?.toFixed(2) : null} */}

                                                <TextField
                                                  required
                                                  fullWidth
                                                  type="number"
                                                  label={'Retail Price Each'}
                                                  // disabled={
                                                  //   values.project_categories
                                                  //     ?.name ==
                                                  //   'Time & Material'
                                                  //     ? true
                                                  //     : false
                                                  // }
                                                  disabled={
                                                     false
                                                  }
                                                  sx={{ width: 85 }}
                                                  value={data.retail_price}
                                                  defaultValue={0}
                                                  onChange={(event) => {
                                                    let newValue =
                                                      event.target.value
                                                    if (newValue !== '') {
                                                      setSelectedProducts(
                                                        (pv) => [
                                                          ...pv.map((p) => {
                                                            if (
                                                              p.indexId ===
                                                              data.indexId
                                                            ) {
                                                              return {
                                                                ...p,
                                                                retail_price:
                                                                  newValue,
                                                                price: newValue,
                                                              }
                                                            } else {
                                                              return p
                                                            }
                                                          }),
                                                        ],
                                                      )
                                                      data['retail_price'] =
                                                        newValue || 0
                                                      data['price'] =
                                                        newValue || 0
                                                    }
                                                  }}
                                                  // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                                  // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                                />
                                              </TableCell>
                                              <TableCell>
                                                {hasMarkupPermission
                                                  ? data?.SPMA || null
                                                  : null}
                                              </TableCell>
                                              <TableCell>
                                                <TextField
                                                  required
                                                  fullWidth
                                                  type="number"
                                                  label={shortUnitName}
                                                  disabled={
                                                    shortUnitName == 'Unit'
                                                      ? true
                                                      : false
                                                  }
                                                  sx={{ width: 85 }}
                                                  // {...getFieldProps(quantityFieldName)}
                                                  value={Number(data.quantity)}
                                                  defaultValue={1}
                                                  onFocus={selectInputValue}
                                                  onClick={selectInputValue}
                                                  onKeyPress={(event) => {
                                                    if (
                                                      event.key === '0' &&
                                                      event.target.value === ''
                                                    ) {
                                                      event.preventDefault()
                                                    }
                                                    if (event.key === '-') {
                                                      event.preventDefault()
                                                    }
                                                    if (event.key === '.') {
                                                      event.preventDefault()
                                                    }
                                                  }}
                                                  onChange={(event) => {
                                                    let newValue =
                                                      event.target.value
                                                    if (
                                                      newValue !== '0' &&
                                                      newValue !== ''
                                                    ) {
                                                      console.log(
                                                        '################SelectedSeer',
                                                        selectedServices,
                                                      )

                                                      setSelectedProducts(
                                                        (pv) => [
                                                          ...pv.map((p) => {
                                                            if (
                                                              p.indexId ===
                                                              data.indexId
                                                            ) {
                                                              // if (p.id === data.id) {
                                                              // let arrayAddr

                                                              // const commonAddresses = (allLocationSame && pv.length > 0) ? [...pv[0].addresses][0] : null;

                                                              // if (allLocationSame && commonAddresses) {
                                                              //   arrayAddr = Array(Number(newValue)).fill().map((_, i) => ({
                                                              //     ...commonAddresses,
                                                              //     id: i
                                                              //   }));

                                                              // }
                                                              // else {
                                                              //   arrayAddr = [...p.addresses]
                                                              //   if (p.addresses.length < Number(newValue)) {
                                                              //     arrayAddr.push(...[...Array(Number(newValue) - p.addresses.length)].map((a, i) => {

                                                              //       return {
                                                              //         id: p.addresses.length + i,
                                                              //         address: '',
                                                              //         city: '',
                                                              //         state: '',
                                                              //         zip: '',
                                                              //       }
                                                              //     }))
                                                              //   } else {
                                                              //     arrayAddr = arrayAddr.slice(0, -(p.addresses.length - Number(newValue)));
                                                              //   }
                                                              // }

                                                              return {
                                                                ...p,
                                                                quantity:
                                                                  Number(
                                                                    newValue,
                                                                  ),
                                                                // addresses: arrayAddr
                                                              }
                                                            } else {
                                                              return p
                                                            }
                                                          }),
                                                        ],
                                                      )
                                                      setSelectedServices(
                                                        (pv) => [
                                                          ...pv.map(
                                                            (service) => {
                                                              // if (service.product_id === data.id) {
                                                              if (
                                                                service.productIndex ===
                                                                data.indexId
                                                              ) {
                                                                return {
                                                                  ...service,
                                                                  productIndex:
                                                                    data.indexId,
                                                                  quantity: (
                                                                    service.previousQty *
                                                                    Number(
                                                                      newValue,
                                                                    ) *
                                                                    service.locationQuantity
                                                                  )?.toFixed(2),
                                                                  qtyData:
                                                                    Number(
                                                                      newValue,
                                                                    ),
                                                                  total: (
                                                                    service.cost *
                                                                    (service.previousQty *
                                                                      Number(
                                                                        newValue,
                                                                      ) *
                                                                      service.locationQuantity)
                                                                  )?.toFixed(2),
                                                                }
                                                              } else {
                                                                return service
                                                              }
                                                            },
                                                          ),
                                                        ],
                                                      )
                                                      //new chnage on 2-2-24
                                                      if (
                                                        newValue === '' ||
                                                        newValue <= 0
                                                      ) {
                                                        event.preventDefault()
                                                        return
                                                      }
                                                      if (
                                                        newValue.startsWith('-')
                                                      ) {
                                                        newValue =
                                                          newValue.slice(1)
                                                      }
                                                      data['quantity'] =
                                                        newValue || 1
                                                      setFieldValue(
                                                        quantityFieldName,
                                                        newValue,
                                                      )
                                                    }
                                                  }}
                                                  error={Boolean(
                                                    touched[
                                                      quantityFieldName
                                                    ] &&
                                                      errors[quantityFieldName],
                                                  )}
                                                  helperText={
                                                    touched[
                                                      quantityFieldName
                                                    ] &&
                                                    errors[quantityFieldName]
                                                  }
                                                />
                                              </TableCell>
                                              <TableCell>
                                                <TextField
                                                  required
                                                  fullWidth
                                                  type="number"
                                                  label={'Qty'}
                                                  // {...getFieldProps(quantityFieldName)}
                                                  value={Number(
                                                    data.locationQuantity,
                                                  )}
                                                  defaultValue={1}
                                                  onFocus={selectInputValue}
                                                  onClick={selectInputValue}
                                                  onKeyPress={(event) => {
                                                    if (
                                                      event.key === '0' &&
                                                      event.target.value === ''
                                                    ) {
                                                      event.preventDefault()
                                                    }
                                                    if (event.key === '-') {
                                                      event.preventDefault()
                                                    }
                                                    if (event.key === '.') {
                                                      event.preventDefault()
                                                    }
                                                  }}
                                                  onChange={(event) => {
                                                    let newValue =
                                                      event.target.value
                                                    if (
                                                      newValue !== '0' &&
                                                      newValue !== ''
                                                    ) {
                                                      setSelectedProducts(
                                                        (pv) => [
                                                          ...pv.map((p) => {
                                                            console.log(
                                                              '################p.id',
                                                              p.id,
                                                            )
                                                            console.log(
                                                              '################data.id',
                                                              data.id,
                                                            )
                                                            // if (p.id === data.id) {
                                                            if (
                                                              p.indexId ===
                                                              data.indexId
                                                            ) {
                                                              let arrayAddr

                                                              const commonAddresses =
                                                                data?.allLocationSame &&
                                                                pv.length > 0
                                                                  ? p.addresses[0]
                                                                  : null

                                                              if (
                                                                data?.allLocationSame &&
                                                                commonAddresses
                                                              ) {
                                                                arrayAddr =
                                                                  Array(
                                                                    Number(1),
                                                                  )
                                                                    .fill()
                                                                    .map(
                                                                      (
                                                                        _,
                                                                        i,
                                                                      ) => ({
                                                                        ...commonAddresses,
                                                                        id: i,
                                                                      }),
                                                                    )
                                                              } else {
                                                                arrayAddr = [
                                                                  ...p.addresses,
                                                                ]
                                                                console.log(
                                                                  '################arrayAddr',
                                                                  arrayAddr,
                                                                )
                                                                console.log(
                                                                  '################p.addresses.length',
                                                                  p.addresses
                                                                    .length,
                                                                )
                                                                console.log(
                                                                  '################Number(newValue)',
                                                                  Number(
                                                                    newValue,
                                                                  ),
                                                                )
                                                                if (
                                                                  p.addresses
                                                                    .length < 1
                                                                ) {
                                                                  arrayAddr.push(
                                                                    ...[
                                                                      ...Array(
                                                                        1 -
                                                                          p
                                                                            .addresses
                                                                            .length,
                                                                      ),
                                                                    ].map(
                                                                      (
                                                                        a,
                                                                        i,
                                                                      ) => {
                                                                        return {
                                                                          id:
                                                                            p
                                                                              .addresses
                                                                              .length +
                                                                            i,
                                                                          address:
                                                                            '',
                                                                          city: '',
                                                                          state: '',
                                                                          zip: '',
                                                                        }
                                                                      },
                                                                    ),
                                                                  )
                                                                } else if (
                                                                  p.addresses
                                                                    .length > Number(newValue) //1
                                                                ) {
                                                                  arrayAddr =
                                                                    arrayAddr.slice(
                                                                      0,
                                                                      Number(newValue), //1
                                                                    )
                                                                } else {
                                                                  arrayAddr = arrayAddr.slice(0, -(p.addresses.length - Number(newValue)));
                                                                }
                                                              }

                                                              console.log(
                                                                '###########Arrayadde',
                                                                arrayAddr,
                                                              )
                                                              return {
                                                                ...p,
                                                                // quantity: Number(newValue),
                                                                locationQuantity:
                                                                  Number(
                                                                    newValue,
                                                                  ),
                                                                addresses:
                                                                  arrayAddr,
                                                              }
                                                            } else {
                                                              return p
                                                            }
                                                          }),
                                                        ],
                                                      )
                                                      setSelectedServices(
                                                        (pv) => [
                                                          ...pv.map(
                                                            (service) => {
                                                              // if (service.product_id === data.id) {
                                                              console.log(
                                                                'locationQty---service----',
                                                                service,
                                                              )
                                                              console.log(
                                                                'locationQty---data----',
                                                                data,
                                                              )
                                                              if (
                                                                service?.productIndex ===
                                                                data?.indexId
                                                              ) {
                                                                return {
                                                                  ...service,
                                                                  productIndex:
                                                                    data?.indexId,
                                                                  quantity: (
                                                                    service.previousQty *
                                                                    Number(
                                                                      newValue,
                                                                    ) *
                                                                    (service.qtyData ||
                                                                      1)
                                                                  )?.toFixed(2),
                                                                  locationQuantity:
                                                                    Number(
                                                                      newValue,
                                                                    ),
                                                                }
                                                              } else {
                                                                return service
                                                              }
                                                            },
                                                          ),
                                                        ],
                                                      )
                                                      //new chnage on 2-2-24
                                                      if (
                                                        newValue === '' ||
                                                        newValue <= 0
                                                      ) {
                                                        event.preventDefault()
                                                        return
                                                      }
                                                      if (
                                                        newValue.startsWith('-')
                                                      ) {
                                                        newValue =
                                                          newValue.slice(1)
                                                      }
                                                      data['locationQuantity'] =
                                                        newValue || 1
                                                      // setFieldValue(quantityFieldName, newValue);
                                                    }
                                                  }}
                                                  // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                                  // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                                />
                                              </TableCell>
                                              <TableCell>
                                                <IconButton
                                                  onClick={() => {
                                                    setLocationStates({
                                                      ...locationStates,
                                                      [data.indexId]: true,
                                                    })
                                                  }}
                                                >
                                                  <LocationOn
                                                    sx={{
                                                      color:
                                                        data.addresses.some(
                                                          (obj) =>
                                                            [obj.address, obj.city, obj.state, obj.zip].some(
                                                              (value) =>
                                                                (value === '' || value === null),
                                                            ),
                                                        )
                                                          ? ''
                                                          : theme.palette
                                                              .primary.main,
                                                    }}
                                                  />
                                                </IconButton>
                                              </TableCell>
                                              {/* <TableCell>{data.id}</TableCell> */}
                                              <TableCell>
                                                <Autocomplete
                                                  sx={{ width: 70 }}
                                                  id="combo-box-demo"
                                                  disableClearable
                                                  options={
                                                    marketingAdjustmentType ||
                                                    []
                                                  }
                                                  defaultValue={
                                                    marketingAdjustmentType.find(
                                                      (type) =>
                                                        type.id ===
                                                        data.markAdjType,
                                                    ) ||
                                                    marketingAdjustmentType[0]
                                                  }
                                                  onChange={(
                                                    event,
                                                    newValue,
                                                  ) => {
                                                    setSelectedProducts(
                                                      (prevProducts) => {
                                                        return prevProducts.map(
                                                          (product) => {
                                                            if (
                                                              product.indexId ===
                                                              data.indexId
                                                            ) {
                                                              return {
                                                                ...product,
                                                                markAdjType:
                                                                  newValue?.id ||
                                                                  marketingAdjustmentType[0]
                                                                    .id, // Set adjustment type or default to the first option
                                                                adjustment: 0,
                                                              }
                                                            }
                                                            return product
                                                          },
                                                        )
                                                      },
                                                    )
                                                  }}
                                                  renderInput={(params) => (
                                                    <TextField
                                                      {...params}
                                                      required
                                                      error={Boolean(
                                                        touched.marketingAdjType &&
                                                          errors.marketingAdjType,
                                                      )}
                                                      helperText={
                                                        touched.marketingAdjType &&
                                                        errors.marketingAdjType
                                                      }
                                                      label="Select type"
                                                    />
                                                  )}
                                                  getOptionLabel={(option) =>
                                                    option.name
                                                      ? option.name
                                                      : ''
                                                  }
                                                />
                                              </TableCell>
                                              <TableCell>
                                                {/* <TextField
                                      type="number"
                                      label="Discount"
                                      defaultValue={0}
                                      value={Number(data.discount)}
                                      // {...getFieldProps(discountFieldName)}
                                      onChange={(event) => {
                                        let newValue = event.target.value;
                                        if (newValue.startsWith('-')) {
                                          newValue = newValue.slice(1);
                                        }
                                        if (markupType == 1) {
                                          if (Number(newValue) > maxDiscount_wholesale) {
                                            newValue = maxDiscount_wholesale.toFixed(2);
                                          }
                                        } else if (markupType == 2) {
                                          if (Number(newValue) > maxDiscount_retail) {
                                            newValue = maxDiscount_retail.toFixed(2);
                                          }
                                        } else {
                                          newValue = 0;
                                        }
                                        if (newValue === '-0.00') {
                                          newValue = 0;
                                        }
                                        data['discount'] = newValue
                                        setFieldValue(discountFieldName, newValue);
                                      }}
                                      error={Boolean(touched[discountFieldName] && errors[discountFieldName])}
                                      helperText={touched[discountFieldName] && errors[discountFieldName]}
                                      inputProps={{ max: markupType == 1 ? maxDiscount_wholesale : markupType == 2 ? maxDiscount_retail : 0, min: 0 }}
                                    /> */}
                                                <TextField
                                                  type="number"
                                                  label={
                                                    data.markAdjType === 2
                                                      ? '$'
                                                      : data.markAdjType === 3
                                                      ? '¢'
                                                      : '%'
                                                  }
                                                  defaultValue={
                                                    data?.adjustment
                                                      ? Number(data?.adjustment)
                                                      : 0
                                                  }
                                                  value={Number(
                                                    data.adjustment,
                                                  ).toFixed(2)}
                                                  onChange={(event) => {
                                                    let newValue =
                                                      event.target.value
                                                    if (
                                                      newValue.startsWith('-')
                                                    ) {
                                                      newValue =
                                                        newValue.slice(1)
                                                    }
                                                    if (newValue === '-0.00') {
                                                      newValue = 0
                                                    }
                                                    data['adjustment'] =
                                                      newValue
                                                    setFieldValue(
                                                      adjustmentFieldName,
                                                      newValue,
                                                    )
                                                  }}
                                                  error={Boolean(
                                                    touched[
                                                      adjustmentFieldName
                                                    ] &&
                                                      errors[
                                                        adjustmentFieldName
                                                      ],
                                                  )}
                                                  helperText={
                                                    touched[
                                                      adjustmentFieldName
                                                    ] &&
                                                    errors[adjustmentFieldName]
                                                  }
                                                />
                                              </TableCell>
                                              <TableCell>
                                                {calculateTotal(
                                                  markupType == 1
                                                    ? Number(data.price)
                                                    : markupType == 2
                                                    ? Number(data.retail_price)
                                                    : 0,
                                                  Number(data.quantity),
                                                  values[discountFieldName],
                                                  data.locationQuantity,
                                                  data.adjustment,
                                                  data.markAdjType,
                                                  data.adj_value_type
                                                )?.toFixed(2)}
                                              </TableCell>
                                              <TableCell>
                                                <IconButton
                                                  onClick={() =>
                                                    handleDeleteProduct(
                                                      data.id,
                                                      data.indexId,
                                                    )
                                                  }
                                                >
                                                  <Delete />
                                                </IconButton>
                                              </TableCell>
                                            </TableRow>
                                            <Modal
                                              open={
                                                locationStates[data.indexId]
                                              }
                                              handleClose={() => {
                                                setLocationStates({
                                                  ...locationStates,
                                                  [data.indexId]: false,
                                                })
                                              }}
                                            >
                                              {/* {index === 0 && ( */}
                                                <FormControlLabel
                                                  control={
                                                    <Switch
                                                      checked={data?.allLocationSame}
                                                      onChange={()=>
                                                        handleAllLocationSameChange(index)
                                                      }
                                                    />
                                                  }
                                                  label="All Locations Same"
                                                />
                                              {/* )} */}
                                              <Grid
                                                container
                                                spacing={3}
                                                sx={{
                                                  justifyContent: 'center',
                                                  width: '100%',
                                                }}
                                              >
                                                {data?.addresses?.map(
                                                  (addr, i) => (
                                                    <Grid item xs={12}>
                                                      {/* Side Heading */}
                                                      <Typography
                                                        variant="h5"
                                                        sx={{ mb: 2 }}
                                                      >
                                                        Location {i + 1}
                                                      </Typography>

                                                      {/* Address Fields */}

                                                      <Stack
                                                        direction={{
                                                          xs: 'column',
                                                          sm: 'row',
                                                        }}
                                                        spacing={{
                                                          xs: 3,
                                                          sm: 2,
                                                        }}
                                                        sx={{ mb: 2 }}
                                                      >
                                                        <TextField
                                                          fullWidth
                                                          label="Address"
                                                          size="small"
                                                          value={
                                                            data.addresses[i]
                                                              .address || ''
                                                          }
                                                          disabled={
                                                            i !== 0 &&
                                                            data?.allLocationSame
                                                              ? true
                                                              : false
                                                          }
                                                          // onChange={(event) => {
                                                          //   let arrayAddr = [
                                                          //     ...data.addresses,
                                                          //   ]
                                                          //   arrayAddr[
                                                          //     i
                                                          //   ].address =
                                                          //     event.target.value
                                                          //   setSelectedProducts(
                                                          //     (pv) => [
                                                          //       ...pv.map(
                                                          //         (p) => {
                                                          //           // if (p.id === data.id) {
                                                          //           if (
                                                          //             p.indexId ===
                                                          //             data.indexId
                                                          //           ) {
                                                          //             return {
                                                          //               ...p,
                                                          //               addresses:
                                                          //                 arrayAddr,
                                                          //             }
                                                          //           } else {
                                                          //             return p
                                                          //           }
                                                          //         },
                                                          //       ),
                                                          //     ],
                                                          //   )
                                                          // }}
                                                          onChange={(event) => {
                                                            setSelectedProducts((prevProducts) =>
                                                              prevProducts.map((p) => {
                                                                if (p.indexId === data.indexId) {
                                                                  let updatedAddresses = [...p.addresses];
                                                                  if (p.allLocationSame) {
                                                                    updatedAddresses = updatedAddresses.map(() => ({
                                                                      ...updatedAddresses[0],
                                                                      address: event.target.value,
                                                                    }));
                                                                  } else {
                                                                    updatedAddresses[i] = {
                                                                      ...updatedAddresses[i],
                                                                      address: event.target.value,
                                                                    };
                                                                  }
                                                                  return {
                                                                    ...p,
                                                                    addresses: updatedAddresses,
                                                                  };
                                                                }
                                                                return p;
                                                              })
                                                            );
                                                          }}
                                                        />
                                                      </Stack>

                                                      {/* City, State, Zip Fields */}
                                                      <Stack
                                                        direction={{
                                                          xs: 'column',
                                                          sm: 'row',
                                                        }}
                                                        spacing={{
                                                          xs: 3,
                                                          sm: 2,
                                                        }}
                                                        sx={{ mb: 2 }}
                                                      >
                                                        <TextField
                                                          fullWidth
                                                          label="City"
                                                          size="small"
                                                          value={
                                                            data.addresses[i]
                                                              .city || ''
                                                          }
                                                          disabled={
                                                            i !== 0 &&
                                                            data?.allLocationSame
                                                              ? true
                                                              : false
                                                          }
                                                          // onChange={(event) => {
                                                          //   let arrayAddr = [
                                                          //     ...data.addresses,
                                                          //   ]
                                                          //   arrayAddr[i].city =
                                                          //     event.target.value
                                                          //   setSelectedProducts(
                                                          //     (pv) => [
                                                          //       ...pv.map(
                                                          //         (p) => {
                                                          //           // if (p.id === data.id) {
                                                          //           if (
                                                          //             p.indexId ===
                                                          //             data.indexId
                                                          //           ) {
                                                          //             return {
                                                          //               ...p,
                                                          //               addresses:
                                                          //                 arrayAddr,
                                                          //             }
                                                          //           } else {
                                                          //             return p
                                                          //           }
                                                          //         },
                                                          //       ),
                                                          //     ],
                                                          //   )
                                                          // }}
                                                          onChange={(event) => {
                                                            setSelectedProducts((prevProducts) =>
                                                              prevProducts.map((p) => {
                                                                if (p.indexId === data.indexId) {
                                                                  let updatedAddresses = [...p.addresses];
                                                                  if (p.allLocationSame) {
                                                                    updatedAddresses = updatedAddresses.map(() => ({
                                                                      ...updatedAddresses[0],
                                                                      city: event.target.value,
                                                                    }));
                                                                  } else {
                                                                    updatedAddresses[i] = {
                                                                      ...updatedAddresses[i],
                                                                      city: event.target.value,
                                                                    };
                                                                  }
                                                                  return {
                                                                    ...p,
                                                                    addresses: updatedAddresses,
                                                                  };
                                                                }
                                                                return p;
                                                              })
                                                            );
                                                          }}
                                                        />
                                                        <TextField
                                                          fullWidth
                                                          label="State"
                                                          size="small"
                                                          value={
                                                            data.addresses[i]
                                                              .state || ''
                                                          }
                                                          disabled={
                                                            i !== 0 &&
                                                            data?.allLocationSame
                                                              ? true
                                                              : false
                                                          }
                                                          // onChange={(event) => {
                                                          //   let arrayAddr = [
                                                          //     ...data.addresses,
                                                          //   ]
                                                          //   arrayAddr[i].state =
                                                          //     event.target.value
                                                          //   setSelectedProducts(
                                                          //     (pv) => [
                                                          //       ...pv.map(
                                                          //         (p) => {
                                                          //           // if (p.id === data.id) {
                                                          //           if (
                                                          //             p.indexId ===
                                                          //             data.indexId
                                                          //           ) {
                                                          //             return {
                                                          //               ...p,
                                                          //               addresses:
                                                          //                 arrayAddr,
                                                          //             }
                                                          //           } else {
                                                          //             return p
                                                          //           }
                                                          //         },
                                                          //       ),
                                                          //     ],
                                                          //   )
                                                          // }}
                                                          onChange={(event) => {
                                                            setSelectedProducts((prevProducts) =>
                                                              prevProducts.map((p) => {
                                                                if (p.indexId === data.indexId) {
                                                                  let updatedAddresses = [...p.addresses];
                                                                  if (p.allLocationSame) {
                                                                    updatedAddresses = updatedAddresses.map(() => ({
                                                                      ...updatedAddresses[0],
                                                                      state: event.target.value,
                                                                    }));
                                                                  } else {
                                                                    updatedAddresses[i] = {
                                                                      ...updatedAddresses[i],
                                                                      state: event.target.value,
                                                                    };
                                                                  }
                                                                  return {
                                                                    ...p,
                                                                    addresses: updatedAddresses,
                                                                  };
                                                                }
                                                                return p;
                                                              })
                                                            );
                                                          }}
                                                        />
                                                        <TextField
                                                          fullWidth
                                                          label="Zip / Postal Code"
                                                          size="small"
                                                          value={
                                                            data.addresses[i]
                                                              .zip || ''
                                                          }
                                                          disabled={
                                                            i !== 0 &&
                                                            data?.allLocationSame
                                                              ? true
                                                              : false
                                                          }
                                                          // onChange={(event) => {
                                                          //   let arrayAddr = [
                                                          //     ...data.addresses,
                                                          //   ]
                                                          //   arrayAddr[i].zip =
                                                          //     event.target.value
                                                          //   setSelectedProducts(
                                                          //     (pv) => [
                                                          //       ...pv.map(
                                                          //         (p) => {
                                                          //           if (
                                                          //             p.indexId ===
                                                          //             data.indexId
                                                          //           ) {
                                                          //             // if (p.id === data.id) {
                                                          //             return {
                                                          //               ...p,
                                                          //               addresses:
                                                          //                 arrayAddr,
                                                          //             }
                                                          //           } else {
                                                          //             return p
                                                          //           }
                                                          //         },
                                                          //       ),
                                                          //     ],
                                                          //   )
                                                          // }}
                                                          onChange={(event) => {
                                                            setSelectedProducts((prevProducts) =>
                                                              prevProducts.map((p) => {
                                                                if (p.indexId === data.indexId) {
                                                                  let updatedAddresses = [...p.addresses];
                                                                  if (p.allLocationSame) {
                                                                    updatedAddresses = updatedAddresses.map(() => ({
                                                                      ...updatedAddresses[0],
                                                                      zip: event.target.value,
                                                                    }));
                                                                  } else {
                                                                    updatedAddresses[i] = {
                                                                      ...updatedAddresses[i],
                                                                      zip: event.target.value,
                                                                    };
                                                                  }
                                                                  return {
                                                                    ...p,
                                                                    addresses: updatedAddresses,
                                                                  };
                                                                }
                                                                return p;
                                                              })
                                                            );
                                                          }}
                                                        />
                                                      </Stack>
                                                    </Grid>
                                                  ),
                                                )}
                                              </Grid>

                                              <Grid
                                                container
                                                justifyContent="center"
                                                alignItems="center"
                                              >
                                                <Grid item xs={12} md={4}>
                                                  {/* {index !== 0 && data?.allLocationSame */}
                                                  {false
                                                  ? (
                                                    ''
                                                  ) : (
                                                    <Box
                                                      sx={{
                                                        mt: 3,
                                                        display: 'flex',
                                                        justifyContent:
                                                          'center',
                                                        gap: 1,
                                                      }}
                                                    >
                                                      <LoadingButton
                                                        variant="contained"
                                                        onClick={() => {
                                                          setIsSaving(true)
                                                          setTimeout(() => {
                                                            setIsSaving(false)
                                                            setLocationStates(
                                                              false,
                                                            )
                                                          }, 100)
                                                        }}
                                                        loading={isSaving}
                                                      >
                                                        {' Save '}
                                                      </LoadingButton>
                                                      {/* <Button variant="outlined" type="submit" onClick={() => { setLocationStates(false) }}>
                                        Cancel
                                      </Button> */}
                                                    </Box>
                                                  )}
                                                </Grid>
                                              </Grid>
                                            </Modal>
                                            <Modal
                                              open={
                                                openProductNote[data.indexId] ||
                                                false
                                              }
                                              handleClose={() =>
                                                handleCloseNote(data.indexId)
                                              }
                                            >
                                              <Grid
                                                container
                                                spacing={3}
                                                sx={{
                                                  justifyContent: 'center',
                                                  width: '100%',
                                                }}
                                              >
                                                <Grid item xs={12}>
                                                  <Typography
                                                    variant="h5"
                                                    sx={{ mb: 2 }}
                                                  >
                                                    Note
                                                  </Typography>

                                                  <Stack
                                                    direction={{
                                                      xs: 'column',
                                                      sm: 'row',
                                                    }}
                                                    spacing={{ xs: 3, sm: 2 }}
                                                    sx={{ mb: 2 }}
                                                  >
                                                    <TextField
                                                      fullWidth
                                                      multiline
                                                      rows={4}
                                                      size="medium"
                                                      value={currentNote}
                                                      onChange={handleNoteChange}
                                                      inputProps={{
                                                        maxLength: MAX_CHARACTERS,
                                                      }}
                                                      helperText={
                                                        error
                                                          ? error // Show error message if validation fails
                                                          : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                      }
                                                      error={Boolean(error)} // Highlight the field in error state if validation fails
                                                      InputProps={{
                                                        sx: {
                                                          color: 'error.main', // You can change this to a suitable color or style
                                                        },
                                                      }}
                                                    />
                                                    {/* <TextField
                                                      fullWidth
                                                      multiline
                                                      rows={4}
                                                      size="medium"
                                                      value={currentNote}
                                                      onChange={
                                                        handleNoteChange
                                                      }
                                                      inputProps={{
                                                        maxLength:
                                                          MAX_CHARACTERS,
                                                      }}
                                                      helperText={`${currentNote.length}/${MAX_CHARACTERS} characters`}
                                                      InputProps={{
                                                        sx: {
                                                          color: 'error.main',
                                                        }
                                                      }}
                                                    /> */}
                                                  </Stack>
                                                </Grid>
                                              </Grid>

                                              <Grid
                                                container
                                                justifyContent="center"
                                                alignItems="center"
                                              >
                                                <Grid item xs={12} md={4}>
                                                  <Box
                                                    sx={{
                                                      mt: 3,
                                                      display: 'flex',
                                                      justifyContent: 'center',
                                                      gap: 1,
                                                    }}
                                                  >
                                                    <LoadingButton
                                                      variant="contained"
                                                      onClick={() =>
                                                        handleSaveNote(
                                                          data.indexId,
                                                        )
                                                      }
                                                      loading={isSavingNote}
                                                    >
                                                      Save
                                                    </LoadingButton>
                                                    <LoadingButton
                                                      variant="outlined"
                                                      color="error"
                                                      onClick={() =>
                                                        handleClearNote(
                                                          data.indexId,
                                                        )
                                                      }
                                                      loading={isClearingNote}
                                                      disabled={!currentNote.trim()}
                                                    >
                                                      Clear
                                                    </LoadingButton>
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </Modal>
                                            <Modal
                                              open={
                                                openProductAttachment[data.indexId] ||
                                                false
                                              }
                                              handleClose={() =>
                                                handleCloseAttachment(data.indexId)
                                              }
                                            >
                                              {renderAttachmentModalContent({
                                                itemKey: String(data.indexId),
                                                tabValue: attachmentTabValue[data.indexId],
                                                onTabChange: handleAttachmentTabChange,
                                                selectedImages:
                                                  selectedUploadedImages[String(data.indexId)] ||
                                                  selectedUploadedImages[data.indexId] ||
                                                  [],
                                                linkedAttachments:
                                                  productAttachments[String(data.indexId)] ||
                                                  productAttachments[data.indexId] ||
                                                  [],
                                                onImageSelect: handleImageSelect,
                                                onAddSelected: handleAddSelectedImages,
                                                onDrop: handleProductDrop,
                                                onRemove: handleProductRemove,
                                                isUploadingItem: isUploadingProduct[data.indexId] || false,
                                              })}
                                            </Modal>
                                            <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
                                              <Card
                                                sx={{
                                                  p: 3,
                                                  maxWidth: 768,
                                                  margin: 'auto',
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  justifyContent: 'center',
                                                  alignItems: 'center',
                                                }}
                                              >
                                                <div style={{width:'90%', display:'flex',justifyContent:'flex-end', marginBottom: '15px',marginLeft:'25px' }}>
                                                  <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={() => {
                                                      if (isClient || userType === 3) {
                                                        const newWindow = window.open('', '_blank');
                                                        newWindow.document.write(`
                                                          <html>
                                                            <head>
                                                              <title>PDF Viewer</title>
                                                              <style>
                                                                body { margin: 0; padding: 0; overflow: hidden; }
                                                                iframe { width: 100vw; height: 100vh; border: none; }
                                                              </style>
                                                            </head>
                                                            <body>
                                                              <iframe src="${selectedPDF}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
                                                            </body>
                                                          </html>
                                                        `);
                                                        newWindow.document.close();
                                                      } else {
                                                        window.open(selectedPDF, '_blank');
                                                      }
                                                    }}
                                                    disabled={!selectedPDF}
                                                    startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                                                    sx={{
                                                      fontSize:'14px'
                                                    }}
                                                  >
                                                    View PDF
                                                  </Button>
                                                </div>
                                                {pdfLoading && (
                                                  <Skeleton variant="rectangular" width="100%" height={500} />
                                                )}
                                                {(isClient || userType === 3) && useOfficeViewer ? (
                                                  <iframe
                                                    src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
                                                    title="Selected PDF"
                                                    width="100%"
                                                    height="500px"
                                                    frameBorder="0"
                                                    sandbox="allow-scripts allow-same-origin"
                                                    style={{ display: pdfLoading ? 'none' : 'block' }}
                                                    onLoad={() => setPdfLoading(false)}
                                                    onError={() => {
                                                      setUseOfficeViewer(false);
                                                      setPdfLoading(false);
                                                    }}
                                                  />
                                                ) : (
                                                  <iframe
                                                    src={selectedPDF}
                                                    title="Selected PDF"
                                                    width="100%"
                                                    height="500px"
                                                    frameBorder="0"
                                                    style={{ display: pdfLoading ? 'none' : 'block' }}
                                                    onLoad={() => setPdfLoading(false)}
                                                  />
                                                )}
                                              </Card>
                                            </DialogAnimate>
                                          </>
                                        )
                                      })}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Scrollbar>
                              {/* {
                            showAddNewRow ?
                              <Stack sx={{ justifyContent: 'center' }}>
                                <Box sx={{ justifyContent: 'center' }}>
                                  <Button
                                    variant="outlined"
                                    startIcon={
                                      <Stack>
                                        {' '}
                                        <Add />{' '}
                                      </Stack>
                                    }
                                    onClick={() => {
                                      addNewProductRow()
                                      // setMarkupType(1)
                                    }}
                                  >
                                    Add Product Row
                                  </Button>
                                </Box>
                              </Stack>
                              :""} */}
                            </>
                          ) : (
                            <>
                              <Stack
                                direction={{ xs: 'column', sm: 'row' }}
                                spacing={{ xs: 3, sm: 2 }}
                                alignItems={'center'}
                              >
                                {isSplitOrder && (values?.facility_type || []).filter(Boolean).length > 1 ? (
                                  <Stack sx={{ width: { xs: '100%', sm: '60%' } }} spacing={2}>
                                    {(values?.facility_type || []).filter(Boolean).map((facility) => (
                                      <Autocomplete
                                        key={`product-autocomplete-${facility?.id}`}
                                        sx={{ width: '100%' }}
                                        multiple
                                        disableCloseOnSelect
                                        clearOnBlur={false}
                                        inputValue={facilityProductInputs[String(facility?.id)] ?? ''}
                                        onInputChange={(event, newInputValue, reason) => {
                                          const fid = String(facility?.id);
                                          if (reason === 'reset' && newInputValue === '') {
                                            return;
                                          }
                                          setFacilityProductInputs((prev) => ({
                                            ...prev,
                                            [fid]: newInputValue,
                                          }));
                                        }}
                                        id={`combo-box-demo-${facility?.id}`}
                                        // options={
                                        //   (allProducts || []).filter((option) => {
                                        //     return !selectedProducts?.some((selected) => selected.id === option.id);
                                        //   })
                                        // }
                                        options={filteredProductOptions?.filter((opt) => Number(opt?.facility_id) === Number(facility?.id))}
                                        value={selectedProducts?.filter((item) => (item?.fromMapServices != true && !item.isAdditionalProduct && Number(item?.facility_id) === Number(facility?.id)))}
                                        onChange={(event, newValue) => {
                                          const regularSelectedProducts = selectedProducts?.filter((item) => (item?.fromMapServices != true && !item.isAdditionalProduct)) || [];
                                          const otherFacilities = regularSelectedProducts?.filter((p) => Number(p?.facility_id) !== Number(facility?.id)) || [];
                                          const updated = [...otherFacilities, ...(newValue || [])].map((item) => ({
                                            ...item,
                                            is_single_card: values.project_categories?.id !==14 ? true : false
                                          }));
                                          setFieldValue('products', updated)
                                          handleProduct(updated)
                                          setShowAddNewRow(true)
                                        }}
                                        // isOptionEqualToValue={(option, value) =>
                                        //   option != null &&
                                        //   value != null &&
                                        //   Number(option.id) === Number(value.id) &&
                                        //   Number(option.facility_id ?? 0) === Number(value.facility_id ?? 0)
                                        // }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            required
                                            error={Boolean(touched.products && errors.products)}
                                            helperText={touched.products && errors.products}
                                            label={`Select a product - ${facility?.label || ''}`}
                                          />
                                        )}
                                        // getOptionLabel={(option) =>
                                        //   option.name ? option.name : ''
                                        // }
                                        getOptionLabel={(option) => {
                                          const name = option.name || '';
                                          const description = option.description || '';
                                          const categoryId = values?.project_categories?.id;
                                          const suffix = option.inhouse === 4
                                            ? '(In Stock Catalog)'
                                            : option.isTrafficCatalog
                                              ? '(TC)' :
                                              option.inhouse === 5
                                              ? '(Client Owned Catalog)'
                                              : option.inhouse === 0
                                              ? '(Sub Contract)'
                                              : option.inhouse === 6
                                              ? '(Split Catalog)'
                                              : option.inhouse === 7
                                              ? '(Estimate Catalog)'
                                              : '(Production Catalog)';
                                          return `${description} ${suffix} \u200B${name}`;
                                        }}
                                        renderOption={(props, option) => {
                                          const { style, ...liProps } = props;
                                          const description =option.description // option.name || option.name;
                                          const name = option.name || '';
                                          const categoryId = values?.project_categories?.id;
                                          const suffix = option.inhouse === 4
                                            ? '(In Stock Catalog)'
                                            : option.isTrafficCatalog
                                              ? '(TC)' :
                                              option.inhouse === 5
                                                ? '(Client Owned Catalog)'
                                            : option.inhouse === 0
                                              ? '(Sub Contract)'
                                            : option.inhouse === 6
                                              ? '(Split Catalog)'
                                            : option.inhouse === 7
                                              ? '(Estimate Catalog)'
                                              : '(Production Catalog)';

                                          return (
                                            <li
                                              {...liProps}
                                              style={{
                                                ...style,
                                                display: 'flex',
                                                alignItems: 'center',
                                              }}
                                            >
                                          <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                            {option?.syncWithQuickbooks === 1 && (
                                              <img
                                                src={quickbookLogo}
                                                width="40px"
                                                height="20px"
                                                // style={{ marginRight: 8 }}
                                                alt="QuickBooks"
                                              />
                                            )}
                                          </div>
                                              <Tooltip title={`${description} ${suffix}`}>
                                                <span
                                                  style={{
                                                    flex: 1,
                                                    minWidth: 0,
                                                    display: 'block',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    color: theme.palette[
                                                      FacilityTypes.find(
                                                        (f) => f.id === option?.facility_id,
                                                      )?.color || 'primary'
                                                    ]?.main,
                                                  }}
                                                >
                                                  {`${name} ${suffix}`}
                                                </span>
                                              </Tooltip>
                                              <span style={{ display: 'none' }}>{option.name}</span>
                                            </li>
                                          );
                                        }}
                                        filterOptions={(options, { inputValue }) => {
                                          const fid = String(facility?.id);
                                          const raw =
                                            facilityProductInputs[fid] ??
                                            inputValue ??
                                            '';
                                          const searchText = raw.toString().trim().toLowerCase();
                                          if (!searchText) return options;
                                          return options.filter((option) => {
                                            const nameMatch = option.name?.toLowerCase().includes(searchText);
                                            const descMatch = option.description?.toLowerCase().includes(searchText);
                                            const idMatch = String(option.id)?.includes(searchText);
                                            const tagsMatch = String(option.tags ?? '').toLowerCase().includes(searchText);
                                            return nameMatch || descMatch || idMatch || tagsMatch;
                                          });
                                        }}
                                        renderTags={(value, getTagProps) =>
                                          value.map((option, index) => {
                                            const categoryId = values?.project_categories?.id;
                                            const suffix = option.inhouse === 4
                                              ? '(In Stock Catalog)'
                                              : option.isTrafficCatalog
                                                ? '(TC)':
                                                option.inhouse === 5
                                                    ? '(Client Owned Catalog)'
                                                : option.inhouse === 0
                                                    ? '(Sub Contract)'
                                                : option.inhouse === 6
                                                    ? '(Split Catalog)'
                                                : option.inhouse === 7
                                                    ? '(Estimate Catalog)'
                                                : '(Production Catalog)';
                                            return (
                                              <Tooltip key={index} title={`${option.description || ''} ${suffix}`}>
                                                <Chip  sx={{color:theme.palette[
                                                    FacilityTypes.find(f => f.id === option?.facility_id)?.color || 'primary'
                                                  ]?.main
                                                }}
                                                  {...getTagProps({ index })}
                                                  label={`${option.name} ${suffix}`}
                                                />
                                              </Tooltip>
                                            );
                                          })
                                        }
                                      />
                                    ))}
                                  </Stack>
                                ) : (
                                  <Autocomplete
                                    key={`product-autocomplete-${isSplitOrder}-${values?.facility_type?.length || 0}-${filteredProductOptions?.length || 0}`}
                                    sx={{ width: '60%' }}
                                    multiple
                                    disableCloseOnSelect
                                    clearOnBlur={false}
                                    inputValue={productAutocompleteInput}
                                    onInputChange={(event, newInputValue, reason) => {
                                      if (reason === 'reset' && newInputValue === '') {
                                        return;
                                      }
                                      setProductAutocompleteInput(newInputValue);
                                      productInputValueRef.current = newInputValue || '';
                                    }}
                                    id="combo-box-demo"
                                    // options={
                                    //   (allProducts || []).filter((option) => {
                                    //     return !selectedProducts?.some((selected) => selected.id === option.id);
                                    //   })
                                    // }
                                    options={filteredProductOptions}
                                    value={selectedProducts?.filter(
                                      (item) => (item?.fromMapServices != true && !item.isAdditionalProduct)
                                    )}
                                    onChange={(event, newValue) => {
                                      const updated = newValue.map((item) => ({
                                        ...item,
                                        is_single_card: values.project_categories?.id !==14 ? true : false
                                      }));
                                      setFieldValue('products', updated)
                                      handleProduct(updated)
                                      setShowAddNewRow(true)

                                    }}
                                    // isOptionEqualToValue={(option, value) =>
                                    //   option != null &&
                                    //   value != null &&
                                    //   Number(option.id) === Number(value.id) &&
                                    //   Number(option.facility_id ?? 0) === Number(value.facility_id ?? 0)
                                    // }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        required
                                        error={Boolean(
                                          touched.products && errors.products,
                                        )}
                                        helperText={
                                          touched.products && errors.products
                                        }
                                        label="Select a product"
                                      />
                                    )}
                                    // getOptionLabel={(option) =>
                                    //   option.name ? option.name : ''
                                    // }
                                    getOptionLabel={(option) => {
                                      const name = option.name || '';
                                      const description = option.description || '';
                                      const categoryId = values?.project_categories?.id;
                                      const suffix = option.inhouse === 4
                                        ? '(In Stock Catalog)'
                                        : option.isTrafficCatalog
                                          ? '(TC)' :
                                          option.inhouse === 5
                                          ? '(Client Owned Catalog)'
                                          : option.inhouse === 0
                                          ? '(Sub Contract)'
                                          : option.inhouse === 6
                                          ? '(Split Catalog)'
                                          : option.inhouse === 7
                                          ? '(Estimate Catalog)'
                                          : '(Production Catalog)';
                                  return `${description} ${suffix} \u200B${name}`;
                                }}
                                  renderOption={(props, option) => {
                                    const { style, ...liProps } = props;
                                    const description =option.description  //option.name  || option.name;
                                    const name = option.name || '';
                                    const categoryId = values?.project_categories?.id;
                                    const suffix = option.inhouse === 4
                                      ? '(In Stock Catalog)'
                                      : option.isTrafficCatalog
                                        ? '(TC)' :
                                        option.inhouse === 5
                                          ? '(Client Owned Catalog)'
                                      : option.inhouse === 0
                                        ? '(Sub Contract)'
                                      : option.inhouse === 6
                                        ? '(Split Catalog)'
                                      : option.inhouse === 7
                                        ? '(Estimate Catalog)'
                                      : '(Production Catalog)';

                                    return (
                                      <li
                                        {...liProps}
                                        style={{
                                          ...style,
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}
                                      >
                                         <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                            {option?.syncWithQuickbooks === 1 && (
                                              <img
                                                src={quickbookLogo}
                                                width="40px"
                                                height="20px"
                                                // style={{ marginRight: 8 }}
                                                alt="QuickBooks"
                                              />
                                            )}
                                          </div>
                                        <Tooltip title={`${description} ${suffix}`}>
                                          <span
                                            style={{
                                              flex: 1,
                                              minWidth: 0,
                                              display: 'block',
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              color: isSplitOrder
                                                ? theme.palette[
                                                    FacilityTypes.find(
                                                      (f) => f.id === option?.facility_id,
                                                    )?.color || 'primary'
                                                  ]?.main
                                                : 'inherit',
                                            }}
                                          >
                                            {`${name} ${suffix}`}
                                          </span>
                                        </Tooltip>
                                        <span style={{ display: 'none' }}>{option.name}</span>
                                      </li>
                                    );
                                  }}
                                  filterOptions={(options, { inputValue }) => {
                                    const currentInput =
                                      productAutocompleteInput ||
                                      productInputValueRef.current ||
                                      (inputValue !== undefined && inputValue !== null ? inputValue : '');
                                    const searchText = (currentInput || '').toString().trim().toLowerCase();
                                    if (!searchText) return options;
                                    return options.filter((option) => {
                                      const nameMatch = option.name?.toLowerCase().includes(searchText);
                                      const descMatch = option.description?.toLowerCase().includes(searchText);
                                      const idMatch = String(option.id)?.includes(searchText);
                                      const tagsMatch = String(option.tags ?? '').toLowerCase().includes(searchText);
                                      return nameMatch || descMatch || idMatch || tagsMatch;
                                    });
                                  }}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                  const categoryId = values?.project_categories?.id;
                                  const suffix = option.inhouse === 4
                                    ? '(In Stock Catalog)'
                                    : option.isTrafficCatalog
                                      ? '(TC)':
                                      option.inhouse === 5
                                          ? '(Client Owned Catalog)'
                                      : option.inhouse === 0
                                          ? '(Sub Contract)'
                                      : option.inhouse === 6
                                          ? '(Split Catalog)'
                                      : option.inhouse === 7
                                          ? '(Estimate Catalog)'
                                      : '(Production Catalog)';
                                  return (
                                    <Tooltip key={index} title={`${option.description || ''} ${suffix}`}>
                                      <Chip  sx={{color:isSplitOrder ?theme.palette[
                                          FacilityTypes.find(f => f.id === option?.facility_id)?.color || 'primary'
                                        ]?.main
                                      : 'inherit' }}
                                        {...getTagProps({ index })}
                                        label={`${option.name} ${suffix}`}
                                      />
                                    </Tooltip>
                                  );
                                })
                              }
                                  />
                                )}
                                {/* Split Order Catalog Type Autocomplete - Only visible for split orders */}
                                {isSplitOrder ? (
                                  <Autocomplete
                                    sx={{ width: '40%' }}
                                    id="split-catalog-type"
                                    options={[...splitOrderCatalogTypes]
                                      // ✅ filter only when Service Only
                                      .filter(type =>
                                        values.project_categories?.id === 11
                                          ? (
                                              type.id === 'all' ||
                                              type.id === 'client_owned' ||
                                              type.id === 'traffic'
                                            )
                                          : true
                                      )
                                      // ✅ keep your existing sort
                                      .sort((a, b) => {
                                        if (a.id === 'all') return -1;
                                        if (b.id === 'all') return 1;
                                        return a.label.localeCompare(b.label);
                                      })
                                    }
                                    value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                                    onChange={(event, newValue) => {
                                      const finalValue = newValue || splitOrderCatalogTypes.find((type) => type.id === 'all')
                                      setFieldValue('split_catalog_type', finalValue)
                                      console.log('Split catalog type changed:', finalValue)
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Catalog Type"
                                        placeholder="Select catalog type"
                                      />
                                    )}
                                    getOptionLabel={(option) => option.label}
                                  />
                                ): 
                                (() => {
                                  // Hide Catalog Type field when project category is Build Order (id 15)
                                  const categoryId = values?.project_categories?.id;
                                  const isBuildOrder = categoryId === 15;
                                  const isServiceOnly = categoryId === 11;
                                  
                                  // Don't show Catalog Type for Build Order
                                  if (isBuildOrder) {
                                    return null;
                                  }
                                  
                                  // For Service Only: show only All, Client Owned, and Traffic
                                  if (isServiceOnly) {
                                    const serviceOnlyCatalogTypes = splitOrderCatalogTypes
                                      .filter(type => type.id === 'all' || type.id === 'client_owned' || type.id === 'traffic')
                                      .sort((a, b) => {
                                        // Keep "All" at the top, then sort rest alphabetically
                                        if (a.id === 'all') return -1;
                                        if (b.id === 'all') return 1;
                                        return a.label.localeCompare(b.label);
                                      });
                                    
                                    return (
                                      <Autocomplete
                                        sx={{ width: '50%' }}
                                        id="normal-catalog-type"
                                        options={serviceOnlyCatalogTypes}
                                        value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                                        onChange={(event, newValue) => {
                                          const finalValue = newValue || splitOrderCatalogTypes.find((type) => type.id === 'all')
                                          setFieldValue('split_catalog_type', finalValue)
                                          console.log('Service Only catalog type changed:', finalValue)
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Catalog Type"
                                            placeholder="Select catalog type"
                                          />
                                        )}
                                        getOptionLabel={(option) => option.label}
                                      />
                                    );
                                  }
                                  
                                  // For normal orders: remove split_catalog, add sub_contract (keep production_catalog)
                                  const filteredCatalogTypes = splitOrderCatalogTypes
                                    .filter(type => type.id !== 'split_catalog')
                                    .concat([{ id: 'sub_contract', label: 'Sub Contract', inhouse: 0, isTrafficCatalog: false }])
                                    .sort((a, b) => {
                                      // Keep "All" at the top, then sort rest alphabetically
                                      if (a.id === 'all') return -1;
                                      if (b.id === 'all') return 1;
                                      return a.label.localeCompare(b.label);
                                    });
                                  
                                  return (
                                    <Autocomplete
                                      sx={{ width: '50%' }}
                                      id="normal-catalog-type"
                                      options={filteredCatalogTypes}
                                      value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                                      onChange={(event, newValue) => {
                                        const finalValue = newValue || splitOrderCatalogTypes.find((type) => type.id === 'all')
                                        setFieldValue('split_catalog_type', finalValue)
                                        console.log('Normal catalog type changed:', finalValue)
                                        // Trigger product filtering by updating a dependency
                                        // The filteredProductOptions will react to values.split_catalog_type change
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Catalog Type"
                                          placeholder="Select catalog type"
                                        />
                                      )}
                                      getOptionLabel={(option) => option.label}
                                    />
                                  );
                                })()}
                                
                              </Stack>
                              <LabelStyle>Selected Products</LabelStyle>
                              <Scrollbar>
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell padding="checkbox" sx={{ width: 40 }} />
                                        {VALUE?.map((val) => {
                                          // Hide Marketing Adjustment headers when split order
                                          if (
                                            isSplitOrder &&
                                            (val.id === 17 || val.id === 12)
                                          ) {
                                            return null;
                                          }
                                          if (val.value === null || val.value === undefined) {
                                            return null;
                                          }
                                          if (val.id === 14) {
                                            return (
                                              <Tooltip
                                                key={val.id}
                                                title="Selling Price With Marketing Adjustment"
                                              >
                                                <TableCell>{val.value}</TableCell>
                                              </Tooltip>
                                            );
                                          }
                                          if (val.id === 20) {
                                            // Markup column - only show for non-split orders
                                            return !isSplitOrder ? (
                                              <TableCell key={val.id}>
                                                {val.value}
                                              </TableCell>
                                            ) : null;
                                          }
                                          if (val.id === 16) {
                                            // Conditionally show Incoming Percentage column
                                            return isSplitOrder ? (
                                              <TableCell key={val.id}>
                                                {val.value}
                                              </TableCell>
                                            ) : null;
                                          }
                                          // if (val.id === 18) {
                                          //   return isSplitOrder ? (
                                          //     <TableCell key={val.id}>
                                          //       {val.value}
                                          //     </TableCell>
                                          //   ) : null;
                                          // }
                                          return (
                                            <TableCell key={val.id}>
                                              {val.value}
                                            </TableCell>
                                          );
                                        })}
                                      </TableRow>
                                    </TableHead>
                                    <DragDropContext onDragEnd={handleProductTableDragEnd}>
                                      <Droppable droppableId="official-request-add-product-rows">
                                        {(droppableProvided) => (
                                    <TableBody
                                      ref={droppableProvided.innerRef}
                                      {...droppableProvided.droppableProps}
                                    >
                                      {selectedProducts?.sort((a, b) => a.indexId - b.indexId)?.map((data, index) => {
                                        console.log("dataaaaa",data)
                                        const quantityFieldName = `quantity_${index}`
                                        const discountFieldName = `discount_${index}`
                                        const adjustmentFieldName = `adjustment_${index}`
                                        let unitName = UNITS?.filter(
                                          (item) => item?.id == data?.unit,
                                        )
                                        unitName = unitName[0]?.name
                                        let shortUnitName = ''
                                        if (unitName == 'Square feet') {
                                          shortUnitName = 'Sq ft'
                                        } else if (unitName == 'Lineal feet') {
                                          shortUnitName = 'Lin ft'
                                        } else if (
                                          unitName == 'Square Inches'
                                        ) {
                                          shortUnitName = 'Sq Inches'
                                        } else if (unitName == 'Unit') {
                                          shortUnitName = 'Unit'
                                        }
                                        if(data.adj_value_type == null){
                                          data.adj_value_type =true
                                         }
                                        if (data.install_adj_value_type == null) {
                                          data.install_adj_value_type = true
                                        }
                                        if (data.install_adjustment == null) {
                                          data.install_adjustment = 0
                                         }
                                        if (data.install_quantity == null) {
                                          data.install_quantity = 1
                                        }

                                        if(!data?.done){
                                          data.done = 2
                                        }
                                        if((data.inhouse !== 1 || (data.inhouse ==1 && data.isTrafficCatalog == 1)) && data.done ==2 && !data.retail_price_edited){
                                          let price = data.max_price ? data.max_price : data.actual_retail_price

                                          const baseInstallCost =
                                            parseFloat(data?.original_install_cost ?? data?.install_cost) || 0
                                          const installAdj = parseFloat(data?.install_adjustment) || 0
                                          const signedInstallAdj =
                                            data?.install_adj_value_type === false ? -installAdj : installAdj
                                          const installCost = Math.max(0, baseInstallCost + signedInstallAdj)
                                          const installQty = Number(data?.install_quantity) || 1
                                          const prodQty = Number(data?.quantity) || 1
                                          const installEach = prodQty > 0 ? (installCost * (installQty / prodQty)) : installCost

                                          data['actual_retail_price'] =
                                            price +
                                            (data.adj_value_type
                                              ? Number(data?.adjustment || 0)
                                              : -(Number(data?.adjustment || 0)))

                                          const calculatedRetailPrice = installEach > 0 ? price + installEach : price
                                          data['retail_price'] =
                                            calculatedRetailPrice +
                                            (data.adj_value_type
                                              ? Number(data?.adjustment || 0)
                                              : -(Number(data?.adjustment || 0)))

                                          data.done = 1
                                        }
                                        // if(isNoChargeJob && data.inhouse !==0 && data.done ==2){
                                          if(isNoChargeJob && data.inhouse !==0 ){ // commented due to markup calculation issue in No Charge
                                          // For no charge products, calculate retail_price based on expected_cost + install_cost
                                          const baseInstallCost =
                                            parseFloat(data?.expected_install_labor_cost) || 0
                                          const installAdj = parseFloat(data?.install_adjustment) || 0
                                          const signedInstallAdj =
                                            data?.install_adj_value_type === false ? -installAdj : installAdj
                                          const backupAdjustment = data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0)
                                          const backupActualRetail = data.product_retail_price ?? data.actual_retail_price
                                          const backupOriginalActualRetail = backupActualRetail != null ? Number(backupActualRetail) - backupAdjustment : data.original_actual_retail_price
                                          const backupInstallCost = parseFloat(data?.original_install_cost ?? data?.install_cost) || 0
                                          const backupInstallQty = Number(data?.install_quantity) || 1
                                          const backupProdQty = Number(data?.quantity) || 1
                                          const backupInstallEach = backupProdQty > 0 ? (backupInstallCost * (backupInstallQty / backupProdQty)) : backupInstallCost
                                          data.expected_cost_before_no_charge = data.expected_cost_before_no_charge ?? data.expected_cost
                                          data.retail_price_before_no_charge = data.retail_price_before_no_charge ?? ((backupOriginalActualRetail != null ? backupOriginalActualRetail + backupInstallEach + backupAdjustment : data.retail_price))
                                          data.actual_retail_price_before_no_charge = data.actual_retail_price_before_no_charge ?? (backupActualRetail ?? data.actual_retail_price)
                                          data.product_retail_price_before_no_charge = data.product_retail_price_before_no_charge ?? (backupActualRetail ?? data.product_retail_price)
                                          data.price_before_no_charge = data.price_before_no_charge ?? data.price
                                          data.original_actual_retail_price_before_no_charge = data.original_actual_retail_price_before_no_charge ?? backupOriginalActualRetail
                                          data.original_retail_price_before_no_charge = data.original_retail_price_before_no_charge ?? ((backupOriginalActualRetail != null ? backupOriginalActualRetail + backupInstallEach : data.original_retail_price))
                                          data.original_price_before_no_charge = data.original_price_before_no_charge ?? data.original_price
                                          data.install_cost = Math.max(0, baseInstallCost + signedInstallAdj)
                                          // const expectedCost = parseFloat(data?.expected_cost) || 0
                                          const expectedCost = (parseFloat(data?.expected_service_cost) || 0) + (parseFloat(data?.expected_material_cost) || 0);
                                          const installCost = parseFloat(data?.install_cost) || 0
                                          const installQty = Number(data?.install_quantity) || 1
                                          const prodQty = Number(data?.quantity) || 1
                                          const installEach = prodQty > 0 ? (installCost * (installQty / prodQty)) : installCost
                                          
                                          // If install_cost is available, add it to expected_cost
                                          const calculatedRetailPrice = installEach > 0 ? expectedCost + installEach : expectedCost
                                          
                                          data['retail_price'] = calculatedRetailPrice + (data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0))
                                          data['actual_retail_price'] = expectedCost + (data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0))
                                          data['expected_cost'] = expectedCost
                                        //  }else{
                                        //   const baseInstallCost =
                                        //     parseFloat(data?.original_install_cost) || 0
                                        //   const installAdj = parseFloat(data?.install_adjustment) || 0
                                        //   const signedInstallAdj =
                                        //     data?.install_adj_value_type === false ? -installAdj : installAdj
                                        //   data.install_cost = Math.max(0, baseInstallCost + signedInstallAdj)
                                         }

                                        if(isSplitOrder && data?.facility_id !== currentFacilityId){
                                         const splitSetting = selectedSplitOrderSettings?.find(setting => setting?.id == data?.facility_id);
                                         let outgoingPercentage = splitSetting?.split_percentage || 0;

                                         if (!data.originalExpectedCost) {
                                          data.originalExpectedCost = Number(data?.expected_cost)
                                        console.log('data.originalExpectedCost--', data.originalExpectedCost)
                                        }
                                        
                                        let amountWithOutgoingPercentage = data.originalExpectedCost * (outgoingPercentage / 100)
                                        const calculatedExpectedCost = data.originalExpectedCost + amountWithOutgoingPercentage
                                        data.expected_cost = Number(calculatedExpectedCost.toFixed(2))
                                        let amountWithIncomingPercentage = data.expected_cost * (incomingSplitMarkup / 100)
                                        const calculatedActualRetailPrice = (data.expected_cost + amountWithIncomingPercentage) + (data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0))
                                        data['actual_retail_price'] = Number(calculatedActualRetailPrice.toFixed(2))
                                        const calculatedRetailPrice = data.actual_retail_price + data.install_cost
                                        data['retail_price'] = Number(calculatedRetailPrice.toFixed(2))
                                        // data['retail_price'] =data?.originalExpectedCost + data?.install_cost
                                        data['incoming_split_percentage'] =incomingSplitMarkup || 0
                                        data['split_percentage'] =outgoingPercentage || 0
                                        data['outgoing_split_percentage'] =outgoingPercentage || 0
                                        }

                                        if (
                                          data.original_actual_retail_price == null &&
                                          data.original_product_retail_price == null
                                        ) {
                                          Object.assign(
                                            data,
                                            hydrateEstimateLineMarketingPrices(data),
                                          )
                                        }
                                        const signedProductAdj = getSignedMarketingAdjustment(data)
                                        const signedInstallAdj = getSignedInstallMarketingAdjustment(data)

                                        const syncedProduct = data?.is_product_row
                                          ? data
                                          : getCatalogProductWithAdjustment(data)

                                        const dataActualRetail = (() => {
                                          return syncedProduct.original_actual_retail_price != null
                                            ? syncedProduct.original_actual_retail_price +
                                                getSignedMarketingAdjustment(syncedProduct)
                                            : (syncedProduct.actual_retail_price ??
                                                syncedProduct.retail_price ??
                                                0)
                                        })()
                                        const dataPrice = data.price

                                        const rowTotal = calculateTotal(
                                          markupType == 1
                                            ? data.price
                                            : markupType == 2
                                            ? data.retail_price
                                            : 0,
                                          Number(data.quantity),
                                          values[discountFieldName],
                                          data.locationQuantity,
                                          data.adjustment,
                                          data.adj_value_type
                                        )
                                        const locQtyForLineTotal = Number(data?.locationQuantity) || 1
                                        const installQtyForLineTotal = Number(data?.install_quantity) || 1
                                        const discountForLineTotal =
                                          Number(values[discountFieldName]) || Number(data?.discount) || 0
                                        const lineProductSubTotal =
                                          markupType == 1
                                            ? (Number(data?.price) || 0) * locQtyForLineTotal
                                            : markupType == 2
                                            ? (Number(data?.actual_retail_price || data?.retail_price || 0)) * locQtyForLineTotal
                                            : 0
                                        const lineInstallSubTotal =
                                          (Number(data?.install_cost) || 0) * installQtyForLineTotal
                                        const lineProductTotal = Math.max(
                                          0,
                                          lineProductSubTotal + lineInstallSubTotal - discountForLineTotal,
                                        )
                                        // Accumulate the totalAmount
                                        totalAmount += rowTotal
                                        // values['sub_total'] = totalAmount?.toFixed(2)
                                        data['product_sub_total'] = rowTotal
                                        data['markup_type'] = markupType
                                        const invoiceAmount =
                                          parseFloat(
                                            data?.expected_material_cost?.toFixed(
                                              2,
                                            ),
                                          ) +
                                          parseFloat(
                                            data?.expected_total_service_cost?.toFixed(
                                              2,
                                            ),
                                          )

                                        let markup =
                                          markupType == 1
                                            ? ((data.price -
                                                parseFloat(
                                                  data.expected_cost?.toFixed(
                                                    2,
                                                  ),
                                                )) /
                                                parseFloat(
                                                  data.expected_cost?.toFixed(
                                                    2,
                                                  ),
                                                )) *
                                              100
                                            : markupType == 2
                                            ? ((data.retail_price -
                                                parseFloat(
                                                  data.expected_cost?.toFixed(
                                                    2,
                                                  ),
                                                )) /
                                                parseFloat(
                                                  data.expected_cost?.toFixed(
                                                    2,
                                                  ),
                                                )) *
                                              100
                                            : 0
                                        // const markup = ((data.retail_price - data.price) / data.price) * 100;
                                        // let markup = markupType ? (invoiceAmount / rowTotal) : null
                                        markup = markup ? Number(markup) : 0
                                        if (isNoChargeJob) markup = 0

                                        let newTotalProductFormula =
                                          parseFloat(
                                            data.expected_cost?.toFixed(2),
                                          ) *
                                          data.quantity *
                                          data.locationQuantity
                                        newTotalProductFormula =
                                          newTotalProductFormula
                                            ? Number(newTotalProductFormula)
                                            : 0

                                        let newTotalWholesalePrice =
                                          data.price *
                                          data.quantity *
                                          data.locationQuantity
                                        if (data?.adjustment) {
                                          newTotalWholesalePrice =
                                            newTotalWholesalePrice
                                              ? newTotalWholesalePrice +
                                                (newTotalWholesalePrice *
                                                  data?.adjustment) /
                                                  100
                                              : 0
                                        }
                                        newTotalWholesalePrice =
                                          newTotalWholesalePrice
                                            ? Number(newTotalWholesalePrice)
                                            : 0

                                        let newTotalRetailPrice =
                                          data.retail_price *
                                          data.quantity *
                                          data.locationQuantity
                                        if (data?.adjustment) {
                                          newTotalRetailPrice =
                                            newTotalRetailPrice
                                              ? newTotalRetailPrice +
                                                (newTotalRetailPrice *
                                                  data?.adjustment) /
                                                  100
                                              : 0
                                        }
                                        newTotalRetailPrice =
                                          newTotalRetailPrice
                                            ? Number(newTotalRetailPrice)
                                            : 0

                                        totalProductFormula += Number(
                                          newTotalProductFormula,
                                        )
                                        totalWholesalePrice += Number(
                                          newTotalWholesalePrice,
                                        )
                                        totalRetailPrice +=
                                          Number(newTotalRetailPrice)

                                        values['totalProductFormula'] =
                                          totalProductFormula
                                        values['totalWholesalePrice'] =
                                          totalWholesalePrice
                                        values['totalRetailPrice'] =
                                          totalRetailPrice

                                        totalMarkup += markup
                                        let originalMarkup =
                                          markupType == 1
                                            ? data.wholesaleMarkup
                                            : markupType == 2
                                            ? data.retailMarkup
                                            : 0
                                        originaltotalMarkup += originalMarkup
                                        // values['totalMarkup'] = totalMarkup?.toFixed(2)
                                        data['markup'] = markup?.toFixed(2)
                                        // data['markup'] = Math.round(markup)
                                        console.log(
                                          '###############markup',
                                          markup,
                                        )
                                        console.log(
                                          '###############devvvvvv123',
                                          data,
                                        )

                                        const pfc =
                                          parseFloat(
                                            data.expected_cost?.toFixed(2),
                                          ) *
                                          data.quantity *
                                          data.locationQuantity // total product formula cost
                                        const rtp =
                                          data.retail_price *
                                          data.quantity *
                                          data.locationQuantity // total retail price
                                        const wsp =
                                          data.price *
                                          data.quantity *
                                          data.locationQuantity // total wholesale price

                                        // const maxDiscount_wholesale = (wsp - pfc) - DiscountTotal
                                        // const maxDiscount_retail = (rtp - pfc) - DiscountTotal

                                        const maxDiscount_wholesale = wsp - pfc
                                        const maxDiscount_retail = rtp - pfc

                                        console.log(
                                          'maxDiscount_wholesale--',
                                          maxDiscount_wholesale,
                                        )
                                        console.log(
                                          'maxDiscount_retail--',
                                          maxDiscount_retail,
                                        )
                                        console.log(
                                          'DiscountTotal--',
                                          DiscountTotal,
                                        )
                                        console.log('pfc--', pfc)
                                        console.log('rtp--', rtp)
                                        console.log('wsp--', wsp)
                                        data['product_total'] = rowTotal
                                        const productFormulaCost =
                                          parseFloat(
                                            (
                                              parseFloat(
                                                data.expected_material_cost?.toFixed(
                                                  2,
                                                ),
                                              ) *
                                              data.quantity *
                                              data.locationQuantity
                                            ).toFixed(2),
                                          ) +
                                          parseFloat(
                                            (
                                              parseFloat(
                                                data.expected_total_service_cost?.toFixed(
                                                  2,
                                                ),
                                              ) *
                                              data.quantity *
                                              data.locationQuantity
                                            ).toFixed(2),
                                          )

                                        let SPMA = 0
                                        if (markupType) {
                                          if (markupType == 1) {
                                            if (
                                              data.markAdjType == 2 ||
                                              data.markAdjType == 3
                                            ) {
                                              SPMA =
                                                (Number(data.price) || 0) +
                                                (data.adjustment
                                                  ? Number(data.adjustment)
                                                  : 0)
                                            } else {
                                              SPMA =
                                                (Number(data.price) || 0) +
                                                ((Number(data.price) || 0) *
                                                  (data.adjustment
                                                    ? Number(data.adjustment)
                                                    : 0)) /
                                                  100
                                            }
                                          } else {
                                            if (
                                              data.markAdjType == 2 ||
                                              data.markAdjType == 3
                                            ) {
                                              SPMA =
                                                (Number(data.retail_price) || 0) +
                                                (data.adjustment
                                                  ? Number(data.adjustment)
                                                  : 0)
                                            } else {
                                              SPMA =
                                                (Number(data.retail_price) || 0) +
                                                ((Number(data.retail_price) || 0) *
                                                  (data.adjustment
                                                    ? Number(data.adjustment)
                                                    : 0)) /
                                                  100
                                            }
                                          }
                                        }
                                        console.log(
                                          'SPMA-----data.price-----',
                                          data.price,
                                        )
                                        console.log(
                                          'SPMA-----data.adjustment-----',
                                          data.adjustment,
                                        )
                                        console.log(
                                          'SPMA-----data.retail_price-----',
                                          data.retail_price,
                                        )
                                        console.log('SPMA-----SPMA-----', SPMA)
                                        SPMA = Number(SPMA)
                                        data['SPMA'] = SPMA?.toFixed(2)
                                        // if(values?.project_categories?.id !== 11){
                                        //   data['actual_retail_price'] = data?.actual_retail_price + (data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0))
                                        //   data['retail_price'] = data?.retail_price + (data.adj_value_type ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0))

                                        // }
                                        const productFormulaEach =
                                          data?.inhouse === 0
                                            ? Number(
                                                data?.sub_contract_price || 0,
                                              )
                                            : Number(
                                                (data?.expected_material_cost_with_markup ||
                                                  0) +
                                                  (data?.expected_service_cost_with_markup ||
                                                    0),
                                              )
                                        const hasNegativeRetailPermission =
                                          explodedPermissions?.some((permission) =>
                                            [
                                              'Allow Negative Marketing Adjustment Sales Order',
                                            ].includes(permission),
                                          )
                                        const retailPriceMin = hasNegativeRetailPermission
                                          ? 0.01
                                          : Math.max(0.01, productFormulaEach)
                                        const productRetailEach = Math.max(
                                          0,
                                          Number(
                                            data?.actual_retail_price ??
                                              data?.retail_price ??
                                              data?.product_retail_price ??
                                              0,
                                          ),
                                        )
                                        const isNegativeProductAdjustmentMode =
                                          data?.adj_value_type === false ||
                                          data?.adj_value_type === 0 ||
                                          data?.adj_value_type === '0' ||
                                          data?.adj_value_type === 'false'
                                        const isProductLosingMoney =
                                          isNegativeProductAdjustmentMode &&
                                          productRetailEach < productFormulaEach

                                        const installFormulaEach = Number(
                                          data?.expected_install_labor_cost_with_markup ||
                                            0,
                                        )
                                        const installRetailEach = Math.max(
                                          0,
                                          Number(data?.install_cost || 0),
                                        )
                                        const isNegativeInstallAdjustmentMode =
                                          data?.install_adj_value_type ===
                                            false ||
                                          data?.install_adj_value_type === 0 ||
                                          data?.install_adj_value_type ===
                                            '0' ||
                                          data?.install_adj_value_type ===
                                            'false'
                                        const isInstallLosingMoney =
                                          isNegativeInstallAdjustmentMode &&
                                          installRetailEach < installFormulaEach

                                        const isLosingMoneyItem =
                                          isProductLosingMoney ||
                                          isInstallLosingMoney

                                        const losingMoneyRowSx =
                                          isLosingMoneyItem
                                            ? {
                                                '& .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)):not(:nth-of-type(11)), & .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)):not(:nth-of-type(11)) .MuiInputBase-input, & .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)):not(:nth-of-type(11)) .MuiFormLabel-root':
                                                  {
                                                    color: `${theme.palette.error.main} !important`,
                                                  },
                                              }
                                            : undefined

                                        return (
                                          <Draggable
                                            key={`product-${data.indexId}`}
                                            draggableId={`product-${data.indexId}`}
                                            index={index}
                                          >
                                            {(provided, snapshot) => (
                                          <>
                                            <TableRow
                                              key={`main-${data.indexId}`}
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              onDragOver={(e) => handleProductIconDragOver(e, data.indexId)}
                                              onDragLeave={(e) => handleProductIconDragLeave(e, data.indexId)}
                                              onDrop={(e) => handleProductIconDrop(e, data.indexId)}
                                              sx={{
                                                ...losingMoneyRowSx,
                                                ...(productAttachmentDragOver[data.indexId] && {
                                                  backgroundColor: 'action.hover',
                                                  outline: `2px dashed ${theme.palette.primary.main}`,
                                                  outlineOffset: -2,
                                                }),
                                              }}
                                              style={{
                                                ...provided.draggableProps.style,
                                                ...(snapshot.isDragging
                                                  ? {
                                                      backgroundColor:
                                                        theme.palette.action.hover,
                                                    }
                                                  : {}),
                                              }}
                                            >
                                              <TableCell
                                                padding="checkbox"
                                                {...provided.dragHandleProps}
                                                sx={{ width: 40, cursor: 'grab' }}
                                              >
                                                <DragIndicator fontSize="small" color="action" />
                                              </TableCell>
                                              <TableCell>
                                                #{data?.indexId}
                                              </TableCell>
                                          <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                              <TableCell>
                                              {data?.isAdditionalProduct ?
                                                <TextField
                                                  required
                                                  fullWidth
                                                  type="text"
                                                  label={'Product Name'}
                                                  sx={{ width: 85 }}
                                                  value={data.name}
                                                  onChange={(event) => {
                                                    let newValue =
                                                      event.target.value

                                                    // Update the selectedProducts state
                                                    setSelectedProducts(
                                                      (prevProducts) =>
                                                        prevProducts.map(
                                                          (product) => {
                                                            if (
                                                              product.indexId ===
                                                              data.indexId
                                                            ) {
                                                              return {
                                                                ...product,
                                                                name: newValue,
                                                              }
                                                            } else {
                                                              return product
                                                            }
                                                          },
                                                        ),
                                                    )
                                                    data['name'] =
                                                      newValue || ''
                                                    if (isSubmitted)
                                                      setIsSubmitted(false)
                                                  }}
                                                  error={
                                                    isSubmitted &&
                                                    data?.name?.trim() === ''
                                                  }
                                                  helperText={
                                                    isSubmitted &&
                                                    data?.name?.trim() === ''
                                                      ? 'Product Name is required'
                                                      : ''
                                                  }
                                                />
                                              : 
                                              // data.name
                                              <Box>
                                                <Typography sx={{color:"inherit"}}>
                                                  { data.name}
                                                </Typography>
                                             { data.product_notes ?  <Typography sx={{color:isSplitOrder ?theme.palette[
                                                FacilityTypes.find(f => f.id === data?.facility_id)?.color || 'primary'
                                              ]?.main
                                            : (data.product_notes ? theme.palette.error.main : 'inherit') }}> Note:{" "}{ data.product_notes && data.product_notes !== '' ? data.product_notes : ""} </Typography>:""}
                                              </Box>
                                              }
                                              </TableCell>
                                              <TableCell>
                                                <IconButton
                                                  onClick={() =>
                                                    handleOpenNote(
                                                      data.indexId,
                                                      data.product_notes,
                                                    )
                                                  }
                                                >
                                                  <NoteAdd
                                                    sx={{
                                                      color:
                                                        !data?.product_notes ||
                                                        data?.product_notes ===
                                                          ''
                                                          ? ''
                                                          : theme.palette
                                                              .primary.main,
                                                    }}
                                                  />
                                                </IconButton>
                                              </TableCell>
                                              <TableCell>
                                                <Tooltip title="Drop files on row or click to open attachments">
                                                  <IconButton onClick={() => handleOpenAttachment(data.indexId)}>
                                                    {isUploadingProduct[data.indexId] ? (
                                                      <CircularProgress size={28} />
                                                    ) : (
                                                      <UploadFile
                                                        sx={{
                                                          color:
                                                            !productAttachments[data.indexId] ||
                                                            productAttachments[data.indexId]?.length === 0
                                                              ? 'error.main'
                                                              : theme.palette
                                                                  .primary.main,
                                                        }}
                                                      />
                                                    )}
                                                  </IconButton>
                                                </Tooltip>
                                              </TableCell>
                                              <TableCell align="center">
                                                {canShowProductFormulaIcon(data, currentFacilityId) ? (
                                                  <IconButton size="small" onClick={() => handleOpenProductFormula(data.recipe_id)}>
                                                    <span class="heroicons-solid--beaker"></span>
                                                  </IconButton>
                                                ) : '-'}
                                              </TableCell>
                                              <Tooltip 
                                               title={
                                                (isSplitOrder && 
                                                 data.facility_id != currentFacilityId) 
                                                  ? ''
                                                  // (
                                                  //     <>
                                                  //       {`${data?.outgoing_split_percentage} % Outgoing Percentage Included with Expected Cost ${data?.originalExpectedCost}`}
                                                  //     </>
                                                  //   ) 
                                                  : ""
                                              }
                                              >
                                              <TableCell>
                                                {/* {data?.isAdditionalProduct
                                                  ? 'N/A'
                                                  : (data.inhouse === 0
                                                      ? (data?.sub_contract_price?.toFixed(2) || '0.00')
                                                      : isSplitOrder && data?.facility_id !== currentFacilityId
                                                        ? Math.max(
                                                            0,
                                                            (data?.expected_cost || 0) -
                                                              (data?.expected_install_labor_cost_with_markup || 0),
                                                          ).toFixed(2)
                                                        : Math.max(
                                                            0,
                                                            (data?.expected_material_cost_with_markup || 0) +
                                                              (data?.expected_service_cost_with_markup || 0) -
                                                              (data?.expected_install_labor_cost_with_markup || 0),
                                                          ).toFixed(2)
                                                    // (data?.expected_material_cost_with_markup || 0)?.toFixed(2)
                                                    )}
                                                */}
                                                {data?.isAdditionalProduct ? 'N/A' : (data.inhouse === 0 ? (data?.sub_contract_price?.toFixed(2) || '0.00'): 
                                                  isSplitOrder && data?.facility_id !== currentFacilityId ?
                                                  (data?.expected_cost || 0)?.toFixed(2)
                                                  :
                                                  ((data?.expected_material_cost_with_markup || 0) + (data?.expected_service_cost_with_markup || 0))?.toFixed(2)
                                                  // (data?.expected_material_cost_with_markup || 0)?.toFixed(2)
                                                )}
                                              </TableCell>
                                              </Tooltip>
                                              {/* Incoming Percentage column - only show when isSplitOrder is true */}
                                              {isSplitOrder ? (
                                                <TableCell align='center'>
                                                  {data?.isAdditionalProduct ? 'N/A' : (
                                                    data?.facility_id != currentFacilityId ? 
                                                      `${incomingSplitMarkup || 0}%` : 
                                                      '-'
                                                  )}
                                                </TableCell>
                                              ) : (
                                                <TableCell align='center'>
                                                  {isNoChargeJob ? '-' : (data.inhouse === 0 ? (data?.sub_contract_markup != null && data?.sub_contract_markup !== '' ? `${Number(data.sub_contract_markup).toFixed(2)}` : '-') : '-')}
                                                </TableCell>
                                              )}
                                              {/* <TableCell>{invoiceAmount}</TableCell> */}
                                              {/* <TableCell>{productFormulaCost?.toFixed(2)}</TableCell> */}
                                              {/* <Tooltip title={isSplitOrder && data?.facility_id != currentFacilityId ? `Product formula cost + (Product formula cost * incoming split markup (${incomingSplitMarkup}) / 100)` : ""}>
                                              <TableCell>
                                                {((hasMarkupPermission && markupType == 2)
                                                    ? 
                                                    (data?.isAdditionalProduct ?
                                                      <TextField
                                                        required
                                                        fullWidth
                                                        type="number"
                                                        label={'Retail Price Each'}
                                                        // disabled={
                                                        //   values.project_categories
                                                        //     ?.name ==
                                                        //   'Time & Material'
                                                        //     ? true
                                                        //     : false
                                                        // }
                                                        disabled={
                                                           false
                                                        }
                                                        sx={{ width: 85 }}
                                                        value={data?.actual_retail_price || data?.retail_price}
                                                        // onWheel={(e) => e.target.blur()}
                                                        onKeyPress={(event) => {
                                                          // if (event.key === '0' && event.target.value === '') {
                                                          //   event.preventDefault();
                                                          // }
                                                          if (event.key === '-') {
                                                            event.preventDefault();
                                                          }
                                                          if (event.key === 'e') {
                                                            event.preventDefault();
                                                          }
                                                        }}
                                                        inputProps={{ min: 0 }}
                                                        defaultValue={0}
                                                        onChange={(event) => {
                                                          let newValue =
                                                            event.target.value
                                                          if (newValue !== '') {
                                                            setSelectedProducts(
                                                              (pv) => [
                                                                ...pv.map((p) => {
                                                                  if (
                                                                    p.indexId ===
                                                                    data.indexId
                                                                  ) {
                                                                    return {
                                                                      ...p,
                                                                      retail_price:
                                                                        newValue,
                                                                      price: newValue,
                                                                    }
                                                                  } else {
                                                                    return p
                                                                  }
                                                                }),
                                                              ],
                                                            )
                                                            data['retail_price'] =
                                                              newValue || 0
                                                            data['price'] =
                                                              newValue || 0
                                                          }
                                                        }}
                                                        // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                                        // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                                      /> :
                                                     Math.max(
                                                      0,
                                                      (data?.actual_retail_price || data?.retail_price || 0)
                                                      //  *
                                                      //   (data?.locationQuantity || 1)
                                                    ).toFixed(2)
                                                    ) 
                                                    : null)}
                                              </TableCell>
                                              </Tooltip> */}
                                              {hasMarkupPermission ? <TableCell>
                                                {markupType == 2
                                                  ? (data?.isAdditionalProduct ?
                                                    <TextField
                                                      required
                                                      fullWidth
                                                      type="number"
                                                      label={'Retail Price Each'}
                                                      disabled={false}
                                                      sx={{ width: 85 }}
                                                      value={
                                                        data.retail_price_draft !== undefined
                                                          ? limitDecimalInput(data.retail_price_draft)
                                                          : formatRetailPriceDisplay(
                                                              roundMoneyValue(dataActualRetail) ?? 0,
                                                            )
                                                      }
                                                      onKeyPress={(event) => {
                                                        if (event.key === '-') {
                                                          event.preventDefault();
                                                        }
                                                        if (event.key === 'e') {
                                                          event.preventDefault();
                                                        }
                                                      }}
                                                      onKeyDown={(event) => {
                                                        if (
                                                          event.key === 'ArrowUp' ||
                                                          event.key === 'ArrowDown'
                                                        ) {
                                                          event.preventDefault()
                                                          const current =
                                                            data.retail_price_draft !== undefined
                                                              ? data.retail_price_draft
                                                              : formatRetailPriceDisplay(
                                                                  dataActualRetail ?? 0,
                                                                )
                                                          handleRetailPriceChange(
                                                            data.indexId,
                                                            stepRetailPriceByArrow(
                                                              current,
                                                              event.key === 'ArrowUp'
                                                                ? 'up'
                                                                : 'down',
                                                              retailPriceMin,
                                                            ),
                                                            { isBlur: true },
                                                          )
                                                        }
                                                      }}
                                                      inputProps={{ min: retailPriceMin, step: 1 }}
                                                      defaultValue={0}
                                                      onFocus={selectInputValue}
                                                      onClick={selectInputValue}
                                                      onChange={(event) => {
                                                        const current =
                                                          data.retail_price_draft !== undefined
                                                            ? data.retail_price_draft
                                                            : formatRetailPriceDisplay(
                                                                dataActualRetail ?? 0,
                                                              )
                                                        handleRetailPriceChange(
                                                          data.indexId,
                                                          normalizeRetailArrowChange(
                                                            current,
                                                            event.target.value,
                                                            retailPriceMin,
                                                          ),
                                                        )
                                                      }}
                                                      onBlur={(event) => {
                                                        handleRetailPriceChange(
                                                          data.indexId,
                                                          event.target.value,
                                                          { isBlur: true },
                                                        )
                                                      }}
                                                    /> :
                                                    <>
                                                      {/* ALL-815 backup - previous read-only retail display:
                                                      Math.max(
                                                        0,
                                                        (data?.actual_retail_price || data?.retail_price || 0)
                                                      ).toFixed(2) */}
                                                      <TextField
                                                        required
                                                        fullWidth
                                                        type="number"
                                                        label={'Retail Price Each'}
                                                        disabled={
                                                          values.project_categories
                                                            ?.name ===
                                                          'Time & Material'
                                                        }
                                                        sx={{ width: 120 }}
                                                        value={
                                                          data.retail_price_draft !== undefined
                                                            ? limitDecimalInput(data.retail_price_draft)
                                                            : formatRetailPriceDisplay(
                                                              roundMoneyValue(dataActualRetail) ?? 0,
                                                              )
                                                        }
                                                        onFocus={selectInputValue}
                                                        onClick={selectInputValue}
                                                        onKeyPress={(event) => {
                                                          if (event.key === '-') {
                                                            event.preventDefault();
                                                          }
                                                          if (event.key === 'e') {
                                                            event.preventDefault();
                                                          }
                                                        }}
                                                        onKeyDown={(event) => {
                                                          if (
                                                            event.key === 'ArrowUp' ||
                                                            event.key === 'ArrowDown'
                                                          ) {
                                                            event.preventDefault()
                                                            const current =
                                                              data.retail_price_draft !== undefined
                                                                ? data.retail_price_draft
                                                                : formatRetailPriceDisplay(
                                                                    dataActualRetail ?? 0,
                                                                  )
                                                            handleRetailPriceChange(
                                                              data.indexId,
                                                              stepRetailPriceByArrow(
                                                                current,
                                                                event.key === 'ArrowUp'
                                                                  ? 'up'
                                                                  : 'down',
                                                                retailPriceMin,
                                                              ),
                                                              { isBlur: true },
                                                            )
                                                          }
                                                        }}
                                                        inputProps={{ min: retailPriceMin, step: 1 }}
                                                        defaultValue={0}
                                                        onChange={(event) => {
                                                          const current =
                                                            data.retail_price_draft !== undefined
                                                              ? data.retail_price_draft
                                                              : formatRetailPriceDisplay(
                                                                  dataActualRetail ?? 0,
                                                                )
                                                          handleRetailPriceChange(
                                                            data.indexId,
                                                            normalizeRetailArrowChange(
                                                              current,
                                                              event.target.value,
                                                              retailPriceMin,
                                                            ),
                                                          )
                                                        }}
                                                        onBlur={(event) => {
                                                          handleRetailPriceChange(
                                                            data.indexId,
                                                            event.target.value,
                                                            { isBlur: true },
                                                          )
                                                        }}
                                                      />
                                                    </>
                                                  ) 
                                                  : markupType == 1
                                                  ? (data?.isAdditionalProduct ?
                                                    <TextField
                                                      required
                                                      fullWidth
                                                      type="number"
                                                      label={'Retail Price Each'}
                                                      disabled={
                                                        false
                                                      }
                                                      sx={{ width: 85 }}
                                                      value={
                                                        data.retail_price_draft !== undefined
                                                          ? limitDecimalInput(data.retail_price_draft)
                                                          : formatRetailPriceDisplay(roundMoneyValue(dataPrice) ?? 0)
                                                      }
                                                      defaultValue={0}
                                                      onFocus={selectInputValue}
                                                      onClick={selectInputValue}
                                                      onKeyPress={(event) => {
                                                        if (event.key === '-') {
                                                          event.preventDefault();
                                                        }
                                                        if (event.key === 'e') {
                                                          event.preventDefault();
                                                        }
                                                      }}
                                                      onKeyDown={(event) => {
                                                        if (
                                                          event.key === 'ArrowUp' ||
                                                          event.key === 'ArrowDown'
                                                        ) {
                                                          event.preventDefault()
                                                          const current =
                                                            data.retail_price_draft !== undefined
                                                              ? data.retail_price_draft
                                                              : formatRetailPriceDisplay(dataPrice ?? 0)
                                                          handleRetailPriceChange(
                                                            data.indexId,
                                                            stepRetailPriceByArrow(
                                                              current,
                                                              event.key === 'ArrowUp' ? 'up' : 'down',
                                                              retailPriceMin,
                                                            ),
                                                            { isBlur: true },
                                                          )
                                                        }
                                                      }}
                                                      inputProps={{ min: retailPriceMin, step: 1 }}
                                                      onChange={(event) => {
                                                        const current =
                                                          data.retail_price_draft !== undefined
                                                            ? data.retail_price_draft
                                                            : formatRetailPriceDisplay(dataPrice ?? 0)
                                                        handleRetailPriceChange(
                                                          data.indexId,
                                                          normalizeRetailArrowChange(
                                                            current,
                                                            event.target.value,
                                                            retailPriceMin,
                                                          ),
                                                        )
                                                      }}
                                                      onBlur={(event) => {
                                                        handleRetailPriceChange(
                                                          data.indexId,
                                                          event.target.value,
                                                          { isBlur: true },
                                                        )
                                                      }}
                                                    /> :
                                                    <>
                                                      {/* ALL-815 backup - previous read-only retail display: data.price?.toFixed(2) */}
                                                      <TextField
                                                        required
                                                        fullWidth
                                                        type="number"
                                                        label={'Retail Price Each'}
                                                        disabled={
                                                          values.project_categories
                                                            ?.name ===
                                                          'Time & Material'
                                                        }
                                                        sx={{ width: 120 }}
                                                        value={
                                                          data.retail_price_draft !== undefined
                                                            ? limitDecimalInput(data.retail_price_draft)
                                                            : formatRetailPriceDisplay(roundMoneyValue(dataPrice) ?? 0)
                                                        }
                                                        onFocus={selectInputValue}
                                                        onClick={selectInputValue}
                                                        defaultValue={0}
                                                        onKeyPress={(event) => {
                                                          if (event.key === '-') {
                                                            event.preventDefault();
                                                          }
                                                          if (event.key === 'e') {
                                                            event.preventDefault();
                                                          }
                                                        }}
                                                        onKeyDown={(event) => {
                                                          if (
                                                            event.key === 'ArrowUp' ||
                                                            event.key === 'ArrowDown'
                                                          ) {
                                                            event.preventDefault()
                                                            const current =
                                                              data.retail_price_draft !== undefined
                                                                ? data.retail_price_draft
                                                                : formatRetailPriceDisplay(dataPrice ?? 0)
                                                            handleRetailPriceChange(
                                                              data.indexId,
                                                              stepRetailPriceByArrow(
                                                                current,
                                                                event.key === 'ArrowUp' ? 'up' : 'down',
                                                                retailPriceMin,
                                                              ),
                                                              { isBlur: true },
                                                            )
                                                          }
                                                        }}
                                                        inputProps={{ min: retailPriceMin, step: 1 }}
                                                        onChange={(event) => {
                                                          const current =
                                                            data.retail_price_draft !== undefined
                                                              ? data.retail_price_draft
                                                              : formatRetailPriceDisplay(dataPrice ?? 0)
                                                          handleRetailPriceChange(
                                                            data.indexId,
                                                            normalizeRetailArrowChange(
                                                              current,
                                                              event.target.value,
                                                              retailPriceMin,
                                                            ),
                                                          )
                                                        }}
                                                        onBlur={(event) => {
                                                          handleRetailPriceChange(
                                                            data.indexId,
                                                            event.target.value,
                                                            { isBlur: true },
                                                          )
                                                        }}
                                                      />
                                                    </>
                                                  )
                                                  : null}
                                              </TableCell> : null}
                                              {/* <TableCell>
                                                {hasMarkupPermission
                                                  ? data?.SPMA || null
                                                  : null}
                                              </TableCell> */}
                                              {/* <TableCell> */}
                                              {/* old */}
                                              {/* {(hasMarkupPermission && markupType == 1) ? data.wholesaleMarkup?.toFixed(2)
                                    : (hasMarkupPermission && markupType == 2) ? data.retailMarkup?.toFixed(2)
                                      : null} */}
                                              {/* previos */}
                                              {/* {(hasMarkupPermission && markupType == 1) ? data.wholesaleMarkup?.toFixed(2)
                                    : (hasMarkupPermission && markupType == 2) ? data.pf_retail_markup?.toFixed(2)
                                      : null} */}
                                              {/* {(hasMarkupPermission && markupType) ? (markup * data.quantity).toFixed(2) : null} */}
                                              {/* </TableCell> */}

                                              {/* <TableCell>{shortUnitName}</TableCell> */}
                                             {/* <TableCell>
                                                <TextField
                                                  required
                                                  fullWidth
                                                  type="number"
                                                  label={shortUnitName}
                                                  disabled={
                                                    data?.fromMapServices ==
                                                    true
                                                      ? true
                                                      : shortUnitName == 'Unit'
                                                      ? true
                                                      : false
                                                  }
                                                  sx={{ width: 85 }}
                                                  // {...getFieldProps(quantityFieldName)}
                                                  value={Number(data.quantity)}
                                                  defaultValue={1}
                                                  onKeyPress={(event) => {
                                                    if (
                                                      event.key === '0' &&
                                                      event.target.value === ''
                                                    ) {
                                                      event.preventDefault()
                                                    }
                                                    if (event.key === '-') {
                                                      event.preventDefault()
                                                    }
                                                    if (event.key === '.') {
                                                      event.preventDefault()
                                                    }
                                                  }}
                                                  onChange={(event) => {
                                                    let newValue =
                                                      event.target.value
                                                    if (
                                                      newValue !== '0' &&
                                                      newValue !== ''
                                                    ) {
                                                      console.log(
                                                        '################SelectedSeer',
                                                        selectedServices,
                                                      )

                                                      setSelectedProducts(
                                                        (pv) => [
                                                          ...pv.map((p) => {
                                                            if (
                                                              p.indexId ===
                                                              data.indexId
                                                            ) {
                                                              // if (p.id === data.id) {
                                                              // let arrayAddr

                                                              // const commonAddresses = (allLocationSame && pv.length > 0) ? [...pv[0].addresses][0] : null;

                                                              // if (allLocationSame && commonAddresses) {
                                                              //   arrayAddr = Array(Number(newValue)).fill().map((_, i) => ({
                                                              //     ...commonAddresses,
                                                              //     id: i
                                                              //   }));

                                                              // }
                                                              // else {
                                                              //   arrayAddr = [...p.addresses]
                                                              //   if (p.addresses.length < Number(newValue)) {
                                                              //     arrayAddr.push(...[...Array(Number(newValue) - p.addresses.length)].map((a, i) => {

                                                              //       return {
                                                              //         id: p.addresses.length + i,
                                                              //         address: '',
                                                              //         city: '',
                                                              //         state: '',
                                                              //         zip: '',
                                                              //       }
                                                              //     }))
                                                              //   } else {
                                                              //     arrayAddr = arrayAddr.slice(0, -(p.addresses.length - Number(newValue)));
                                                              //   }
                                                              // }

                                                              return {
                                                                ...p,
                                                                quantity:
                                                                  Number(
                                                                    newValue,
                                                                  ),
                                                                // addresses: arrayAddr
                                                              }
                                                            } else {
                                                              return p
                                                            }
                                                          }),
                                                        ],
                                                      )
                                                      setSelectedServices(
                                                        (pv) => [
                                                          ...pv.map(
                                                            (service) => {
                                                              // if (service.product_id === data.id) {
                                                              if (
                                                                service.productIndex ===
                                                                data.indexId
                                                              ) {
                                                                return {
                                                                  ...service,
                                                                  productIndex:
                                                                    data.indexId,
                                                                  quantity: (
                                                                    service.previousQty *
                                                                    Number(
                                                                      newValue,
                                                                    ) *
                                                                    service.locationQuantity
                                                                  )?.toFixed(2),
                                                                  qtyData:
                                                                    Number(
                                                                      newValue,
                                                                    ),
                                                                  total: (
                                                                    service.cost *
                                                                    (service.previousQty *
                                                                      Number(
                                                                        newValue,
                                                                      ) *
                                                                      service.locationQuantity)
                                                                  )?.toFixed(2),
                                                                }
                                                              } else {
                                                                return service
                                                              }
                                                            },
                                                          ),
                                                        ],
                                                      )
                                                      //new chnage on 2-2-24
                                                      if (
                                                        newValue === '' ||
                                                        newValue <= 0
                                                      ) {
                                                        event.preventDefault()
                                                        return
                                                      }
                                                      if (
                                                        newValue.startsWith('-')
                                                      ) {
                                                        newValue =
                                                          newValue.slice(1)
                                                      }
                                                      data['quantity'] =
                                                        newValue || 1
                                                      setFieldValue(
                                                        quantityFieldName,
                                                        newValue,
                                                      )
                                                    }
                                                  }}
                                                  error={Boolean(
                                                    touched[
                                                      quantityFieldName
                                                    ] &&
                                                      errors[quantityFieldName],
                                                  )}
                                                  helperText={
                                                    touched[
                                                      quantityFieldName
                                                    ] &&
                                                    errors[quantityFieldName]
                                                  }
                                                />
                                              </TableCell> */}
                                              <TableCell>
                                                <TextField
                                                  required
                                                  fullWidth
                                                  type="number"
                                                  label={'Qty'}
                                                  disabled={
                                                    data?.fromMapServices ==
                                                    true
                                                      ? true
                                                      : false
                                                  }
                                                  // {...getFieldProps(quantityFieldName)}
                                                  value={Number(
                                                    data.locationQuantity,
                                                  )}
                                                  onFocus={selectInputValue}
                                                  onClick={selectInputValue}
                                                  defaultValue={1}
                                                  onKeyPress={(event) => {
                                                    if (
                                                      event.key === '0' &&
                                                      event.target.value === ''
                                                    ) {
                                                      event.preventDefault()
                                                    }
                                                    if (event.key === '-') {
                                                      event.preventDefault()
                                                    }
                                                    if (event.key === '.') {
                                                      event.preventDefault()
                                                    }
                                                  }}
                                                  onChange={(event) => {
                                                    let newValue =
                                                      event.target.value
                                                    if (
                                                      newValue !== '0' &&
                                                      newValue !== ''
                                                    ) {
                                                      setSelectedProducts(
                                                        (pv) => [
                                                          ...pv.map((p) => {
                                                            console.log(
                                                              '################p.id',
                                                              p.id,
                                                            )
                                                            console.log(
                                                              '################data.id',
                                                              data.id,
                                                            )
                                                            // if (p.id === data.id) {
                                                            if (
                                                              p.indexId ===  data.indexId
                                                            ) {
                                                              let arrayAddr

                                                              const commonAddresses =
                                                              data?.allLocationSame &&
                                                                pv.length > 0
                                                                  ? p.addresses[0]
                                                                  : null
                                                                const newAddr = data?.is_single_card ? 1 : newValue
                                                              if (
                                                                data?.allLocationSame &&
                                                                commonAddresses
                                                              ) {
                                                                // const newAddr = singleLocationCard ? 1 : newValue
                                                                arrayAddr =
                                                                  Array( Number(newAddr), ) //1
                                                                    .fill()
                                                                    .map(
                                                                      (
                                                                        _,
                                                                        i,
                                                                      ) => ({
                                                                        ...commonAddresses,
                                                                        id: i,
                                                                      }),
                                                                    )
                                                              } else {
                                                                arrayAddr = [
                                                                  ...p.addresses,
                                                                ]
                                                                console.log(
                                                                  '################arrayAddr',
                                                                  arrayAddr,
                                                                )
                                                                console.log(
                                                                  '################p.addresses.length',
                                                                  p.addresses
                                                                    .length,
                                                                )
                                                                console.log(
                                                                  '################Number(newValue)',
                                                                  Number(
                                                                    newValue,
                                                                  ),
                                                                )
                                                                if ( p.addresses?.length < newAddr ) { //1
                                                                  arrayAddr.push(
                                                                    ...[
                                                                      ...Array(
                                                                        newAddr - p.addresses.length, //1
                                                                      ),
                                                                    ].map(
                                                                      ( a, i, ) => {
                                                                        return {
                                                                          id:
                                                                            p.addresses.length + i,
                                                                          address:
                                                                            '',
                                                                          city: '',
                                                                          state:
                                                                            '',
                                                                          zip: '',
                                                                        }
                                                                      },
                                                                    ),
                                                                  )
                                                                } else if ( p.addresses?.length > Number(newAddr) ) { //1
                                                                  arrayAddr = arrayAddr.slice( 0, Number(newAddr), ) //1
                                                                } else {
                                                                  arrayAddr = arrayAddr.slice(0, -(p.addresses.length - Number(newAddr)));
                                                                }
                                                              }

                                                              console.log( '###########Arrayadde1', p.addresses, )
                                                              console.log( '###########Arrayadde2', arrayAddr, )
                                                              return {
                                                                ...p,
                                                                // quantity: Number(newValue),
                                                                locationQuantity: Number( newValue, ),
                                                                addresses: arrayAddr,
                                                                install_quantity: p.manually_updated_install_quantity ?  p.install_quantity :Number(newValue) ,
                                                              }
                                                            } else {
                                                              return p
                                                            }
                                                          }),
                                                        ],
                                                      )
                                                      setSelectedServices(
                                                        (pv) => [
                                                          ...pv.map(
                                                            (service) => {
                                                              // if (service.product_id === data.id) {
                                                              console.log(
                                                                'locationQty---service----',
                                                                service,
                                                              )
                                                              console.log(
                                                                'locationQty---data----',
                                                                data,
                                                              )
                                                              if ( service?.productIndex === data?.indexId ) {
                                                                return {
                                                                  ...service,
                                                                  productIndex:
                                                                    data?.indexId,
                                                                  quantity: (
                                                                    service.previousQty *
                                                                    Number(
                                                                      newValue,
                                                                    ) *
                                                                    (service.qtyData ||
                                                                      1)
                                                                  )?.toFixed(2),
                                                                  locationQuantity:
                                                                    Number(
                                                                      newValue,
                                                                    ),
                                                                }
                                                              } else {
                                                                return service
                                                              }
                                                            },
                                                          ),
                                                        ],
                                                      )
                                                      //new chnage on 2-2-24
                                                      if (
                                                        newValue === '' ||
                                                        newValue <= 0
                                                      ) {
                                                        event.preventDefault()
                                                        return
                                                      }
                                                      if (
                                                        newValue.startsWith('-')
                                                      ) {
                                                        newValue =
                                                          newValue.slice(1)
                                                      }
                                                      data['locationQuantity'] =
                                                        newValue || 1
                                                      // setFieldValue(quantityFieldName, newValue);
                                                    }
                                                  }}
                                                  // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                                  // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                                />
                                              </TableCell>
                                              {isSplitOrder && Number(data?.facility_id) !== Number(currentFacilityId) ? 
                                                <TableCell align='center'>
                                                  {Number(data?.facility_id) !== Number(currentFacilityId) ? (
                                                    <Stack direction="column" spacing={1} alignItems="center" sx={{ textAlign: 'center' }}>
                                                      <Button
                                                        size="small"
                                                        variant={data?.delivery_installation?.installer_id || data?.delivery_installation?.installer_facility_id ? "contained" : "outlined"}
                                                        onClick={() => openDeliveryInstallDialog(data)}
                                                        sx={{ textAlign: 'center' }}
                                                      >
                                                        {data?.delivery_installation?.installer_id ||
                                                      data?.delivery_installation?.installer_facility_id
                                                          ? 'Edit'
                                                          : 'Set'}
                                                      </Button>
                                                      {data?.delivery_installation?.installer_facility_id ? (
                                                        <Tooltip
                                                          title={`${deliveryTypeLabelById(
                                                            data?.delivery_installation
                                                              ?.delivery_type_id ||
                                                              data?.delivery_installation
                                                                ?.complete_status,
                                                          )} • ${
                                                            data?.delivery_installation
                                                              ?.installer_facility_name ||
                                                            getFacilityOption(
                                                              data?.delivery_installation
                                                                ?.installer_facility_id,
                                                            )?.name ||
                                                            ''
                                                          }`}
                                                        >
                                                          <Typography
                                                            variant="caption"
                                                            noWrap
                                                            sx={{ maxWidth: 140 }}
                                                          >
                                                            {deliveryTypeLabelById(
                                                              data?.delivery_installation
                                                                ?.delivery_type_id ||
                                                                data?.delivery_installation
                                                                  ?.complete_status,
                                                            )}
                                                            {' • '}
                                                            {data?.delivery_installation
                                                              ?.installer_facility_name ||
                                                              getFacilityOption(
                                                                data?.delivery_installation
                                                                  ?.installer_facility_id,
                                                              )?.name ||
                                                              ''}
                                                          </Typography>
                                                        </Tooltip>
                                                      ) : null}
                                                    </Stack>
                                                  ) : (
                                                      '-'
                                                  )}
                                                </TableCell>
                                              : 
                                              <TableCell align='center'>
                                                   <Stack direction="column" spacing={1} alignItems="center" sx={{ textAlign: 'center' }}>
                                                      <Button
                                                        size="small"
                                                        variant={data?.delivery_installation?.delivery_type_id || data?.delivery_installation?.installer_facility_id ? "contained" : "outlined"}
                                                        onClick={() => openDeliveryTypeDialog(data, 'product')}
                                                        sx={{ textAlign: 'center' }}
                                                      >
                                                        {data?.delivery_installation?.delivery_type_id ||
                                                      data?.delivery_installation?.installer_facility_id
                                                          ? 'Edit'
                                                          : 'Set'}
                                                      </Button>
                                                      {data?.delivery_installation?.delivery_type_id || data?.delivery_installation?.complete_status ? (
                                                        <Tooltip
                                                          title={`${deliveryTypeLabelById(
                                                            data?.delivery_installation
                                                              ?.delivery_type_id ||
                                                              data?.delivery_installation
                                                                ?.complete_status,
                                                          )} `}
                                                        >
                                                          <Typography
                                                            variant="caption"
                                                            noWrap
                                                            sx={{ maxWidth: 140 }}
                                                          >
                                                            {deliveryTypeLabelById(
                                                              data?.delivery_installation
                                                                ?.delivery_type_id ||
                                                                data?.delivery_installation
                                                                  ?.complete_status,
                                                            )}
                                                          </Typography>
                                                        </Tooltip>
                                                      ) : null}
                                                    </Stack> 
                                                </TableCell>
                                              }
                                              <TableCell>
                                                <IconButton
                                                  onClick={() => {
                                                    setLocationStates({
                                                      ...locationStates,
                                                      [data.indexId]: true,
                                                    })
                                                  }}
                                                >
                                                  <LocationOn
                                                    sx={{
                                                      color:
                                                        data.addresses.some(
                                                          (obj) =>
                                                            [obj.address, obj.city, obj.state, obj.zip].some(
                                                              (value) =>
                                                                (value === '' || value === null),
                                                            ),
                                                        )
                                                          ? ''
                                                          : theme.palette
                                                              .primary.main,
                                                    }}
                                                  />
                                                </IconButton>
                                              </TableCell>
                                              {/* <TableCell>{data.id}</TableCell> */}
                                              {/* <TableCell>
                                                <Autocomplete
                                                  disabled={
                                                    false
                                                  }
                                                  sx={{ width: 70 }}
                                                  id="combo-box-demo"
                                                  disableClearable
                                                  options={
                                                    marketingAdjustmentType ||
                                                    []
                                                  }
                                                  defaultValue={
                                                    marketingAdjustmentType.find(
                                                      (type) =>
                                                        type.id ===
                                                        data.markAdjType,
                                                    ) ||
                                                    marketingAdjustmentType[0]
                                                  }
                                                  onChange={(
                                                    event,
                                                    newValue,
                                                  ) => {
                                                    setSelectedProducts(
                                                      (prevProducts) => {
                                                        return prevProducts.map(
                                                          (product) => {
                                                            if (
                                                              product.indexId ===
                                                              data.indexId
                                                            ) {
                                                              return {
                                                                ...product,
                                                                markAdjType:
                                                                  newValue?.id ||
                                                                  marketingAdjustmentType[0]
                                                                    .id, // Set adjustment type or default to the first option
                                                                // adjustment: 0,
                                                              }
                                                            }
                                                            return product
                                                          },
                                                        )
                                                      },
                                                    )
                                                  }}
                                                  renderInput={(params) => (
                                                    <TextField
                                                      {...params}
                                                      required
                                                      error={Boolean(
                                                        touched.marketingAdjType &&
                                                          errors.marketingAdjType,
                                                      )}
                                                      helperText={
                                                        touched.marketingAdjType &&
                                                        errors.marketingAdjType
                                                      }
                                                      label="Select type"
                                                    />
                                                  )}
                                                  getOptionLabel={(option) =>
                                                    option.name
                                                      ? option.name
                                                      : ''
                                                  }
                                                />
                                              </TableCell> */}
                                              {/* <TableCell> */}
                                                {/* <TextField
                                    type="number"
                                    label="Discount"
                                    defaultValue={0}
                                    value={Number(data.discount)}
                                    // {...getFieldProps(discountFieldName)}
                                    onChange={(event) => {
                                      let newValue = event.target.value;
                                      if (newValue.startsWith('-')) {
                                        newValue = newValue.slice(1);
                                      }
                                      if (markupType == 1) {
                                        if (Number(newValue) > maxDiscount_wholesale) {
                                          newValue = maxDiscount_wholesale.toFixed(2);
                                        }
                                      } else if (markupType == 2) {
                                        if (Number(newValue) > maxDiscount_retail) {
                                          newValue = maxDiscount_retail.toFixed(2);
                                        }
                                      } else {
                                        newValue = 0;
                                      }
                                      if (newValue === '-0.00') {
                                        newValue = 0;
                                      }
                                      data['discount'] = newValue
                                      setFieldValue(discountFieldName, newValue);
                                    }}
                                    error={Boolean(touched[discountFieldName] && errors[discountFieldName])}
                                    helperText={touched[discountFieldName] && errors[discountFieldName]}
                                    inputProps={{ max: markupType == 1 ? maxDiscount_wholesale : markupType == 2 ? maxDiscount_retail : 0, min: 0 }}
                                  /> */}
                                                {/* <TextField
                                                  type="number"
                                                  label={
                                                    data.markAdjType === 2
                                                      ? '$'
                                                      : data.markAdjType === 3
                                                      ? '¢'
                                                      : '%'
                                                  }
                                                  disabled={
                                                    false
                                                  }
                                                  // disabled={
                                                  //   values.project_categories
                                                  //     ?.name ==
                                                  //   'Time & Material'
                                                  //     ? true
                                                  //     : false
                                                  // }
                                                  // defaultValue={data?.adjustment ? Number(data?.adjustment) : 0}
                                                  // value={Number(data.adjustment)}
                                                  value={
                                                    Number(data.adjustment) ||
                                                    null
                                                  }
                                                  onChange={(event) => {
                                                    let newValue =
                                                      event.target.value

                                                    // Allow only two decimal places
                                                    if (
                                                      newValue.includes('.')
                                                    ) {
                                                      const parts =
                                                        newValue.split('.')
                                                      if (parts[1].length > 2) {
                                                        newValue = `${
                                                          parts[0]
                                                        }.${parts[1].slice(
                                                          0,
                                                          2,
                                                        )}`
                                                      }
                                                    }
                                                    data['adjustment'] =
                                                      newValue
                                                    setFieldValue(
                                                      adjustmentFieldName,
                                                      newValue,
                                                    )
                                                  }}
                                                  onKeyDown={(event) => {
                                                    if (
                                                      event.key === '-' ||
                                                      event.key === '+'
                                                    ) {
                                                      event.preventDefault()
                                                    }
                                                  }}
                                                  error={Boolean(
                                                    touched[
                                                      adjustmentFieldName
                                                    ] &&
                                                      errors[
                                                        adjustmentFieldName
                                                      ],
                                                  )}
                                                  helperText={
                                                    touched[
                                                      adjustmentFieldName
                                                    ] &&
                                                    errors[adjustmentFieldName]
                                                  }
                                                />
                                              </TableCell> */}
                                              {/* //maketting adjustment */}
                                              {
                                                isSplitOrder ? null :
                                                <>
                                              <TableCell>
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                  <Remove 
                                                    fontSize="small" 
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                      const hasPermission =  explodedPermissions?.some((permission) =>
                                                        ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                      )
                                                      // if(!hasPermission) {
                                                      //   return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                      // }
                                                      const formulaEach = Number(
                                                        (data?.expected_material_cost_with_markup || 0) +
                                                          (data?.expected_service_cost_with_markup || 0),
                                                      )
                                                      const retailEachBase = Math.max(
                                                        0,
                                                        Number(
                                                          data.original_actual_retail_price ??
                                                            data.original_retail_price ??
                                                            data.actual_retail_price ??
                                                            data.retail_price ??
                                                            data.product_retail_price ??
                                                            0,
                                                        ),
                                                      )
                                                      if (retailEachBase <= formulaEach && !hasPermission) {
                                                        return enqueueSnackbar(
                                                                'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
                                                                { variant: 'error' },
                                                              )
                                                        // return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                      }
                                                      // const expected = Number(data.formula_cost) || 0;
                                                      // const qty = Number(data.quantity) || 1;
                                                      // const locQty = Number(data.locationQuantity) || 1;
                                                      // const pfCost =expected ? (parseFloat((expected)?.toFixed(2))*qty*locQty) : 0
                                                      const adjustment = Number(data.adjustment) || 0;
                                                      // if(Number(adjustment) > Number(pfCost)) {
                                                      const maxNegative = getMaxNegativeAdjustment(data,hasPermission);
                                                      // console.log("aaaaaaaaaaaaa",maxNegative);
                                                      // console.log("aaaaaaaaaaaaa",adjustment);                                                      
                                                      if (Number(adjustment) >= maxNegative && hasPermission) {
                                                        return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                      } else if (Number(adjustment) > maxNegative && !hasPermission) {
                                                        return enqueueSnackbar(`Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Product Formula Limit)`, { variant: 'error' })
                                                      }
                                                      const newValue = false
                                                      setSelectedProducts(
                                                        (prevProducts) =>
                                                          prevProducts.map(
                                                            (product) => {
                                                              if (
                                                                product.indexId ===
                                                                data.indexId
                                                              ) {
                                                                return {
                                                                  ...product,
                                                                  adj_value_type: newValue,
                                                                  actual_retail_price:data.original_actual_retail_price? data?.original_actual_retail_price + (newValue ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0)) : null,
                                                                  retail_price: data.original_retail_price? data?.original_retail_price + (newValue ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0)) : null,
                                                                }
                                                              }
                                                              return product
                                                            },
                                                          ),
                                                      )
                                                      data['adj_value_type'] = newValue
                                                      // setFieldValue('manager_approval_required', true)
                                                    }}
                                                  />
                                                  <FormControlLabel
                                                    control={
                                                      <Switch
                                                        checked={data.adj_value_type}
                                                        onChange={(event) => {
                                                          const newValue = event.target.checked
                                                          const hasPermission =  explodedPermissions?.some((permission) =>
                                                            ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                          )
                                                          
                                                          if (newValue === false) {
                                                            const formulaEach = Number(
                                                              (data?.expected_material_cost_with_markup || 0) +
                                                                (data?.expected_service_cost_with_markup || 0),
                                                            )
                                                            const retailEachBase = Math.max(
                                                              0,
                                                              Number(
                                                                data.original_actual_retail_price ??
                                                                  data.original_retail_price ??
                                                                  data.actual_retail_price ??
                                                                  data.retail_price ??
                                                                  data.product_retail_price ??
                                                                  0,
                                                              ),
                                                            )
                                                            if (retailEachBase <= formulaEach && !hasPermission) {
                                                              return enqueueSnackbar(
                                                                'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
                                                                { variant: 'error' },
                                                              )
                                                            //   return enqueueSnackbar(
                                                            //   'Access Denied : You do not have Suffient Permission',
                                                            //   { variant: 'error' },
                                                            // )
                                                            }
                                                          }
                                                          // const expected = Number(data.formula_cost) || 0;
                                                          // const qty = Number(data.quantity) || 1;
                                                          // const locQty = Number(data.locationQuantity) || 1;
                                                          // const pfCost =expected ? (parseFloat((expected)?.toFixed(2))*qty*locQty) : 0
                                                          const adjustment = Number(data.adjustment) || 0;
                                                          // if(Number(adjustment) > Number(pfCost) && newValue === false) {
                                                          const maxNegative = getMaxNegativeAdjustment(data, hasPermission);
                                                          // console.log('getMaxNegativeAdjustment11-maxNegative--',maxNegative)
                                                          // console.log('getMaxNegativeAdjustment11-adjustment--',adjustment)
                                                          // console.log('getMaxNegativeAdjustment11-newValue--',newValue)
                                                          if (Number(adjustment) >= maxNegative && hasPermission && newValue === false) {
                                                            return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                          } else if (Number(adjustment) > maxNegative && !hasPermission && newValue === false) {
                                                            // return enqueueSnackbar('Negative Adjustment Amount cannot reduce below Product Formula Cost', { variant: 'error' })
                                                            return enqueueSnackbar(`Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Product Formula Limit)`, { variant: 'error' })
                                                          }
                                                          setSelectedProducts(
                                                            (prevProducts) =>
                                                              prevProducts.map(
                                                                (product) => {
                                                                  if (
                                                                    product.indexId ===
                                                                    data.indexId
                                                                  ) {
                                                                    return {
                                                                      ...product,
                                                                      adj_value_type: newValue,
                                                                      actual_retail_price: data.original_actual_retail_price? data?.original_actual_retail_price + (newValue ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0)) : null,
                                                                      retail_price: data.original_retail_price? data?.original_retail_price + (newValue ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0)) : null,
                                                                    }
                                                                  }
                                                                  return product
                                                                },
                                                              ),
                                                          )
                                                          data['adj_value_type'] = newValue
                                                          if (newValue === false) {
                                                            // setFieldValue('manager_approval_required', true)
                                                          }
                                                        }}
                                                      />
                                                    }
                                                    label=""
                                                  />
                                                  <Add 
                                                    fontSize="small" 
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                      const newValue = true
                                                      setSelectedProducts(
                                                        (prevProducts) =>
                                                          prevProducts.map(
                                                            (product) => {
                                                              if (
                                                                product.indexId ===
                                                                data.indexId
                                                              ) {
                                                                return {
                                                                  ...product,
                                                                  adj_value_type: newValue,
                                                                  actual_retail_price: data.original_actual_retail_price? data?.original_actual_retail_price + (newValue ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0)) : null,
                                                                  retail_price: data.original_retail_price? data?.original_retail_price + (newValue ? (Number(data?.adjustment) || 0) : -(Number(data?.adjustment) || 0)) : null,
                                                                }
                                                              }
                                                              return product
                                                            },
                                                          ),
                                                      )
                                                      data['adj_value_type'] = newValue
                                                    }}
                                                  />
                                                </Stack>
                                              </TableCell>
                                            <TableCell>
                                               <TextField
                                                  type="number"
                                                  inputProps={{ min: 0 }}
                                                  label='$'
                                                  value={
                                                    data.adjustment_draft !== undefined
                                                      ? limitDecimalInput(
                                                          data.adjustment_draft,
                                                        )
                                                      : Number(data.adjustment) || ''
                                                  }
                                                  InputLabelProps={{
                                                    shrink: Boolean(
                                                      data.adjustment_draft !== undefined
                                                        ? data.adjustment_draft !== ''
                                                        : Number(data.adjustment),
                                                    ),
                                                  }}
                                                  onWheel={(e) => e.target.blur()}
                                                  onBeforeInput={(e) => {
                                                    const inputElement = e.target;
                                                     const nextValue = inputElement.value; 
                                                    const hasPermission =  explodedPermissions?.some((permission) =>
                                                      ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                    )
                                                    const maxNegative = getMaxNegativeAdjustment(data, hasPermission);
                                                    if (Number(nextValue) >= maxNegative && data.adj_value_type === false && hasPermission) {
                                                      e.preventDefault();
                                                      enqueueSnackbar(
                                                        "Retail value cannot be zero or less",
                                                        { variant: "error" }
                                                      );
                                                    } else if (Number(nextValue) > maxNegative && data.adj_value_type === false && !hasPermission) {
                                                      e.preventDefault();
                                                      enqueueSnackbar(
                                                        `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Product Formula Limit)`,
                                                        { variant: "error" }
                                                      );
                                                    }
                                                  }}
                                                  onChange={(event) => {
                                                    handleMarketingAdjustmentChange(
                                                      data.indexId,
                                                      event.target.value,
                                                    )
                                                  }}
                                                  onBlur={(event) => {
                                                    handleMarketingAdjustmentChange(
                                                      data.indexId,
                                                      event.target.value,
                                                      { isBlur: true },
                                                    )
                                                  }}
                                                  onKeyDown={(event) => {
                                                    if (
                                                      event.key === '-' ||
                                                      event.key === '+'
                                                    ) {
                                                      event.preventDefault()
                                                    }
                                                    // Prevent arrow down key when value is 0 or would go negative
                                                    if (event.key === 'ArrowDown') {
                                                      const inputValue = event.target.value
                                                      const currentValue = parseFloat(inputValue) || 0
                                                      const step = parseFloat(event.target.step) || 1
                                                      if (currentValue - step < 0) {
                                                        event.preventDefault()
                                                      }
                                                    }
                                                  }}
                                                  error={Boolean(
                                                    touched[
                                                      adjustmentFieldName
                                                    ] &&
                                                      errors[
                                                        adjustmentFieldName
                                                      ],
                                                  )}
                                                  helperText={
                                                    touched[
                                                      adjustmentFieldName
                                                    ] &&
                                                    errors[adjustmentFieldName]
                                                  }
                                                />
                                              </TableCell>
                                                </>
                                              }

                                              <TableCell>
                                                {(data?.actual_retail_price ? Number(data.actual_retail_price) * (Number(data?.locationQuantity) || 1) : Number(data?.retail_price || 0) * (Number(data?.locationQuantity) || 1)).toFixed(2)}
                                              </TableCell>
                                              <TableCell>
                                                {data?.install_cost ? '' : lineProductTotal.toFixed(2)}
                                              </TableCell>
                                              <TableCell>
                                                {data?.fromMapServices ==
                                                true ? (
                                                  ''
                                                ) : (
                                                  <IconButton
                                                    onClick={() =>
                                                      handleDeleteProduct(
                                                        data.id,
                                                        data.indexId,
                                                      )
                                                    }
                                                  >
                                                    <Delete />
                                                  </IconButton>
                                                )}
                                              </TableCell>
                                            </TableRow>
                                            {
                                              data?.install_cost ?
                                                <TableRow key={`summary-${data.indexId}`} sx={losingMoneyRowSx}>
                                                  <TableCell padding="checkbox" sx={{ width: 40 }} />
                                                  <TableCell>#{data?.indexId}</TableCell>
                                                  <TableCell> </TableCell>
                                                  <TableCell>
                                                    <Typography>Install Price</Typography>
                                                   { data?.install_notes? <Typography sx={{color:isSplitOrder ? theme.palette[
                                                  FacilityTypes.find(f => f.id === data?.facility_id)?.color || 'primary'
                                                ]?.main
                                    :data?.install_notes? 'red' : 'inherit' ,whiteSpace: 'pre-wrap'}}> Note : {' '}{data?.install_notes ? data?.install_notes : ``} </Typography>:""}</TableCell>
                                                 
                                                 <TableCell align='center'>
                                                   <IconButton
                                                     onClick={() =>
                                                       handleOpenInstallNote(
                                                         data.indexId,
                                                         data.install_notes,
                                                       )
                                                     }
                                                   >
                                                     <NoteAdd
                                                       sx={{
                                                         color:
                                                           !data?.install_notes ||
                                                           data?.install_notes ===
                                                             ''
                                                             ? ''
                                                             : theme.palette
                                                                 .primary.main,
                                                       }}
                                                     />
                                                   </IconButton>
                                                 </TableCell>
                                                 <TableCell align='center'>-</TableCell>
                                                 <TableCell align='center'>-</TableCell>
                                                  <TableCell>{
                                                    isSplitOrder && data?.facility_id !== currentFacilityId ?
                                                    data?.install_cost?.toFixed(2) || 0
                                                    : data?.expected_install_labor_cost_with_markup?.toFixed(2) || 0
                                                  }</TableCell>
                                                  {/* Incoming Percentage column for Install Price - only show when isSplitOrder is true */}
                                                  {isSplitOrder ? (
                                                    <TableCell align='center'>-</TableCell>
                                                  ) : (
                                                    <TableCell align='center'>-</TableCell>
                                                  )}
                                                  {hasMarkupPermission ? <TableCell align='center'>
                                                    {/* ALL-815 backup - previous read-only install price display:
                                                    (parseFloat(data?.install_cost || 0)).toFixed(2) */}
                                                    {(() => {
                                                      const installFormulaEach = Number(
                                                        data?.expected_install_labor_cost_with_markup ||
                                                          0,
                                                      )
                                                      const hasNegativeInstallPermission =
                                                        explodedPermissions?.some(
                                                          (permission) =>
                                                            [
                                                              'Allow Negative Marketing Adjustment Sales Order',
                                                            ].includes(permission),
                                                        )
                                                      const installPriceMin =
                                                        hasNegativeInstallPermission
                                                          ? 0.01
                                                          : Math.max(
                                                              0.01,
                                                              installFormulaEach,
                                                            )
                                                      const dataInstallCost = getDisplayedInstallPrice(data)
                                                      return (
                                                    <TextField
                                                      required
                                                      fullWidth
                                                      type="number"
                                                      label={'Install Price Each'}
                                                      sx={{ width: 120 }}
                                                      value={
                                                        data.install_price_draft !== undefined
                                                          ? limitDecimalInput(
                                                              data.install_price_draft,
                                                            )
                                                          : formatRetailPriceDisplay(
                                                              dataInstallCost,
                                                            )
                                                      }
                                                      onFocus={selectInputValue}
                                                      onClick={selectInputValue}
                                                      onKeyPress={(event) => {
                                                        if (event.key === '-') {
                                                          event.preventDefault();
                                                        }
                                                        if (event.key === 'e') {
                                                          event.preventDefault();
                                                        }
                                                      }}
                                                      onKeyDown={(event) => {
                                                        if (
                                                          event.key === 'ArrowUp' ||
                                                          event.key === 'ArrowDown'
                                                        ) {
                                                          event.preventDefault()
                                                          const current =
                                                            data.install_price_draft !== undefined
                                                              ? data.install_price_draft
                                                              : formatRetailPriceDisplay(
                                                                  dataInstallCost,
                                                                )
                                                          handleInstallPriceChange(
                                                            data.indexId,
                                                            stepRetailPriceByArrow(
                                                              current,
                                                              event.key === 'ArrowUp'
                                                                ? 'up'
                                                                : 'down',
                                                              installPriceMin,
                                                            ),
                                                            { isBlur: true },
                                                          )
                                                        }
                                                      }}
                                                      inputProps={{
                                                        min: installPriceMin,
                                                        step: 1,
                                                      }}
                                                      defaultValue={0}
                                                      onChange={(event) => {
                                                        const current =
                                                          data.install_price_draft !== undefined
                                                            ? data.install_price_draft
                                                            : formatRetailPriceDisplay(
                                                                dataInstallCost,
                                                              )
                                                        handleInstallPriceChange(
                                                          data.indexId,
                                                          normalizeRetailArrowChange(
                                                            current,
                                                            event.target.value,
                                                            installPriceMin,
                                                          ),
                                                        )
                                                      }}
                                                      onBlur={(event) => {
                                                        handleInstallPriceChange(
                                                          data.indexId,
                                                          event.target.value,
                                                          { isBlur: true },
                                                        )
                                                      }}
                                                    />
                                                      )
                                                    })()}
                                                  </TableCell> : null}
                                                  <TableCell align='center'>
                                                    <TextField
                                                      required
                                                      fullWidth
                                                      type="number"
                                                      min={0}
                                                      label={'Qty'}
                                                      // sx={{ width: 85 }}
                                                      value={Number(isSplitOrder ? (data.install_quantity ?? 0) : (data.install_quantity || 1))}
                                                      defaultValue={1}
                                                      onFocus={selectInputValue}
                                                      onClick={selectInputValue}
                                                      onKeyPress={(event) => {
                                                        if (
                                                          event.key === '0' &&
                                                          event.target.value === ''
                                                        ) {
                                                          event.preventDefault()
                                                        }
                                                        if (event.key === '-') {
                                                          event.preventDefault()
                                                        }
                                                        if (event.key === '.') {
                                                          event.preventDefault()
                                                        }
                                                      }}
                                                      onChange={(event) => {
                                                        let newValue = event.target.value
                                                        if (Number(newValue) < 0) return
                                                        if ((newValue !== '0' && newValue !== '') || (isSplitOrder && newValue === '0')) {
                                                          setSelectedProducts((prevProducts) =>
                                                            prevProducts.map((p) => {
                                                              if (p.indexId !== data.indexId) return p
                                                              return {
                                                                ...p,
                                                                install_quantity: Number(newValue),
                                                                retail_price: (Number(newValue) === 0 ? (Number(p?.actual_retail_price) || 0) : (Number(p?.actual_retail_price) || 0) + (Number(p?.install_cost) || 0)) * (p?.locationQuantity || 1),
                                                                manually_updated_install_quantity: true,
                                                              }
                                                            }),
                                                          )
                                                          data['install_quantity'] = Number(newValue)
                                                          data['retail_price'] = (Number(newValue) === 0 ? (Number(data?.actual_retail_price) || 0) : (Number(data?.actual_retail_price) || 0) + (Number(data?.install_cost) || 0)) * (data?.locationQuantity || 1)
                                                        }
                                                      }}
                                                    />
                                                  </TableCell>
                                                  {/* {isSplitOrder ? (
                                                    <TableCell align='center'>-</TableCell>
                                                  ) : null} */}
                                                  <TableCell align='center'>-</TableCell>
                                                  <TableCell align='center'></TableCell>
                                                  {/* Marketing adjustment for Install Price (separate from product marketing adjustment) */}
                                                  {
                                                  isSplitOrder ? null :
                                                  <>
                                                  <TableCell>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                      <Remove
                                                        fontSize="small"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => {
                                                          const hasPermission =
                                                            explodedPermissions?.some((permission) =>
                                                              ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                            )
                                                          // if (!hasPermission) {
                                                          //   // We do not immediately block them, we check when comparing retail with formula limit.
                                                          // }
                                                          const formulaEach = Number(
                                                            data?.expected_install_labor_cost_with_markup || 0,
                                                          )
                                                          const retailEachBase = Math.max(
                                                            0,
                                                            Number(data.install_cost || 0),
                                                          )
                                                          if (retailEachBase <= formulaEach && !hasPermission) {
                                                            // return enqueueSnackbar(
                                                            //   'Access Denied : You do not have Suffient Permission',
                                                            //   { variant: 'error' },
                                                            // )
                                                             return enqueueSnackbar(
                                                                'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
                                                                { variant: 'error' },
                                                              )
                                                          }
                                                          const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
                                                          const adjustment = Number(data.install_adjustment) || 0
                                                          if (Number(adjustment) >= maxNegative && hasPermission) {
                                                            return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                          } else if (Number(adjustment) > maxNegative && !hasPermission) {
                                                            return enqueueSnackbar(
                                                              `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                              { variant: 'error' },
                                                            )
                                                          }

                                                          const newValue = false
                                                          setSelectedProducts((prevProducts) =>
                                                            prevProducts.map((product) => {
                                                              if (product.indexId !== data.indexId) return product

                                                              // const baseInstall =
                                                              //   Number(product?.original_install_cost) ||
                                                              //   Number(product?.install_cost) ||
                                                              //   0
                                                              // const adj =
                                                              //   Number(product?.install_adjustment) || 0
                                                              // const signedAdj = newValue ? adj : -adj
                                                              // const newInstallCost = Math.max(0, baseInstall + signedAdj)
                                                              const baseInstall = Number(data?.original_install_cost) || 0
                                                              const adj = Number(data?.install_adjustment) || 0
                                                              const newInstallCost = baseInstall ? Math.max(0, baseInstall + (newValue ? adj : -adj)) : null

                                                              return {
                                                                ...product,
                                                                install_adj_value_type: newValue,
                                                                install_cost: newInstallCost,
                                                              }
                                                            }),
                                                          )
                                                          data['install_adj_value_type'] = newValue
                                                          // setFieldValue('manager_approval_required', true)
                                                        }}
                                                      />
                                                      <FormControlLabel
                                                        control={
                                                          <Switch
                                                            checked={Boolean(data.install_adj_value_type)}
                                                            onChange={(event) => {
                                                              const newValue = event.target.checked
                                                              const hasPermission =
                                                                explodedPermissions?.some((permission) =>
                                                                  ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                                )
                                                              if (newValue === false) {
                                                                const formulaEach = Number(
                                                                  data?.expected_install_labor_cost_with_markup || 0,
                                                                )
                                                                const retailEachBase = Math.max(
                                                                  0,
                                                                  Number(data.install_cost || 0),
                                                                )
                                                                if (retailEachBase <= formulaEach && !hasPermission) {
                                                                  return enqueueSnackbar(
                                                                    'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
                                                                    { variant: 'error' },
                                                                  )
                                                                  // return enqueueSnackbar(
                                                                  //   'Access Denied : You do not have Suffient Permission',
                                                                  //   { variant: 'error' },
                                                                  // )
                                                                }
                                                              }

                                                              const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
                                                              const adjustment = Number(data.install_adjustment) || 0
                                                              if (Number(adjustment) >= maxNegative && hasPermission && newValue === false) {
                                                                return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                              } else if (Number(adjustment) > maxNegative && !hasPermission && newValue === false) {
                                                                return enqueueSnackbar(
                                                                  `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                                  { variant: 'error' },
                                                                )
                                                              }

                                                              setSelectedProducts((prevProducts) =>
                                                                prevProducts.map((product) => {
                                                                  if (product.indexId !== data.indexId) return product

                                                                //   const baseInstall =
                                                                //   Number(product?.original_install_cost) ||
                                                                //   Number(product?.install_cost) ||
                                                                //   0
                                                                // const adj =
                                                                //   Number(product?.install_adjustment) || 0
                                                                // const signedAdj = newValue ? adj : -adj
                                                                // const newInstallCost = Math.max(0, baseInstall + signedAdj)
                                                                  const baseInstall = Number(data?.original_install_cost) || 0
                                                                  const adj = Number(data?.install_adjustment) || 0
                                                                  const newInstallCost = baseInstall ? Math.max(0, baseInstall + (newValue ? adj : -adj)) : null

                                                                  return {
                                                                    ...product,
                                                                    install_adj_value_type: newValue,
                                                                    install_cost: newInstallCost,
                                                                  }
                                                                }),
                                                              )
                                                              data['install_adj_value_type'] = newValue
                                                              if (newValue === false) {
                                                                // setFieldValue('manager_approval_required', true)
                                                              }
                                                            }}
                                                          />
                                                        }
                                                        label=""
                                                      />
                                                      <Add
                                                        fontSize="small"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => {
                                                          const newValue = true
                                                          setSelectedProducts((prevProducts) =>
                                                            prevProducts.map((product) => {
                                                              if (product.indexId !== data.indexId) return product

                                                            //   const baseInstall =
                                                            //   Number(product?.original_install_cost) ||
                                                            //   Number(product?.install_cost) ||
                                                            //   0
                                                            // const adj =
                                                            //   Number(product?.install_adjustment) || 0
                                                            // const signedAdj = newValue ? adj : -adj
                                                            // const newInstallCost = Math.max(0, baseInstall + signedAdj)
                                                              const baseInstall = Number(data?.original_install_cost) || 0
                                                              const adj = Number(data?.install_adjustment) || 0
                                                              const newInstallCost = baseInstall ? Math.max(0, baseInstall + (newValue ? adj : -adj)) : null

                                                              return {
                                                                ...product,
                                                                install_adj_value_type: newValue,
                                                                install_cost: newInstallCost,
                                                              }
                                                            }),
                                                          )
                                                          data['install_adj_value_type'] = newValue
                                                        }}
                                                      />
                                                    </Stack>
                                                  </TableCell>
                                                  <TableCell>
                                                    <TextField
                                                      type="number"
                                                      inputProps={{ min: 0 }}
                                                      label="$"
                                                      InputLabelProps={{
                                                        shrink: Boolean(
                                                          data.install_adjustment_draft !== undefined
                                                            ? data.install_adjustment_draft !== ''
                                                            : Number(data.install_adjustment),
                                                        ),
                                                      }}
                                                      value={
                                                        data.install_adjustment_draft !== undefined
                                                          ? limitDecimalInput(
                                                              data.install_adjustment_draft,
                                                            )
                                                          : Number(data.install_adjustment) || ''
                                                      }
                                                      onWheel={(e) => e.target.blur()}
                                                      onBeforeInput={(e) => {
                                                        // const char = e.data
                                                        // const nextValue = e.target.value + char
                                                        const inputElement = e.target;
                                                        const nextValue = inputElement.value; 
                                                        const hasPermission = explodedPermissions?.some((permission) => ['Allow Negative Marketing Adjustment Sales Order'].includes(permission))
                                                        const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
                                                        if (Number(nextValue) >= maxNegative && data.install_adj_value_type === false && hasPermission) {
                                                          e.preventDefault()
                                                          enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                        } else if (Number(nextValue) > maxNegative && data.install_adj_value_type === false && !hasPermission) {
                                                          e.preventDefault()
                                                          enqueueSnackbar(
                                                            `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                            { variant: 'error' },
                                                          )
                                                        }
                                                      }}
                                                      onChange={(event) => {
                                                        let newValue = event.target.value
                                                        const hasPermission = explodedPermissions?.some((permission) => ['Allow Negative Marketing Adjustment Sales Order'].includes(permission))
                                                        const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
                                                        if (Number(newValue) >= maxNegative && data.install_adj_value_type === false && hasPermission) {
                                                          enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                          return
                                                        } else if (Number(newValue) > maxNegative && data.install_adj_value_type === false && !hasPermission) {
                                                          enqueueSnackbar(
                                                            `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
                                                            { variant: 'error' },
                                                          )
                                                          return
                                                        }

                                                        const numValue = parseFloat(newValue) || 0
                                                        if (numValue < 0) {
                                                          newValue = 0
                                                        } else {
                                                          newValue = String(numValue)
                                                        }

                                                        // Allow only two decimal places
                                                        if (newValue.includes('.')) {
                                                          const parts = newValue.split('.')
                                                          if (parts[1].length > 2) {
                                                            newValue = `${parts[0]}.${parts[1].slice(0, 2)}`
                                                          }
                                                        }

                                                        setSelectedProducts((prevProducts) =>
                                                          prevProducts.map((product) => {
                                                            if (product.indexId !== data.indexId) return product

                                                            // const baseInstall =
                                                            // Number(product?.original_install_cost) ||
                                                            // Number(product?.install_cost) ||
                                                            // 0
                                                            const baseInstall = Number(data?.original_install_cost) || 0
                                                            const adj = Number(newValue) || 0
                                                            // const signedAdj = product.install_adj_value_type ? adj : -adj
                                                            // const newInstallCost = Math.max(0, baseInstall + signedAdj)
                                                            const newInstallCost = baseInstall ? Math.max(0, baseInstall + (product.install_adj_value_type ? adj : -adj)) : null

                                                            return {
                                                              ...product,
                                                              install_adjustment: newValue,
                                                              install_adjustment_draft: newValue,
                                                              install_cost: newInstallCost,
                                                              install_price_draft: undefined,
                                                              retail_price: Number(
                                                                (
                                                                  (Number(product.actual_retail_price) || 0) +
                                                                  (Number(newInstallCost) || 0)
                                                                ).toFixed(2),
                                                              ),
                                                            }
                                                          }),
                                                        )
                                                        setRefreshCalculation((v) => !v)
                                                      }}
                                                      onKeyDown={(event) => {
                                                        if (event.key === '-' || event.key === '+') {
                                                          event.preventDefault()
                                                        }
                                                        if (event.key === 'ArrowDown') {
                                                          const inputValue = event.target.value
                                                          const currentValue = parseFloat(inputValue) || 0
                                                          const step = parseFloat(event.target.step) || 1
                                                          if (currentValue - step < 0) {
                                                            event.preventDefault()
                                                          }
                                                        }
                                                      }}
                                                    />
                                                  </TableCell>
                                                  </>
                                                  }
                                                  <TableCell align='center'>
                                                    {(
                                                    parseFloat(data?.install_cost || 0) *
                                                    (isSplitOrder ? (Number(data?.install_quantity) || 0) : (Number(data?.install_quantity) || 1))
                                                    // *(data?.locationQuantity || 1)
                                                  ).toFixed(2)}
                                                  </TableCell>
                                                  <TableCell>
                                                     {/* {calculateTotal(
                                                  markupType == 1
                                                    ? data.price
                                                    : markupType == 2
                                                    ? data.retail_price
                                                    : 0,
                                                  Number(data.quantity),
                                                  values[discountFieldName],
                                                  data.locationQuantity,
                                                  data.adjustment,
                                                  data.markAdjType,
                                                  data.adj_value_type
                                                )?.toFixed(2)} */}
                                               {(() => {
                                                  const locQty = Number(data?.locationQuantity) || 1
                                                  // const productQty = Number(data?.quantity) || 1
                                                  const installQty = isSplitOrder ? (Number(data?.install_quantity) || 0) : (Number(data?.install_quantity) || 1)
                                                  const discount = Number(values[discountFieldName]) || 0

                                                 
                                                  // Use the exact same calculation as the product subtotal column (line 8635)
                                                  const productSubTotal =
                                                    markupType == 1
                                                      ? (Number(data?.price) || 0) * locQty
                                                      : markupType == 2
                                                      // ? Number(
                                                      //   (data?.install_cost || data?.original_install_cost)
                                                      //     ? (data?.retail_price ?? 0)
                                                      //     : (data?.actual_retail_price ?? data?.retail_price ?? 0),
                                                      // )
                                                      ? (Number(data?.actual_retail_price || data?.retail_price || 0)) * locQty
                                                      : 0

                                                  // Use the exact same calculation as the install subtotal column (line 8942-8945)
                                                  const installSubTotal =
                                                    (Number(data?.install_cost) || 0) *
                                                    installQty

                                                  // Product Total is the sum of both subtotals minus discount
                                                  return Math.max(
                                                    0,
                                                    productSubTotal + installSubTotal - discount,
                                                  ).toFixed(2)
                                                })()}
                                              </TableCell>
                                              <TableCell>
                                                <IconButton
                                                  onClick={() =>
                                                    handleDeleteInstallCost(
                                                      data.id,
                                                      data.indexId,
                                                    )
                                                  }
                                                >
                                                  <Delete />
                                                </IconButton>
                                              </TableCell>
                                                </TableRow> :
                                                ''
                                            }
                                            <TableRow>
                                              <TableCell colSpan={15} sx={{ padding: 0 }}>
                                                <Divider />
                                              </TableCell>
                                            </TableRow>                                       
                                            <Modal
                                              open={
                                                locationStates[data.indexId]
                                              }
                                              handleClose={() => {
                                                setLocationStates({
                                                  ...locationStates,
                                                  [data.indexId]: false,
                                                })
                                              }}
                                            >
                                              <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'} alignItems={'center'}>
                                              {data?.fromMapServices != true &&
                                                // index === 0 && 
                                                (
                                                  <FormControlLabel
                                                    control={
                                                      <Switch
                                                        checked={
                                                          data?.allLocationSame
                                                        }
                                                        onChange={()=>
                                                          handleAllLocationSameChange(index)
                                                        }
                                                      />
                                                    }
                                                    label="All Locations Same"
                                                  />
                                                )}
                                                {
                                                  values.project_categories?.id !== 14 ?
                                                
                                                <Box sx={{ display: 'flex', flexDirection: 'column',width:'50%', alignItems: 'center', mt: 2 }}>
                                                  <LabelStyle >Qty Location Settings</LabelStyle>
                                                        <Box display="flex" alignItems="center" gap={1} mt={1}>
                                                          {/* <LabelStyle>Multiple</LabelStyle> */}
                                                          <Typography variant="subtitle2">Multiple</Typography>
                                                          <Switch
                                                            color="primary"
                                                            checked={data?.is_single_card}
                                                            onChange={(event) => {
                                                              const checked = event.target.checked;

                                                              setSelectedProducts((prev) =>
                                                                prev.map((p) => {
                                                                  if (p.indexId !== data.indexId) return p;

                                                                  const count = Number(p.locationQuantity || 1);

                                                                  if (checked) {
                                                                    return {
                                                                      ...p,
                                                                      is_single_card: true,
                                                                      addresses: p.addresses?.length
                                                                        ? [p.addresses[0]]
                                                                        : [
                                                                            {
                                                                              id: 0,
                                                                              address: '',
                                                                              city: '',
                                                                              state: '',
                                                                              zip: '',
                                                                            },
                                                                          ],
                                                                    };
                                                                  } else {
                                                                    const allSame = p.allLocationSame;
                                                                    const firstAddress = p.addresses?.[0];
                                                                    let arrayAddr = [];

                                                                    if (allSame && firstAddress) {
                                                                      arrayAddr = Array(count)
                                                                        .fill()
                                                                        .map((_, i) => ({
                                                                          ...firstAddress,
                                                                          id: i,
                                                                          req_loc_id: p.addresses[i]?.req_loc_id ?? null,
                                                                        }));
                                                                    } else {
                                                                      arrayAddr = [...p.addresses];
                                                                      if (arrayAddr.length < count) {
                                                                        arrayAddr.push(
                                                                          ...Array(count - arrayAddr.length)
                                                                            .fill()
                                                                            .map((_, i) => ({
                                                                              id: arrayAddr.length + i,
                                                                              address: '',
                                                                              city: '',
                                                                              state: '',
                                                                              zip: '',
                                                                            }))
                                                                        );
                                                                      } else if (arrayAddr.length > count) {
                                                                        arrayAddr = arrayAddr.slice(0, count);
                                                                      }
                                                                    }

                                                                    return {
                                                                      ...p,
                                                                      is_single_card: false,
                                                                      addresses: arrayAddr,
                                                                    };
                                                                  }
                                                                })
                                                              );
                                                            }}
                                                          />
                                                          {/* <LabelStyle>Single</LabelStyle> */}
                                                          <Typography variant="subtitle2">Single</Typography>
                                                        </Box>
                                                 </Box> :''
                                                }
                                                 </Stack>
                                              <Grid
                                                container
                                                spacing={3}
                                                sx={{
                                                  justifyContent: 'center',
                                                  width: '100%',
                                                }}
                                              >
                                                {data?.addresses?.map(
                                                  (addr, i) => (
                                                    <Grid item xs={12}>
                                                      {/* Side Heading */}
                                                      <Typography
                                                        variant="h5"
                                                        sx={{ mb: 2 }}
                                                      >
                                                        Location{' '}
                                                        {data?.fromMapServices ==
                                                        true
                                                          ? i + 1
                                                          : i + 1}
                                                      </Typography>

                                                      {/* Address Fields */}

                                                      <Stack
                                                        direction={{
                                                          xs: 'column',
                                                          sm: 'row',
                                                        }}
                                                        spacing={{
                                                          xs: 3,
                                                          sm: 2,
                                                        }}
                                                        sx={{ mb: 2 }}
                                                      >
                                                        <TextField
                                                          fullWidth
                                                          label="Address"
                                                          size="small"
                                                          value={
                                                            data.addresses[i]
                                                              .address || ''
                                                          }
                                                          disabled={
                                                            data?.fromMapServices ==
                                                              true &&
                                                            data.addresses[i]
                                                              .address
                                                              ? true
                                                              : 
                                                              i !== 0 &&
                                                              data?.allLocationSame
                                                              ? true
                                                              : false
                                                          }
                                                          // onChange={(event) => {
                                                          //   let arrayAddr = [...data.addresses,]
                                                          //   arrayAddr[i].address = event.target.value
                                                          //   setSelectedProducts(
                                                          //     (pv) => [
                                                          //       ...pv.map(
                                                          //         (p) => {
                                                          //           // if (p.id === data.id) {
                                                          //           if ( p.indexId === data.indexId ) {
                                                          //             if(p.allLocationSame == true){
                                                          //               return {
                                                          //                 ...p,
                                                          //                 addresses:
                                                          //                   arrayAddr,
                                                          //               }
                                                          //             }else{
                                                          //               return {
                                                          //                 ...p,
                                                          //                 addresses: arrayAddr,
                                                          //               }
                                                          //             }
                                                          //           } else {
                                                          //             return p
                                                          //           }
                                                          //         },
                                                          //       ),
                                                          //     ],
                                                          //   )
                                                          // }}
                                                          onChange={(event) => {
                                                            setSelectedProducts((prevProducts) =>
                                                              prevProducts.map((p) => {
                                                                if (p.indexId === data.indexId) {
                                                                  let updatedAddresses = [...p.addresses];
                                                                  if (p.allLocationSame) {
                                                                    updatedAddresses = updatedAddresses.map(() => ({
                                                                      ...updatedAddresses[0],
                                                                      address: event.target.value,
                                                                    }));
                                                                  } else {
                                                                    updatedAddresses[i] = {
                                                                      ...updatedAddresses[i],
                                                                      address: event.target.value,
                                                                    };
                                                                  }
                                                                  return {
                                                                    ...p,
                                                                    addresses: updatedAddresses,
                                                                  };
                                                                }
                                                                return p;
                                                              })
                                                            );
                                                          }}
                                                        />
                                                      </Stack>

                                                      {/* City, State, Zip Fields */}
                                                      <Stack
                                                        direction={{
                                                          xs: 'column',
                                                          sm: 'row',
                                                        }}
                                                        spacing={{
                                                          xs: 3,
                                                          sm: 2,
                                                        }}
                                                        sx={{ mb: 2 }}
                                                      >
                                                        <TextField
                                                          fullWidth
                                                          label="City"
                                                          size="small"
                                                          value={
                                                            data.addresses[i]
                                                              .city || ''
                                                          }
                                                          disabled={
                                                            data?.fromMapServices ==
                                                              true &&
                                                            data.addresses[i]
                                                              .city
                                                              ? true
                                                              : 
                                                              i !== 0 &&
                                                              data?.allLocationSame
                                                              ? true
                                                              : false
                                                          }
                                                          // onChange={(event) => {
                                                          //   let arrayAddr = [
                                                          //     ...data.addresses,
                                                          //   ]
                                                          //   arrayAddr[i].city =
                                                          //     event.target.value
                                                          //   setSelectedProducts(
                                                          //     (pv) => [
                                                          //       ...pv.map(
                                                          //         (p) => {
                                                          //           // if (p.id === data.id) {
                                                          //           if (
                                                          //             p.indexId ===
                                                          //             data.indexId
                                                          //           ) {
                                                          //             return {
                                                          //               ...p,
                                                          //               addresses:
                                                          //                 arrayAddr,
                                                          //             }
                                                          //           } else {
                                                          //             return p
                                                          //           }
                                                          //         },
                                                          //       ),
                                                          //     ],
                                                          //   )
                                                          // }}
                                                          onChange={(event) => {
                                                            setSelectedProducts((prevProducts) =>
                                                              prevProducts.map((p) => {
                                                                if (p.indexId === data.indexId) {
                                                                  let updatedAddresses = [...p.addresses];
                                                                  if (p.allLocationSame) {
                                                                    updatedAddresses = updatedAddresses.map(() => ({
                                                                      ...updatedAddresses[0],
                                                                      city: event.target.value,
                                                                    }));
                                                                  } else {
                                                                    updatedAddresses[i] = {
                                                                      ...updatedAddresses[i],
                                                                      city: event.target.value,
                                                                    };
                                                                  }
                                                                  return {
                                                                    ...p,
                                                                    addresses: updatedAddresses,
                                                                  };
                                                                }
                                                                return p;
                                                              })
                                                            );
                                                          }}
                                                        />
                                                        <TextField
                                                          fullWidth
                                                          label="State"
                                                          size="small"
                                                          value={
                                                            data.addresses[i]
                                                              .state || ''
                                                          }
                                                          disabled={
                                                            data?.fromMapServices ==
                                                              true &&
                                                            data.addresses[i]
                                                              .state
                                                              ? true
                                                              : 
                                                              i !== 0 &&
                                                              data?.allLocationSame
                                                              ? true
                                                              : false
                                                          }
                                                          // onChange={(event) => {
                                                          //   let arrayAddr = [
                                                          //     ...data.addresses,
                                                          //   ]
                                                          //   arrayAddr[i].state =
                                                          //     event.target.value
                                                          //   setSelectedProducts(
                                                          //     (pv) => [
                                                          //       ...pv.map(
                                                          //         (p) => {
                                                          //           // if (p.id === data.id) {
                                                          //           if (
                                                          //             p.indexId ===
                                                          //             data.indexId
                                                          //           ) {
                                                          //             return {
                                                          //               ...p,
                                                          //               addresses:
                                                          //                 arrayAddr,
                                                          //             }
                                                          //           } else {
                                                          //             return p
                                                          //           }
                                                          //         },
                                                          //       ),
                                                          //     ],
                                                          //   )
                                                          // }}
                                                          onChange={(event) => {
                                                            setSelectedProducts((prevProducts) =>
                                                              prevProducts.map((p) => {
                                                                if (p.indexId === data.indexId) {
                                                                  let updatedAddresses = [...p.addresses];
                                                                  if (p.allLocationSame) {
                                                                    updatedAddresses = updatedAddresses.map(() => ({
                                                                      ...updatedAddresses[0],
                                                                      state: event.target.value,
                                                                    }));
                                                                  } else {
                                                                    updatedAddresses[i] = {
                                                                      ...updatedAddresses[i],
                                                                      state: event.target.value,
                                                                    };
                                                                  }
                                                                  return {
                                                                    ...p,
                                                                    addresses: updatedAddresses,
                                                                  };
                                                                }
                                                                return p;
                                                              })
                                                            );
                                                          }}
                                                        />
                                                        <TextField
                                                          fullWidth
                                                          label="Zip / Postal Code"
                                                          size="small"
                                                          value={
                                                            data.addresses[i]
                                                              .zip || ''
                                                          }
                                                          disabled={
                                                            data?.fromMapServices ==
                                                              true &&
                                                            data.addresses[i]
                                                              .zip
                                                              ? true
                                                              : 
                                                              i !== 0 &&
                                                              data?.allLocationSame
                                                              ? true
                                                              : false
                                                          }
                                                          // onChange={(event) => {
                                                          //   let arrayAddr = [
                                                          //     ...data.addresses,
                                                          //   ]
                                                          //   arrayAddr[i].zip =
                                                          //     event.target.value
                                                          //   setSelectedProducts(
                                                          //     (pv) => [
                                                          //       ...pv.map(
                                                          //         (p) => {
                                                          //           if (
                                                          //             p.indexId ===
                                                          //             data.indexId
                                                          //           ) {
                                                          //             // if (p.id === data.id) {
                                                          //             return {
                                                          //               ...p,
                                                          //               addresses:
                                                          //                 arrayAddr,
                                                          //             }
                                                          //           } else {
                                                          //             return p
                                                          //           }
                                                          //         },
                                                          //       ),
                                                          //     ],
                                                          //   )
                                                          // }}
                                                          onChange={(event) => {
                                                            setSelectedProducts((prevProducts) =>
                                                              prevProducts.map((p) => {
                                                                if (p.indexId === data.indexId) {
                                                                  let updatedAddresses = [...p.addresses];
                                                                  if (p.allLocationSame) {
                                                                    updatedAddresses = updatedAddresses.map(() => ({
                                                                      ...updatedAddresses[0],
                                                                      zip: event.target.value,
                                                                    }));
                                                                  } else {
                                                                    updatedAddresses[i] = {
                                                                      ...updatedAddresses[i],
                                                                      zip: event.target.value,
                                                                    };
                                                                  }
                                                                  return {
                                                                    ...p,
                                                                    addresses: updatedAddresses,
                                                                  };
                                                                }
                                                                return p;
                                                              })
                                                            );
                                                          }}
                                                        />
                                                      </Stack>
                                                    </Grid>
                                                  ),
                                                )}
                                              </Grid>

                                              <Grid
                                                container
                                                justifyContent="center"
                                                alignItems="center"
                                              >
                                                <Grid item xs={12} md={4}>
                                                  {data?.fromMapServices ==
                                                  true ? (
                                                    ''
                                                  ) : 
                                                  // index !== 0 && data?.allLocationSame
                                                  false ? (
                                                    ''
                                                  ) : (
                                                    <Box
                                                      sx={{
                                                        mt: 3,
                                                        display: 'flex',
                                                        justifyContent:
                                                          'center',
                                                        gap: 1,
                                                      }}
                                                    >
                                                      <LoadingButton
                                                        variant="contained"
                                                        onClick={() => {
                                                          setIsSaving(true)
                                                          setTimeout(() => {
                                                            setIsSaving(false)
                                                            setLocationStates(
                                                              false,
                                                            )
                                                          }, 100)
                                                        }}
                                                        loading={isSaving}
                                                      >
                                                        {' Save '}
                                                      </LoadingButton>
                                                      {/* <Button variant="outlined" type="submit" onClick={() => { setLocationStates(false) }}>
                                      Cancel
                                    </Button> */}
                                                    </Box>
                                                  )}
                                                </Grid>
                                              </Grid>
                                            </Modal>
                                            <Modal
                                              open={
                                                openProductNote[data.indexId] ||
                                                false
                                              }
                                              handleClose={() =>
                                                handleCloseNote(data.indexId)
                                              }
                                            >
                                              <Grid
                                                container
                                                spacing={3}
                                                sx={{
                                                  justifyContent: 'center',
                                                  width: '100%',
                                                }}
                                              >
                                                <Grid item xs={12}>
                                                  <Typography
                                                    variant="h5"
                                                    sx={{ mb: 2 }}
                                                  >
                                                    Note
                                                  </Typography>

                                                  <Stack
                                                    direction={{
                                                      xs: 'column',
                                                      sm: 'row',
                                                    }}
                                                    spacing={{ xs: 3, sm: 2 }}
                                                    sx={{ mb: 2 }}
                                                  >
                                                    <TextField
                                                      fullWidth
                                                      multiline
                                                      rows={4}
                                                      size="medium"
                                                      value={currentNote}
                                                      onChange={
                                                        handleNoteChange
                                                      }
                                                      error={!currentNote.trim() && currentNote.length > 0}
                                                      inputProps={{
                                                        maxLength:
                                                          MAX_CHARACTERS,
                                                      }}
                                                      helperText={
                                                        !currentNote.trim() && currentNote.length > 0
                                                          ? 'Note cannot be empty or contain only spaces'
                                                          : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                      }
                                                      InputProps={{
                                                        sx: {
                                                          color: 'error.main',
                                                        }
                                                      }}
                                                    />
                                                  </Stack>
                                                </Grid>
                                              </Grid>

                                              <Grid
                                                container
                                                justifyContent="center"
                                                alignItems="center"
                                              >
                                                <Grid item xs={12} md={4}>
                                                  <Box
                                                    sx={{
                                                      mt: 3,
                                                      display: 'flex',
                                                      justifyContent: 'center',
                                                      gap: 1,
                                                    }}
                                                  >
                                                    <LoadingButton
                                                      variant="contained"
                                                      onClick={() =>
                                                        handleSaveNote(
                                                          data.indexId,
                                                        )
                                                      }
                                                      loading={isSavingNote}
                                                      disabled={!currentNote.trim()}
                                                    >
                                                      Save
                                                    </LoadingButton>
                                                    <LoadingButton
                                                      variant="outlined"
                                                      color="error"
                                                      onClick={() =>
                                                        handleClearNote(
                                                          data.indexId,
                                                        )
                                                      }
                                                      loading={isClearingNote}
                                                      disabled={!currentNote.trim()}
                                                    >
                                                      Clear
                                                    </LoadingButton>
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </Modal>
                                            <Modal
                                              open={
                                                openInstallNote[data.indexId] ||
                                                false
                                              }
                                              handleClose={() =>
                                                handleCloseInstallNote(data.indexId)
                                              }
                                            >
                                              <Grid
                                                container
                                                spacing={3}
                                                sx={{
                                                  justifyContent: 'center',
                                                  width: '100%',
                                                }}
                                              >
                                                <Grid item xs={12}>
                                                  <Typography
                                                    variant="h5"
                                                    sx={{ mb: 2 }}
                                                  >
                                                    Install Note
                                                  </Typography>

                                                  <Stack
                                                    direction={{
                                                      xs: 'column',
                                                      sm: 'row',
                                                    }}
                                                    spacing={{ xs: 3, sm: 2 }}
                                                    sx={{ mb: 2 }}
                                                  >
                                                    <TextField
                                                      fullWidth
                                                      multiline
                                                      rows={4}
                                                      size="medium"
                                                      value={currentNote}
                                                      onChange={
                                                        handleNoteChange
                                                      }
                                                      error={!currentNote.trim() && currentNote.length > 0}
                                                      inputProps={{
                                                        maxLength:
                                                          MAX_CHARACTERS,
                                                      }}
                                                      helperText={
                                                        !currentNote.trim() && currentNote.length > 0
                                                          ? 'Note cannot be empty or just spaces'
                                                          : error
                                                          ? error
                                                          : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                      }
                                                      InputProps={{
                                                        sx: {
                                                          color: 'error.main',
                                                        },
                                                      }}
                                                    />
                                                  </Stack>
                                                </Grid>
                                              </Grid>

                                              <Grid
                                                container
                                                justifyContent="center"
                                                alignItems="center"
                                              >
                                                <Grid item xs={12} md={4}>
                                                  <Box
                                                    sx={{
                                                      mt: 3,
                                                      display: 'flex',
                                                      justifyContent: 'center',
                                                      gap: 1,
                                                    }}
                                                  >
                                                    <LoadingButton
                                                      variant="contained"
                                                      onClick={() =>
                                                        handleSaveInstallNote(
                                                          data.indexId,
                                                        )
                                                      }
                                                      loading={isSavingNote}
                                                      disabled={!currentNote.trim()}
                                                    >
                                                      Save
                                                    </LoadingButton>
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </Modal>
                                            <Modal
                                              open={
                                                openProductAttachment[data.indexId] ||
                                                false
                                              }
                                              handleClose={() =>
                                                handleCloseAttachment(data.indexId)
                                              }
                                            >
                                              {renderAttachmentModalContent({
                                                itemKey: String(data.indexId),
                                                tabValue: attachmentTabValue[data.indexId],
                                                onTabChange: handleAttachmentTabChange,
                                                selectedImages:
                                                  selectedUploadedImages[String(data.indexId)] ||
                                                  selectedUploadedImages[data.indexId] ||
                                                  [],
                                                linkedAttachments:
                                                  productAttachments[String(data.indexId)] ||
                                                  productAttachments[data.indexId] ||
                                                  [],
                                                onImageSelect: handleImageSelect,
                                                onAddSelected: handleAddSelectedImages,
                                                onDrop: handleProductDrop,
                                                onRemove: handleProductRemove,
                                                isUploadingItem: isUploadingProduct[data.indexId] || false,
                                              })}
                                            </Modal>
                                            <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
                                              <Card
                                                sx={{
                                                  p: 3,
                                                  maxWidth: 768,
                                                  margin: 'auto',
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  justifyContent: 'center',
                                                  alignItems: 'center',
                                                }}
                                              >
                                                <div style={{width:'90%', display:'flex',justifyContent:'flex-end', marginBottom: '15px',marginLeft:'25px' }}>
                                                  <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={() => {
                                                      if (isClient || userType === 3) {
                                                        const newWindow = window.open('', '_blank');
                                                        newWindow.document.write(`
                                                          <html>
                                                            <head>
                                                              <title>PDF Viewer</title>
                                                              <style>
                                                                body { margin: 0; padding: 0; overflow: hidden; }
                                                                iframe { width: 100vw; height: 100vh; border: none; }
                                                              </style>
                                                            </head>
                                                            <body>
                                                              <iframe src="${selectedPDF}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
                                                            </body>
                                                          </html>
                                                        `);
                                                        newWindow.document.close();
                                                      } else {
                                                        window.open(selectedPDF, '_blank');
                                                      }
                                                    }}
                                                    disabled={!selectedPDF}
                                                    startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                                                    sx={{
                                                      fontSize:'14px'
                                                    }}
                                                  >
                                                    View PDF
                                                  </Button>
                                                </div>
                                                {pdfLoading && (
                                                  <Skeleton variant="rectangular" width="100%" height={500} />
                                                )}
                                                {(isClient || userType === 3) && useOfficeViewer ? (
                                                  <iframe
                                                    src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
                                                    title="Selected PDF"
                                                    width="100%"
                                                    height="500px"
                                                    frameBorder="0"
                                                    sandbox="allow-scripts allow-same-origin"
                                                    style={{ display: pdfLoading ? 'none' : 'block' }}
                                                    onLoad={() => setPdfLoading(false)}
                                                    onError={() => {
                                                      setUseOfficeViewer(false);
                                                      setPdfLoading(false);
                                                    }}
                                                  />
                                                ) : (
                                                  <iframe
                                                    src={selectedPDF}
                                                    title="Selected PDF"
                                                    width="100%"
                                                    height="500px"
                                                    frameBorder="0"
                                                    style={{ display: pdfLoading ? 'none' : 'block' }}
                                                    onLoad={() => setPdfLoading(false)}
                                                  />
                                                )}
                                              </Card>
                                            </DialogAnimate>
                                          </>
                                            )}
                                          </Draggable>
                                        )
                                      })}
                                    {droppableProvided.placeholder}
                                    </TableBody>
                                        )}
                                      </Droppable>
                                    </DragDropContext>
                                  </Table>
                                </TableContainer>
                              </Scrollbar>
                              {/* {
                            showAddNewRow ?
                              <Stack sx={{ justifyContent: 'space-between', alignItems: 'center', display:'flex', flexDirection:'row' }}>
                                <Button
                                  variant="outlined"
                                  startIcon={
                                    <Stack>
                                      {' '}
                                      <Add />{' '}
                                    </Stack>
                                  }
                                  onClick={() => {
                                    addNewProductRow()
                                    // setMarkupType(1)
                                  }}
                                >
                                  Add Product Row
                                </Button>
                                <Typography variant="h6">
                                  Total Additional Product Cost:{' '}
                                  {selectedProductsAdditionalCost}
                                </Typography>
                              </Stack>
                              :""} */}
                            </>
                          )}
                        </>
                      )}
                      <Divider />

                      <Stack direction="row">
                        <LabelStyleHead>Services</LabelStyleHead>
                        {/* {showServices ? <Remove sx={{color:theme.palette.primary.main}} onClick={(e)=>{setShowServices(false)}} /> : <Add sx={{color:theme.palette.primary.main}} onClick={(e)=>{setShowServices(true)}} />} */}
                      </Stack>
                      {/* {showServices && <> */}
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                        alignItems={'center'}
                      >
                        {isSplitOrder && (values?.facility_type || []).filter(Boolean).length > 1 ? (
                          <Stack sx={{ width: { xs: '100%', sm: '60%' } }} spacing={2}>
                            {(values?.facility_type || []).filter(Boolean).map((facility) => (
                              <Autocomplete
                                key={`service-autocomplete-${facility?.id}`}
                                sx={{ width: '100%' }}
                                multiple
                                id={`combo-box-demo-service-${facility?.id}`}
                                options={getSplitFacilityServiceOptions(facility)}
                                value={values.services?.filter((item) => (!item.isAdditionalProduct && Number(item?.facility_id) === Number(facility?.id))) || null}
                                onChange={(event, newValue) => {
                                  setAdditionalSelectedServices((prevServices) => {
                                    const {
                                      address: projAddress = '',
                                      city: projCity = '',
                                      state: projState = '',
                                      zip: projZip = '',
                                    } = values?.community || {}
                                    const communityAddress = {
                                      address: projAddress,
                                      city: projCity,
                                      state: projState,
                                      zip: projZip,
                                    }
                                    const additionals = prevServices?.filter(item => item.isAdditionalProduct === true)
                                    const regularSelectedServices = prevServices?.filter((item) => !item.isAdditionalProduct) || [];
                                    const otherFacilities = regularSelectedServices?.filter((s) => Number(s?.facility_id) !== Number(facility?.id)) || [];
                                    const updatedServices = newValue?.map((service) => {
                                      const existingService = prevServices.find(
                                        (p) => p?.id === service?.id && p?.indexId === service?.indexId,
                                      )
                                      if (existingService) {
                                        let addresses = [...existingService.addresses]
                                        if (addresses.length < 1) {
                                          addresses.push({
                                            id: 0,
                                            address: '',
                                            city: '',
                                            state: '',
                                            zip: '',
                                          })
                                        }
                                        return {
                                          ...existingService,
                                          addresses,
                                        }
                                      } else {
                                        const hasCommunityAddress = projAddress && projCity && projState && projZip
                                        let assignedService
                                        if (hasCommunityAddress) {
                                          assignedService = assignAddresses(
                                            prevServices,
                                            service,
                                            allServiceLocationSame,
                                            communityAddress,
                                          )
                                        } else {
                                          assignedService = {
                                            ...service,
                                            addresses: [{
                                              id: 0,
                                              address: '',
                                              city: '',
                                              state: '',
                                              zip: '',
                                            }],
                                          }
                                          if (allServiceLocationSame && prevServices.length > 0) {
                                            const commonAddress = {...prevServices[0].addresses[0]}
                                            assignedService.addresses[0] = commonAddress
                                          }
                                        }
                                        const newIndexCounter = serviceIndexCounter + 1
                                        setServiceIndexCounter(newIndexCounter)

                                        // Auto-apply existing delivery/installer settings for this facility
                                        const existingDeliverySettings = getExistingDeliverySettingsForFacility(facility?.id);

                                        return {
                                          ...assignedService,
                                          indexId: newIndexCounter,
                                          ...(existingDeliverySettings && { delivery_installation: existingDeliverySettings })
                                        }
                                      }
                                    }) || []
                                    const finalServices = [...otherFacilities, ...updatedServices, ...additionals];
                                    setFieldValue('services', finalServices)
                                    return finalServices
                                  })
                                  setShowAddNewRow(true)
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    required
                                    error={Boolean(touched.services && errors.services)}
                                    helperText={touched.services && errors.services}
                                    label={`${values.project_categories?.name == 'Time & Material' || values.project_categories?.name == 'Service only' ? 'Select services' : 'Select additional services'} - ${facility?.label || ''}`}
                                  />
                                )}
                                getOptionLabel={(option) =>
                                  option?.name
                                    ? `${option.name} (${getLabourCostServiceTabLabel(option.inhouse)})`
                                    : ''
                                }
                                renderOption={(props, option) => {
                                  const { style, ...liProps } = props;
                                  const suffix = getLabourCostServiceTabLabel(option.inhouse);
                                  const label = `${option.name} (${suffix})`;
                                  return (
                                    <li
                                      {...liProps}
                                      style={{
                                        ...style,
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                       <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                            {option?.syncWithQuickbooks === 1 && (
                                              <img
                                                src={quickbookLogo}
                                                width="40px"
                                                height="20px"
                                                // style={{ marginRight: 8 }}
                                                alt="QuickBooks"
                                              />
                                            )}
                                        </div>
                                      <Tooltip title={label}>
                                        <span
                                          style={{
                                            flex: 1,
                                            minWidth: 0,
                                            display: 'block',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            color: theme.palette[
                                              FacilityTypes.find(
                                                (f) => f.id === option?.facility_id,
                                              )?.color || 'primary'
                                            ]?.main,
                                          }}
                                        >
                                          {label}
                                        </span>
                                      </Tooltip>
                                    </li>
                                  );
                                }}
                                renderTags={(value, getTagProps) =>
                                  value.map((option, index) => {
                                    const suffix = getLabourCostServiceTabLabel(option.inhouse);
                                    const label = `${option.name} (${suffix})`;
                                    return (
                                      <Tooltip key={index} title={label}>
                                        <Chip
                                          sx={{
                                            color: theme.palette[
                                              FacilityTypes.find(
                                                (f) => f.id === option?.facility_id,
                                              )?.color || 'primary'
                                            ]?.main,
                                          }}
                                          {...getTagProps({ index })}
                                          label={label}
                                        />
                                      </Tooltip>
                                    );
                                  })
                                }
                                filterOptions={(options, state) => {
                                  const searchText = state.inputValue.toLowerCase();
                                  return options.filter(
                                    (option) =>
                                      option.name.toLowerCase().includes(searchText) ||
                                      (option.description && option.description.toLowerCase().includes(searchText)) // Include description in search
                                  );
                                }}
                              />
                            ))}
                          </Stack>
                        ) : (
                          <Autocomplete
                            sx={{ width: 400 }}
                            multiple
                            id="combo-box-demo"
                            options={filteredServiceOptions}
                            value={values.services?.filter(item=>!item.isAdditionalProduct) || null}
                            onChange={(event, newValue) => {
                              setAdditionalSelectedServices((prevServices) => {
                                const {
                                  address: projAddress = '',
                                  city: projCity = '',
                                  state: projState = '',
                                  zip: projZip = '',
                                } = values?.community || {}
                                const communityAddress = {
                                  address: projAddress,
                                  city: projCity,
                                  state: projState,
                                  zip: projZip,
                                }
                                const additionals = prevServices?.filter(item => item.isAdditionalProduct === true)
                                const updatedServices = newValue?.map((service) => {
                                  const existingService = prevServices.find(
                                    (p) => p?.id === service?.id && p?.indexId === service?.indexId,
                                  )
                                  if (existingService) {
                                    let addresses = [...existingService.addresses]
                                    if (addresses.length < 1) {
                                      addresses.push({
                                        id: 0,
                                        address: '',
                                        city: '',
                                        state: '',
                                        zip: '',
                                      })
                                    }
                                    return {
                                      ...existingService,
                                      addresses,
                                    }
                                  } else {
                                    const hasCommunityAddress = projAddress && projCity && projState && projZip
                                    let assignedService
                                    if (hasCommunityAddress) {
                                      assignedService = assignAddresses(
                                        prevServices,
                                        service,
                                        allServiceLocationSame,
                                        communityAddress,
                                      )
                                    } else {
                                      assignedService = {
                                        ...service,
                                        addresses: [{
                                          id: 0,
                                          address: '',
                                          city: '',
                                          state: '',
                                          zip: '',
                                        }],
                                      }
                                      if (allServiceLocationSame && prevServices.length > 0) {
                                        const commonAddress = {...prevServices[0].addresses[0]}
                                        assignedService.addresses[0] = commonAddress
                                      }
                                    }
                                    const newIndexCounter = serviceIndexCounter + 1
                                    setServiceIndexCounter(newIndexCounter)

                                    // Auto-apply existing delivery/installer settings for this facility
                                    const existingDeliverySettings = getExistingDeliverySettingsForFacility(service.facility_id);

                                    return {
                                      ...assignedService,
                                      indexId: newIndexCounter,
                                      ...(existingDeliverySettings && { delivery_installation: {... existingDeliverySettings,delivery_type_id: 1 } }),
                                      ...(!existingDeliverySettings && { delivery_installation: {delivery_type_id: 1, installer_facility_id: Number(currentFacilityId) } })
                                    }
                                  }
                                }) || []
                                const finalServices = [...updatedServices, ...additionals];
                                setFieldValue('services', finalServices)
                                return finalServices
                              })
                              setShowAddNewRow(true)
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                error={Boolean(
                                  touched.services && errors.services,
                                )}
                                helperText={touched.services && errors.services}
                                label={
                                  values.project_categories?.name ==
                                    'Time & Material' ||
                                  values.project_categories?.name ==
                                    'Service only'
                                    ? 'Select services'
                                    : 'Select additional services'
                                }
                              />
                            )}
                            getOptionLabel={(option) =>
                              option?.name
                                ? `${option.name} (${getLabourCostServiceTabLabel(option.inhouse)})`
                                : ''
                            }
                            renderOption={(props, option) => {
                              const { style, ...liProps } = props;
                              const suffix = getLabourCostServiceTabLabel(option.inhouse);
                              const label = `${option.name} (${suffix})`;

                            return (
                              <li
                                {...liProps}
                              style={{
                                    ...style,
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                   <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                      {option?.syncWithQuickbooks === 1 && (
                                        <img
                                          src={quickbookLogo}
                                          width="40px"
                                          height="20px"
                                          // style={{ marginRight: 8 }}
                                          alt="QuickBooks"
                                        />
                                      )}
                                    </div>
                                  <Tooltip title={label}>
                                    <span
                                      style={{
                                        flex: 1,
                                        minWidth: 0,
                                        display: 'block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        color: isSplitOrder
                                          ? theme.palette[
                                              FacilityTypes.find(
                                                (f) => f.id === option?.facility_id,
                                              )?.color || 'primary'
                                            ]?.main
                                          : 'inherit',
                                      }}
                                    >
                                      {label}
                                    </span>
                                  </Tooltip>
                                </li>
                              );
                            }}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => {
                                const suffix = getLabourCostServiceTabLabel(option.inhouse);
                                const label = `${option.name} (${suffix})`;
                                return (
                                  <Tooltip key={index} title={label}>
                                    <Chip
                                      sx={{
                                        color: isSplitOrder
                                          ? theme.palette[
                                              FacilityTypes.find(
                                                (f) => f.id === option?.facility_id,
                                              )?.color || 'primary'
                                            ]?.main
                                          : 'inherit',
                                      }}
                                      {...getTagProps({ index })}
                                      label={label}
                                    />
                                  </Tooltip>
                                );
                            })                     
                          }
                          filterOptions={(options, state) => {
                            const searchText = state.inputValue.toLowerCase();
                            return options.filter(
                              (option) =>
                                option.name.toLowerCase().includes(searchText) ||
                                (option.description && option.description.toLowerCase().includes(searchText)) // Include description in search
                            );
                          }}
                       />
                        )}
                      </Stack>
                      <LabelStyle>Selected services</LabelStyle>
                      <Scrollbar>
                        <TableContainer sx={{ minWidth: 500 }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell padding="checkbox" sx={{ width: 40 }} />
                                {/* {VALUE_SERVICES?.map((val) =>
                                  // ((values.project_categories?.name == 'Time & Material') && val.id === 6) ? <TableCell></TableCell> :
                                  (values.project_categories?.name ==
                                    'Service only' 
                                    // ||
                                    // values.project_categories?.name ==
                                    //   'Time & Material'
                                    ) &&
                                  val.id ===
                                    0 ? //  || ((values.project_categories?.name !== 'Service only') && val.id === 6)
                                  null : (
                                    <TableCell>{val.value}</TableCell>
                                  ),
                                )} */}
                                 {VALUE_SERVICES?.map((val) => {
                                  if (val.id === 4 && isSplitOrder) {
                                    return (
                                      <>
                                        <TableCell key={`${val.id}-cost`}>{val.value}</TableCell>
                                        <TableCell key={`${val.id}-incoming`}>Incoming Percentage</TableCell>
                                      </>
                                    );
                                  }
                                  if (val.id === 18) {
                                    return isSplitOrder ? (
                                      <TableCell key={val.id}>
                                        {val.value}
                                      </TableCell>
                                    ) : null;
                                  }
                                  return (
                                    <TableCell key={val.id}>
                                      {val.value}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            </TableHead>
                            <DragDropContext onDragEnd={handleServiceTableDragEnd}>
                              <Droppable droppableId="official-request-add-service-rows">
                                {(droppableProvided) => (
                            <TableBody
                              ref={droppableProvided.innerRef}
                              {...droppableProvided.droppableProps}
                            >
                              {/* {selectedServices?.map((data, index) => {
                                console.log('-------------------------', data)
                                const quantityFieldName = `service_quantity_${index}`
                                // if (
                                //   values.project_categories?.name ==
                                //   'Time & Material'
                                // ) {
                                //   data['total_cost'] = 0
                                //   data['unit_cost'] = 0
                                //   data['cost'] = 0
                                //   data['quantity'] = 0
                                // }
                                const total = data.total_cost * data.quantity
                                let markup = 0
                                if (total > 0) {
                                  markup = data.total_cost / total
                                }
                                let originalMarkup = data.originalMarkup || 0
                                data['markup'] = markup?.toFixed(2)
                                totalServiceMarkup += markup
                                originaltotalServiceMarkup += originalMarkup
                                console.log('#############Total', total)
                                data['total'] = total?.toFixed(2)
                                data['totalServiceMarkup'] =
                                  totalServiceMarkup?.toFixed(2)
                                values['totalServiceMarkup'] =
                                  totalServiceMarkup?.toFixed(2)
                                const previousQty =
                                  data.previousQty *
                                    (data.qtyData || 1) *
                                    data.locationQuantity || 0
                                const newQty = (
                                  data.previousQty *
                                  (data.qtyData || 1) *
                                  data.locationQuantity
                                )?.toFixed(2)
                                let quantityDifference = 0
                                if (
                                  values.project_categories?.name ==
                                  'Time & Material'
                                ) {
                                  // quantityDifference = 0
                                  quantityDifference =
                                    Number(data.quantity) - newQty
                                } else {
                                  quantityDifference =
                                    Number(data.quantity) - newQty
                                }
                                data['quantityDifference'] = quantityDifference
                                data['jobcost_unit_cost'] =
                                  data.cost?.toFixed(2)
                                data['jobcost_quantity'] = quantityDifference
                                data['jobcost_total_cost'] = (
                                  data.cost * Number(data.quantity)?.toFixed(2)
                                )?.toFixed(2)

                                let newTotalCost = (
                                  data.unit_cost * quantityDifference
                                )?.toFixed(2)
                                let newTotalProductFormula = (
                                  data.cost * quantityDifference
                                )?.toFixed(2)
                                totalProductFormula += Number(
                                  newTotalProductFormula,
                                )
                                totalWholesalePrice += Number(newTotalCost)
                                totalRetailPrice += Number(newTotalCost)
                                values['totalProductFormula'] =
                                  totalProductFormula
                                values['totalWholesalePrice'] =
                                  totalWholesalePrice
                                values['totalRetailPrice'] = totalRetailPrice

                                return (
                                  <>
                                    <TableRow key={index}>
                                      <TableCell>
                                        #{data.productIndex}
                                      </TableCell>
                                      <TableCell>{data.name}</TableCell>
                                      <TableCell>
                                        {originalMarkup?.toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                        {data.cost?.toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                        {data.total_cost?.toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                        <TextField
                                          type="number"
                                          // sx={{ width: 400 }}
                                          label={'Hours'}
                                          {...getFieldProps(quantityFieldName)}
                                          disabled={
                                            data?.fromMapServices
                                              ? true
                                              : values.project_categories
                                                  ?.name == 'Time & Material'
                                              ? true
                                              : false
                                          }
                                          value={
                                            values.project_categories?.name ==
                                            'Time & Material'
                                              ? 0
                                              : Number(data.quantity)?.toFixed(
                                                  2,
                                                ) || 1
                                          }
                                          defaultValue={
                                            values.project_categories?.name ==
                                            'Time & Material'
                                              ? 0
                                              : 1
                                          }
                                          // value={Number(data.quantity)?.toFixed(2)}
                                          // defaultValue={1}
                                          onChange={(event) => {
                                            let newValue = event.target.value
                                            // if (newValue <= 0) {
                                            //   event.preventDefault();
                                            //   return;
                                            // }
                                            if (newValue.startsWith('-')) {
                                              newValue = newValue.slice(1)
                                            }
                                            if (newValue < previousQty) {
                                              setShowWarning((prev) => {
                                                const newWarnings = [...prev]
                                                newWarnings[index] = true
                                                return newWarnings
                                              })
                                              data['quantity'] = previousQty
                                            } else {
                                              setShowWarning((prev) => {
                                                const newWarnings = [...prev]
                                                newWarnings[index] = false
                                                return newWarnings
                                              })
                                              data['quantity'] = newValue || 1
                                            }
                                            setFieldValue(
                                              quantityFieldName,
                                              newValue,
                                            )
                                          }}
                                          inputProps={{ min: previousQty }}
                                          error={Boolean(
                                            touched[quantityFieldName] &&
                                              errors[quantityFieldName],
                                          )}
                                          helperText={
                                            touched[quantityFieldName] &&
                                            errors[quantityFieldName]
                                          }
                                        />
                                        <TextField
                                          type="number"
                                          // sx={{ width: 400 }}
                                          sx={{ minWidth: '80px' }}
                                          label={'Hours'}
                                          {...getFieldProps(quantityFieldName)}
                                          // disabled={
                                          //   data?.fromMapServices
                                          //     ? true
                                          //     : 
                                          //     values.project_categories
                                          //         ?.name == 'Time & Material'
                                          //     ? true
                                          //     : false
                                          // }
                                          disabled
                                          value={
                                            Number(data.quantity)?.toFixed(
                                                  2,
                                                ) || 1
                                          }
                                          defaultValue={
                                             1
                                          }
                                          // value={Number(data.quantity)?.toFixed(2)}
                                          // defaultValue={1}
                                          onChange={(event) => {
                                            let newValue = event.target.value
                                            // if (newValue <= 0) {
                                            //   event.preventDefault();
                                            //   return;
                                            // }
                                            if (newValue.startsWith('-')) {
                                              newValue = newValue.slice(1)
                                            }
                                            if (newValue < previousQty) {
                                              setShowWarning((prev) => {
                                                const newWarnings = [...prev]
                                                newWarnings[index] = true
                                                return newWarnings
                                              })
                                              data['quantity'] = previousQty
                                            } else {
                                              setShowWarning((prev) => {
                                                const newWarnings = [...prev]
                                                newWarnings[index] = false
                                                return newWarnings
                                              })
                                              data['quantity'] = newValue || 1
                                            }
                                            setFieldValue(
                                              quantityFieldName,
                                              newValue,
                                            )
                                          }}
                                          inputProps={{ min: previousQty }}
                                          error={Boolean(
                                            touched[quantityFieldName] &&
                                              errors[quantityFieldName],
                                          )}
                                          helperText={
                                            touched[quantityFieldName] &&
                                            errors[quantityFieldName]
                                          }
                                        />
                                        {showWarning[index] && (
                                          <Typography
                                            color="error"
                                            variant="body2"
                                          >
                                            Cannot reduce the added hours in the
                                            product formula. If you need to
                                            reduce, change it in the product
                                            formula.
                                          </Typography>
                                        )}
                                      </TableCell>
                                      <TableCell>N/A</TableCell>
                                      <TableCell>
                                        {(
                                          data.cost *
                                          quantityDifference?.toFixed(2)
                                        )?.toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                        {(
                                          data.unit_cost *
                                          quantityDifference?.toFixed(2)
                                        )?.toFixed(2)}
                                      </TableCell>
                                      <TableCell>{total?.toFixed(2)}</TableCell>
                                      <TableCell align='right'>
                          <IconButton onClick={() => handleDeleteService(data.id)}>
                            <Delete />
                          </IconButton>
                        </TableCell>
                                    </TableRow>
                                  </>
                                )
                              })} */}
                              {[...(additionalSelectedServices || [])]
                                .sort(
                                  (a, b) =>
                                    (Number(a?.newIndexId ?? a?.indexId ?? a?.product_index) || 0) -
                                    (Number(b?.newIndexId ?? b?.indexId ?? b?.product_index) || 0),
                                )
                                .map(
                                (data, index) => {
                                  console.log(
                                    '############additional services',
                                    data,
                                  )
                                  const serviceLineKey = getServiceLineKey(data)

                                  const quantityFieldName = `service_quantity_${index}`
                                  const dataQuantity = data?.quantity
                                    ? data?.quantity
                                    : 1
                                  data['quantity'] = dataQuantity
                                  if (Number(data?.id) === 10 &&
                                    values.project_categories?.name ==
                                    'Time & Material'
                                  ) {
                                    // data['total_cost'] = 0
                                    // data['cost'] = 0
                                    data['quantity'] = 0
                                  }
                                  
                                  // Declare variables outside if-else block
                                  let total, originalMarkup
                                  
                                  // Check if service is from other facility
                                  const isOtherFacilityService = data?.facility_id && Number(data.facility_id) !== Number(currentFacilityId);

                                  if (!isOtherFacilityService) {
                                    if (data.original_total_cost == null) data.original_total_cost = data.total_cost
                                    if (data.original_service_markup == null) data.original_service_markup = data.originalMarkup
                                  }
                                  
                                  // For other facility services: set originalMarkup to 0 and calculate total_cost with split percentage
                                  let costWithOutgoing = data.cost; // Default to original cost
                                  
                                  if (isOtherFacilityService) {
                                    originalMarkup = 0
                                    data['originalMarkup'] = 0
                                    
                                    // Get outgoing percentage from split settings
                                    const splitSetting = selectedSplitOrderSettings?.find(setting => setting?.id == data?.facility_id);
                                    let outgoingPercentage = splitSetting?.split_percentage || 0;
                                    
                                    // Calculate cost with outgoing percentage: cost + (cost * outgoingPercentage / 100)
                                    let amountWithOutgoingPercentage = data.cost * (outgoingPercentage / 100)
                                    costWithOutgoing = data.cost + amountWithOutgoingPercentage
                                    
                                    // Calculate total_cost: add incoming percentage to cost with outgoing
                                    const incomingPercentage = incomingSplitMarkup || 0
                                    let amountWithIncomingPercentage = costWithOutgoing * (incomingPercentage / 100)
                                    data['total_cost'] = Number((costWithOutgoing + amountWithIncomingPercentage).toFixed(2))
                                    data['incoming_split_percentage'] = incomingPercentage
                                    data['split_percentage'] = outgoingPercentage
                                    data['outgoing_split_percentage'] = outgoingPercentage
                                    // Store calculated cost for display (don't mutate original cost)
                                    data['costWithOutgoing'] = Number(costWithOutgoing.toFixed(2))
                                  }
                                  
                                  // Check if nocharge is enabled
                                  if (isNoChargeJob && !isOtherFacilityService) {
                                    // Nocharge case: markup = 0, original markup = 0, total = cost * quantity
                                    total = data.cost * data?.quantity
                                    data['markup'] = 0
                                    totalServiceMarkup += 0
                                    originalMarkup = 0
                                    originaltotalServiceMarkup += 0
                                    data['total'] = total?.toFixed(2)
                                    data['total_cost'] = data.cost
                                    data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    data['originalMarkup'] = 0
                                    values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                  } else {
                                    // Normal case: existing logic
                                    if (!isOtherFacilityService) {
                                      data['total_cost'] = data.original_total_cost
                                      data['originalMarkup'] = data.original_service_markup
                                    }
                                    total = data.total_cost * data?.quantity
                                    let markup = 0
                                    if (total > 0) {
                                      markup = data.total_cost / Number(total)
                                      data['markup'] = markup?.toFixed(2)
                                    } else {
                                      markup = 0
                                      data['markup'] = 0
                                    }
                                    totalServiceMarkup += markup

                                    if (!isOtherFacilityService) {
                                      originalMarkup = data.originalMarkup || 0
                                      originaltotalServiceMarkup += originalMarkup
                                    }
                                    data['total'] = total?.toFixed(2)
                                    data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                  }
                                  const quantityDifference = Number(
                                    data.quantity,
                                  )
                                  data['quantityDifference'] =
                                    quantityDifference
                                  data['jobcost_unit_cost'] = data.cost
                                  data['jobcost_quantity'] = quantityDifference
                                  data['jobcost_total_cost'] = (
                                    data.cost * Number(data.quantity) || 1
                                  )?.toFixed(2)

                                  let newTotalCost = total?.toFixed(2)
                                  let newTotalProductFormula = (
                                    data.cost * quantityDifference
                                  )?.toFixed(2)
                                  totalProductFormula += Number(
                                    newTotalProductFormula,
                                  )
                                  totalWholesalePrice += Number(newTotalCost)
                                  totalRetailPrice += Number(newTotalCost)
                                  values['totalProductFormula'] =
                                    totalProductFormula
                                  values['totalWholesalePrice'] =
                                    totalWholesalePrice
                                  values['totalRetailPrice'] = totalRetailPrice

                                  return (
                                    <Draggable
                                      key={`service-${serviceLineKey}`}
                                      draggableId={`service-${serviceLineKey}`}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                    <>
                                      <TableRow
                                        key={index}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        onDragOver={(e) => handleServiceIconDragOver(e, data.indexId)}
                                        onDragLeave={(e) => handleServiceIconDragLeave(e, data.indexId)}
                                        onDrop={(e) => handleServiceIconDrop(e, data.indexId)}
                                        sx={{
                                          ...(serviceAttachmentDragOver[data.indexId] && {
                                            backgroundColor: 'action.hover',
                                            outline: `2px dashed ${theme.palette.primary.main}`,
                                            outlineOffset: -2,
                                          }),
                                        }}
                                        style={{
                                          ...provided.draggableProps.style,
                                          ...(snapshot.isDragging
                                            ? { backgroundColor: theme.palette.action.hover }
                                            : {}),
                                        }}
                                      >
                                        <TableCell
                                          padding="checkbox"
                                          {...provided.dragHandleProps}
                                          sx={{ width: 40, cursor: 'grab' }}
                                        >
                                          <DragIndicator fontSize="small" color="action" />
                                        </TableCell>
                                        {values.project_categories?.name !=
                                          'Service only old' ? (
                                          null
                                        ) : null}
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                        <TableCell>
                                          {data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="text"
                                              label={'Service Name'}
                                              sx={{ width: 85 }}
                                              value={data.name}
                                              onChange={(event) => {
                                                let newValue = event.target.value

                                                // Update the selectedProducts state
                                                setAdditionalSelectedServices(
                                                  (prevProducts) =>
                                                    prevProducts.map((service) => {
                                                        if ( service.newIndexId === data.newIndexId ) {
                                                          return {
                                                            ...service,
                                                            name: newValue,
                                                          }
                                                        } else {
                                                          return service
                                                        }
                                                      },
                                                    ),
                                                )
                                                data['name'] = newValue || ''
                                                if (isSubmitted)
                                                  setIsSubmitted(false)
                                              }}
                                              error={
                                                isSubmitted && data?.name?.trim() === ''
                                              }
                                              helperText={
                                                isSubmitted && data?.name?.trim() === '' ? 'Service Name is required' : ''
                                              }
                                            />
                                          : 
                                          // data.name
                                         <Box>
                                          <Typography sx={{color:"inherit"}}>{data.name}</Typography>

                                          { data.service_notes? <Typography sx={{color:isSplitOrder ?theme.palette[
                                            FacilityTypes.find(f => f.id === data?.facility_id)?.color || 'primary'
                                          ]?.main
                                        : (data.service_notes ? theme.palette.error.main : 'inherit'), whiteSpace: 'pre-wrap' }}> Note:{" "}{ data.service_notes && data.service_notes !== '' ? data.service_notes : ""}</Typography>:""}
                                         </Box>
                                        
                                        }
                                        </TableCell>
                                        <TableCell>
                                          <IconButton onClick={() => handleOpenServiceNote(data.indexId, data.service_notes)}>
                                            <NoteAdd
                                              sx={{
                                                color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                              }}
                                            />
                                          </IconButton>
                                        </TableCell>
                                        <TableCell>
                                          <Tooltip title="Drop files on row or click to open attachments">
                                            <IconButton onClick={() => handleOpenServiceAttachment(data.indexId)}>
                                              {isUploadingService[data.indexId] ? (
                                                <CircularProgress size={28} />
                                              ) : (
                                                <UploadFile
                                                  sx={{
                                                    fontSize: 28,
                                                    color:
                                                      !serviceAttachments[data.indexId] ||
                                                      serviceAttachments[data.indexId]?.length === 0
                                                        ? 'error.main'
                                                        : theme.palette.primary.main,
                                                  }}
                                                />
                                              )}
                                            </IconButton>
                                          </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                        {
                                        // data?.isAdditionalProduct ?
                                        //   <TextField
                                        //     required
                                        //     fullWidth
                                        //     type="number"
                                        //     label={'Markup'}
                                        //     disabled={values.project_categories?.name == 'Time & Material' ? true : false}
                                        //     sx={{ width: 85 }}
                                        //     value={data.originalMarkup}
                                        //     defaultValue={0}
                                        //     onChange={(event) => {
                                        //       let newValue = event.target.value
                                        //       if (newValue !== '') {
                                        //         setAdditionalSelectedServices((pv) => [
                                        //             ...pv.map((p) => {
                                        //               if ( p.newIndexId === data.newIndexId ) {
                                        //                 return {
                                        //                   ...p,
                                        //                   originalMarkup: newValue,
                                        //                 }
                                        //               } else {
                                        //                 return p
                                        //               }
                                        //             }),
                                        //           ],
                                        //         )
                                        //         data['originalMarkup'] =  newValue || 0
                                        //         originalMarkup = newValue || 0
                                        //         data['total_cost'] = newValue * data.cost
                                        //       }
                                        //     }}
                                        //     // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                        //     // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        //   />
                                        // : 
                                        isNoChargeJob ? '-' : (isOtherFacilityService ? '-' : originalMarkup?.toFixed(2))}
                                        </TableCell>
                                        <TableCell>
                                        {
                                        // data?.isAdditionalProduct ?
                                        //   <TextField
                                        //     required
                                        //     fullWidth
                                        //     type="number"
                                        //     label={'Cost'}
                                        //     disabled={values.project_categories?.name == 'Time & Material' ? true : false}
                                        //     sx={{ width: 85 }}
                                        //     value={data.cost}
                                        //     defaultValue={0}
                                        //     onChange={(event) => {
                                        //       let newValue = event.target.value
                                        //       if (newValue !== '') {
                                        //         setAdditionalSelectedServices((pv) => [
                                        //             ...pv.map((p) => {
                                        //               if ( p.newIndexId === data.newIndexId ) {
                                        //                 return {
                                        //                   ...p,
                                        //                   cost: newValue,
                                        //                 }
                                        //               } else {
                                        //                 return p
                                        //               }
                                        //             }),
                                        //           ],
                                        //         )
                                        //         data['cost'] =  newValue || 0
                                        //         data['total_cost'] = newValue * data.originalMarkup
                                        //       }
                                        //     }}
                                        //     // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                        //     // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                        //   />
                                        // : 
                                        isOtherFacilityService ? (data?.costWithOutgoing || data.cost) : data.cost}</TableCell>
                                        {isSplitOrder && (
                                          <TableCell>
                                            { data?.facility_id !== currentFacilityId ?
                                            `${data?.incoming_split_percentage} %`|| incomingSplitMarkup || 0 
                                            : '-'
                                            }
                                          </TableCell>
                                        )}
                                        <Tooltip 
                                            title={
                                            (isSplitOrder && 
                                              data.facility_id != currentFacilityId) 
                                              ? `Cost + (Cost * incoming split markup (${data?.incoming_split_percentage }) / 100)`
                                              : ""
                                          }
                                          >
                                        <TableCell>{
                                          data?.isAdditionalProduct ?
                                          <TextField
                                            required
                                            fullWidth
                                            type="number"
                                            label={'Hourly Cost'}
                                            // disabled={values.project_categories?.name == 'Time & Material' ? true : false}
                                            sx={{ width: 85 }}
                                            value={data.total_cost}
                                            // onWheel={(e) => e.target.blur()}
                                            onKeyPress={(event) => {
                                              // if (event.key === '0' && event.target.value === '') {
                                              //   event.preventDefault();
                                              // }
                                              if (event.key === '-') {
                                                event.preventDefault();
                                              }
                                              if (event.key === 'e') {
                                                event.preventDefault();
                                              }
                                            }}
                                            inputProps={{ min: 0 }}
                                            defaultValue={0}
                                            onChange={(event) => {
                                              let newValue = event.target.value
                                              if (newValue !== '') {
                                                setAdditionalSelectedServices((pv) => [
                                                    ...pv.map((p) => {
                                                      if ( p.newIndexId === data.newIndexId ) {
                                                        return {
                                                          ...p,
                                                          total_cost: newValue,
                                                          original_total_cost: newValue,
                                                        }
                                                      } else {
                                                        return p
                                                      }
                                                    }),
                                                  ],
                                                )
                                                data['total_cost'] =  newValue || 0
                                                data['original_total_cost'] = newValue || 0
                                              }
                                            }}
                                            // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          /> :
                                        data.total_cost}</TableCell>
                                        </Tooltip>
                                        <TableCell>
                                          <TextField
                                            type="number"
                                            // sx={{ width: 400 }}
                                            sx={{ minWidth: '80px' }}
                                            label={'Hours'}
                                            // {...getFieldProps(quantityFieldName)}
                                            // disabled={
                                            //   values.project_categories?.name ==
                                            //   'Time & Material'
                                            //     ? true
                                            //     : false
                                            // }
                                            value={
                                              (values.project_categories?.name ==
                                              'Time & Material' && Number(data?.id) === 10 )
                                                ? 0
                                                // ? Number(data.quantity) || 0
                                                : Number(data.quantity) || 0
                                            }
                                            onFocus={selectInputValue}
                                            onClick={selectInputValue}
                                            defaultValue={
                                              (values.project_categories?.name ==
                                              'Time & Material' && Number(data?.id) === 10)
                                                ? 0
                                                : 1
                                            }
                                            onKeyPress={(event) => { 
                                              if (event.key === '-') {
                                                event.preventDefault();
                                              }
                                            }}
                                            onChange={(event) => {
                                              let newValue = event.target.value
                                              // if (newValue <= 0) {
                                              //   event.preventDefault();
                                              //   return;
                                              // }
                                              // if (newValue.startsWith('-')) {
                                              //   newValue = newValue.slice(1)
                                              // }
                                              data['quantity'] = newValue || 0
                                              setFieldValue(
                                                quantityFieldName,
                                                newValue,
                                              )
                                            }}

                                            onWheel={(e) => e.target.blur()}

                                            onKeyDown={(event) => {
                                              if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                const newValue = event.target.value || 0;
                                                if (newValue < 1 && event.key === 'ArrowDown') {
                                                  event.preventDefault(); 
                                                }
                                              }
                                            }}


                                            error={Boolean(
                                              touched[quantityFieldName] &&
                                                errors[quantityFieldName],
                                            )}
                                            helperText={
                                              touched[quantityFieldName] &&
                                              errors[quantityFieldName]
                                            }
                                          />
                                        </TableCell>
                                        {isSplitOrder  ?
                                          <TableCell align='center'>
                                            {Number(data?.facility_id) !== Number(currentFacilityId) ? (
                                              <Stack direction="column" spacing={1} alignItems="center" sx={{ textAlign: 'center' }}>
                                                <Button
                                                  size="small"
                                                  variant={data?.delivery_installation?.installer_id || data?.delivery_installation?.installer_facility_id ? "contained" : "outlined"}
                                                  onClick={() => openDeliveryInstallDialog(data)}
                                                  sx={{ textAlign: 'center' }}
                                                >
                                                  {data?.delivery_installation?.installer_id ||
                                                    data?.delivery_installation?.installer_facility_id
                                                    ? 'Edit'
                                                    : 'Set'}
                                                </Button>
                                                {data?.delivery_installation?.installer_facility_id ? (
                                                  <Tooltip
                                                    title={`${deliveryTypeLabelById(
                                                      data?.delivery_installation
                                                        ?.delivery_type_id ||
                                                      data?.delivery_installation
                                                        ?.complete_status,
                                                    )} • ${data?.delivery_installation
                                                        ?.installer_facility_name ||
                                                      getFacilityOption(
                                                        data?.delivery_installation
                                                          ?.installer_facility_id,
                                                      )?.name ||
                                                      ''
                                                      }`}
                                                  >
                                                    <Typography
                                                      variant="caption"
                                                      noWrap
                                                      sx={{ maxWidth: 140 }}
                                                    >
                                                      {deliveryTypeLabelById(
                                                        data?.delivery_installation
                                                          ?.delivery_type_id ||
                                                        data?.delivery_installation
                                                          ?.complete_status,
                                                      )}
                                                      {' • '}
                                                      {data?.delivery_installation
                                                        ?.installer_facility_name ||
                                                        getFacilityOption(
                                                          data?.delivery_installation
                                                            ?.installer_facility_id,
                                                        )?.name ||
                                                        ''}
                                                    </Typography>
                                                  </Tooltip>
                                                ) : null}
                                              </Stack>
                                            ) : (
                                              '-'
                                            )}
                                          </TableCell>
                                          : null
                                        //   <TableCell align='center'>
                                        //   {
                                        //   values?.project_categories?.id == 11 && data?.makeInstallCard == 0 && data?.makeAsTask == 0 ?
                                        //   null :
                                        //   <Stack direction="column" spacing={1} alignItems="center" sx={{ textAlign: 'center' }}>
                                        //     <Button
                                        //       size="small"
                                        //       variant={data?.delivery_installation?.delivery_type_id ? "contained" : "outlined"}
                                        //       onClick={() => openDeliveryTypeDialog(data, 'service')}
                                        //       sx={{ textAlign: 'center' }}
                                        //     >
                                        //       {data?.delivery_installation?.delivery_type_id ? 'Edit' : 'Set'}
                                        //     </Button>
                                        //     {data?.delivery_installation?.delivery_type_id || data?.delivery_installation?.complete_status ? (
                                        //       <Tooltip
                                        //         title={`${deliveryTypeLabelById(
                                        //           data?.delivery_installation?.delivery_type_id ||
                                        //           data?.delivery_installation?.complete_status,
                                        //         )}`}
                                        //       >
                                        //         <Typography
                                        //           variant="caption"
                                        //           noWrap
                                        //           sx={{ maxWidth: 140 }}
                                        //         >
                                        //           {deliveryTypeLabelById(
                                        //             data?.delivery_installation?.delivery_type_id ||
                                        //             data?.delivery_installation?.complete_status,
                                        //           )}
                                        //         </Typography>
                                        //       </Tooltip>
                                        //     ) : null}
                                        //   </Stack>
                                        //     }
                                        // </TableCell>
                                          }
                                        {/* <TableCell>
                                          <Switch
                                            checked={data.makeAsTask === 1}
                                            onChange={(e) => {
                                              const newValue = e.target.checked ? 1 : 0;
                                              setAdditionalSelectedServices((prevServices) =>
                                                prevServices.map((service) =>
                                                  service.indexId === data.indexId
                                                    ? { ...service, makeAsTask: newValue }
                                                    : service
                                                )
                                              );
                                              data['makeAsTask'] = newValue;
                                            }}
                                            color="primary"
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <Switch
                                            checked={data.makeInstallCard === 1}
                                            onChange={(e) => {
                                              const newValue = e.target.checked ? 1 : 0;
                                              setAdditionalSelectedServices((prevServices) =>
                                                prevServices.map((service) =>
                                                  service.indexId === data.indexId
                                                    ? { ...service, makeInstallCard: newValue }
                                                    : service
                                                )
                                              );
                                              data['makeInstallCard'] = newValue;
                                            }}
                                            color="primary"
                                          />
                                        </TableCell> */}
                                        {/* {(values.project_categories?.name == 'Service only' || (values?.project_categories?.name == 'Time & Material')) ? ( */}
                                        <TableCell>
                                          <IconButton
                                            onClick={() => {
                                              setServiceOnlyLocationStates({
                                                ...serviceOnlyLocationStates,
                                                [data.indexId]: true,
                                              })
                                            }}
                                          >
                                            <LocationOn
                                              sx={{
                                                color: data?.addresses?.some(
                                                  (obj) =>
                                                    [obj.address, obj.city, obj.state, obj.zip].some(
                                                      (value) => (value === '' || value === null),
                                                    ),
                                                )
                                                  ? ''
                                                  : theme.palette.primary.main,
                                              }}
                                            />
                                          </IconButton>
                                        </TableCell>
                                        {/* ) : null} */}
                                        {/* <TableCell>
                                          {data?.isAdditionalProduct ? 'N/A' : (data.cost * quantityDifference?.toFixed(2))?.toFixed(2)}
                                        </TableCell> */}
                                        <TableCell>
                                          {total?.toFixed(2)}
                                        </TableCell>
                                        <TableCell>
                                          {total?.toFixed(2)}
                                        </TableCell>
                                        <TableCell align="right">
                                          <IconButton
                                            onClick={() =>
                                              handleDeleteService(
                                                data.id,
                                                data.newIndexId,
                                                index
                                              )
                                            }
                                          >
                                            <Delete />
                                          </IconButton>
                                        </TableCell>
                                      </TableRow>
                                      <Modal
                                        open={openServiceAttachment[data.indexId] || false}
                                        handleClose={() => handleCloseServiceAttachment(data.indexId)}
                                      >
                                        {renderAttachmentModalContent({
                                          itemKey: String(data.indexId),
                                              isService: true,
                                              tabValue: attachmentTabValueService[data.indexId],
                                              onTabChange: handleAttachmentTabChangeService,
                                              selectedImages:
                                                selectedUploadedImagesService[String(data.indexId)] ||
                                                selectedUploadedImagesService[data.indexId] ||
                                                [],
                                              linkedAttachments:
                                                serviceAttachments[String(data.indexId)] ||
                                                serviceAttachments[data.indexId] ||
                                                [],
                                              onImageSelect: handleImageSelectService,
                                              onAddSelected: handleAddSelectedImagesService,
                                              onDrop: handleServiceDrop,
                                              onRemove: handleServiceRemove,
                                              isUploadingItem: isUploadingService[data.indexId] || false,
                                            })}
                                      </Modal>
                                      <Modal
                                        open={
                                          serviceOnlyLocationStates[
                                            data.indexId
                                          ]
                                        }
                                        handleClose={() => {
                                          setServiceOnlyLocationStates({
                                            ...serviceOnlyLocationStates,
                                            [data.indexId]: false,
                                          })
                                        }}
                                      >
                                        {index === 0 && (
                                          <FormControlLabel
                                            control={
                                              <Switch
                                                checked={allServiceLocationSame}
                                                onChange={
                                                  handleAllServiceLocationSameChange
                                                }
                                              />
                                            }
                                            label="All Locations Same"
                                          />
                                        )}
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{
                                            justifyContent: 'center',
                                            width: '100%',
                                          }}
                                        >
                                          {data?.addresses?.map((addr, i) => (
                                            <Grid item xs={12}>
                                              {/* Side Heading */}
                                              <Typography
                                                variant="h5"
                                                sx={{ mb: 2 }}
                                              >
                                                Location
                                              </Typography>

                                              {/* Address Fields */}

                                              <Stack
                                                direction={{
                                                  xs: 'column',
                                                  sm: 'row',
                                                }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  label="Address"
                                                  size="small"
                                                  value={
                                                    data.addresses[i].address ||
                                                    ''
                                                  }
                                                  disabled={index !== 0 && allServiceLocationSame ? true : false}
                                                  onChange={(event) => {
                                                    let arrayAddr = [
                                                      ...data.addresses,
                                                    ]
                                                    arrayAddr[i].address =
                                                      event.target.value
                                                    setAdditionalSelectedServices(
                                                      (pv) => [
                                                        ...pv.map((p) => {
                                                          // if (p.id === data.id) {
                                                          if (
                                                            p.indexId ===
                                                            data.indexId
                                                          ) {
                                                            return {
                                                              ...p,
                                                              addresses:
                                                                arrayAddr,
                                                            }
                                                          } else {
                                                            return p
                                                          }
                                                        }),
                                                      ],
                                                    )
                                                  }}
                                                />
                                              </Stack>

                                              {/* City, State, Zip Fields */}
                                              <Stack
                                                direction={{
                                                  xs: 'column',
                                                  sm: 'row',
                                                }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  label="City"
                                                  size="small"
                                                  value={
                                                    data.addresses[i].city || ''
                                                  }
                                                  disabled={index !== 0 && allServiceLocationSame ? true : false}
                                                  onChange={(event) => {
                                                    let arrayAddr = [
                                                      ...data.addresses,
                                                    ]
                                                    arrayAddr[i].city =
                                                      event.target.value
                                                    setAdditionalSelectedServices(
                                                      (pv) => [
                                                        ...pv.map((p) => {
                                                          // if (p.id === data.id) {
                                                          if (
                                                            p.indexId ===
                                                            data.indexId
                                                          ) {
                                                            return {
                                                              ...p,
                                                              addresses:
                                                                arrayAddr,
                                                            }
                                                          } else {
                                                            return p
                                                          }
                                                        }),
                                                      ],
                                                    )
                                                  }}
                                                />
                                                <TextField
                                                  fullWidth
                                                  label="State"
                                                  size="small"
                                                  value={
                                                    data.addresses[i].state ||
                                                    ''
                                                  }
                                                  disabled={index !== 0 && allServiceLocationSame ? true : false}
                                                  onChange={(event) => {
                                                    let arrayAddr = [
                                                      ...data.addresses,
                                                    ]
                                                    arrayAddr[i].state =
                                                      event.target.value
                                                    setAdditionalSelectedServices(
                                                      (pv) => [
                                                        ...pv.map((p) => {
                                                          // if (p.id === data.id) {
                                                          if (
                                                            p.indexId ===
                                                            data.indexId
                                                          ) {
                                                            return {
                                                              ...p,
                                                              addresses:
                                                                arrayAddr,
                                                            }
                                                          } else {
                                                            return p
                                                          }
                                                        }),
                                                      ],
                                                    )
                                                  }}
                                                />
                                                <TextField
                                                  fullWidth
                                                  label="Zip / Postal Code"
                                                  size="small"
                                                  value={
                                                    data.addresses[i].zip || ''
                                                  }
                                                  disabled={index !== 0 && allServiceLocationSame ? true : false}
                                                  onChange={(event) => {
                                                    let arrayAddr = [
                                                      ...data.addresses,
                                                    ]
                                                    arrayAddr[i].zip =
                                                      event.target.value
                                                    setAdditionalSelectedServices(
                                                      (pv) => [
                                                        ...pv.map((p) => {
                                                          if (
                                                            p.indexId ===
                                                            data.indexId
                                                          ) {
                                                            // if (p.id === data.id) {
                                                            return {
                                                              ...p,
                                                              addresses:
                                                                arrayAddr,
                                                            }
                                                          } else {
                                                            return p
                                                          }
                                                        }),
                                                      ],
                                                    )
                                                  }}
                                                />
                                              </Stack>
                                            </Grid>
                                          ))}
                                        </Grid>
                                          {index !== 0 && allServiceLocationSame ? '' :
                                            <Grid
                                              container
                                              justifyContent="center"
                                              alignItems="center"
                                            >
                                              <Grid item xs={12} md={4}>
                                                <Box
                                                  sx={{
                                                    mt: 3,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    gap: 1,
                                                  }}
                                                >
                                                  <LoadingButton
                                                    variant="contained"
                                                    onClick={() => {
                                                      setIsSaving(true)
                                                      setTimeout(() => {
                                                        setIsSaving(false)
                                                        setServiceOnlyLocationStates(
                                                          false,
                                                        )
                                                      }, 100)
                                                    }}
                                                    loading={isSaving}
                                                  >
                                                    {' Save '}
                                                  </LoadingButton>
                                                  {/* <Button variant="outlined" type="submit" onClick={() => { setLocationStates(false) }}>
                                          Cancel
                                        </Button> */}
                                                </Box>
                                              </Grid>
                                            </Grid>
                                          }
                                      </Modal>
                                    </>
                                  )}
                                </Draggable>
                                );
                              })}
                                  {droppableProvided.placeholder}
                            </TableBody>
                                )}
                              </Droppable>
                            </DragDropContext>
                          </Table>
                        </TableContainer>
                      </Scrollbar>
                      {
                            showAddNewRow ?
                      <Stack sx={{ justifyContent: 'flex-end', alignItems: 'flex-end', display:'flex', flexDirection:'column' }}>
                        {/* <Button
                          variant="outlined"
                          startIcon={
                            <Stack>
                              {' '}
                              <Add />{' '}
                            </Stack>
                          }
                          onClick={() => {
                            addNewServiceRow()
                            // setMarkupType(1)
                          }}
                        >
                          Add Service Row
                        </Button> */}
                        <Typography variant="h6">
                          Total Additional Service Cost:{' '}
                          {selectedServicesSubTotal?.toFixed(2)}
                        </Typography>
                         {/* <Typography variant="h6">
                          Total Product Labor Cost:{' '}
                          {totalProductInstallCost?.toFixed(2)}
                        </Typography> */}
                      </Stack>
                      :""}
                      <Divider />
                      {/* {values.project_categories?.name == 'Time & Material'? '' :
              <> */}
                      {(values?.project_type?.name == 'TS' &&
                      values?.project_categories?.id == 14) || values?.project_categories?.id == 12  ? (
                        ''
                      ) : (
                        <>
                          <LabelStyleHead>Proposals</LabelStyleHead>
                          <Autocomplete
                            options={rfps}
                            // getOptionLabel={(option) => option.description}
                            getOptionLabel={(option) =>
                            option && option.description
                              ? `${option.description} ( ${option.vendor_name || ''})`
                              : ''
                            }
                            value={values.rfp}
                            onChange={(event, value) => {
                              handleRfpSelect(event, value)
                              setFieldValue('rfp', value)
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Proposal"
                              />
                            )}
                            filterOptions={(options, { inputValue }) =>
                              options.filter((option) => {
                                const searchText = inputValue.toLowerCase();
                                return (
                                  option.name?.toLowerCase().includes(searchText) ||
                                  option.description?.toLowerCase().includes(searchText)
                                  // option.description?.toLowerCase().includes(searchText)
                                );
                              })
                            }
                          />

                          {/* Modal for RFP Selection */}
                          <Modal open={openModal} handleClose={closeModal}>
                            <Box
                              sx={{
                                position: 'relative',
                                p: 3,
                                bgcolor: 'background.paper',
                                boxShadow: 24,
                              }}
                            >
                              <Tabs
                                value={tabIndex}
                                onChange={handleTabChange}
                                variant="fullWidth"
                                sx={{
                                  marginBottom: 4,
                                }}
                              >
                                  {values?.project_categories?.name !== 'Service only' && (
                                    <Tab
                                      label="Products"
                                      sx={{ width: '50%', minWidth: 0 }}
                                    />
                                  )}
                                <Tab
                                  label="Services"
                                  sx={{ width: '50%', minWidth: 0 }}
                                />
                                {/* {values?.project_categories?.name !=
                                  'Service only' &&
                                  values?.project_categories?.name !=
                                    'Time & Material' && (
                                    <Tab
                                      label="Products"
                                      sx={{ width: '50%', minWidth: 0 }}
                                    />
                                  )} */}
                                   <Tab label="Materials" sx={{ width: '50%', minWidth: 0 }} />
                              </Tabs>
                             
                              {tabIndex === 0 && (
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                    <TableHead>
                                      <TableCell align="center">Name</TableCell>
                                      <TableCell align="center">
                                        Unit Cost
                                      </TableCell>
                                      <TableCell align="center">Unit</TableCell>
                                      <TableCell align="center">Qty</TableCell>
                                      <TableCell align="center">
                                        Total Cost
                                      </TableCell>
                                      <TableCell align="center"></TableCell>
                                    </TableHead>
                                    {rfpProducts?.filter((product)=>product.material == 0).map((product) => {
                                      let unitName = UNITS?.filter(
                                        (item) => item?.id == product?.unit,
                                      )
                                      unitName = unitName[0]?.name
                                      let shortUnitName = ''
                                      if (unitName == 'Square feet') {
                                        shortUnitName = 'Sq ft'
                                      } else if (unitName == 'Lineal feet') {
                                        shortUnitName = 'Lin ft'
                                      } else if (unitName == 'Square Inches') {
                                        shortUnitName = 'Sq Inches'
                                      } else if (unitName == 'Unit') {
                                        shortUnitName = 'Unit'
                                      }
                                      if (
                                        values?.project_categories?.name ==
                                        'Time & Material'
                                      ) {
                                        product.product_price = 0
                                        // product.quantity = 0
                                      }
                                      return (
                                        // <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                        <TableRow key={product.id}>
                                          <TableCell align="center">
                                            {product.product_name}
                                          </TableCell>
                                          <TableCell align="center">
                                            ${product.product_price}
                                          </TableCell>
                                          <TableCell align="center">
                                            {product.quantity} {shortUnitName}
                                          </TableCell>
                                          <TableCell align="center">
                                            {product.location_quantity}
                                          </TableCell>
                                          <TableCell align="center">
                                            $
                                            {(
                                              product.location_quantity *
                                              product.quantity *
                                              (product.product_price.toFixed(
                                                2,
                                              ) || 0)
                                            ).toFixed(2)}
                                          </TableCell>
                                          <TableCell align="center">
                                            <Button
                                              onClick={() => addToCart(product)}
                                            >
                                              Add
                                            </Button>
                                          </TableCell>
                                        </TableRow>
                                        // </Box>
                                      )
                                    })}
                                  </Table>
                                </TableContainer>
                              )}
                                {tabIndex === 1 && (
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                    <TableHead>
                                      <TableCell align="center">Name</TableCell>
                                      <TableCell align="center">
                                        Unit Cost
                                      </TableCell>
                                      <TableCell align="center">
                                        Hours
                                      </TableCell>
                                      <TableCell align="center">
                                        Total Cost
                                      </TableCell>
                                      <TableCell align="center"></TableCell>
                                    </TableHead>
                                    {rfpServices.map((service) => {
                                      if (
                                        values?.project_categories?.name ==
                                        'Time & Material'
                                      ) {
                                        service.sellingPrice = 0
                                        service.quantity = 0
                                        service.total_cost = 0
                                      }
                                      return (
                                        // <Box key={service.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                        <TableRow key={service.id}>
                                          <TableCell align="center">
                                            {service.name}
                                          </TableCell>
                                          <TableCell align="center">
                                            ${service.sellingPrice}
                                          </TableCell>
                                          <TableCell align="center">
                                            {service.quantity}
                                          </TableCell>
                                          <TableCell align="center">
                                            ${service.total_cost}
                                          </TableCell>
                                          <TableCell align="center">
                                            <Button
                                              onClick={() => addToCart(service)}
                                            >
                                              Add
                                            </Button>
                                          </TableCell>
                                        </TableRow>
                                        // </Box>
                                      )
                                    })}
                                  </Table>
                                </TableContainer>
                              )}
                              {tabIndex === 2 && (
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                    <TableHead>
                                      <TableCell align="center">Name</TableCell>
                                      <TableCell align="center">
                                        Unit Cost
                                      </TableCell>
                                      <TableCell align="center">Unit</TableCell>
                                      <TableCell align="center">Qty</TableCell>
                                      <TableCell align="center">
                                        Total Cost
                                      </TableCell>
                                      <TableCell align="center"></TableCell>
                                    </TableHead>
                                    {rfpProducts?.filter((product)=>product.material == 1).map((product) => {
                                      let unitName = UNITS?.filter(
                                        (item) => item?.id == product?.unit,
                                      )
                                      unitName = unitName[0]?.name
                                      let shortUnitName = ''
                                      if (unitName == 'Square feet') {
                                        shortUnitName = 'Sq ft'
                                      } else if (unitName == 'Lineal feet') {
                                        shortUnitName = 'Lin ft'
                                      } else if (unitName == 'Square Inches') {
                                        shortUnitName = 'Sq Inches'
                                      } else if (unitName == 'Unit') {
                                        shortUnitName = 'Unit'
                                      }
                                      if (
                                        values?.project_categories?.name ==
                                        'Time & Material'
                                      ) {
                                        product.product_price = 0
                                        // product.quantity = 0
                                      }
                                      return (
                                        // <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                        <TableRow key={product.id}>
                                          <TableCell align="center">
                                            {product.product_name}
                                          </TableCell>
                                          <TableCell align="center">
                                            ${product.product_price}
                                          </TableCell>
                                          <TableCell align="center">
                                            {product.quantity} {shortUnitName}
                                          </TableCell>
                                          <TableCell align="center">
                                            {product.location_quantity}
                                          </TableCell>
                                          <TableCell align="center">
                                            $
                                            {(
                                              product.location_quantity *
                                              product.quantity *
                                              (product.product_price.toFixed(
                                                2,
                                              ) || 0)
                                            ).toFixed(2)}
                                          </TableCell>
                                          <TableCell align="center">
                                            <Button
                                              onClick={() => addToCart(product)}
                                            >
                                              Add
                                            </Button>
                                          </TableCell>
                                        </TableRow>
                                        // </Box>
                                      )
                                    })}
                                  </Table>
                                </TableContainer>
                              )}
                            </Box>
                          </Modal>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE_RFP_Product?.map((val) => (
                                      <TableCell key={val.id}>
                                        {val.value}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {cart?.filter((item)=>item.material == 0)?.map((data, index) => {
                                    let unitName = UNITS?.filter(
                                      (item) => item?.id == data?.unit,
                                    )
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    if (
                                      values.project_categories?.name ==
                                      'Time & Material'
                                    ) {
                                      data.product_price = 0
                                      data.product_retail_price = 0
                                      data.sellingPrice = 0
                                    }
                                    // let markup = markupType
                                    //   ? markupType === 1
                                    //     ? data.WholesaleMarkup
                                    //     : data.RetailMarkup
                                    //   : 0
                                     let markup = parseFloat(Number(data?.markup)) || 0
                                    data.product_markup = markup
                                    if(isNoChargeJob){
                                      data.product_markup = 0
                                      data.markup = 0
                                      markup = 0
                                    }

                                    let newTotalProductFormula =
                                      (
                                        data.product_price *
                                        data.quantity *
                                        data.location_quantity
                                      )?.toFixed(2) || 0
                                    let newTotalCost = (
                                      data.location_quantity *
                                      data.quantity *
                                      ((
                                        data.product_price +
                                        (data.product_price * markup) / 100
                                      ).toFixed(2) || 0)
                                    ).toFixed(2)

                                    totalProductFormula += Number(
                                      newTotalProductFormula,
                                    )
                                    totalWholesalePrice += Number(newTotalCost)
                                    totalRetailPrice += Number(newTotalCost)
                                    values['totalProductFormula'] =
                                      totalProductFormula
                                    values['totalWholesalePrice'] =
                                      totalWholesalePrice
                                    values['totalRetailPrice'] =
                                      totalRetailPrice

                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                          <TableCell>
                                            {data.name || data.product_name}
                                          </TableCell>
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>
                                            {isNoChargeJob ? '-' : (markup?.toFixed(2) || 0.0)}
                                          </TableCell>
                                          <TableCell>
                                            {data.product_price?.toFixed(2) ||
                                              0}
                                          </TableCell>
                                          <TableCell>
                                            {(
                                              data.product_price +
                                              (data.product_price * markup) /
                                                100
                                            ).toFixed(2) || 0.0}
                                          </TableCell>
                                          <TableCell>
                                            {data.quantity} {shortUnitName}
                                          </TableCell>
                                          <TableCell>
                                            {data.location_quantity}
                                          </TableCell>
                                          {/* <TableCell>
                                            {(
                                              data.product_price *
                                              data.quantity *
                                              data.location_quantity
                                            )?.toFixed(2) || 0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(
                                              data.location_quantity *
                                              data.quantity *
                                              ((
                                                data.product_price +
                                                (data.product_price * markup) /
                                                  100
                                              ).toFixed(2) || 0)
                                            ).toFixed(2)}
                                          </TableCell>
                                          {/* <TableCell>N/A</TableCell>
                                          <TableCell>N/A</TableCell> */}

                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setRfpLocationStates({
                                                  ...rfpLocationStates,
                                                  [data.product_id]: true,
                                                })
                                              }}
                                            >
                                              <LocationOn
                                                sx={{
                                                  color:
                                                    data &&
                                                    data.addresses &&
                                                    data.addresses.some((obj) =>
                                                      [obj.address, obj.city, obj.state, obj.zip].some(
                                                        (value) => (value === '' || value === null),
                                                      ),
                                                    )
                                                      ? ''
                                                      : theme.palette.primary
                                                          .main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell>

                                          <TableCell>
                                            <IconButton
                                              onClick={() =>
                                                handleDeleteRFPProduct(data.id)
                                              }
                                            >
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>

                                        <Modal
                                          open={
                                            rfpLocationStates[data.product_id]
                                          }
                                          handleClose={() => {
                                            setRfpLocationStates({
                                              ...rfpLocationStates,
                                              [data.product_id]: false,
                                            })
                                          }}
                                        >
                                          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'} alignItems={'center'}>
                                          {/* {index === 0 && ( */}
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  checked={
                                                    data?.allRfpProductsLocationSame
                                                  }
                                                  onChange={()=>
                                                    handleAllRfpProductsLocationSameChange(index)
                                                  }
                                                />
                                              }
                                              label="All Locations Same"
                                            />
                                            <Box sx={{ display: 'flex', flexDirection: 'column',width:'50%', alignItems: 'center', mt: 2 }}>
                                                  <LabelStyle >Qty Location Settings</LabelStyle>
                                                        <Box display="flex" alignItems="center" gap={1} mt={1}>
                                                          <Typography variant="subtitle2">Multiple</Typography>
                                                          <Switch
                                                            color="primary"
                                                            checked={data?.is_single_card}
                                                            onChange={(event) => {
                                                              const checked = event.target.checked;

                                                              setCart((prevCart) =>
                                                                prevCart.map((p) => {
                                                                  if (p.product_id !== data.product_id) return p;

                                                                  const count = Number(p.location_quantity || 1);

                                                                  if (checked) {
                                                                    // Single: always exactly one location
                                                                    return {
                                                                      ...p,
                                                                      is_single_card: true,
                                                                      addresses: p.addresses?.length
                                                                        ? [p.addresses[0]]
                                                                        : [
                                                                            {
                                                                              id: 0,
                                                                              address: '',
                                                                              city: '',
                                                                              state: '',
                                                                              zip: '',
                                                                            },
                                                                          ],
                                                                    };
                                                                  } else {
                                                                    // Multiple: create `location_quantity` locations
                                                                    const firstAddress = p.addresses?.[0] || {
                                                                      id: 0,
                                                                      address: '',
                                                                      city: '',
                                                                      state: '',
                                                                      zip: '',
                                                                    };

                                                                    let arrayAddr = Array(count)
                                                                      .fill()
                                                                      .map((_, i) => ({
                                                                        ...firstAddress,
                                                                        id: i,
                                                                      }));

                                                                    return {
                                                                      ...p,
                                                                      is_single_card: false,
                                                                      addresses: arrayAddr,
                                                                    };
                                                                  }
                                                                })
                                                              );
                                                            }}
                                                          />
                                                          <Typography variant="subtitle2">Single</Typography>
                                                        </Box>
                                                 </Box>
                                          {/* )} */}
                                          </Stack>

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{
                                              justifyContent: 'center',
                                              width: '100%',
                                            }}
                                          >
                                            {data?.addresses?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography
                                                  variant="h5"
                                                  sx={{ mb: 2 }}
                                                >
                                                  Location {i+1}
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                  }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={
                                                      data.addresses[i]
                                                        .address || ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].address =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                address: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                address: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                  }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].city ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].city =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                city: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                city: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].state ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].state =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                state: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                state: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].zip ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].zip =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                zip: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                zip: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>

                                          <Grid
                                            container
                                            justifyContent="center"
                                            alignItems="center"
                                          >
                                            <Grid item xs={12} md={4}>
                                              <Box
                                                sx={{
                                                  mt: 3,
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  gap: 1,
                                                }}
                                              >
                                                <LoadingButton
                                                  variant="contained"
                                                  onClick={() => {
                                                    setIsSaving(true)
                                                    setTimeout(() => {
                                                      setIsSaving(false)
                                                      setRfpLocationStates(
                                                        false,
                                                      )
                                                    }, 100)
                                                  }}
                                                  loading={isSaving}
                                                >
                                                  {' Save '}
                                                </LoadingButton>
                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                      </>
                                    )
                                  })}
                                </TableBody>
                                {/* <h6>Services</h6> */}
                                {
                                  cartService?.length > 0 ?
                                  <Typography variant='subtitle2' sx={{fontWeight:500}}>Services</Typography>
                                :''
                                }
                                <TableBody>
                                  {cartService?.map((data, index) => {
                                    if (
                                      values.project_categories?.name ==
                                      'Time & Material'
                                    ) {
                                      data.sellingPrice = 0
                                      data.unit_cost = 0
                                      data.qty = 0
                                    }
                                    if(isNoChargeJob){
                                      data.product_markup = 0
                                      data.originalMarkup = 0
                                      data.markup = 0
                                    }
                                    let newTotalProductFormula =
                                      (data.qty * data.sellingPrice).toFixed(
                                        2,
                                      ) || 0.0
                                    let newTotalCost = (
                                      data.qty *
                                      (data.sellingPrice +
                                        (data.sellingPrice *
                                          data.originalMarkup) /
                                          100)
                                    )?.toFixed(2)

                                    totalProductFormula += Number(
                                      newTotalProductFormula,
                                    )
                                    totalWholesalePrice += Number(newTotalCost)
                                    totalRetailPrice += Number(newTotalCost)
                                    values['totalProductFormula'] =
                                      totalProductFormula
                                    values['totalWholesalePrice'] =
                                      totalWholesalePrice
                                    values['totalRetailPrice'] =
                                      totalRetailPrice
                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                          <TableCell>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: data.service_notes ? theme.palette.error.main : 'inherit' }}>
                                              {data.service_notes && data.service_notes !== '' ? data.service_notes : (data.name || data.product_name)}
                                            </Typography>
                                            {data?.service_notes ? 
                                              <Stack direction={'column'}>
                                                <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                                <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap', color: 'error.main'}}>{data.service_notes}</Typography> 
                                              </Stack>
                                              : ''}
                                          </TableCell>
                                          {/* <TableCell>
                                            <IconButton onClick={() => handleOpenServiceNote(data.indexId, data.service_notes)}>
                                              <NoteAdd
                                                sx={{
                                                  color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell> */}
                                          <TableCell>
                                            {isNoChargeJob ? '-' : (data.originalMarkup?.toFixed(2) ?? '0')}
                                          </TableCell>
                                          <TableCell>
                                            {data.sellingPrice?.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {(
                                              data.sellingPrice +
                                              (data.sellingPrice *
                                                data.originalMarkup) /
                                                100
                                            )?.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {data.qty} Hours
                                          </TableCell>
                                          <TableCell>-</TableCell>
                                          {/* <TableCell>
                                            {(
                                              data.qty * data.sellingPrice
                                            ).toFixed(2) || 0.0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(
                                              data.qty *
                                              (data.sellingPrice +
                                                (data.sellingPrice *
                                                  data.originalMarkup) /
                                                  100)
                                            )?.toFixed(2)}
                                          </TableCell>
                                          {/* <TableCell>
                                            <Switch
                                              checked={data.makeAsTask === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setCartService((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.id === data.id
                                                      ? { ...service, makeAsTask: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeAsTask'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                          </TableCell>
                                          <TableCell>
                                            <Switch
                                              checked={data.makeInstallCard === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setCartService((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.id === data.id
                                                      ? { ...service, makeInstallCard: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeInstallCard'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                          </TableCell> */}
                                          {/* {(values?.project_categories?.name == 'Time & Material') ? '' : 
                                <TableCell >

                              </TableCell>} */}
                                          {/* {((values?.project_categories?.name == 'Service only') ||
                                (values?.project_categories?.name == 'Time & Material')) ?  */}
                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setRfpServiceLocationStates({
                                                  ...rfpServiceLocationStates,
                                                  [data.id]: true,
                                                })
                                              }}
                                            >
                                              <LocationOn
                                                sx={{
                                                  color:
                                                    data &&
                                                    data.addresses &&
                                                    data.addresses.some((obj) =>
                                                      [obj.address, obj.city, obj.state, obj.zip].some(
                                                        (value) => (value === '' || value === null),
                                                      ),
                                                    )
                                                      ? ''
                                                      : theme.palette.primary
                                                          .main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell>
                                          {/* : '' } */}
                                          <TableCell>
                                            <IconButton
                                              onClick={() =>
                                                handleDeleteRFPService(data.id)
                                              }
                                            >
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>

                                        <Modal
                                          open={
                                            rfpServiceLocationStates[
                                              data.id
                                            ]
                                          }
                                          handleClose={() => {
                                            setRfpServiceLocationStates({
                                              ...rfpServiceLocationStates,
                                              [data.id]: false,
                                            })
                                          }}
                                        >
                                          {index === 0 && (
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  checked={
                                                    allRfpServiceLocationSame
                                                  }
                                                  onChange={
                                                    handleAllRfpServiceLocationSameChange
                                                  }
                                                />
                                              }
                                              label="All Locations Same"
                                            />
                                          )}

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{
                                              justifyContent: 'center',
                                              width: '100%',
                                            }}
                                          >
                                            {data?.addresses?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography
                                                  variant="h5"
                                                  sx={{ mb: 2 }}
                                                >
                                                  Location
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                  }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={
                                                      data.addresses[i]
                                                        .address || ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].address =
                                                    //     event.target.value

                                                    //   setCartService((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.labour_cost_service_id ===
                                                    //         data.labour_cost_service_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.addresses];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                address: updatedValue, // Update address field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].address = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                  }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].city ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].city =
                                                    //     event.target.value

                                                    //   setCartService((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.labour_cost_service_id ===
                                                    //         data.labour_cost_service_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.addresses];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                city: updatedValue, // Update city field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].city = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].state ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].state =
                                                    //     event.target.value

                                                    //   setCartService((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.labour_cost_service_id ===
                                                    //         data.labour_cost_service_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.addresses];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                state: updatedValue, // Update state field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].state = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                    }}  
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].zip ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].zip =
                                                    //     event.target.value

                                                    //   setCartService((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.labour_cost_service_id ===
                                                    //         data.labour_cost_service_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.addresses];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                zip: updatedValue, // Update zip field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].zip = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              addresses: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>
                                          {index !== 0 && allRfpServiceLocationSame ? '' :
                                            <Grid
                                              container
                                              justifyContent="center"
                                              alignItems="center"
                                            >
                                              <Grid item xs={12} md={4}>
                                                <Box
                                                  sx={{
                                                    mt: 3,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    gap: 1,
                                                  }}
                                                >
                                                  <LoadingButton
                                                    variant="contained"
                                                    onClick={() => {
                                                      setIsSaving(true)
                                                      setTimeout(() => {
                                                        setIsSaving(false)
                                                        setRfpServiceLocationStates(
                                                          false,
                                                        )
                                                      }, 100)
                                                    }}
                                                    loading={isSaving}
                                                  >
                                                    {' Save '}
                                                  </LoadingButton>
                                                </Box>
                                              </Grid>
                                            </Grid>
                                          }
                                        </Modal>
                                      </>
                                    )
                                  })}
                                </TableBody>
                                {cart?.filter((item)=>item.material == 1).length > 0 ?
                                  <Typography variant='subtitle2' sx={{fontWeight:500}}>Materials</Typography>
                                  :''}
                                  <TableBody>
                                  {cart?.filter((item)=>item.material == 1)?.map((data, index) => {
                                    let unitName = UNITS?.filter(
                                      (item) => item?.id == data?.unit,
                                    )
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    if (
                                      values.project_categories?.name ==
                                      'Time & Material'
                                    ) {
                                      data.product_price = 0
                                      data.product_retail_price = 0
                                      data.sellingPrice = 0
                                    }
                                    // let markup = markupType
                                    //   ? markupType === 1
                                    //     ? data.WholesaleMarkup
                                    //     : data.RetailMarkup
                                    //   : 0
                                     let markup = parseFloat(Number(data?.markup)) || 0
                                    data.product_markup = markup
                                    if(isNoChargeJob){
                                      data.product_markup = 0
                                      data.markup = 0
                                      markup = 0
                                    }
                                    let newTotalProductFormula =
                                      (
                                        data.product_price *
                                        data.quantity *
                                        data.location_quantity
                                      )?.toFixed(2) || 0
                                    let newTotalCost = (
                                      data.location_quantity *
                                      data.quantity *
                                      ((
                                        data.product_price +
                                        (data.product_price * markup) / 100
                                      ).toFixed(2) || 0)
                                    ).toFixed(2)

                                    totalProductFormula += Number(
                                      newTotalProductFormula,
                                    )
                                    totalWholesalePrice += Number(newTotalCost)
                                    totalRetailPrice += Number(newTotalCost)
                                    values['totalProductFormula'] =
                                      totalProductFormula
                                    values['totalWholesalePrice'] =
                                      totalWholesalePrice
                                    values['totalRetailPrice'] =
                                      totalRetailPrice

                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                          <TableCell>
                                            {data.name || data.product_name}
                                          </TableCell>
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>
                                            {isNoChargeJob ? '-' : (markup?.toFixed(2) || 0.0)}
                                          </TableCell>
                                          <TableCell>
                                            {data.product_price?.toFixed(2) ||
                                              0}
                                          </TableCell>
                                          <TableCell>
                                            {(
                                              data.product_price +
                                              (data.product_price * markup) /
                                                100
                                            ).toFixed(2) || 0.0}
                                          </TableCell>
                                          <TableCell>
                                            {data.quantity} {shortUnitName}
                                          </TableCell>
                                          <TableCell>
                                            {data.location_quantity}
                                          </TableCell>
                                          {/* <TableCell>
                                            {(
                                              data.product_price *
                                              data.quantity *
                                              data.location_quantity
                                            )?.toFixed(2) || 0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(
                                              data.location_quantity *
                                              data.quantity *
                                              ((
                                                data.product_price +
                                                (data.product_price * markup) /
                                                  100
                                              ).toFixed(2) || 0)
                                            ).toFixed(2)}
                                          </TableCell>
                                          {/* <TableCell>N/A</TableCell>
                                          <TableCell>N/A</TableCell> */}

                                          <TableCell>
                                            {/* material doesn't have loacation its not creating installations */}
                                            {/* <IconButton
                                              onClick={() => {
                                                setRfpLocationStates({
                                                  ...rfpLocationStates,
                                                  [data.product_id]: true,
                                                })
                                              }}
                                            >
                                              <LocationOn
                                                sx={{
                                                  color:
                                                    data &&
                                                    data.addresses &&
                                                    data.addresses.some((obj) =>
                                                      [obj.address, obj.city, obj.state, obj.zip].some(
                                                        (value) => (value === '' || value === null),
                                                      ),
                                                    )
                                                      ? ''
                                                      : theme.palette.primary
                                                          .main,
                                                }}
                                              />
                                            </IconButton> */}
                                            N/A
                                          </TableCell>

                                          <TableCell>
                                            <IconButton
                                              onClick={() =>
                                                handleDeleteRFPProduct(data.id)
                                              }
                                            >
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>

                                        <Modal
                                          open={
                                            rfpLocationStates[data.product_id]
                                          }
                                          handleClose={() => {
                                            setRfpLocationStates({
                                              ...rfpLocationStates,
                                              [data.product_id]: false,
                                            })
                                          }}
                                        >
                                          {/* {index === 0 && ( */}
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  checked={
                                                    data?.allRfpProductsLocationSame
                                                  }
                                                  onChange={()=>
                                                    handleAllRfpProductsLocationSameChange(index)
                                                  }
                                                />
                                              }
                                              label="All Locations Same"
                                            />
                                          {/* )} */}

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{
                                              justifyContent: 'center',
                                              width: '100%',
                                            }}
                                          >
                                            {data?.addresses?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography
                                                  variant="h5"
                                                  sx={{ mb: 2 }}
                                                >
                                                  Location {i+1}
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                  }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={
                                                      data.addresses[i]
                                                        .address || ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].address =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                address: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                address: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                  }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].city ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].city =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                city: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                city: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].state ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].state =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                state: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                state: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={
                                                      data.addresses[i].zip ||
                                                      ''
                                                    }
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [
                                                    //     ...data.addresses,
                                                    //   ]
                                                    //   arrayAddr[i].zip =
                                                    //     event.target.value

                                                    //   setCart((pv) => [
                                                    //     ...pv.map((p) => {
                                                    //       if (
                                                    //         p.product_id ===
                                                    //         data.product_id
                                                    //       ) {
                                                    //         return {
                                                    //           ...p,
                                                    //           addresses:
                                                    //             arrayAddr,
                                                    //         }
                                                    //       } else {
                                                    //         return {
                                                    //           ...p,
                                                    //         }
                                                    //       }
                                                    //     }),
                                                    //   ])
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.addresses];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                zip: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                zip: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              addresses: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>

                                          <Grid
                                            container
                                            justifyContent="center"
                                            alignItems="center"
                                          >
                                            <Grid item xs={12} md={4}>
                                              <Box
                                                sx={{
                                                  mt: 3,
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  gap: 1,
                                                }}
                                              >
                                                <LoadingButton
                                                  variant="contained"
                                                  onClick={() => {
                                                    setIsSaving(true)
                                                    setTimeout(() => {
                                                      setIsSaving(false)
                                                      setRfpLocationStates(
                                                        false,
                                                      )
                                                    }, 100)
                                                  }}
                                                  loading={isSaving}
                                                >
                                                  {' Save '}
                                                </LoadingButton>
                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                      </>
                                    )
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                        </>
                      )}
                       {values.project_categories?.name == 'Time & Material' ? (
                        ''
                      ) : 
                        <>
                          <LabelStyleHead>Materials</LabelStyleHead>
                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                          >
                          <Autocomplete
                            sx={{ width: 400 }}
                            multiple
                            id="combo-box-demo"
                            options={
                              [...(materials?.filter((option) =>
                                option.inhouse === 0 || option.inhouse === 1
                              ) || [])].sort((a, b) => {
                                const aValue = a?.description || a?.name || '';
                                const bValue = b?.description || b?.name || '';
                                return alphanumericCompare(aValue, bValue);
                              })
                            }
                              // options={materials?.filter((option) => option.inhouse === 0 || option.inhouse === 1) || []} // if we need service only condition for client owned comment this
                              // options={materials || []}
                              // options={
                              //   materials?.filter(
                              //     (option) =>
                              //       !selectedMaterials?.some(
                              //         (selected) => selected.id === option.id,
                              //       ),
                              //   ) || []
                              // }
                              // options={
                              //   materials?.filter((option) => {
                              //     // Exclude selected materials
                              //     const isSelected = selectedMaterials?.some((selected) => selected.id === option.id);
                              //     const isServiceOnly = values.project_categories?.name === 'Service only';
                              //     // Filter materials: show only inhouse = 1 unless it's 'Service only'
                              //     const shouldInclude = isServiceOnly || option.inhouse === 1;
                              //     return !isSelected && shouldInclude;
                              //   }) || []
                              // }
                              // options={
                              //       materials?.filter((option) => {
                              //         const isServiceOnly = values.project_categories?.name === 'Service only';
                              //         // Show all materials if eligible (inhouse or service only)
                              //         return isServiceOnly || option.inhouse === 1;
                              //       }) || []
                              //     }
                              // value={selectedMaterials?.filter(item => !item?.isAdditionalProduct)}
                              value={pendingAutocompleteMaterials?.filter(item => !item?.isAdditionalProduct)}

                              onChange={(event, newValue) => {
                                if (newValue.length < selectedMaterials.length) {
                                // Only update state
                                setFieldValue('additionalMaterials', newValue);
                               setPendingAutocompleteMaterials(newValue); // ✅ sync Autocomplete state
                                handleMaterial(newValue); 
                                return;
                              }
                                if (!newValue || newValue.length === 0) return;
                                const lastSelected = newValue[newValue.length - 1];
                                setFieldValue('additionalMaterials', newValue)
                                // setPendingAutocompleteMaterials(newValue);
                                handleMaterialStockCheck(lastSelected);
                                setShowAddNewRow(true)                               

                              }}
                              // renderOption={(props, option) => {
                              //   const description = option.description || '';
                              //   const ownership = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                              //   return (
                              //     <li {...props}>
                              //       {description}{ownership}
                              //       <span style={{ display: 'none' }}>{option.name}</span>
                              //     </li>
                              //   );
                              // }}
                              renderOption={(props, option) => {
                              const { style, ...liProps } = props;
                              const description = option.description || '';
                              const ownership = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                              const fullText = `${description}${ownership}`;

                              return (
                                <li
                                  {...liProps}
                                  style={{
                                    ...style,
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                 <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                  {option?.syncWithQuickbooks === 1 && (
                                    <img
                                      src={quickbookLogo}
                                      width="40px"
                                      height="20px"
                                      // style={{ marginRight: 8 }}
                                      alt="QuickBooks"
                                    />
                                  )}
                                </div>
                                <Tooltip title={fullText}>
                                    <span style={{
                                      flex: 1,
                                      minWidth: 0,
                                      display: 'block',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}>
                                      {fullText}
                                    </span>
                                  </Tooltip>
                                  <span style={{ display: 'none' }}>{option.name}</span>
                                </li>
                              );
                            }}
                              renderInput={(params) => (
                                // <TextField {...params} label="Materials" variant="outlined" />
                                <TextField
                                  {...params}
                                  label="Materials"
                                  error={Boolean(
                                    touched.additionalMaterials &&
                                      errors.additionalMaterials,
                                  )}
                                  helperText={
                                    touched.additionalMaterials &&
                                    errors.additionalMaterials
                                  }
                                />
                              )}
                              // getOptionLabel={(option) =>
                              //   option.name ? option.name : ''
                              // }
                              getOptionLabel={(option) => {
                                const name = option.name || '';
                                const description = option.description || '';
                                const ownershipLabel = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                                return `${description}${ownershipLabel} \u200B${name}`; // ← \u200B is zero-width space
                              }}
                              filterOptions={(options, { inputValue }) => {
                                const searchText = (inputValue || '').toString().trim().toLowerCase();
                                if (!searchText) return options;
                                console.log("the option for the auto complte is ",options);
                                
                                return options.filter((option) => {
                                  return (
                                    option.name?.toLowerCase().includes(searchText) ||
                                    option.description?.toLowerCase().includes(searchText) ||
                                    String(option.tags ?? '').toLowerCase().includes(searchText)
                                  );
                                });
                              }}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => {
                                const suffix = option.inhouse === 1 ? '(Inhouse)' : '(Client owned)';
                                const stockLabel = option.stock_type === 1
                                ? 'Finished'
                                : `Partial - ${UNITS?.find(u => u.id === option.convertion_unit)?.name || 'Unit'}`;
                                const tooltipText = `${option.description || option.name} ${suffix} [${stockLabel}]`;
                                return (
                                  <Tooltip key={index} title={tooltipText}>
                                    <Chip
                                    {...getTagProps({ index })}
                                    label={`${option.description || option.name} ${suffix} [${stockLabel}]`}
                                    // color={option.stockType === 1 ? 'primary' : 'secondary'}
                                    // variant={option.stockType === 1 ? 'filled' : 'outlined'}
                                  />
                                  </Tooltip>
                                );
                              })
                            }
                            />
                          </Stack>
                          <LabelStyle>Selected Materials</LabelStyle>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE_MATERIAL?.map((val,index) =>
                                      val.id === 3 ? (
                                        <Tooltip
                                          key={val.id}
                                          title="Unit Price + ((Unit Price * Markup)/100)"
                                        >
                                          <TableCell key={val.id}>
                                            {val.value}
                                          </TableCell>
                                        </Tooltip>
                                      ) : val.id === 5 ? (
                                        <Tooltip
                                          key={val.id}
                                          title="Unit Price * Quantity"
                                        >
                                          <TableCell key={val.id}>
                                            {val.value}
                                          </TableCell>
                                        </Tooltip>
                                      ) : val.id === 6 ? (
                                        <Tooltip
                                          key={val.id}
                                          title="Markup Cost * Quantity"
                                        >
                                          <TableCell key={val.id}>
                                            {val.value}
                                          </TableCell>
                                        </Tooltip>
                                      ) : (
                                        <TableCell key={val.id}>
                                          {val.value}
                                        </TableCell>
                                      ),
                                    )}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {selectedMaterials?.map((data, index) => {
                                    console.log("daaaaaaaaaaaaaaa",data);
                                    const adjustmentFieldName = `adjustment_${index}`;
                                    let price = data.price || 0
                                    let quantity = data.quantity || 0
                                    // if ( values.project_categories?.name == 'Time & Material' ) {
                                    //   data['price'] = 0
                                    //   data['quantity'] = 0
                                    //   price = 0
                                    //   quantity = 0
                                    // }
                                    if (values.project_categories?.name == 'Service only' && data?.inhouse == 0 ) {
                                      data['price'] = 0
                                      price = 0
                                    }
                                    let unitName ='';
                                  if(data?.stock_type===1){
                                  unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                  }else{
                                    unitName = UNITS?.filter((item) => item?.id == data?.convertion_unit)
                                  }
                                      // unitName = unitName[0]?.name
                                      let shortUnitName = unitName[0]?.short_name
                                    // if (unitName == 'Square feet') {
                                    //   shortUnitName = 'Sq ft'
                                    // } else if (unitName == 'Lineal feet') {
                                    //   shortUnitName = 'Lin ft'
                                    // } else if (unitName == 'Square Inches') {
                                    //   shortUnitName = 'Sq Inches'
                                    // } else if (unitName == 'Unit') {
                                    //   shortUnitName = 'Unit'
                                    // }
                                    // const markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.markup || 0)) / 100)
                                    if(isNoChargeJob){
                                      data.product_markup = 0
                                      data.markup = 0
                                    }
                                    const markUpCost = price + (price * parseFloat(data.markup || 0)) / 100
                                    data['markUpCost'] = parseFloat(parseFloat(markUpCost).toFixed(2),) || 0

                                    // let newTotalProductFormula = (data.price*(data.quantity||1))?.toFixed(2)
                                    let newTotalProductFormula = (
                                      price * quantity
                                    ).toFixed(2)
                                    let newTotalCost = (
                                      (data.markUpCost || 0) *
                                      (data.quantity || 0)
                                    )?.toFixed(2)

                                    totalProductFormula += Number( newTotalProductFormula, )
                                    totalWholesalePrice += Number(newTotalCost)
                                    totalRetailPrice += Number(newTotalCost)
                                    values['totalProductFormula'] = totalProductFormula
                                    values['totalWholesalePrice'] = totalWholesalePrice
                                    values['totalRetailPrice'] = totalRetailPrice
                                    if(data.adj_value_type == null){
                                      data.adj_value_type =true
                                     }
                                    const isNegativeMaterialAdjustmentMode =
                                      data?.adj_value_type === false ||
                                      data?.adj_value_type === 0 ||
                                      data?.adj_value_type === '0' ||
                                      data?.adj_value_type === 'false'
                                    const materialAdjustmentValue =
                                      Number(data?.adjustment) || 0
                                    const adjustedMarkupCostEach =
                                      Number(data?.markUpCost || 0) +
                                      (isNegativeMaterialAdjustmentMode
                                        ? -materialAdjustmentValue
                                        : materialAdjustmentValue)
                                    const materialFormulaEach =
                                      Number(data?.price) || 0
                                    const isLosingMoneyItem =
                                      isNegativeMaterialAdjustmentMode &&
                                      adjustedMarkupCostEach < materialFormulaEach

                                    const losingMoneyRowSx = isLosingMoneyItem
                                      ? {
                                          '& .MuiTableCell-root:not(:nth-of-type(4)), & .MuiTableCell-root:not(:nth-of-type(4)) .MuiInputBase-input, & .MuiTableCell-root:not(:nth-of-type(4)) .MuiFormLabel-root':
                                            {
                                              color: `${theme.palette.error.main} !important`,
                                            },
                                        }
                                      : undefined
                                    console.log('datadatadatamaterial',index,data)
                                    return (
                                      <>
                                        <TableRow key={data?.newIndexId || index} sx={losingMoneyRowSx}>
                                          <TableCell>{index + 1}</TableCell>
                                          <TableCell>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 40,
                                                height: 20,
                                              }}
                                            >
                                              {data?.syncWithQuickbooks === 1 && (
                                                <img
                                                  src={quickbookLogo}
                                                  alt="QuickBooks"
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </TableCell>
                                          <TableCell>
                                            {data?.isAdditionalProduct ?
                                              <TextField
                                                required
                                                fullWidth
                                                type="text"
                                                label={'Material Name'}
                                                sx={{ width: 85 }}
                                                value={data.name}
                                                onChange={(event) => {
                                                  let newValue = event.target.value
  
                                                  // Update the selectedProducts state
                                                  setSelectedMaterials(
                                                    (prevProducts) =>
                                                      prevProducts.map((service) => {
                                                          if ( service.newIndexId === data.newIndexId ) {
                                                            return {
                                                              ...service,
                                                              name: newValue,
                                                            }
                                                          } else {
                                                            return service
                                                          }
                                                        },
                                                      ),
                                                  )
                                                  data['name'] = newValue || ''
                                                  if (isSubmitted)
                                                    setIsSubmitted(false)
                                                }}
                                                error={
                                                  isSubmitted && data?.name?.trim() === ''
                                                }
                                                helperText={
                                                  isSubmitted && data?.name?.trim() === '' ? 'Material Name is required' : ''
                                                }
                                              />
                                              : 
                                              //  data.name
                                                  <Box>
                                                    <Typography sx={{color:"inherit"}}>{data.name}</Typography>
                                                    {data.material_notes? <Typography sx={{ color: data.material_notes ? theme.palette.error.main : 'inherit' }}> Note:{" "}{data.material_notes && data.material_notes !== '' ? data.material_notes :""}</Typography>:""}
                                                  </Box>
                                             }
                                              {/* {data?.isAdditionalProduct ? '' : data.inhouse == 1 ? ' (Inhouse)' : ' (Client owned)'} */}
                                            </TableCell>
                                            <TableCell>
                                              <IconButton
                                                onClick={() =>
                                                  handleOpenMaterialNote(
                                                    data.newIndexId || index,
                                                    data.material_notes,
                                                  )
                                                }
                                              >
                                                <NoteAdd
                                                  sx={{
                                                    color:
                                                      !data?.material_notes ||
                                                      data?.material_notes ===
                                                      ''
                                                        ? ''
                                                        : theme.palette
                                                          .primary.main,
                                                  }}
                                                />
                                              </IconButton>
                                              <Modal
                                                open={
                                                  openMaterialNote[data.newIndexId || index] ||
                                                  false
                                                }
                                                handleClose={() =>
                                                  handleCloseMaterialNote(data.newIndexId || index)
                                                }
                                              >
                                                <Grid
                                                  container
                                                  spacing={3}
                                                  sx={{
                                                    justifyContent: 'center',
                                                    width: '100%',
                                                  }}
                                                >
                                                  <Grid item xs={12}>
                                                    <Typography
                                                      variant="h5"
                                                      sx={{ mb: 2 }}
                                                    >
                                                      Note
                                                    </Typography>
  
                                                    <Stack
                                                      direction={{
                                                        xs: 'column',
                                                        sm: 'row',
                                                      }}
                                                      spacing={{ xs: 3, sm: 2 }}
                                                      sx={{ mb: 2 }}
                                                    >
                                                      <TextField
                                                        fullWidth
                                                        multiline
                                                        rows={4}
                                                        size="medium"
                                                        value={currentNote}
                                                        onChange={handleNoteChange}
                                                        sx={{
                                                          '& .MuiInputBase-input': {
                                                            color: 'red',
                                                          },
                                                        }}
                                                        inputProps={{
                                                          maxLength: MAX_CHARACTERS,
                                                        }}
                                                        helperText={
                                                          error
                                                            ? error // Show error message if validation fails
                                                            : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                        }
                                                        error={Boolean(error)} // Highlight the field in error state if validation fails
                                                      />
                                                    </Stack>
                                                    <Box
                                                      sx={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        gap: 2,
                                                      }}
                                                    >
                                                      <LoadingButton
                                                        type="submit"
                                                        variant="contained"
                                                        onClick={() =>
                                                          handleSaveMaterialNote(data.newIndexId || index)
                                                        }
                                                        loading={isSavingNote}
                                                      >
                                                        Save
                                                      </LoadingButton>
                                                    <LoadingButton
                                                      variant="outlined"
                                                      color="error"
                                                      onClick={() => handleClearMaterialNote(data.newIndexId)}
                                                      loading={isClearingNote}
                                                      disabled={!currentNote.trim()}
                                                    >
                                                      Clear
                                                    </LoadingButton>
                                                    </Box>
                                                  </Grid>
                                                </Grid>
                                              </Modal>
                                          </TableCell>
                                            <TableCell>
                                              {data.stock_type === 1 ? "Finished" : "Partial"}
                                            </TableCell>
                                            <TableCell>
                                            {data.isAdditionalProduct ? (
                                              <TextField
                                                required
                                                fullWidth
                                                type="number"
                                                label="Unit Price"
                                                value={roundMoneyValue(data.price)}
                                                onFocus={selectInputValue}
                                                onClick={selectInputValue}
                                                onChange={(event) => {
                                                  const newValue = event.target.value;
                                                  setSelectedMaterials((prev) =>
                                                    prev.map((p) => p.newIndexId === data.newIndexId ? { ...p, price: Number(newValue) } : p)
                                                  );
                                                  data['price'] = Number(newValue);
                                                }}
                                              />
                                            ) : (
                                              roundMoneyValue(data.price).toFixed(2)
                                            )}
                                          </TableCell>

                                          <TableCell>
                                            <TextField
                                              required
                                              fullWidth
                                              disabled={isNoChargeJob}
                                              type="number"
                                              label="Markup"
                                              value={isNoChargeJob ? 0 : (Number(data.markup) || 0)}
                                              inputProps={{ min: 0 }}
                                              onFocus={selectInputValue}
                                              onClick={selectInputValue}
                                              onKeyPress={(event) => {
                                                if (event.key === '-' || event.key === 'e') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              onChange={(event) => {
                                                let newValue = event.target.value;

                                                if (/^0[0-9]+$/.test(newValue) || newValue === '') {
                                                  newValue = '0';
                                                }

                                                setSelectedMaterials((prevMaterials) =>
                                                  prevMaterials.map((p) => {
                                                    const isMatchingProduct = data.isAdditionalProduct
                                                      ? p.newIndexId === data.newIndexId
                                                      : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                        p.stock_type === data.stock_type &&
                                                        (p.stock_type === 1 || p.convertion_unit === data.convertion_unit) &&
                                                        (p.newIndexId === data.newIndexId || (!data.isAdditionalProduct && p.id === data.id));

                                                    const isNegativeMode =
                                                      p.adj_value_type === false ||
                                                      p.adj_value_type === 0 ||
                                                      p.adj_value_type === '0' ||
                                                      p.adj_value_type === 'false';

                                                    return isMatchingProduct
                                                      ? (isNegativeMode
                                                          ? {
                                                              ...p,
                                                              markup: Number(newValue),
                                                              adj_value_type: true,
                                                              adjustment: 0,
                                                            }
                                                          : {
                                                              ...p,
                                                              markup: Number(newValue),
                                                            })
                                                      : p;
                                                  }),
                                                );

                                                data['markup'] = Number(newValue);
                                                const isNegativeMode =
                                                  data?.adj_value_type === false ||
                                                  data?.adj_value_type === 0 ||
                                                  data?.adj_value_type === '0' ||
                                                  data?.adj_value_type === 'false';
                                                if (isNegativeMode) {
                                                  data['adj_value_type'] = true;
                                                  data['adjustment'] = 0;
                                                  setFieldValue(adjustmentFieldName, 0);
                                                }
                                              }}
                                            />
                                          </TableCell>

                                          {/* <TableCell>
                                            {data.markUpCost || 0}
                                          </TableCell> */}
                                          <TableCell>{(data.markUpCost + (data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0))).toFixed(2) || 0}</TableCell>
                                          <TableCell>
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              label={shortUnitName || 'Quantity'}
                                              // disabled={values.project_categories?.name === 'Time & Material'}
                                              value={
                                                values.project_categories?.name === 'Time & Material'
                                                  // ? 0
                                                  ? Number(data.quantity) || 0
                                                  : Number(data.quantity) || 0
                                              }
                                              inputProps={{ min: 0 }}
                                              onFocus={selectInputValue}
                                              onClick={selectInputValue}
                                              onKeyPress={(event) => {
                                                if (event.key === '-' || event.key === 'e') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              onChange={(event) => {
                                                const newValue = event.target.value;

                                                setSelectedMaterials((prevMaterials) =>
                                                  prevMaterials.map((p) => {
                                                    const isMatchingProduct = data.isAdditionalProduct
                                                      ? p.newIndexId === data.newIndexId
                                                      : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                        p.stock_type === data.stock_type &&
                                                        (p.stock_type === 1 || p.convertion_unit === data.convertion_unit) &&
                                                        (p.newIndexId === data.newIndexId || (!data.isAdditionalProduct && p.id === data.id));

                                                    return isMatchingProduct
                                                      ? { ...p, quantity: newValue === '' ? 0 : Number(newValue) }
                                                      : p;
                                                  }),
                                                );
                                              }}
                                              onWheel={(e) => e.target.blur()}
                                              onKeyDown={(event) => {
                                                if (event.key === 'ArrowDown' && (event.target.value || 0) <= 1) {
                                                  event.preventDefault();
                                                }
                                              }}
                                            />
                                          </TableCell>
                                          <TableCell>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                              <Remove
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  const hasPermission = explodedPermissions?.some((permission) =>
                                                    ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                  )
                                                  // if (!hasPermission) {
                                                  //   return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                  // }
                                                  // const formulaEach = Number(data.markUpCost)
                                                  // const retailEachBase = Number(data.price)
                                                  const formulaEach = Number(data.price)
                                                  const retailEachBase = Number(data.markUpCost)
                                                  if (retailEachBase <= formulaEach && !hasPermission) {
                                                    return enqueueSnackbar(
                                                      'To apply a negative marketing adjustment, Markup Cost Each must be higher than Unit Price.',
                                                      { variant: 'error' },
                                                    )
                                                  }
                                                  const maxNegative = getMaterialMaxNegativeAdjustment(data, hasPermission);
                                                  const adjustment = Number(data?.adjustment) || 0;
                                                  // console.log('aaaaaaaaaaaaaa', data?.adjustment);
                                                  // console.log('aaaaaaaaaaaaaa', adjustment);
                                                  // console.log('aaaaaaaaaaaaaa', maxNegative);

                                                  if (adjustment >= maxNegative && hasPermission) {
                                                    return enqueueSnackbar(
                                                      'Markup Cost value cannot be zero or less',
                                                      { variant: 'error' },
                                                    );
                                                  } else if (adjustment > maxNegative && !hasPermission) {
                                                    return enqueueSnackbar(
                                                      `Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative}`,
                                                      { variant: 'error' }
                                                    );
                                                  }
                                                  const newValue = false
                                                  // setSelectedMaterials((prevMaterials) =>
                                                  //   prevMaterials.map((p) => {
                                                  //     if (p.newIndexId === data.newIndexId) {
                                                  //       console.log('aaaaaaaaaaaaaaaaaaaaaaaaa',p);
                                                  //       console.log('aaaaaaaaaaaaaaaaaaaaaaaaa',data);
                                                        
                                                  //       return {
                                                  //         ...p,
                                                  //         adj_value_type: newValue,
                                                  //       };
                                                  //     }
                                                  //     return p;
                                                  //   }),
                                                  // )
                                                  setSelectedMaterials((prevMaterials) =>
                                                    prevMaterials.map((p) => {
                                                      const isMatchingProduct = data.isAdditionalProduct
                                                        ? p.newIndexId === data.newIndexId
                                                        : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                          p.stock_type === data.stock_type &&
                                                          (p.stock_type === 1 || p.convertion_unit === data.convertion_unit) &&
                                                          (p.newIndexId === data.newIndexId || (!data.isAdditionalProduct && p.id === data.id));
                                                  
                                                      return isMatchingProduct
                                                        ? { ...p, adj_value_type: newValue }
                                                        : p;
                                                    }),
                                                  );
                                                  // setFieldValue('manager_approval_required', true)
                                                  // data['adj_value_type'] = newValue
                                                  // markUnsavedChanges();
                                                }}
                                              />
                                              <FormControlLabel
                                                control={
                                                  <Switch
                                                    checked={data.adj_value_type}
                                                    onChange={(event) => {
                                                      const newValue = event.target.checked
                                                      const hasPermission = explodedPermissions?.some((permission) =>
                                                        ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                      )
                                                      // if (!hasPermission && newValue === false) {
                                                      //   return enqueueSnackbar('Access Denied : You do not have Suffient Permission', { variant: 'error' })
                                                      // }
                                                      if (newValue === false) {
                                                        const formulaEach = Number(data?.price)
                                                        const retailEachBase = Number(data.markUpCost)
                                                        if (retailEachBase <= formulaEach && !hasPermission) {
                                                          return enqueueSnackbar(
                                                            'To apply a negative marketing adjustment, Markup Cost Each must be higher than Unit Price.',
                                                            { variant: 'error' },
                                                          )
                                                        }
                                                      }
                                                      const maxNegative = getMaterialMaxNegativeAdjustment(data, hasPermission);
                                                      const adjustment = Number(data.adjustment) || 0;
                                                      if (adjustment >= maxNegative && newValue === false && hasPermission) {
                                                        return enqueueSnackbar(
                                                          'Markup Cost value cannot be zero or less',
                                                          { variant: 'error' }
                                                        );
                                                      } else if (adjustment > maxNegative && newValue === false && !hasPermission) {
                                                        return enqueueSnackbar(
                                                          `Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative}`,
                                                          { variant: 'error' }
                                                        );
                                                      }

                                                      // setSelectedMaterials((prevMaterials) =>
                                                      //   prevMaterials.map((p) => {
                                                      //     if (p.newIndexId === data.newIndexId) {
                                                      //       return {
                                                      //         ...p,
                                                      //         adj_value_type: newValue,
                                                      //       };
                                                      //     }
                                                      //     return p;
                                                      //   }),
                                                      // )
                                                      setSelectedMaterials((prevMaterials) =>
                                                        prevMaterials.map((p) => {
                                                          const isMatchingProduct = data.isAdditionalProduct
                                                            ? p.newIndexId === data.newIndexId
                                                            : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                              p.stock_type === data.stock_type &&
                                                              (p.stock_type === 1 || p.convertion_unit === data.convertion_unit) &&
                                                              (p.newIndexId === data.newIndexId || (!data.isAdditionalProduct && p.id === data.id));
                                                      
                                                          return isMatchingProduct
                                                            ? { ...p, adj_value_type: newValue }
                                                            : p;
                                                        }),
                                                      );
                                                      data['adj_value_type'] = newValue
                                                      if (newValue === false) {
                                                        // setFieldValue('manager_approval_required', true)
                                                      }
                                                      // markUnsavedChanges();
                                                    }}
                                                  />
                                                }
                                                label=""
                                              />
                                              <Add
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  const newValue = true
                                                  // setSelectedMaterials(
                                                  //   (prevProducts) =>
                                                  //     prevProducts.map(
                                                  //       (product) => {
                                                  //         if (
                                                  //           product.newIndexId ===
                                                  //           data.newIndexId
                                                  //         ) {
                                                  //           return {
                                                  //             ...product,
                                                  //             adj_value_type: newValue,
                                                  //           }
                                                  //         }
                                                  //         return product
                                                  //       },
                                                  //     ),
                                                  // )
                                                  setSelectedMaterials((prevMaterials) =>
                                                    prevMaterials.map((p) => {
                                                      const isMatchingProduct = data.isAdditionalProduct
                                                        ? p.newIndexId === data.newIndexId
                                                        : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                          p.stock_type === data.stock_type &&
                                                          (p.stock_type === 1 || p.convertion_unit === data.convertion_unit) &&
                                                          (p.newIndexId === data.newIndexId || (!data.isAdditionalProduct && p.id === data.id));
                                                  
                                                      return isMatchingProduct
                                                        ? { ...p, adj_value_type: newValue }
                                                        : p;
                                                    }),
                                                  );
                                                  // data['adj_value_type'] = newValue
                                                  // markUnsavedChanges();
                                                }}
                                              />
                                            </Stack>
                                          </TableCell>
                                          <TableCell>
                                            <TextField
                                              type="number"
                                              inputProps={{ min: 0 }}
                                              // label={
                                              //   data.markAdjType === 2
                                              //     ? '$'
                                              //     : data.markAdjType === 3
                                              //     ? '¢'
                                              //     : '%'
                                              // }
                                              label='$'
                                              InputLabelProps={{ shrink: data.adjustment!=null ? true : false }}
                                              value={ data.adjustment ?
                                                Number(data.adjustment) ||
                                                null : ''
                                              }
                                              onWheel={(e) => e.target.blur()}
                                              // onBeforeInput={(e) => {
                                              //   // const char = e.data; // next typed character
                                              //   // const nextValue = e.target.value + char;
                                              //   const inputElement = e.target;
                                              //   const nextValue = inputElement.value;

                                              //   const maxNegative = getMaterialMaxNegativeAdjustment(data);
                                              //   console.log('getMaxNegativeAdjustment1-maxNegative--maxNegative1',maxNegative);
                                              //   console.log('getMaxNegativeAdjustment1-maxNegative--nextValue',nextValue);
                                                
                                                
                                              //   if (Number(nextValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0)) {
                                              //     e.preventDefault(); // ← stops the key BEFORE appearing
                                              //     enqueueSnackbar(
                                              //       `1 Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative.toFixed(2)}`,
                                              //       { variant: "error" }
                                              //     );
                                              //   }
                                              // }}
                                              onBeforeInput={(e) => {
                                                // const char = e.data; // next typed character
                                                // const nextValue = e.target.value + char;
                                                const inputElement = e.target;
                                                const nextValue = inputElement.value; 
                                            
                                                const hasPermission = explodedPermissions?.some((permission) =>
                                                  ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                )
                                                const maxNegative = getMaterialMaxNegativeAdjustment(data, hasPermission);
                                                const isNegativeMode = data.adj_value_type === false || data.adj_value_type === 0 || data.adj_value_type === '0'
                                                if (Number(nextValue) >= maxNegative && isNegativeMode && hasPermission) {
                                                  e.preventDefault();
                                                  enqueueSnackbar(
                                                    'Markup Cost value cannot be zero or less',
                                                    { variant: "error" }
                                                  );
                                                } else if (Number(nextValue) > maxNegative && isNegativeMode && !hasPermission) {
                                                  e.preventDefault(); // ← stops the key BEFORE appearing
                                                  enqueueSnackbar(
                                                    `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative}`,
                                                    { variant: "error" }
                                                  );
                                                }
                                              }}
                                              
                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                const hasPermission = explodedPermissions?.some((permission) =>
                                                  ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                                )
                                                const maxNegative = getMaterialMaxNegativeAdjustment(data, hasPermission);
                                                // console.log('getMaxNegativeAdjustment1-maxNegative--maxNegative2',maxNegative);
                                                // console.log('getMaxNegativeAdjustment1-maxNegative--newValue',newValue);
                                                // console.log('getMaxNegativeAdjustment1-maxNegative--newValue',Number(newValue) > maxNegative);
                                                console.log('getMaxNegativeAdjustment1-maxNegative--adj_value_type',data.adj_value_type);
                                                const isNegativeMode = data.adj_value_type === false || data.adj_value_type === 0 || data.adj_value_type === '0'
                                                if (Number(newValue) >= maxNegative && isNegativeMode && hasPermission) {
                                                  enqueueSnackbar(
                                                    'Markup Cost value cannot be zero or less',
                                                    { variant: 'error' }
                                                  );
                                                  return;
                                                } else if (Number(newValue) > maxNegative && isNegativeMode && !hasPermission) {
                                                  enqueueSnackbar(
                                                    `Negative Adjustment Amount cannot reduce total below Product Unit Price. Max allowed: $${maxNegative}`,
                                                    { variant: 'error' }
                                                  );
                                                  
                                                  return;
                                                }
                                                console.log('getMaxNegativeAdjustment1-maxNegative--adj_value_type2',data.adj_value_type);
                                                const numValue = parseFloat(newValue) || 0
                                                if (numValue < 0) {
                                                  newValue = 0
                                                } else {
                                                  newValue = String(numValue)
                                                }
                                                // Allow only two decimal places
                                                if (
                                                  newValue.includes('.')
                                                ) {
                                                  const parts =
                                                    newValue.split('.')
                                                  if (parts[1].length > 2) {
                                                    newValue = `${parts[0]
                                                      }.${parts[1].slice(
                                                        0,
                                                        2,
                                                      )}`
                                                  }
                                                }
                                                data['adjustment'] =
                                                  newValue
                                                setFieldValue(
                                                  adjustmentFieldName,
                                                  newValue,
                                                );
                                                setRefreshCalculation(!refreshCalculation)
                                                // markUnsavedChanges();
                                              }}
                                              onKeyDown={(event) => {
                                                if (
                                                  event.key === '-' ||
                                                  event.key === '+'
                                                ) {
                                                  event.preventDefault()
                                                }
                                                // Prevent arrow down key when value is 0 or would go negative
                                                if (event.key === 'ArrowDown') {
                                                  const inputValue = event.target.value
                                                  const currentValue = parseFloat(inputValue) || 0
                                                  const step = parseFloat(event.target.step) || 1
                                                  if (currentValue - step < 0) {
                                                    event.preventDefault()
                                                  }
                                                }
                                              }}
                                              error={Boolean(
                                                touched[
                                                adjustmentFieldName
                                                ] &&
                                                errors[
                                                adjustmentFieldName
                                                ],
                                              )}
                                              helperText={
                                                touched[
                                                adjustmentFieldName
                                                ] &&
                                                errors[adjustmentFieldName]
                                              }
                                            />
                                          </TableCell>
                                          {/* <TableCell>
                                            {(
                                              data.price * (data.quantity || 0)
                                            )?.toFixed(2)}
                                          </TableCell> */}
                                          {/* <TableCell>
                                            {(
                                              (data.markUpCost || 0) *
                                              (data.quantity || 0)
                                            )?.toFixed(2)}
                                          </TableCell> */}
                                           <TableCell>
                                            {(
                                              (data.markUpCost + (data.adj_value_type ? Number(data.adjustment || 0) : -Number(data.adjustment || 0))) * (data.quantity || 0)
                                            )?.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            <IconButton
                                              onClick={() =>
                                                handleDeleteMaterial(data.id, data.newIndexId, data)
                                              }
                                            >
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                      </>
                                    )
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          {
                            showAddNewRow ?
                          <Stack sx={{ justifyContent: 'flex-end', alignItems: 'center', display:'flex', flexDirection:'row' }}>
                            {/* <Button
                              variant="outlined"
                              startIcon={
                                <Stack>
                                  {' '}
                                  <Add />{' '}
                                </Stack>
                              }
                              onClick={() => {
                                addNewMaterialRow()
                                // setMarkupType(1)
                              }}
                            >
                              Add Material Row
                            </Button> */}
                           <Typography variant="h6">
                                Total Additional Material Cost:{' '}
                                {selectedMaterialSubTotal}
                              </Typography>
                          </Stack>
                          :""}
                        </>
                       }

                        {
                       (values?.project_categories?.id === 13)  ?"" :
                      
                      <Stack direction={{ xs: 'column', md: 'column' }} display="flex" justifyContent="space-between">
                        <Stack direction="row" alignItems="center">
                          <Box onClick={(e) => {
                            const isInvalidJobType = values.project_categories?.name === 'Time & Material' || values.project_categories?.name === 'No Charge';
                            if (isInvalidJobType) {
                              enqueueSnackbar('DEPOSIT AND PROGRESS BILLING is not available for No Charge or Time & Material jobs.', { variant: 'error' });
                              e.preventDefault();
                              e.stopPropagation();
                            }
                          }}>
                            <Switch
                              checked={depositAndProgressBilling}
                              disabled={values.project_categories?.name === 'Time & Material' || values.project_categories?.name === 'No Charge'}
                              onChange={(e) => setDepositAndProgressBilling(e.target.checked)}
                              sx={{ ...(values.project_categories?.name === 'Time & Material' || values.project_categories?.name === 'No Charge' ? { pointerEvents: 'none' } : {}) }}
                            />
                          </Box>
                          <Typography variant="body2" sx={{ color: 'text.secondary', ml: 1 }}>
                            DEPOSIT AND PROGRESS BILLING
                          </Typography>
                          
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mt: 1, mb: 1 }}>
                          {[
                            { label: 'Grand Total', value: grandTotal ? fUSPrice(grandTotal) : fUSPrice(0), icon: <Receipt fontSize="small" /> },
                            { label: 'Balance', value: fUSPrice(Math.max((Number(grandTotal) || 0) - getDepositProgressBillingTotal(), 0)), icon: <AttachMoney fontSize="small" /> },
                          ].map((item) => (
                            <Paper
                              key={item.label}
                              variant="outlined"
                              sx={{
                                flex: 1,
                                p: 1.25,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                borderRadius: 1,
                              }}
                            >
                              <Box sx={{ color: 'primary.main', display: 'flex' }}>
                                {item.icon}
                              </Box>
                              <Box>
                                <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1 }}>
                                  {item.label}
                                </Typography>
                                <Typography variant="subtitle2">
                                  {item.value}
                                </Typography>
                              </Box>
                            </Paper>
                          ))}
                        </Stack>
                        {/* {depositAndProgressBilling && (
                          <Autocomplete
                            options={billingTypes}
                            fullWidth
                            getOptionLabel={(option) => option?.name}
                            // sx={{ minWidth: 200 }}
                            onChange={(event, newValue) => {
                              setFieldValue('billing_type', newValue)
                              setFieldValue('customerTypeId', newValue?.id)
                            }}
                            value={values.billing_type}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Payment Terms"
                                placeholder="Select Payment Terms"
                                error={Boolean(touched.billing_type && errors.billing_type)}
                                helperText={touched.billing_type && errors.billing_type}
                              />
                            )}
                          />
                        )} */}
                        {depositAndProgressBilling && (
                          <Stack spacing={2} sx={{ mt: 1 }}>
                            {depositProgressBillingRows.map((row, index) => (
                              <Stack
                                key={index}
                                direction={{ xs: 'column', md: 'row' }}
                                spacing={2}
                              >
                                <TextField
                                  fullWidth
                                  label="Title"
                                  value={row.title}
                                  onChange={(e) =>
                                    handleDepositProgressBillingChange(index, 'title', e.target.value)
                                  }
                                />
                                <TextField
                                  fullWidth
                                  type="number"
                                  label="Amount"
                                  value={row.amount}
                                  inputProps={{ min: 0, max: Number(getDepositProgressBillingMaxAmount(index)) }}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    if (!/^\d*\.?\d{0,2}$/.test(value)) {
                                      return
                                    }

                                    handleDepositProgressBillingChange(index, 'amount', value)
                                  }}
                                />
                                <IconButton
                                  onClick={() => handleDeleteDepositProgressBillingRow(index)}
                                  sx={{ alignSelf: { xs: 'flex-end', md: 'center' } }}
                                >
                                  <Icon icon={trash2Outline} />
                                </IconButton>
                              </Stack>
                            ))}
                            {canAddDepositProgressBillingRow() && (
                              <Button
                                variant="outlined"
                                startIcon={<Icon icon={plusFill} />}
                                onClick={handleAddDepositProgressBillingRow}
                                sx={{ alignSelf: 'flex-start' }}
                              >
                                Add Row
                              </Button>
                            )}
                          </Stack>
                        )}
                      </Stack>
                }
   

                      {/* <Divider /> */}
                      <Divider />
                      <LabelStyle>Notes</LabelStyle>
                      <TextField
                        fullWidth
                        multiline
                        minRows={3}
                        maxRows={7}
                        label="Notes"
                        // {...getFieldProps('notes')}
                        name="notes"
                      value={nameFileds?.notes}
                      onChange={(e) => {
                        const v = e.target.value;
                        setNameFileds({ ...nameFileds, notes: v });
                        if (v.trim()) {
                            setFieldErrors((prev) => ({
                              ...prev,
                              notes: undefined,
                            }));
                          }
                        }}
                        error={Boolean(touched.notes && errors.notes)}
                        helperText={
                          touched.notes && errors.notes
                            ? errors.notes
                            : `${nameFileds?.notes?.length || 0}/${MAX_CHARACTERS} characters`
                        }
                        inputProps={{
                          maxLength: MAX_CHARACTERS,
                        }}
                        InputProps={{
                          sx: {
                            color: 'error.main',
                          }
                        }}
                      />
                      {/* </>} */}
                      {/* <LabelStyle>Extra Discount</LabelStyle> */}
                      {/* Discount hidden — restore when needed
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <TextField
                          // sx={{ width: 400 }}
                          fullWidth
                          type="number"
                          onKeyPress={(event) => {
                            if (event.key === '-') {
                              event.preventDefault()
                            }
                          }}
                          onChange={(event) => {
                            let newValue = event.target.value
                            let data = 0
                            if (markupType === 1) {
                              data = totalWholesalePrice - totalJobcostSum
                            } else if (markupType === 2) {
                              data = totalRetailPrice - totalJobcostSum
                            }
                            console.log('extradiscount--totalsum--', totalsum)
                            console.log(
                              'extradiscount--totalWholesalePrice--',
                              totalWholesalePrice,
                            )
                            console.log(
                              'extradiscount--totalRetailPrice--',
                              totalRetailPrice,
                            )
                            console.log(
                              'extradiscount--DiscountTotal--',
                              DiscountTotal,
                            )
                            console.log(
                              'extradiscount--totalJobcostSum--',
                              totalJobcostSum,
                            )
                            console.log('extradiscount--newValue--', newValue)
                            console.log('extradiscount--data--', data)
                            // if (markupType === 1) {
                            //   data = (totalWholesalePrice - DiscountTotal) - totalProductFormula
                            // } else if (markupType === 2) {
                            //   data = (totalRetailPrice - DiscountTotal) - totalProductFormula
                            // } else {
                            //   data = 0
                            // }
                            if (Number(newValue) > data) {
                              newValue = data?.toFixed(2)
                            }
                            if (newValue === '-0.00') {
                              newValue = 0
                            }
                            setFieldValue('invoice_discount', newValue)
                          }}
                          label={
                            hasDiscountPermission
                              ? 'Discount (Access Denied)'
                              : 'Discount'
                          }
                          disabled={hasDiscountPermission}
                          value={values.invoice_discount}
                          // {...getFieldProps('invoice_discount')}
                          error={Boolean(
                            touched.invoice_discount && errors.invoice_discount,
                          )}
                          helperText={
                            touched.invoice_discount && errors.invoice_discount
                          }
                          inputProps={{
                            max:
                              markupType === 1
                                ? totalWholesalePrice - totalJobcostSum
                                : markupType === 2
                                ? totalRetailPrice - totalJobcostSum
                                : 0,
                            min: 0,
                          }}
                        />
                      */}
                        {/* <Autocomplete
                          // sx={{ width: 400 }}
                          fullWidth
                          id="combo-box-demo"
                          options={taxCategories || []}
                          disabled={true}
                          value={selectedTaxCategory || null}
                          onChange={(event, newValue) => {
                            setSelectedTaxCategory(newValue)
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Tax category" />
                          )}
                          getOptionLabel={(option) =>
                            option.name ? option.name : ''
                          }
                        /> */}
                      {/* </Stack> */}
                      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={'flex-start'} spacing={{ xs: 2, sm: 2 }} sx={{ mb: 2 }}>
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          maxRows={7}
                          label="Bill To"
                          placeholder="Enter billing address"
                          name="bill_to"
                          value={billToInputValue || ''}
                          onChange={(event) => {
                            const nextValue = event.target.value;
                            setIsBillToDirty(true);
                            setBillToInputValue(nextValue);
                            setFieldValue('bill_to', nextValue, false);
                          }}
                          onBlur={(event) => setFieldValue('bill_to', event.target.value, false)}
                        />
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          maxRows={7}
                          label="Ship To"
                          placeholder="Enter shipping address"
                          name="ship_to"
                          value={shipToInputValue || ''}
                          onChange={(event) => {
                            const nextValue = event.target.value;
                            setIsShipToDirty(true);
                            setShipToInputValue(nextValue);
                            setFieldValue('ship_to', nextValue, false);
                          }}
                          onBlur={(event) => setFieldValue('ship_to', event.target.value, false)}
                        />
                      </Stack>
                      <Typography sx={{ color: theme.palette.error.main }}>
                        **All values in the software are rounded to two decimal
                        places in accordance with standard US calculation
                        practices.
                      </Typography>
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        alignItems={'center'}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <Stack>
                          {/* <Typography sx={{ color: 'text.secondary' }}>Sub Total: {RFQSubTotal ? RFQSubTotal?.toFixed(2) : 0}</Typography> */}
                          {/* <Typography sx={{ color: 'text.secondary' }}>Service cost in Product Formula: {InitialServiceCostInProductFormula ? InitialServiceCostInProductFormula?.toFixed(2) : 0}</Typography> */}
                          {/* <Typography sx={{ color: 'text.secondary' }}>Total ({RFQSubTotal?.toFixed(2)} - {InitialServiceCostInProductFormula?.toFixed(2)}): {totalsum ? totalsum?.toFixed(2) : 0}</Typography> */}
                          {/* <Typography >
                            Install Price: {installCost ? installCost : '0.00'}
                          </Typography> */}
                          <Typography >
                            Sub Total:{' '}
                            { totalsum
                                ? fUSPrice(totalsum)
                                : fUSPrice(0)}
                          </Typography>
                          {/* <Typography >
                            Tax: {parseFloat(taxAmount).toFixed(2) || 0.0}
                          </Typography> */}
                          {isRushFeeChecked && (
                            <Typography>
                              Rush Fee:{' '}
                              {fUSPrice(rushFeeAmount)}
                            </Typography>
                          )}
                          {noCharge ? (
                            <Typography sx={{ color: 'red' }}>
                              {/* Grand Total:{' '}
                              {canViewCosts
                                ? grandTotal
                                  ? parseFloat(grandTotal)?.toFixed(2)
                                  : 0.0
                                : '—'} */}
                                Grand Total:{' '}
                              {grandTotal
                                ? fUSPrice(grandTotal)
                                : fUSPrice(0)}
                            </Typography>
                          ) : (
                            <Typography sx={{ color: theme.palette.mode === 'light' ? '#FFAF00' : 'yellow' }}>
                              Grand Total:{' '}
                              {grandTotal
                                  ? fUSPrice(grandTotal)
                                  : fUSPrice(0)}
                            </Typography>
                          )}
                          {/* <Typography sx={{ color: 'yellow' }}>
                    Grand Total: {grandTotal ? parseFloat(grandTotal)?.toFixed(2) : 0.00}
                  </Typography> */}
                          {/* <Typography sx={{ color: 'yellow' }}>Grand Total : {totalsum ? totalsum?.toFixed(2) : 0.00}</Typography> */}
                          {/* <Typography sx={{ color: 'yellow' }}>
                            Total Product Formula Cost:{' '}
                            {totalJobcostSum ? totalJobcostSum?.toFixed(2) : 0}
                          </Typography> */}
                          {/* <Typography sx={{ color: 'text.secondary' }}>Total: {totalsum < 0 ? 0 : totalsum?.toFixed(2)}</Typography> */}
                          {/* Discount hidden — restore when needed
                          <Typography >
                            Total Discount:
                            { DiscountTotal
                                ? DiscountTotal?.toFixed(2)
                                : 0.0}
                          </Typography>
                          */}

                          {/* <Tooltip title="Sub Total - Total Product Formula Cost">
                            <Typography
                              sx={{
                                // color: 'text.secondary',
                                cursor: 'pointer',
                              }}
                            >
                              Total Markup Amount:
                              {(totalsum - totalJobcostSum)?.toFixed(2)}
                            </Typography>
                          </Tooltip> */}

                          {/* <Tooltip title="(Total Markup Amount / Total Product Formula Cost) * 100">
                            <Typography
                              sx={{
                                // color: 'text.secondary',
                                cursor: 'pointer',
                              }}
                            >
                              Total Markup Percentage:
                              {totalJobcostSum !== 0 && totalsum !== 0
                                ? (
                                    ((totalsum - totalJobcostSum) /
                                      totalJobcostSum) *
                                    100
                                  ).toFixed(2)
                                : '0.00'}
                            </Typography>
                          </Tooltip> */}

                          {/* <Typography sx={{ color: 'text.secondary' }}>Total Product Markup:{(originaltotalMarkup / selectedProducts.length)?.toFixed(2)}</Typography> */}
                          {/* <Typography sx={{ color: 'text.secondary' }}>Total Service Markup:{(originaltotalServiceMarkup / (selectedServices.length + additionalSelectedServices.length))?.toFixed(2)}</Typography> */}
                        </Stack>
                        <Stack direction={'column'} display={'flex'} justifyContent={'center'}>
                        <FormControlLabel
                          control={
                            <Switch
                              {...getFieldProps('welcome_message')}
                              color="primary"
                              checked={values.welcome_message}
                            />
                          }
                          labelPlacement="end"
                          label="Use Custom Welcome Message"
                          sx={{ mt: 6 ,mb:2 }}
                        />
                          {
                            noCharge ? ""
                              :
                              <>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      {...getFieldProps('client_approve')}
                                      color="primary"
                                      checked={values.client_approve}
                                      onChange={(event) => setFieldValue('client_approve', event.target.checked)}
                                    />
                                  }
                                  labelPlacement="end"
                                  label="Enable for Client Approval"
                                  sx={{ mt: 0 }}
                                />
                              </>
                          }
                          {/* Sales orders no longer use manager approval toggle
                          {showManagerApprovalToggle && (
                            <FormControlLabel
                              control={
                                <Switch
                                  {...getFieldProps('manager_approval_required')}
                                  color="primary"
                                  checked={values.manager_approval_required}
                                  readOnly={isLocked}
                                  inputProps={{ readOnly: isLocked }}
                                  onChange={(event) => setFieldValue('manager_approval_required', event.target.checked)}
                                />
                              }
                              labelPlacement="end"
                              label="Enable for Manager approval"
                              sx={{ mt: 0 }}
                            />
                          )} */}
                       <FormControlLabel
                          control={
                            <Switch
                            {...getFieldProps('show_install_price')}
                              color="primary"
                              checked={values.show_install_price == 0 ? false : true}
                              onChange={(event) => setFieldValue('show_install_price', event.target.checked ? 1 : 0)}
                            />
                          }
                          labelPlacement="end"
                          label="Show Install Price"
                          sx={{ mt: 2 }}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={isRushFeeChecked}
                              disabled={rushFeeSwitchDisabled}
                              onChange={(event) => {
                                if (rushFeeSwitchDisabled) return;
                                if (isRushFeeAutoLocked && !canOverrideRushFeeLock) return;
                                const turningOff = !event.target.checked;
                                markRushFeeUserToggled(rushFeeSyncRefs.current, {
                                  turnedOn: event.target.checked,
                                  declinedWhileLocked: turningOff && isRushFeeAutoLocked && canOverrideRushFeeLock,
                                });
                                setFieldValue('rush_fee', event.target.checked ? 1 : 0);
                              }}
                            />
                          }
                          labelPlacement="end"
                          label={
                            rushFeeAccessDenied
                              ? 'Rush Fee (Access Denied)'
                              : 'Rush Fee'
                          }
                          sx={{ mt: 2 }}
                        />       
                        </Stack>
                      </Stack>
                      {values.welcome_message == true && (
                        <>
                          <Stack>
                            <LabelStyle>Subject</LabelStyle>
                            <TextField
                              //   fullWidth
                              type="text"
                              sx={{ width: 400 }}
                              {...getFieldProps('subject')}
                              error={Boolean(touched.subject && errors.subject)}
                              helperText={touched.subject && errors.subject}
                            />
                          </Stack>
                          <LabelStyle>Email Content</LabelStyle>
                          <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            maxRows={7}
                            label="Email Content"
                            {...getFieldProps('email_content')}
                            error={Boolean(
                              touched.email_content && errors.email_content,
                            )}
                            helperText={
                              touched.email_content && errors.email_content
                            }
                          />
                        </>
                      )}
                      <LabelStyle>Request state</LabelStyle>
                      <Typography>
                        While in draft mode, clients you add to request tasks
                        won't be notified
                      </Typography>
                      <FormControlLabel
                        control={
                          <Switch
                            {...getFieldProps('draft')}
                            color="primary"
                            checked={values.draft}
                          />
                        }
                        labelPlacement="end"
                        label="Draft"
                        sx={{ mt: 5 }}
                      />
                    </>
                  )}
                  <Dialog open={openMakeTaskDialog} onClose={handleCloseMakeTastDialog}>
                    <DialogTitle>Do you want to continue?</DialogTitle>
                    <DialogContent>
                      {(() => {
                        // Filter out items with id == 10 when project_categories.id !== 11
                        const filteredAdditionalServices = values.project_categories?.id !== 11 
                          ? additionalSelectedServices.filter(item => item.id !== 10)
                          : additionalSelectedServices;
                        
                        const additionalServicesWithoutTask = filteredAdditionalServices?.filter(item => item?.makeAsTask === 0) || [];
                        const additionalServicesWithoutInstallCard = filteredAdditionalServices?.filter(item => item?.makeInstallCard === 0) || [];

                        const proposalServicesWithoutTask = cartService?.filter(item => item?.makeAsTask === 0) || [];
                        const proposalServicesWithoutInstallCard = cartService?.filter(item => item?.makeInstallCard === 0) || [];

                        // Additional services with jobCost === 0
                        const additionalServicesWithZeroJobCost = filteredAdditionalServices?.filter(item => item?.jobCost === 0) || [];
                        const proposalServicesWithZeroJobCost = cartService?.filter(item => item?.jobCost === 0) || [];

                        return (
                          <Alert severity="warning">
                            {additionalServicesWithoutTask.length > 0 || proposalServicesWithoutTask.length > 0 ? (
                              <div>
                                {additionalServicesWithoutTask.length > 0 && (
                                  <>The additional services <em>{additionalServicesWithoutTask.map(item => item.name).join(', ')}</em></>
                                )}
                                {additionalServicesWithoutTask.length > 0 && proposalServicesWithoutTask.length > 0 && <> and </>}
                                {proposalServicesWithoutTask.length > 0 && (
                                  <>The proposal services <em>{proposalServicesWithoutTask.map(item => item.name).join(', ')}</em></>
                                )}
                                {' '}have the <strong>Make As Task</strong> toggle turned off.{`${values?.project_categories?.id == 12 ? "This will appear in production without tasks" : "These will not appear in production as they are not creating tasks."}`}
                                <br /><br />
                              </div>
                            ) : null}

                            {additionalServicesWithoutInstallCard.length > 0 || proposalServicesWithoutInstallCard.length > 0 ? (
                              <div>
                                {additionalServicesWithoutInstallCard.length > 0 && (
                                  <>The additional services <em>{additionalServicesWithoutInstallCard.map(item => item.name).join(', ')}</em></>
                                )}
                                {additionalServicesWithoutInstallCard.length > 0 && proposalServicesWithoutInstallCard.length > 0 && <> and </>}
                                {proposalServicesWithoutInstallCard.length > 0 && (
                                  <>The proposal services <em>{proposalServicesWithoutInstallCard.map(item => item.name).join(', ')}</em></>
                                )}
                                {' '}have the <strong>Make Install Card</strong> toggle turned off. These will not appear in installation as they are not creating install cards.
                                <br /><br />
                              </div>
                            ) : null}

                            {additionalServicesWithZeroJobCost.length > 0 || proposalServicesWithZeroJobCost.length > 0 ? (
                              <div>
                                {additionalServicesWithZeroJobCost.length > 0 && (
                                  <>The additional services <em>{additionalServicesWithZeroJobCost.map(item => item.name).join(', ')}</em></>
                                )}
                                {additionalServicesWithZeroJobCost.length > 0 && proposalServicesWithZeroJobCost.length > 0 && <> and </>}
                                {proposalServicesWithZeroJobCost.length > 0 && (
                                  <>The proposal services <em>{proposalServicesWithZeroJobCost.map(item => item.name).join(', ')}</em></>
                                )}
                                {' '}have a <strong>Job Cost Toggle</strong> turned off, and will not appear in the job cost.
                                <br /><br />
                              </div>
                            ) : null}

                            Do you want to continue?
                          </Alert>
                        );
                      })()}
                    </DialogContent>
                    <DialogActions>
                      <Button variant='outlined' onClick={handleCloseMakeTastDialog} color="inherit">
                        No
                      </Button>
                      <Button
                        onClick={() => {
                          handleContinueMakeTastDialog();
                          setTimeout(() => {
                            handleSubmit();
                          }, 100); // small delay ensures dialog closes before submission
                        }}
                        variant="contained"
                      >
                        Yes
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <Dialog open={showMakeTaskErrorDialog} onClose={() => setShowMakeTaskErrorDialog(false)}>
                    <DialogTitle>Action Required: Enable Service Install Card</DialogTitle>
                    <DialogContent>
                      <Alert severity="error">
                        {values?.project_categories?.id == 11 ? (
                          <>
                            You cannot submit a <strong>Service Only</strong> job if all selected services have the <em>Make Install Card</em> toggle turned off.
                            At least one service must generate an install card to proceed.
                          </>
                        ) : (
                          <>
                            You cannot submit a <strong>Time & Material</strong> job without any products or materials,
                            and with all services having the <em>Make Install Card</em> toggle turned off. Please add a
                            product, material, or enable the <em>Make Install Card</em> toggle for at least one service.
                          </>
                        )}
                      </Alert>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setShowMakeTaskErrorDialog(false)} color="primary" variant="contained">
                        OK, I Understand
                      </Button>
                    </DialogActions>
                  </Dialog>
                  
                  {/* Service Note Modal */}
                  {cartService?.map((data, index) => (
                    <Modal
                      key={`service-note-${data.indexId || data.id}`}
                      open={openServiceNote[data.indexId || data.id] || false}
                      handleClose={() => handleCloseServiceNote(data.indexId || data.id)}
                    >
                      <Grid
                        container
                        spacing={3}
                        sx={{ justifyContent: 'center', width: '100%' }}
                      >
                        <Grid item xs={12}>
                          <Typography variant="h5" sx={{ mb: 2, }}>
                            Note
                          </Typography>

                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                            sx={{ mb: 2 }}
                          >
                            <TextField
                              fullWidth
                              multiline
                              rows={4}
                              size="medium"
                              value={currentNote}
                              onChange={handleServiceNoteChange}
                              error={!currentNote.trim() && currentNote.length > 0}
                              inputProps={{ maxLength: MAX_CHARACTERS }}
                              helperText={
                                !currentNote.trim() && currentNote.length > 0
                                  ? 'Note cannot be empty or contain only spaces'
                                  : `${currentNote.length}/${MAX_CHARACTERS} characters`
                              }
                              InputProps={{
                                sx: {
                                  color: 'error.main',
                                }
                              }}
                            />
                          </Stack>
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={4}>
                          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                            <LoadingButton
                              variant="contained"
                              onClick={() => handleSaveServiceNote(data.indexId || data.id)}
                              loading={isSavingNote}
                              disabled={!currentNote.trim()}>
                              Save
                            </LoadingButton>
                            <LoadingButton
                              variant="outlined"
                              color="error"
                              onClick={() => handleClearServiceNote(data.indexId || data.id)}
                              loading={isClearingNote}
                              disabled={!currentNote.trim()}>
                              Clear
                            </LoadingButton>
                          </Box>
                        </Grid>
                      </Grid>
                    </Modal>
                  ))}

                  {/* Service Note Modal for additionalSelectedServices */}
                  {additionalSelectedServices?.map((data, index) => (
                    <Modal
                      key={`additional-service-note-${data.indexId || data.newIndexId || index}`}
                      open={openServiceNote[data.indexId || data.newIndexId || index] || false}
                      handleClose={() => handleCloseServiceNote(data.indexId || data.newIndexId || index)}
                    >
                      <Grid
                        container
                        spacing={3}
                        sx={{ justifyContent: 'center', width: '100%' }}
                      >
                        <Grid item xs={12}>
                          <Typography variant="h5" sx={{ mb: 2, }}>
                            Note
                          </Typography>

                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                            sx={{ mb: 2 }}
                          >
                            <TextField
                              fullWidth
                              multiline
                              rows={4}
                              size="medium"
                              value={currentNote}
                              onChange={handleServiceNoteChange}
                              error={!currentNote.trim() && currentNote.length > 0}
                              inputProps={{ maxLength: MAX_CHARACTERS }}
                              helperText={
                                !currentNote.trim() && currentNote.length > 0
                                  ? 'Note cannot be empty or contain only spaces'
                                  : `${currentNote.length}/${MAX_CHARACTERS} characters`
                              }
                              InputProps={{
                                sx: {
                                  color: 'error.main',
                                }
                              }}
                            />
                          </Stack>
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={4}>
                          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                            <LoadingButton
                              variant="contained"
                              onClick={() => handleSaveServiceNote(data.indexId || data.newIndexId || index)}
                              loading={isSavingNote}
                              disabled={!currentNote.trim()}>
                              Save
                            </LoadingButton>
                            <LoadingButton
                              variant="outlined"
                              color="error"
                              onClick={() => handleClearServiceNote(data.indexId || data.newIndexId || index)}
                              loading={isClearingNote}
                              disabled={!currentNote.trim()}>
                              Clear
                            </LoadingButton>
                          </Box>
                        </Grid>
                      </Grid>
                    </Modal>
                  ))}
                  
                <Box
                  sx={{
                    mt: 3,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 1,
                  }}
                >
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                    // disabled={depositAndProgressBilling && Math.max((Number(grandTotal) || 0) - getDepositProgressBillingTotal(), 0).toFixed(2) !== '0.00'}
                  >
                    Save Order
                  </LoadingButton>
                  {userType !== 3 &&
                    explodedPermissions?.some((permission) =>
                      ['Create Request'].includes(permission),
                    ) && (
                      <Button
                        variant="outlined"
                        onClick={() => setOpenPreview(!openPreview)}
                      >
                        Preview
                      </Button>
                    )}
                  <Button variant="outlined" onClick={() => handleCancel()}>
                    Cancel
                  </Button>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>
        <ViewProductFormulaModal
  open={openProductFormulaModal}
  onClose={() => setOpenProductFormulaModal(false)}
  formulaId={selectedProductFormulaId}
  user={user}
  explodedPermissions={explodedPermissions}
  hideEdit={true}
/>
      </Form>
        <Dialog open={openDialog} >
    <DialogTitle>Select Stock Type</DialogTitle>
    <DialogContent>
      <RadioGroup
        value={String(stockType)}
        onChange={(e) => {
          const val = e.target.value;
          setStockType(val === '1' ? 1 : 2);
          if (val === '1') setConvertionUnit(0);
        }}
      >
        <FormControlLabel value="1" control={<Radio />} label="Finished Product" />
        <FormControlLabel value="2" control={<Radio />} label="Partial Finished Product" />
      </RadioGroup>

      {stockType === 2 && (
        partialProducts.length > 0 ? (
          <>
            <Typography>Select Conversion Unit</Typography>
            <RadioGroup
              value={convertionUnit}
              onChange={(e) => setConvertionUnit(Number(e.target.value))}
            >
              {UNITS
                .filter(u => partialProducts.some(p => p.partial_unit === u.id))
                .map(u => (
                  <FormControlLabel
                    key={u.id}
                    value={u.id}
                    control={<Radio />}
                    label={u.name}
                  />
                ))}
            </RadioGroup>
          </>
        ) : (
          <Typography color="error">No partial stock found</Typography>
        )
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={closeDialog} color="error">Cancel</Button>
      <Button
        onClick={handleSubmitPopUp}
        disabled={stockType === 2 && partialProducts.length === 0}
        variant="contained"
      >
        Add Material
      </Button>
    </DialogActions>
  </Dialog>

  {/* Delivery & Installation picker (used for split orders and normal sales orders)
      - Split order: requires installer facility + delivery type
      - Non-split: only delivery type is required; installer is optional/ignored */}
  <Dialog
    open={deliveryInstallDialog.open}
    onClose={closeDeliveryInstallDialog}
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle>
      {isSplitOrder && Number(deliveryInstallDialog?.productFacilityId) !== Number(currentFacilityId) 
        ? 'Delivery & Installation' 
        : 'Installation'}
    </DialogTitle>
    <DialogContent>
      <Stack spacing={2} sx={{ mt: 1 }}>
        {isSplitOrder && Number(deliveryInstallDialog?.productFacilityId) !== Number(currentFacilityId) ? (
          <Autocomplete
            options={deliveryInstallDialog.facilityOptions || []}
            value={deliveryInstallDialog.installerFacility}
            onChange={(event, newValue) => {
              setDeliveryInstallDialog((prev) => {
                const nextInstallerId = Number(newValue?.id)
                const isCurrentFacilityInstaller =
                  nextInstallerId === Number(currentFacilityId)

                // If current facility is selected as installer, hide "Installs" and prevent selecting it
                const nextCompleteStatus =
                  isCurrentFacilityInstaller && Number(prev.complete_status) === 1
                    ? 2
                    : prev.complete_status

                return {
                  ...prev,
                  installerFacility: newValue,
                  complete_status: nextCompleteStatus,
                }
              })
            }}
            getOptionLabel={(option) => option?.name || option?.label || option?.value || ''}
            isOptionEqualToValue={(option, value) => String(option?.id) === String(value?.id)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Who is installing?"
                placeholder="Select facility"
              />
            )}
          />
        ) : null}

        <RadioGroup
          value={String(deliveryInstallDialog.complete_status)}
          onChange={(e) => {
            const val = Number(e.target.value)
            setDeliveryInstallDialog((prev) => ({
              ...prev,
              complete_status: val,
            }))
          }}
        > 
          {(isSplitOrder && Number(deliveryInstallDialog?.productFacilityId) !== Number(currentFacilityId)
            ? Number(deliveryInstallDialog?.installerFacility?.id) !== Number(currentFacilityId)
            : true) && (
            <FormControlLabel value="1" control={<Radio />} label="Installs" />
          )}
          {
            (Number(deliveryInstallDialog?.productFacilityId) == Number(currentFacilityId) && values?.project_categories?.id == 11) ?
            null :
            <>
          <FormControlLabel value="2" control={<Radio />} label="Pickup" />
          <FormControlLabel value="3" control={<Radio />} label="Shipping" />
            </>
          }
        </RadioGroup>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={closeDeliveryInstallDialog} color="inherit">
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={isSplitOrder && Number(deliveryInstallDialog?.productFacilityId) !== Number(currentFacilityId) 
          ? saveDeliveryInstallSelection 
          : saveDeliveryTypeSelection}
      >
        Save
      </Button>
    </DialogActions>
  </Dialog>

  {/* 🚀 PROGRESS TRACKING: Progress Modal */}
  {/* <RequestProgressModal
    open={showProgressModal}
    onClose={() => setShowProgressModal(false)}
    requestData={progressRequestData}
    onSocketReady={setSocketReady}
    heading={`Creating Sales Order`}
  /> */}
      <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        heading="Creating Sales Order"
        message="We're processing your Sales Order. Please wait..."
      />

      {/* Auto-save confirmation dialog */}
      <Dialog
        open={openBackConfirm}
        onClose={() => setOpenBackConfirm(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Go back?</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Do you want to auto save this sales order before going back?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleBackConfirmNo} variant="outlined" color="primary">
            No, Go Back
          </Button>
          <Button onClick={handleBackConfirmYes} variant="contained" color="primary">
            Yes, Auto Save
          </Button>
        </DialogActions>
      </Dialog>

    </FormikProvider>
  )
}
